var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import moment from "moment";
function makeMap(str, expectsLowerCase) {
  const map2 = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i2 = 0; i2 < list.length; i2++) {
    map2[list[i2]] = true;
  }
  return expectsLowerCase ? (val) => !!map2[val.toLowerCase()] : (val) => !!map2[val];
}
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(value) {
  return !!value || value === "";
}
function normalizeStyle(value) {
  if (isArray$c(value)) {
    const res = {};
    for (let i2 = 0; i2 < value.length; i2++) {
      const item = value[i2];
      const normalized = isString$5(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString$5(value)) {
    return value;
  } else if (isObject$3(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:(.+)/;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString$5(value)) {
    res = value;
  } else if (isArray$c(value)) {
    for (let i2 = 0; i2 < value.length; i2++) {
      const normalized = normalizeClass(value[i2]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject$3(value)) {
    for (const name in value) {
      if (value[name]) {
        res += name + " ";
      }
    }
  }
  return res.trim();
}
const toDisplayString = (val) => {
  return val == null ? "" : isArray$c(val) || isObject$3(val) && (val.toString === objectToString$2 || !isFunction$4(val.toString)) ? JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (val && val.__v_isRef) {
    return replacer(_key, val.value);
  } else if (isMap$2(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val2]) => {
        entries[`${key} =>`] = val2;
        return entries;
      }, {})
    };
  } else if (isSet$2(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()]
    };
  } else if (isObject$3(val) && !isArray$c(val) && !isPlainObject$2(val)) {
    return String(val);
  }
  return val;
};
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = () => {
};
const NO = () => false;
const onRE = /^on[^a-z]/;
const isOn = (key) => onRE.test(key);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend$2 = Object.assign;
const remove = (arr, el) => {
  const i2 = arr.indexOf(el);
  if (i2 > -1) {
    arr.splice(i2, 1);
  }
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn$4 = (val, key) => hasOwnProperty.call(val, key);
const isArray$c = Array.isArray;
const isMap$2 = (val) => toTypeString(val) === "[object Map]";
const isSet$2 = (val) => toTypeString(val) === "[object Set]";
const isFunction$4 = (val) => typeof val === "function";
const isString$5 = (val) => typeof val === "string";
const isSymbol$2 = (val) => typeof val === "symbol";
const isObject$3 = (val) => val !== null && typeof val === "object";
const isPromise = (val) => {
  return isObject$3(val) && isFunction$4(val.then) && isFunction$4(val.catch);
};
const objectToString$2 = Object.prototype.toString;
const toTypeString = (value) => objectToString$2.call(value);
const toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
const isPlainObject$2 = (val) => toTypeString(val) === "[object Object]";
const isIntegerKey = (key) => isString$5(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(",key,ref,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const cacheStringFunction = (fn2) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn2(str));
  };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str) => {
  return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
const toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, arg) => {
  for (let i2 = 0; i2 < fns.length; i2++) {
    fns[i2](arg);
  }
};
const def = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    value
  });
};
const toNumber = (val) => {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
let activeEffectScope;
const effectScopeStack = [];
class EffectScope {
  constructor(detached = false) {
    this.active = true;
    this.effects = [];
    this.cleanups = [];
    if (!detached && activeEffectScope) {
      this.parent = activeEffectScope;
      this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
  }
  run(fn2) {
    if (this.active) {
      try {
        this.on();
        return fn2();
      } finally {
        this.off();
      }
    }
  }
  on() {
    if (this.active) {
      effectScopeStack.push(this);
      activeEffectScope = this;
    }
  }
  off() {
    if (this.active) {
      effectScopeStack.pop();
      activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
    }
  }
  stop(fromParent) {
    if (this.active) {
      this.effects.forEach((e2) => e2.stop());
      this.cleanups.forEach((cleanup) => cleanup());
      if (this.scopes) {
        this.scopes.forEach((e2) => e2.stop(true));
      }
      if (this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        if (last && last !== this) {
          this.parent.scopes[this.index] = last;
          last.index = this.index;
        }
      }
      this.active = false;
    }
  }
}
function recordEffectScope(effect2, scope) {
  scope = scope || activeEffectScope;
  if (scope && scope.active) {
    scope.effects.push(effect2);
  }
}
function getCurrentScope() {
  return activeEffectScope;
}
function onScopeDispose(fn2) {
  if (activeEffectScope) {
    activeEffectScope.cleanups.push(fn2);
  }
}
const createDep = (effects) => {
  const dep = new Set(effects);
  dep.w = 0;
  dep.n = 0;
  return dep;
};
const wasTracked = (dep) => (dep.w & trackOpBit) > 0;
const newTracked = (dep) => (dep.n & trackOpBit) > 0;
const initDepMarkers = ({ deps }) => {
  if (deps.length) {
    for (let i2 = 0; i2 < deps.length; i2++) {
      deps[i2].w |= trackOpBit;
    }
  }
};
const finalizeDepMarkers = (effect2) => {
  const { deps } = effect2;
  if (deps.length) {
    let ptr = 0;
    for (let i2 = 0; i2 < deps.length; i2++) {
      const dep = deps[i2];
      if (wasTracked(dep) && !newTracked(dep)) {
        dep.delete(effect2);
      } else {
        deps[ptr++] = dep;
      }
      dep.w &= ~trackOpBit;
      dep.n &= ~trackOpBit;
    }
    deps.length = ptr;
  }
};
const targetMap = /* @__PURE__ */ new WeakMap();
let effectTrackDepth = 0;
let trackOpBit = 1;
const maxMarkerBits = 30;
const effectStack = [];
let activeEffect;
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
class ReactiveEffect {
  constructor(fn2, scheduler = null, scope) {
    this.fn = fn2;
    this.scheduler = scheduler;
    this.active = true;
    this.deps = [];
    recordEffectScope(this, scope);
  }
  run() {
    if (!this.active) {
      return this.fn();
    }
    if (!effectStack.includes(this)) {
      try {
        effectStack.push(activeEffect = this);
        enableTracking();
        trackOpBit = 1 << ++effectTrackDepth;
        if (effectTrackDepth <= maxMarkerBits) {
          initDepMarkers(this);
        } else {
          cleanupEffect(this);
        }
        return this.fn();
      } finally {
        if (effectTrackDepth <= maxMarkerBits) {
          finalizeDepMarkers(this);
        }
        trackOpBit = 1 << --effectTrackDepth;
        resetTracking();
        effectStack.pop();
        const n = effectStack.length;
        activeEffect = n > 0 ? effectStack[n - 1] : void 0;
      }
    }
  }
  stop() {
    if (this.active) {
      cleanupEffect(this);
      if (this.onStop) {
        this.onStop();
      }
      this.active = false;
    }
  }
}
function cleanupEffect(effect2) {
  const { deps } = effect2;
  if (deps.length) {
    for (let i2 = 0; i2 < deps.length; i2++) {
      deps[i2].delete(effect2);
    }
    deps.length = 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function enableTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = true;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (!isTracking()) {
    return;
  }
  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
  }
  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, dep = createDep());
  }
  trackEffects(dep);
}
function isTracking() {
  return shouldTrack && activeEffect !== void 0;
}
function trackEffects(dep, debuggerEventExtraInfo) {
  let shouldTrack2 = false;
  if (effectTrackDepth <= maxMarkerBits) {
    if (!newTracked(dep)) {
      dep.n |= trackOpBit;
      shouldTrack2 = !wasTracked(dep);
    }
  } else {
    shouldTrack2 = !dep.has(activeEffect);
  }
  if (shouldTrack2) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  let deps = [];
  if (type === "clear") {
    deps = [...depsMap.values()];
  } else if (key === "length" && isArray$c(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        deps.push(dep);
      }
    });
  } else {
    if (key !== void 0) {
      deps.push(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray$c(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap$2(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          deps.push(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray$c(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap$2(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap$2(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  if (deps.length === 1) {
    if (deps[0]) {
      {
        triggerEffects(deps[0]);
      }
    }
  } else {
    const effects = [];
    for (const dep of deps) {
      if (dep) {
        effects.push(...dep);
      }
    }
    {
      triggerEffects(createDep(effects));
    }
  }
}
function triggerEffects(dep, debuggerEventExtraInfo) {
  for (const effect2 of isArray$c(dep) ? dep : [...dep]) {
    if (effect2 !== activeEffect || effect2.allowRecurse) {
      if (effect2.scheduler) {
        effect2.scheduler();
      } else {
        effect2.run();
      }
    }
  }
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol$2));
const get = /* @__PURE__ */ createGetter();
const shallowGet = /* @__PURE__ */ createGetter(false, true);
const readonlyGet = /* @__PURE__ */ createGetter(true);
const arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i2 = 0, l = this.length; i2 < l; i2++) {
        track(arr, "get", i2 + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly2 = false, shallow = false) {
  return function get2(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray$c(target);
    if (!isReadonly2 && targetIsArray && hasOwn$4(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol$2(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
      return shouldUnwrap ? res.value : res;
    }
    if (isObject$3(res)) {
      return isReadonly2 ? readonly(res) : reactive(res);
    }
    return res;
  };
}
const set = /* @__PURE__ */ createSetter();
const shallowSet = /* @__PURE__ */ createSetter(true);
function createSetter(shallow = false) {
  return function set2(target, key, value, receiver) {
    let oldValue = target[key];
    if (!shallow) {
      value = toRaw(value);
      oldValue = toRaw(oldValue);
      if (!isArray$c(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray$c(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn$4(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn$4(target, key);
  target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0);
  }
  return result;
}
function has$9(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol$2(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys(target) {
  track(target, "iterate", isArray$c(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
const mutableHandlers = {
  get,
  set,
  deleteProperty,
  has: has$9,
  ownKeys
};
const readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    return true;
  },
  deleteProperty(target, key) {
    return true;
  }
};
const shallowReactiveHandlers = /* @__PURE__ */ extend$2({}, mutableHandlers, {
  get: shallowGet,
  set: shallowSet
});
const toShallow = (value) => value;
const getProto$2 = (v2) => Reflect.getPrototypeOf(v2);
function get$1(target, key, isReadonly2 = false, isShallow = false) {
  target = target["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly2 && track(rawTarget, "get", key);
  }
  !isReadonly2 && track(rawTarget, "get", rawKey);
  const { has: has2 } = getProto$2(rawTarget);
  const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1$1(key, isReadonly2 = false) {
  const target = this["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (key !== rawKey) {
    !isReadonly2 && track(rawTarget, "has", key);
  }
  !isReadonly2 && track(rawTarget, "has", rawKey);
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size$2(target, isReadonly2 = false) {
  target = target["__v_raw"];
  !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto$2(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto$2(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  }
  const oldValue = get2.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto$2(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  }
  get2 ? get2.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0);
  }
  return result;
}
function createForEach(isReadonly2, isShallow) {
  return function forEach3(callback, thisArg) {
    const observed = this;
    const target = observed["__v_raw"];
    const rawTarget = toRaw(target);
    const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly2, isShallow) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap$2(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size$2(this);
    },
    has: has$1$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size$2(this);
    },
    has: has$1$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size$2(this, true);
    },
    has(key) {
      return has$1$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size$2(this, true);
    },
    has(key) {
      return has$1$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn$4(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive(target) {
  if (target && target["__v_isReadonly"]) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
  return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$3(target)) {
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function isReactive(value) {
  if (isReadonly(value)) {
    return isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
function isProxy(value) {
  return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
  def(value, "__v_skip", true);
  return value;
}
const toReactive = (value) => isObject$3(value) ? reactive(value) : value;
const toReadonly = (value) => isObject$3(value) ? readonly(value) : value;
function trackRefValue(ref2) {
  if (isTracking()) {
    ref2 = toRaw(ref2);
    if (!ref2.dep) {
      ref2.dep = createDep();
    }
    {
      trackEffects(ref2.dep);
    }
  }
}
function triggerRefValue(ref2, newVal) {
  ref2 = toRaw(ref2);
  if (ref2.dep) {
    {
      triggerEffects(ref2.dep);
    }
  }
}
function isRef(r) {
  return Boolean(r && r.__v_isRef === true);
}
function ref(value) {
  return createRef(value, false);
}
function shallowRef(value) {
  return createRef(value, true);
}
function createRef(rawValue, shallow) {
  if (isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, _shallow) {
    this._shallow = _shallow;
    this.dep = void 0;
    this.__v_isRef = true;
    this._rawValue = _shallow ? value : toRaw(value);
    this._value = _shallow ? value : toReactive(value);
  }
  get value() {
    trackRefValue(this);
    return this._value;
  }
  set value(newVal) {
    newVal = this._shallow ? newVal : toRaw(newVal);
    if (hasChanged(newVal, this._rawValue)) {
      this._rawValue = newVal;
      this._value = this._shallow ? newVal : toReactive(newVal);
      triggerRefValue(this);
    }
  }
}
function triggerRef(ref2) {
  triggerRefValue(ref2);
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (isRef(oldValue) && !isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
function toRefs(object) {
  const ret = isArray$c(object) ? new Array(object.length) : {};
  for (const key in object) {
    ret[key] = toRef(object, key);
  }
  return ret;
}
class ObjectRefImpl {
  constructor(_object, _key) {
    this._object = _object;
    this._key = _key;
    this.__v_isRef = true;
  }
  get value() {
    return this._object[this._key];
  }
  set value(newVal) {
    this._object[this._key] = newVal;
  }
}
function toRef(object, key) {
  const val = object[key];
  return isRef(val) ? val : new ObjectRefImpl(object, key);
}
class ComputedRefImpl {
  constructor(getter, _setter, isReadonly2) {
    this._setter = _setter;
    this.dep = void 0;
    this._dirty = true;
    this.__v_isRef = true;
    this.effect = new ReactiveEffect(getter, () => {
      if (!this._dirty) {
        this._dirty = true;
        triggerRefValue(this);
      }
    });
    this["__v_isReadonly"] = isReadonly2;
  }
  get value() {
    const self2 = toRaw(this);
    trackRefValue(self2);
    if (self2._dirty) {
      self2._dirty = false;
      self2._value = self2.effect.run();
    }
    return self2._value;
  }
  set value(newValue) {
    this._setter(newValue);
  }
}
function computed(getterOrOptions, debugOptions) {
  let getter;
  let setter;
  const onlyGetter = isFunction$4(getterOrOptions);
  if (onlyGetter) {
    getter = getterOrOptions;
    setter = NOOP;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter);
  return cRef;
}
Promise.resolve();
function emit$1(instance, event, ...rawArgs) {
  const props2 = instance.vnode.props || EMPTY_OBJ;
  let args = rawArgs;
  const isModelListener2 = event.startsWith("update:");
  const modelArg = isModelListener2 && event.slice(7);
  if (modelArg && modelArg in props2) {
    const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
    const { number, trim: trim2 } = props2[modifiersKey] || EMPTY_OBJ;
    if (trim2) {
      args = rawArgs.map((a) => a.trim());
    } else if (number) {
      args = rawArgs.map(toNumber);
    }
  }
  let handlerName;
  let handler = props2[handlerName = toHandlerKey(event)] || props2[handlerName = toHandlerKey(camelize(event))];
  if (!handler && isModelListener2) {
    handler = props2[handlerName = toHandlerKey(hyphenate(event))];
  }
  if (handler) {
    callWithAsyncErrorHandling(handler, instance, 6, args);
  }
  const onceHandler = props2[handlerName + `Once`];
  if (onceHandler) {
    if (!instance.emitted) {
      instance.emitted = {};
    } else if (instance.emitted[handlerName]) {
      return;
    }
    instance.emitted[handlerName] = true;
    callWithAsyncErrorHandling(onceHandler, instance, 6, args);
  }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.emitsCache;
  const cached = cache.get(comp);
  if (cached !== void 0) {
    return cached;
  }
  const raw = comp.emits;
  let normalized = {};
  let hasExtends = false;
  if (!isFunction$4(comp)) {
    const extendEmits = (raw2) => {
      const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
      if (normalizedFromExtend) {
        hasExtends = true;
        extend$2(normalized, normalizedFromExtend);
      }
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendEmits);
    }
    if (comp.extends) {
      extendEmits(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendEmits);
    }
  }
  if (!raw && !hasExtends) {
    cache.set(comp, null);
    return null;
  }
  if (isArray$c(raw)) {
    raw.forEach((key) => normalized[key] = null);
  } else {
    extend$2(normalized, raw);
  }
  cache.set(comp, normalized);
  return normalized;
}
function isEmitListener(options, key) {
  if (!options || !isOn(key)) {
    return false;
  }
  key = key.slice(2).replace(/Once$/, "");
  return hasOwn$4(options, key[0].toLowerCase() + key.slice(1)) || hasOwn$4(options, hyphenate(key)) || hasOwn$4(options, key);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
  const prev2 = currentRenderingInstance;
  currentRenderingInstance = instance;
  currentScopeId = instance && instance.type.__scopeId || null;
  return prev2;
}
function pushScopeId(id) {
  currentScopeId = id;
}
function popScopeId() {
  currentScopeId = null;
}
function withCtx(fn2, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx)
    return fn2;
  if (fn2._n) {
    return fn2;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    const res = fn2(...args);
    setCurrentRenderingInstance(prevInstance);
    if (renderFnWithContext._d) {
      setBlockTracking(1);
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
function markAttrsAccessed() {
}
function renderComponentRoot(instance) {
  const { type: Component, vnode, proxy, withProxy, props: props2, propsOptions: [propsOptions], slots, attrs, emit, render: render2, renderCache, data: data2, setupState, ctx, inheritAttrs } = instance;
  let result;
  let fallthroughAttrs;
  const prev2 = setCurrentRenderingInstance(instance);
  try {
    if (vnode.shapeFlag & 4) {
      const proxyToUse = withProxy || proxy;
      result = normalizeVNode(render2.call(proxyToUse, proxyToUse, renderCache, props2, setupState, data2, ctx));
      fallthroughAttrs = attrs;
    } else {
      const render3 = Component;
      if (false)
        ;
      result = normalizeVNode(render3.length > 1 ? render3(props2, false ? {
        get attrs() {
          markAttrsAccessed();
          return attrs;
        },
        slots,
        emit
      } : { attrs, slots, emit }) : render3(props2, null));
      fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
    }
  } catch (err) {
    blockStack.length = 0;
    handleError(err, instance, 1);
    result = createVNode(Comment);
  }
  let root = result;
  if (fallthroughAttrs && inheritAttrs !== false) {
    const keys3 = Object.keys(fallthroughAttrs);
    const { shapeFlag } = root;
    if (keys3.length) {
      if (shapeFlag & (1 | 6)) {
        if (propsOptions && keys3.some(isModelListener)) {
          fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
        }
        root = cloneVNode(root, fallthroughAttrs);
      }
    }
  }
  if (vnode.dirs) {
    root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
  }
  if (vnode.transition) {
    root.transition = vnode.transition;
  }
  {
    result = root;
  }
  setCurrentRenderingInstance(prev2);
  return result;
}
const getFunctionalFallthrough = (attrs) => {
  let res;
  for (const key in attrs) {
    if (key === "class" || key === "style" || isOn(key)) {
      (res || (res = {}))[key] = attrs[key];
    }
  }
  return res;
};
const filterModelListeners = (attrs, props2) => {
  const res = {};
  for (const key in attrs) {
    if (!isModelListener(key) || !(key.slice(9) in props2)) {
      res[key] = attrs[key];
    }
  }
  return res;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
  const { props: prevProps, children: prevChildren, component } = prevVNode;
  const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
  const emits = component.emitsOptions;
  if (nextVNode.dirs || nextVNode.transition) {
    return true;
  }
  if (optimized && patchFlag >= 0) {
    if (patchFlag & 1024) {
      return true;
    }
    if (patchFlag & 16) {
      if (!prevProps) {
        return !!nextProps;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    } else if (patchFlag & 8) {
      const dynamicProps = nextVNode.dynamicProps;
      for (let i2 = 0; i2 < dynamicProps.length; i2++) {
        const key = dynamicProps[i2];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
          return true;
        }
      }
    }
  } else {
    if (prevChildren || nextChildren) {
      if (!nextChildren || !nextChildren.$stable) {
        return true;
      }
    }
    if (prevProps === nextProps) {
      return false;
    }
    if (!prevProps) {
      return !!nextProps;
    }
    if (!nextProps) {
      return true;
    }
    return hasPropsChanged(prevProps, nextProps, emits);
  }
  return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
  const nextKeys = Object.keys(nextProps);
  if (nextKeys.length !== Object.keys(prevProps).length) {
    return true;
  }
  for (let i2 = 0; i2 < nextKeys.length; i2++) {
    const key = nextKeys[i2];
    if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
      return true;
    }
  }
  return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
  while (parent && parent.subTree === vnode) {
    (vnode = parent.vnode).el = el;
    parent = parent.parent;
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn2, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray$c(fn2)) {
      suspense.effects.push(...fn2);
    } else {
      suspense.effects.push(fn2);
    }
  } else {
    queuePostFlushCb(fn2);
  }
}
function provide(key, value) {
  if (!currentInstance)
    ;
  else {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance = currentInstance || currentRenderingInstance;
  if (instance) {
    const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction$4(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    } else
      ;
  }
}
function useTransitionState() {
  const state = {
    isMounted: false,
    isLeaving: false,
    isUnmounting: false,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  onMounted(() => {
    state.isMounted = true;
  });
  onBeforeUnmount(() => {
    state.isUnmounting = true;
  });
  return state;
}
const TransitionHookValidator = [Function, Array];
const BaseTransitionImpl = {
  name: `BaseTransition`,
  props: {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
  },
  setup(props2, { slots }) {
    const instance = getCurrentInstance();
    const state = useTransitionState();
    let prevTransitionKey;
    return () => {
      const children = slots.default && getTransitionRawChildren(slots.default(), true);
      if (!children || !children.length) {
        return;
      }
      const rawProps = toRaw(props2);
      const { mode } = rawProps;
      const child = children[0];
      if (state.isLeaving) {
        return emptyPlaceholder(child);
      }
      const innerChild = getKeepAliveChild(child);
      if (!innerChild) {
        return emptyPlaceholder(child);
      }
      const enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
      setTransitionHooks(innerChild, enterHooks);
      const oldChild = instance.subTree;
      const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
      let transitionKeyChanged = false;
      const { getTransitionKey } = innerChild.type;
      if (getTransitionKey) {
        const key = getTransitionKey();
        if (prevTransitionKey === void 0) {
          prevTransitionKey = key;
        } else if (key !== prevTransitionKey) {
          prevTransitionKey = key;
          transitionKeyChanged = true;
        }
      }
      if (oldInnerChild && oldInnerChild.type !== Comment && (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
        const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
        setTransitionHooks(oldInnerChild, leavingHooks);
        if (mode === "out-in") {
          state.isLeaving = true;
          leavingHooks.afterLeave = () => {
            state.isLeaving = false;
            instance.update();
          };
          return emptyPlaceholder(child);
        } else if (mode === "in-out" && innerChild.type !== Comment) {
          leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
            const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
            leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
            el._leaveCb = () => {
              earlyRemove();
              el._leaveCb = void 0;
              delete enterHooks.delayedLeave;
            };
            enterHooks.delayedLeave = delayedLeave;
          };
        }
      }
      return child;
    };
  }
};
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
  const { leavingVNodes } = state;
  let leavingVNodesCache = leavingVNodes.get(vnode.type);
  if (!leavingVNodesCache) {
    leavingVNodesCache = /* @__PURE__ */ Object.create(null);
    leavingVNodes.set(vnode.type, leavingVNodesCache);
  }
  return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props2, state, instance) {
  const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props2;
  const key = String(vnode.key);
  const leavingVNodesCache = getLeavingNodesForType(state, vnode);
  const callHook2 = (hook, args) => {
    hook && callWithAsyncErrorHandling(hook, instance, 9, args);
  };
  const hooks = {
    mode,
    persisted,
    beforeEnter(el) {
      let hook = onBeforeEnter;
      if (!state.isMounted) {
        if (appear) {
          hook = onBeforeAppear || onBeforeEnter;
        } else {
          return;
        }
      }
      if (el._leaveCb) {
        el._leaveCb(true);
      }
      const leavingVNode = leavingVNodesCache[key];
      if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) {
        leavingVNode.el._leaveCb();
      }
      callHook2(hook, [el]);
    },
    enter(el) {
      let hook = onEnter;
      let afterHook = onAfterEnter;
      let cancelHook = onEnterCancelled;
      if (!state.isMounted) {
        if (appear) {
          hook = onAppear || onEnter;
          afterHook = onAfterAppear || onAfterEnter;
          cancelHook = onAppearCancelled || onEnterCancelled;
        } else {
          return;
        }
      }
      let called = false;
      const done = el._enterCb = (cancelled) => {
        if (called)
          return;
        called = true;
        if (cancelled) {
          callHook2(cancelHook, [el]);
        } else {
          callHook2(afterHook, [el]);
        }
        if (hooks.delayedLeave) {
          hooks.delayedLeave();
        }
        el._enterCb = void 0;
      };
      if (hook) {
        hook(el, done);
        if (hook.length <= 1) {
          done();
        }
      } else {
        done();
      }
    },
    leave(el, remove2) {
      const key2 = String(vnode.key);
      if (el._enterCb) {
        el._enterCb(true);
      }
      if (state.isUnmounting) {
        return remove2();
      }
      callHook2(onBeforeLeave, [el]);
      let called = false;
      const done = el._leaveCb = (cancelled) => {
        if (called)
          return;
        called = true;
        remove2();
        if (cancelled) {
          callHook2(onLeaveCancelled, [el]);
        } else {
          callHook2(onAfterLeave, [el]);
        }
        el._leaveCb = void 0;
        if (leavingVNodesCache[key2] === vnode) {
          delete leavingVNodesCache[key2];
        }
      };
      leavingVNodesCache[key2] = vnode;
      if (onLeave) {
        onLeave(el, done);
        if (onLeave.length <= 1) {
          done();
        }
      } else {
        done();
      }
    },
    clone(vnode2) {
      return resolveTransitionHooks(vnode2, props2, state, instance);
    }
  };
  return hooks;
}
function emptyPlaceholder(vnode) {
  if (isKeepAlive(vnode)) {
    vnode = cloneVNode(vnode);
    vnode.children = null;
    return vnode;
  }
}
function getKeepAliveChild(vnode) {
  return isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    setTransitionHooks(vnode.component.subTree, hooks);
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
function getTransitionRawChildren(children, keepComment = false) {
  let ret = [];
  let keyedFragmentCount = 0;
  for (let i2 = 0; i2 < children.length; i2++) {
    const child = children[i2];
    if (child.type === Fragment) {
      if (child.patchFlag & 128)
        keyedFragmentCount++;
      ret = ret.concat(getTransitionRawChildren(child.children, keepComment));
    } else if (keepComment || child.type !== Comment) {
      ret.push(child);
    }
  }
  if (keyedFragmentCount > 1) {
    for (let i2 = 0; i2 < ret.length; i2++) {
      ret[i2].patchFlag = -2;
    }
  }
  return ret;
}
function defineComponent(options) {
  return isFunction$4(options) ? { setup: options, name: options.name } : options;
}
const isAsyncWrapper = (i2) => !!i2.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
  registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
  registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
  const wrappedHook = hook.__wdc || (hook.__wdc = () => {
    let current = target;
    while (current) {
      if (current.isDeactivated) {
        return;
      }
      current = current.parent;
    }
    hook();
  });
  injectHook(type, wrappedHook, target);
  if (target) {
    let current = target.parent;
    while (current && current.parent) {
      if (isKeepAlive(current.parent.vnode)) {
        injectToKeepAliveRoot(wrappedHook, type, target, current);
      }
      current = current.parent;
    }
  }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
  const injected = injectHook(type, hook, keepAliveRoot, true);
  onUnmounted(() => {
    remove(keepAliveRoot[type], injected);
  }, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      if (target.isUnmounted) {
        return;
      }
      pauseTracking();
      setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      unsetCurrentInstance();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, hook, target);
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
  injectHook("ec", hook, target);
}
let shouldCacheAccess = true;
function applyOptions(instance) {
  const options = resolveMergedOptions(instance);
  const publicThis = instance.proxy;
  const ctx = instance.ctx;
  shouldCacheAccess = false;
  if (options.beforeCreate) {
    callHook(options.beforeCreate, instance, "bc");
  }
  const {
    data: dataOptions,
    computed: computedOptions,
    methods,
    watch: watchOptions,
    provide: provideOptions,
    inject: injectOptions,
    created,
    beforeMount,
    mounted,
    beforeUpdate,
    updated,
    activated,
    deactivated,
    beforeDestroy,
    beforeUnmount,
    destroyed,
    unmounted,
    render: render2,
    renderTracked,
    renderTriggered,
    errorCaptured,
    serverPrefetch,
    expose,
    inheritAttrs,
    components,
    directives,
    filters
  } = options;
  const checkDuplicateProperties = null;
  if (injectOptions) {
    resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
  }
  if (methods) {
    for (const key in methods) {
      const methodHandler = methods[key];
      if (isFunction$4(methodHandler)) {
        {
          ctx[key] = methodHandler.bind(publicThis);
        }
      }
    }
  }
  if (dataOptions) {
    const data2 = dataOptions.call(publicThis, publicThis);
    if (!isObject$3(data2))
      ;
    else {
      instance.data = reactive(data2);
    }
  }
  shouldCacheAccess = true;
  if (computedOptions) {
    for (const key in computedOptions) {
      const opt = computedOptions[key];
      const get2 = isFunction$4(opt) ? opt.bind(publicThis, publicThis) : isFunction$4(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
      const set2 = !isFunction$4(opt) && isFunction$4(opt.set) ? opt.set.bind(publicThis) : NOOP;
      const c = computed({
        get: get2,
        set: set2
      });
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => c.value,
        set: (v2) => c.value = v2
      });
    }
  }
  if (watchOptions) {
    for (const key in watchOptions) {
      createWatcher(watchOptions[key], ctx, publicThis, key);
    }
  }
  if (provideOptions) {
    const provides = isFunction$4(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
    Reflect.ownKeys(provides).forEach((key) => {
      provide(key, provides[key]);
    });
  }
  if (created) {
    callHook(created, instance, "c");
  }
  function registerLifecycleHook(register, hook) {
    if (isArray$c(hook)) {
      hook.forEach((_hook) => register(_hook.bind(publicThis)));
    } else if (hook) {
      register(hook.bind(publicThis));
    }
  }
  registerLifecycleHook(onBeforeMount, beforeMount);
  registerLifecycleHook(onMounted, mounted);
  registerLifecycleHook(onBeforeUpdate, beforeUpdate);
  registerLifecycleHook(onUpdated, updated);
  registerLifecycleHook(onActivated, activated);
  registerLifecycleHook(onDeactivated, deactivated);
  registerLifecycleHook(onErrorCaptured, errorCaptured);
  registerLifecycleHook(onRenderTracked, renderTracked);
  registerLifecycleHook(onRenderTriggered, renderTriggered);
  registerLifecycleHook(onBeforeUnmount, beforeUnmount);
  registerLifecycleHook(onUnmounted, unmounted);
  registerLifecycleHook(onServerPrefetch, serverPrefetch);
  if (isArray$c(expose)) {
    if (expose.length) {
      const exposed = instance.exposed || (instance.exposed = {});
      expose.forEach((key) => {
        Object.defineProperty(exposed, key, {
          get: () => publicThis[key],
          set: (val) => publicThis[key] = val
        });
      });
    } else if (!instance.exposed) {
      instance.exposed = {};
    }
  }
  if (render2 && instance.render === NOOP) {
    instance.render = render2;
  }
  if (inheritAttrs != null) {
    instance.inheritAttrs = inheritAttrs;
  }
  if (components)
    instance.components = components;
  if (directives)
    instance.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP, unwrapRef = false) {
  if (isArray$c(injectOptions)) {
    injectOptions = normalizeInject(injectOptions);
  }
  for (const key in injectOptions) {
    const opt = injectOptions[key];
    let injected;
    if (isObject$3(opt)) {
      if ("default" in opt) {
        injected = inject(opt.from || key, opt.default, true);
      } else {
        injected = inject(opt.from || key);
      }
    } else {
      injected = inject(opt);
    }
    if (isRef(injected)) {
      if (unwrapRef) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v2) => injected.value = v2
        });
      } else {
        ctx[key] = injected;
      }
    } else {
      ctx[key] = injected;
    }
  }
}
function callHook(hook, instance, type) {
  callWithAsyncErrorHandling(isArray$c(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
  const getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
  if (isString$5(raw)) {
    const handler = ctx[raw];
    if (isFunction$4(handler)) {
      watch(getter, handler);
    }
  } else if (isFunction$4(raw)) {
    watch(getter, raw.bind(publicThis));
  } else if (isObject$3(raw)) {
    if (isArray$c(raw)) {
      raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
    } else {
      const handler = isFunction$4(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
      if (isFunction$4(handler)) {
        watch(getter, handler, raw);
      }
    }
  } else
    ;
}
function resolveMergedOptions(instance) {
  const base = instance.type;
  const { mixins, extends: extendsOptions } = base;
  const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
  const cached = cache.get(base);
  let resolved;
  if (cached) {
    resolved = cached;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach((m2) => mergeOptions(resolved, m2, optionMergeStrategies, true));
    }
    mergeOptions(resolved, base, optionMergeStrategies);
  }
  cache.set(base, resolved);
  return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from;
  if (extendsOptions) {
    mergeOptions(to, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach((m2) => mergeOptions(to, m2, strats, true));
  }
  for (const key in from) {
    if (asMixin && key === "expose")
      ;
    else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
  }
  return to;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeObjectOptions,
  emits: mergeObjectOptions,
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  watch: mergeWatchOptions,
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to, from) {
  if (!from) {
    return to;
  }
  if (!to) {
    return from;
  }
  return function mergedDataFn() {
    return extend$2(isFunction$4(to) ? to.call(this, this) : to, isFunction$4(from) ? from.call(this, this) : from);
  };
}
function mergeInject(to, from) {
  return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
  if (isArray$c(raw)) {
    const res = {};
    for (let i2 = 0; i2 < raw.length; i2++) {
      res[raw[i2]] = raw[i2];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to, from) {
  return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
  return to ? extend$2(extend$2(/* @__PURE__ */ Object.create(null), to), from) : from;
}
function mergeWatchOptions(to, from) {
  if (!to)
    return from;
  if (!from)
    return to;
  const merged = extend$2(/* @__PURE__ */ Object.create(null), to);
  for (const key in from) {
    merged[key] = mergeAsArray(to[key], from[key]);
  }
  return merged;
}
function initProps(instance, rawProps, isStateful, isSSR = false) {
  const props2 = {};
  const attrs = {};
  def(attrs, InternalObjectKey, 1);
  instance.propsDefaults = /* @__PURE__ */ Object.create(null);
  setFullProps(instance, rawProps, props2, attrs);
  for (const key in instance.propsOptions[0]) {
    if (!(key in props2)) {
      props2[key] = void 0;
    }
  }
  if (isStateful) {
    instance.props = isSSR ? props2 : shallowReactive(props2);
  } else {
    if (!instance.type.props) {
      instance.props = attrs;
    } else {
      instance.props = props2;
    }
  }
  instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
  const { props: props2, attrs, vnode: { patchFlag } } = instance;
  const rawCurrentProps = toRaw(props2);
  const [options] = instance.propsOptions;
  let hasAttrsChanged = false;
  if ((optimized || patchFlag > 0) && !(patchFlag & 16)) {
    if (patchFlag & 8) {
      const propsToUpdate = instance.vnode.dynamicProps;
      for (let i2 = 0; i2 < propsToUpdate.length; i2++) {
        let key = propsToUpdate[i2];
        const value = rawProps[key];
        if (options) {
          if (hasOwn$4(attrs, key)) {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          } else {
            const camelizedKey = camelize(key);
            props2[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
          }
        } else {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
  } else {
    if (setFullProps(instance, rawProps, props2, attrs)) {
      hasAttrsChanged = true;
    }
    let kebabKey;
    for (const key in rawCurrentProps) {
      if (!rawProps || !hasOwn$4(rawProps, key) && ((kebabKey = hyphenate(key)) === key || !hasOwn$4(rawProps, kebabKey))) {
        if (options) {
          if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) {
            props2[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
          }
        } else {
          delete props2[key];
        }
      }
    }
    if (attrs !== rawCurrentProps) {
      for (const key in attrs) {
        if (!rawProps || !hasOwn$4(rawProps, key)) {
          delete attrs[key];
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (hasAttrsChanged) {
    trigger(instance, "set", "$attrs");
  }
}
function setFullProps(instance, rawProps, props2, attrs) {
  const [options, needCastKeys] = instance.propsOptions;
  let hasAttrsChanged = false;
  let rawCastValues;
  if (rawProps) {
    for (let key in rawProps) {
      if (isReservedProp(key)) {
        continue;
      }
      const value = rawProps[key];
      let camelKey;
      if (options && hasOwn$4(options, camelKey = camelize(key))) {
        if (!needCastKeys || !needCastKeys.includes(camelKey)) {
          props2[camelKey] = value;
        } else {
          (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        }
      } else if (!isEmitListener(instance.emitsOptions, key)) {
        if (value !== attrs[key]) {
          attrs[key] = value;
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (needCastKeys) {
    const rawCurrentProps = toRaw(props2);
    const castValues = rawCastValues || EMPTY_OBJ;
    for (let i2 = 0; i2 < needCastKeys.length; i2++) {
      const key = needCastKeys[i2];
      props2[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !hasOwn$4(castValues, key));
    }
  }
  return hasAttrsChanged;
}
function resolvePropValue(options, props2, key, value, instance, isAbsent) {
  const opt = options[key];
  if (opt != null) {
    const hasDefault = hasOwn$4(opt, "default");
    if (hasDefault && value === void 0) {
      const defaultValue = opt.default;
      if (opt.type !== Function && isFunction$4(defaultValue)) {
        const { propsDefaults } = instance;
        if (key in propsDefaults) {
          value = propsDefaults[key];
        } else {
          setCurrentInstance(instance);
          value = propsDefaults[key] = defaultValue.call(null, props2);
          unsetCurrentInstance();
        }
      } else {
        value = defaultValue;
      }
    }
    if (opt[0]) {
      if (isAbsent && !hasDefault) {
        value = false;
      } else if (opt[1] && (value === "" || value === hyphenate(key))) {
        value = true;
      }
    }
  }
  return value;
}
function normalizePropsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.propsCache;
  const cached = cache.get(comp);
  if (cached) {
    return cached;
  }
  const raw = comp.props;
  const normalized = {};
  const needCastKeys = [];
  let hasExtends = false;
  if (!isFunction$4(comp)) {
    const extendProps = (raw2) => {
      hasExtends = true;
      const [props2, keys3] = normalizePropsOptions(raw2, appContext, true);
      extend$2(normalized, props2);
      if (keys3)
        needCastKeys.push(...keys3);
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendProps);
    }
    if (comp.extends) {
      extendProps(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendProps);
    }
  }
  if (!raw && !hasExtends) {
    cache.set(comp, EMPTY_ARR);
    return EMPTY_ARR;
  }
  if (isArray$c(raw)) {
    for (let i2 = 0; i2 < raw.length; i2++) {
      const normalizedKey = camelize(raw[i2]);
      if (validatePropName(normalizedKey)) {
        normalized[normalizedKey] = EMPTY_OBJ;
      }
    }
  } else if (raw) {
    for (const key in raw) {
      const normalizedKey = camelize(key);
      if (validatePropName(normalizedKey)) {
        const opt = raw[key];
        const prop = normalized[normalizedKey] = isArray$c(opt) || isFunction$4(opt) ? { type: opt } : opt;
        if (prop) {
          const booleanIndex = getTypeIndex(Boolean, prop.type);
          const stringIndex = getTypeIndex(String, prop.type);
          prop[0] = booleanIndex > -1;
          prop[1] = stringIndex < 0 || booleanIndex < stringIndex;
          if (booleanIndex > -1 || hasOwn$4(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
  }
  const res = [normalized, needCastKeys];
  cache.set(comp, res);
  return res;
}
function validatePropName(key) {
  if (key[0] !== "$") {
    return true;
  }
  return false;
}
function getType(ctor) {
  const match2 = ctor && ctor.toString().match(/^\s*function (\w+)/);
  return match2 ? match2[1] : ctor === null ? "null" : "";
}
function isSameType(a, b) {
  return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
  if (isArray$c(expectedTypes)) {
    return expectedTypes.findIndex((t) => isSameType(t, type));
  } else if (isFunction$4(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  return -1;
}
const isInternalKey = (key) => key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value) => isArray$c(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
  const normalized = withCtx((...args) => {
    return normalizeSlotValue(rawSlot(...args));
  }, ctx);
  normalized._c = false;
  return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance) => {
  const ctx = rawSlots._ctx;
  for (const key in rawSlots) {
    if (isInternalKey(key))
      continue;
    const value = rawSlots[key];
    if (isFunction$4(value)) {
      slots[key] = normalizeSlot(key, value, ctx);
    } else if (value != null) {
      const normalized = normalizeSlotValue(value);
      slots[key] = () => normalized;
    }
  }
};
const normalizeVNodeSlots = (instance, children) => {
  const normalized = normalizeSlotValue(children);
  instance.slots.default = () => normalized;
};
const initSlots = (instance, children) => {
  if (instance.vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      instance.slots = toRaw(children);
      def(children, "_", type);
    } else {
      normalizeObjectSlots(children, instance.slots = {});
    }
  } else {
    instance.slots = {};
    if (children) {
      normalizeVNodeSlots(instance, children);
    }
  }
  def(instance.slots, InternalObjectKey, 1);
};
const updateSlots = (instance, children, optimized) => {
  const { vnode, slots } = instance;
  let needDeletionCheck = true;
  let deletionComparisonTarget = EMPTY_OBJ;
  if (vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      if (optimized && type === 1) {
        needDeletionCheck = false;
      } else {
        extend$2(slots, children);
        if (!optimized && type === 1) {
          delete slots._;
        }
      }
    } else {
      needDeletionCheck = !children.$stable;
      normalizeObjectSlots(children, slots);
    }
    deletionComparisonTarget = children;
  } else if (children) {
    normalizeVNodeSlots(instance, children);
    deletionComparisonTarget = { default: 1 };
  }
  if (needDeletionCheck) {
    for (const key in slots) {
      if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
        delete slots[key];
      }
    }
  }
};
function withDirectives(vnode, directives) {
  const internalInstance = currentRenderingInstance;
  if (internalInstance === null) {
    return vnode;
  }
  const instance = internalInstance.proxy;
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i2 = 0; i2 < directives.length; i2++) {
    let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i2];
    if (isFunction$4(dir)) {
      dir = {
        mounted: dir,
        updated: dir
      };
    }
    if (dir.deep) {
      traverse(value);
    }
    bindings.push({
      dir,
      instance,
      value,
      oldValue: void 0,
      arg,
      modifiers
    });
  }
  return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
  const bindings = vnode.dirs;
  const oldBindings = prevVNode && prevVNode.dirs;
  for (let i2 = 0; i2 < bindings.length; i2++) {
    const binding = bindings[i2];
    if (oldBindings) {
      binding.oldValue = oldBindings[i2].value;
    }
    let hook = binding.dir[name];
    if (hook) {
      pauseTracking();
      callWithAsyncErrorHandling(hook, instance, 8, [
        vnode.el,
        binding,
        vnode,
        prevVNode
      ]);
      resetTracking();
    }
  }
}
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO,
      performance: false,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid = 0;
function createAppAPI(render2, hydrate) {
  return function createApp(rootComponent, rootProps = null) {
    if (rootProps != null && !isObject$3(rootProps)) {
      rootProps = null;
    }
    const context = createAppContext();
    const installedPlugins = /* @__PURE__ */ new Set();
    let isMounted = false;
    const app = context.app = {
      _uid: uid++,
      _component: rootComponent,
      _props: rootProps,
      _container: null,
      _context: context,
      _instance: null,
      version,
      get config() {
        return context.config;
      },
      set config(v2) {
      },
      use(plugin, ...options) {
        if (installedPlugins.has(plugin))
          ;
        else if (plugin && isFunction$4(plugin.install)) {
          installedPlugins.add(plugin);
          plugin.install(app, ...options);
        } else if (isFunction$4(plugin)) {
          installedPlugins.add(plugin);
          plugin(app, ...options);
        } else
          ;
        return app;
      },
      mixin(mixin) {
        {
          if (!context.mixins.includes(mixin)) {
            context.mixins.push(mixin);
          }
        }
        return app;
      },
      component(name, component) {
        if (!component) {
          return context.components[name];
        }
        context.components[name] = component;
        return app;
      },
      directive(name, directive) {
        if (!directive) {
          return context.directives[name];
        }
        context.directives[name] = directive;
        return app;
      },
      mount(rootContainer, isHydrate, isSVG) {
        if (!isMounted) {
          const vnode = createVNode(rootComponent, rootProps);
          vnode.appContext = context;
          if (isHydrate && hydrate) {
            hydrate(vnode, rootContainer);
          } else {
            render2(vnode, rootContainer, isSVG);
          }
          isMounted = true;
          app._container = rootContainer;
          rootContainer.__vue_app__ = app;
          return getExposeProxy(vnode.component) || vnode.component.proxy;
        }
      },
      unmount() {
        if (isMounted) {
          render2(null, app._container);
          delete app._container.__vue_app__;
        }
      },
      provide(key, value) {
        context.provides[key] = value;
        return app;
      }
    };
    return app;
  };
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
  return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
  const target = getGlobalThis();
  target.__VUE__ = true;
  const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
  const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
    if (n1 === n2) {
      return;
    }
    if (n1 && !isSameVNodeType(n1, n2)) {
      anchor = getNextHostNode(n1);
      unmount(n1, parentComponent, parentSuspense, true);
      n1 = null;
    }
    if (n2.patchFlag === -2) {
      optimized = false;
      n2.dynamicChildren = null;
    }
    const { type, ref: ref2, shapeFlag } = n2;
    switch (type) {
      case Text:
        processText(n1, n2, container, anchor);
        break;
      case Comment:
        processCommentNode(n1, n2, container, anchor);
        break;
      case Static:
        if (n1 == null) {
          mountStaticNode(n2, container, anchor, isSVG);
        }
        break;
      case Fragment:
        processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        break;
      default:
        if (shapeFlag & 1) {
          processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 6) {
          processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 64) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else if (shapeFlag & 128) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else
          ;
    }
    if (ref2 != null && parentComponent) {
      setRef(ref2, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    }
  };
  const processText = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
    } else {
      const el = n2.el = n1.el;
      if (n2.children !== n1.children) {
        hostSetText(el, n2.children);
      }
    }
  };
  const processCommentNode = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
    } else {
      n2.el = n1.el;
    }
  };
  const mountStaticNode = (n2, container, anchor, isSVG) => {
    [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
  };
  const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostInsert(el, container, nextSibling);
      el = next;
    }
    hostInsert(anchor, container, nextSibling);
  };
  const removeStaticNode = ({ el, anchor }) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostRemove(el);
      el = next;
    }
    hostRemove(anchor);
  };
  const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    isSVG = isSVG || n2.type === "svg";
    if (n1 == null) {
      mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let el;
    let vnodeHook;
    const { type, props: props2, shapeFlag, transition, patchFlag, dirs } = vnode;
    if (vnode.el && hostCloneNode !== void 0 && patchFlag === -1) {
      el = vnode.el = hostCloneNode(vnode.el);
    } else {
      el = vnode.el = hostCreateElement(vnode.type, isSVG, props2 && props2.is, props2);
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      if (props2) {
        for (const key in props2) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props2[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
        if ("value" in props2) {
          hostPatchProp(el, "value", null, props2.value);
        }
        if (vnodeHook = props2.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
    }
    const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
    if (needCallTransitionHooks) {
      transition.beforeEnter(el);
    }
    hostInsert(el, container, anchor);
    if ((vnodeHook = props2 && props2.onVnodeMounted) || needCallTransitionHooks || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        needCallTransitionHooks && transition.enter(el);
        dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
      }, parentSuspense);
    }
  };
  const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
    if (scopeId) {
      hostSetScopeId(el, scopeId);
    }
    if (slotScopeIds) {
      for (let i2 = 0; i2 < slotScopeIds.length; i2++) {
        hostSetScopeId(el, slotScopeIds[i2]);
      }
    }
    if (parentComponent) {
      let subTree = parentComponent.subTree;
      if (vnode === subTree) {
        const parentVNode = parentComponent.vnode;
        setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
      }
    }
  };
  const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start2 = 0) => {
    for (let i2 = start2; i2 < children.length; i2++) {
      const child = children[i2] = optimized ? cloneIfMounted(children[i2]) : normalizeVNode(children[i2]);
      patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const el = n2.el = n1.el;
    let { patchFlag, dynamicChildren, dirs } = n2;
    patchFlag |= n1.patchFlag & 16;
    const oldProps = n1.props || EMPTY_OBJ;
    const newProps = n2.props || EMPTY_OBJ;
    let vnodeHook;
    if (vnodeHook = newProps.onVnodeBeforeUpdate) {
      invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
    }
    if (dirs) {
      invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
    }
    const areChildrenSVG = isSVG && n2.type !== "foreignObject";
    if (dynamicChildren) {
      patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
    } else if (!optimized) {
      patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
    }
    if (patchFlag > 0) {
      if (patchFlag & 16) {
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
      } else {
        if (patchFlag & 2) {
          if (oldProps.class !== newProps.class) {
            hostPatchProp(el, "class", null, newProps.class, isSVG);
          }
        }
        if (patchFlag & 4) {
          hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
        }
        if (patchFlag & 8) {
          const propsToUpdate = n2.dynamicProps;
          for (let i2 = 0; i2 < propsToUpdate.length; i2++) {
            const key = propsToUpdate[i2];
            const prev2 = oldProps[key];
            const next = newProps[key];
            if (next !== prev2 || key === "value") {
              hostPatchProp(el, key, prev2, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
            }
          }
        }
      }
      if (patchFlag & 1) {
        if (n1.children !== n2.children) {
          hostSetElementText(el, n2.children);
        }
      }
    } else if (!optimized && dynamicChildren == null) {
      patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
    }
    if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
      }, parentSuspense);
    }
  };
  const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) => {
    for (let i2 = 0; i2 < newChildren.length; i2++) {
      const oldVNode = oldChildren[i2];
      const newVNode = newChildren[i2];
      const container = oldVNode.el && (oldVNode.type === Fragment || !isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : fallbackContainer;
      patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
    }
  };
  const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
    if (oldProps !== newProps) {
      for (const key in newProps) {
        if (isReservedProp(key))
          continue;
        const next = newProps[key];
        const prev2 = oldProps[key];
        if (next !== prev2 && key !== "value") {
          hostPatchProp(el, key, prev2, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
        }
      }
      if (oldProps !== EMPTY_OBJ) {
        for (const key in oldProps) {
          if (!isReservedProp(key) && !(key in newProps)) {
            hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
      }
      if ("value" in newProps) {
        hostPatchProp(el, "value", oldProps.value, newProps.value);
      }
    }
  };
  const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
    const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
    let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
    if (fragmentSlotScopeIds) {
      slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
    }
    if (n1 == null) {
      hostInsert(fragmentStartAnchor, container, anchor);
      hostInsert(fragmentEndAnchor, container, anchor);
      mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
        if (n2.key != null || parentComponent && n2 === parentComponent.subTree) {
          traverseStaticChildren(n1, n2, true);
        }
      } else {
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
    }
  };
  const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    n2.slotScopeIds = slotScopeIds;
    if (n1 == null) {
      if (n2.shapeFlag & 512) {
        parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
      } else {
        mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
      }
    } else {
      updateComponent(n1, n2, optimized);
    }
  };
  const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
    const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
    if (isKeepAlive(initialVNode)) {
      instance.ctx.renderer = internals;
    }
    {
      setupComponent(instance);
    }
    if (instance.asyncDep) {
      parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
      if (!initialVNode.el) {
        const placeholder = instance.subTree = createVNode(Comment);
        processCommentNode(null, placeholder, container, anchor);
      }
      return;
    }
    setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
  };
  const updateComponent = (n1, n2, optimized) => {
    const instance = n2.component = n1.component;
    if (shouldUpdateComponent(n1, n2, optimized)) {
      if (instance.asyncDep && !instance.asyncResolved) {
        updateComponentPreRender(instance, n2, optimized);
        return;
      } else {
        instance.next = n2;
        invalidateJob(instance.update);
        instance.update();
      }
    } else {
      n2.component = n1.component;
      n2.el = n1.el;
      instance.vnode = n2;
    }
  };
  const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
    const componentUpdateFn = () => {
      if (!instance.isMounted) {
        let vnodeHook;
        const { el, props: props2 } = initialVNode;
        const { bm, m: m2, parent } = instance;
        const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
        effect2.allowRecurse = false;
        if (bm) {
          invokeArrayFns(bm);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props2 && props2.onVnodeBeforeMount)) {
          invokeVNodeHook(vnodeHook, parent, initialVNode);
        }
        effect2.allowRecurse = true;
        if (el && hydrateNode) {
          const hydrateSubTree = () => {
            instance.subTree = renderComponentRoot(instance);
            hydrateNode(el, instance.subTree, instance, parentSuspense, null);
          };
          if (isAsyncWrapperVNode) {
            initialVNode.type.__asyncLoader().then(() => !instance.isUnmounted && hydrateSubTree());
          } else {
            hydrateSubTree();
          }
        } else {
          const subTree = instance.subTree = renderComponentRoot(instance);
          patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
          initialVNode.el = subTree.el;
        }
        if (m2) {
          queuePostRenderEffect(m2, parentSuspense);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props2 && props2.onVnodeMounted)) {
          const scopedInitialVNode = initialVNode;
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
        }
        if (initialVNode.shapeFlag & 256) {
          instance.a && queuePostRenderEffect(instance.a, parentSuspense);
        }
        instance.isMounted = true;
        initialVNode = container = anchor = null;
      } else {
        let { next, bu, u: u2, parent, vnode } = instance;
        let originNext = next;
        let vnodeHook;
        effect2.allowRecurse = false;
        if (next) {
          next.el = vnode.el;
          updateComponentPreRender(instance, next, optimized);
        } else {
          next = vnode;
        }
        if (bu) {
          invokeArrayFns(bu);
        }
        if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
          invokeVNodeHook(vnodeHook, parent, next, vnode);
        }
        effect2.allowRecurse = true;
        const nextTree = renderComponentRoot(instance);
        const prevTree = instance.subTree;
        instance.subTree = nextTree;
        patch(prevTree, nextTree, hostParentNode(prevTree.el), getNextHostNode(prevTree), instance, parentSuspense, isSVG);
        next.el = nextTree.el;
        if (originNext === null) {
          updateHOCHostEl(instance, nextTree.el);
        }
        if (u2) {
          queuePostRenderEffect(u2, parentSuspense);
        }
        if (vnodeHook = next.props && next.props.onVnodeUpdated) {
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
        }
      }
    };
    const effect2 = new ReactiveEffect(componentUpdateFn, () => queueJob(instance.update), instance.scope);
    const update = instance.update = effect2.run.bind(effect2);
    update.id = instance.uid;
    effect2.allowRecurse = update.allowRecurse = true;
    update();
  };
  const updateComponentPreRender = (instance, nextVNode, optimized) => {
    nextVNode.component = instance;
    const prevProps = instance.vnode.props;
    instance.vnode = nextVNode;
    instance.next = null;
    updateProps(instance, nextVNode.props, prevProps, optimized);
    updateSlots(instance, nextVNode.children, optimized);
    pauseTracking();
    flushPreFlushCbs(void 0, instance.update);
    resetTracking();
  };
  const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false) => {
    const c1 = n1 && n1.children;
    const prevShapeFlag = n1 ? n1.shapeFlag : 0;
    const c2 = n2.children;
    const { patchFlag, shapeFlag } = n2;
    if (patchFlag > 0) {
      if (patchFlag & 128) {
        patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      } else if (patchFlag & 256) {
        patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      }
    }
    if (shapeFlag & 8) {
      if (prevShapeFlag & 16) {
        unmountChildren(c1, parentComponent, parentSuspense);
      }
      if (c2 !== c1) {
        hostSetElementText(container, c2);
      }
    } else {
      if (prevShapeFlag & 16) {
        if (shapeFlag & 16) {
          patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else {
          unmountChildren(c1, parentComponent, parentSuspense, true);
        }
      } else {
        if (prevShapeFlag & 8) {
          hostSetElementText(container, "");
        }
        if (shapeFlag & 16) {
          mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      }
    }
  };
  const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    c1 = c1 || EMPTY_ARR;
    c2 = c2 || EMPTY_ARR;
    const oldLength = c1.length;
    const newLength = c2.length;
    const commonLength = Math.min(oldLength, newLength);
    let i2;
    for (i2 = 0; i2 < commonLength; i2++) {
      const nextChild = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
      patch(c1[i2], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
    if (oldLength > newLength) {
      unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
    } else {
      mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    }
  };
  const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let i2 = 0;
    const l2 = c2.length;
    let e1 = c1.length - 1;
    let e2 = l2 - 1;
    while (i2 <= e1 && i2 <= e2) {
      const n1 = c1[i2];
      const n2 = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      i2++;
    }
    while (i2 <= e1 && i2 <= e2) {
      const n1 = c1[e1];
      const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      e1--;
      e2--;
    }
    if (i2 > e1) {
      if (i2 <= e2) {
        const nextPos = e2 + 1;
        const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
        while (i2 <= e2) {
          patch(null, c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          i2++;
        }
      }
    } else if (i2 > e2) {
      while (i2 <= e1) {
        unmount(c1[i2], parentComponent, parentSuspense, true);
        i2++;
      }
    } else {
      const s1 = i2;
      const s2 = i2;
      const keyToNewIndexMap = /* @__PURE__ */ new Map();
      for (i2 = s2; i2 <= e2; i2++) {
        const nextChild = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
        if (nextChild.key != null) {
          keyToNewIndexMap.set(nextChild.key, i2);
        }
      }
      let j;
      let patched = 0;
      const toBePatched = e2 - s2 + 1;
      let moved = false;
      let maxNewIndexSoFar = 0;
      const newIndexToOldIndexMap = new Array(toBePatched);
      for (i2 = 0; i2 < toBePatched; i2++)
        newIndexToOldIndexMap[i2] = 0;
      for (i2 = s1; i2 <= e1; i2++) {
        const prevChild = c1[i2];
        if (patched >= toBePatched) {
          unmount(prevChild, parentComponent, parentSuspense, true);
          continue;
        }
        let newIndex;
        if (prevChild.key != null) {
          newIndex = keyToNewIndexMap.get(prevChild.key);
        } else {
          for (j = s2; j <= e2; j++) {
            if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
              newIndex = j;
              break;
            }
          }
        }
        if (newIndex === void 0) {
          unmount(prevChild, parentComponent, parentSuspense, true);
        } else {
          newIndexToOldIndexMap[newIndex - s2] = i2 + 1;
          if (newIndex >= maxNewIndexSoFar) {
            maxNewIndexSoFar = newIndex;
          } else {
            moved = true;
          }
          patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          patched++;
        }
      }
      const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
      j = increasingNewIndexSequence.length - 1;
      for (i2 = toBePatched - 1; i2 >= 0; i2--) {
        const nextIndex = s2 + i2;
        const nextChild = c2[nextIndex];
        const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
        if (newIndexToOldIndexMap[i2] === 0) {
          patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (moved) {
          if (j < 0 || i2 !== increasingNewIndexSequence[j]) {
            move(nextChild, container, anchor, 2);
          } else {
            j--;
          }
        }
      }
    }
  };
  const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
    const { el, type, transition, children, shapeFlag } = vnode;
    if (shapeFlag & 6) {
      move(vnode.component.subTree, container, anchor, moveType);
      return;
    }
    if (shapeFlag & 128) {
      vnode.suspense.move(container, anchor, moveType);
      return;
    }
    if (shapeFlag & 64) {
      type.move(vnode, container, anchor, internals);
      return;
    }
    if (type === Fragment) {
      hostInsert(el, container, anchor);
      for (let i2 = 0; i2 < children.length; i2++) {
        move(children[i2], container, anchor, moveType);
      }
      hostInsert(vnode.anchor, container, anchor);
      return;
    }
    if (type === Static) {
      moveStaticNode(vnode, container, anchor);
      return;
    }
    const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
    if (needTransition) {
      if (moveType === 0) {
        transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        queuePostRenderEffect(() => transition.enter(el), parentSuspense);
      } else {
        const { leave, delayLeave, afterLeave } = transition;
        const remove3 = () => hostInsert(el, container, anchor);
        const performLeave = () => {
          leave(el, () => {
            remove3();
            afterLeave && afterLeave();
          });
        };
        if (delayLeave) {
          delayLeave(el, remove3, performLeave);
        } else {
          performLeave();
        }
      }
    } else {
      hostInsert(el, container, anchor);
    }
  };
  const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
    const { type, props: props2, ref: ref2, children, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
    if (ref2 != null) {
      setRef(ref2, null, parentSuspense, vnode, true);
    }
    if (shapeFlag & 256) {
      parentComponent.ctx.deactivate(vnode);
      return;
    }
    const shouldInvokeDirs = shapeFlag & 1 && dirs;
    const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
    let vnodeHook;
    if (shouldInvokeVnodeHook && (vnodeHook = props2 && props2.onVnodeBeforeUnmount)) {
      invokeVNodeHook(vnodeHook, parentComponent, vnode);
    }
    if (shapeFlag & 6) {
      unmountComponent(vnode.component, parentSuspense, doRemove);
    } else {
      if (shapeFlag & 128) {
        vnode.suspense.unmount(parentSuspense, doRemove);
        return;
      }
      if (shouldInvokeDirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
      }
      if (shapeFlag & 64) {
        vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
      } else if (dynamicChildren && (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
        unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
      } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
        unmountChildren(children, parentComponent, parentSuspense);
      }
      if (doRemove) {
        remove2(vnode);
      }
    }
    if (shouldInvokeVnodeHook && (vnodeHook = props2 && props2.onVnodeUnmounted) || shouldInvokeDirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
      }, parentSuspense);
    }
  };
  const remove2 = (vnode) => {
    const { type, el, anchor, transition } = vnode;
    if (type === Fragment) {
      removeFragment(el, anchor);
      return;
    }
    if (type === Static) {
      removeStaticNode(vnode);
      return;
    }
    const performRemove = () => {
      hostRemove(el);
      if (transition && !transition.persisted && transition.afterLeave) {
        transition.afterLeave();
      }
    };
    if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
      const { leave, delayLeave } = transition;
      const performLeave = () => leave(el, performRemove);
      if (delayLeave) {
        delayLeave(vnode.el, performRemove, performLeave);
      } else {
        performLeave();
      }
    } else {
      performRemove();
    }
  };
  const removeFragment = (cur, end2) => {
    let next;
    while (cur !== end2) {
      next = hostNextSibling(cur);
      hostRemove(cur);
      cur = next;
    }
    hostRemove(end2);
  };
  const unmountComponent = (instance, parentSuspense, doRemove) => {
    const { bum, scope, update, subTree, um } = instance;
    if (bum) {
      invokeArrayFns(bum);
    }
    scope.stop();
    if (update) {
      update.active = false;
      unmount(subTree, instance, parentSuspense, doRemove);
    }
    if (um) {
      queuePostRenderEffect(um, parentSuspense);
    }
    queuePostRenderEffect(() => {
      instance.isUnmounted = true;
    }, parentSuspense);
    if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
      parentSuspense.deps--;
      if (parentSuspense.deps === 0) {
        parentSuspense.resolve();
      }
    }
  };
  const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start2 = 0) => {
    for (let i2 = start2; i2 < children.length; i2++) {
      unmount(children[i2], parentComponent, parentSuspense, doRemove, optimized);
    }
  };
  const getNextHostNode = (vnode) => {
    if (vnode.shapeFlag & 6) {
      return getNextHostNode(vnode.component.subTree);
    }
    if (vnode.shapeFlag & 128) {
      return vnode.suspense.next();
    }
    return hostNextSibling(vnode.anchor || vnode.el);
  };
  const render2 = (vnode, container, isSVG) => {
    if (vnode == null) {
      if (container._vnode) {
        unmount(container._vnode, null, null, true);
      }
    } else {
      patch(container._vnode || null, vnode, container, null, null, null, isSVG);
    }
    flushPostFlushCbs();
    container._vnode = vnode;
  };
  const internals = {
    p: patch,
    um: unmount,
    m: move,
    r: remove2,
    mt: mountComponent,
    mc: mountChildren,
    pc: patchChildren,
    pbc: patchBlockChildren,
    n: getNextHostNode,
    o: options
  };
  let hydrate;
  let hydrateNode;
  if (createHydrationFns) {
    [hydrate, hydrateNode] = createHydrationFns(internals);
  }
  return {
    render: render2,
    hydrate,
    createApp: createAppAPI(render2, hydrate)
  };
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
  if (isArray$c(rawRef)) {
    rawRef.forEach((r, i2) => setRef(r, oldRawRef && (isArray$c(oldRawRef) ? oldRawRef[i2] : oldRawRef), parentSuspense, vnode, isUnmount));
    return;
  }
  if (isAsyncWrapper(vnode) && !isUnmount) {
    return;
  }
  const refValue = vnode.shapeFlag & 4 ? getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
  const value = isUnmount ? null : refValue;
  const { i: owner, r: ref2 } = rawRef;
  const oldRef = oldRawRef && oldRawRef.r;
  const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
  const setupState = owner.setupState;
  if (oldRef != null && oldRef !== ref2) {
    if (isString$5(oldRef)) {
      refs[oldRef] = null;
      if (hasOwn$4(setupState, oldRef)) {
        setupState[oldRef] = null;
      }
    } else if (isRef(oldRef)) {
      oldRef.value = null;
    }
  }
  if (isString$5(ref2)) {
    const doSet = () => {
      {
        refs[ref2] = value;
      }
      if (hasOwn$4(setupState, ref2)) {
        setupState[ref2] = value;
      }
    };
    if (value) {
      doSet.id = -1;
      queuePostRenderEffect(doSet, parentSuspense);
    } else {
      doSet();
    }
  } else if (isRef(ref2)) {
    const doSet = () => {
      ref2.value = value;
    };
    if (value) {
      doSet.id = -1;
      queuePostRenderEffect(doSet, parentSuspense);
    } else {
      doSet();
    }
  } else if (isFunction$4(ref2)) {
    callWithErrorHandling(ref2, owner, 12, [value, refs]);
  } else
    ;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
  callWithAsyncErrorHandling(hook, instance, 7, [
    vnode,
    prevVNode
  ]);
}
function traverseStaticChildren(n1, n2, shallow = false) {
  const ch1 = n1.children;
  const ch2 = n2.children;
  if (isArray$c(ch1) && isArray$c(ch2)) {
    for (let i2 = 0; i2 < ch1.length; i2++) {
      const c1 = ch1[i2];
      let c2 = ch2[i2];
      if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
        if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
          c2 = ch2[i2] = cloneIfMounted(ch2[i2]);
          c2.el = c1.el;
        }
        if (!shallow)
          traverseStaticChildren(c1, c2);
      }
    }
  }
}
function getSequence(arr) {
  const p2 = arr.slice();
  const result = [0];
  let i2, j, u2, v2, c;
  const len = arr.length;
  for (i2 = 0; i2 < len; i2++) {
    const arrI = arr[i2];
    if (arrI !== 0) {
      j = result[result.length - 1];
      if (arr[j] < arrI) {
        p2[i2] = j;
        result.push(i2);
        continue;
      }
      u2 = 0;
      v2 = result.length - 1;
      while (u2 < v2) {
        c = u2 + v2 >> 1;
        if (arr[result[c]] < arrI) {
          u2 = c + 1;
        } else {
          v2 = c;
        }
      }
      if (arrI < arr[result[u2]]) {
        if (u2 > 0) {
          p2[i2] = result[u2 - 1];
        }
        result[u2] = i2;
      }
    }
  }
  u2 = result.length;
  v2 = result[u2 - 1];
  while (u2-- > 0) {
    result[u2] = v2;
    v2 = p2[v2];
  }
  return result;
}
const isTeleport = (type) => type.__isTeleport;
const COMPONENTS = "components";
function resolveComponent(name, maybeSelfReference) {
  return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol();
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
  const instance = currentRenderingInstance || currentInstance;
  if (instance) {
    const Component = instance.type;
    if (type === COMPONENTS) {
      const selfName = getComponentName(Component);
      if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
        return Component;
      }
    }
    const res = resolve(instance[type] || Component[type], name) || resolve(instance.appContext[type], name);
    if (!res && maybeSelfReference) {
      return Component;
    }
    return res;
  }
}
function resolve(registry, name) {
  return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
}
const Fragment = Symbol(void 0);
const Text = Symbol(void 0);
const Comment = Symbol(void 0);
const Static = Symbol(void 0);
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
  isBlockTreeEnabled += value;
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props2, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(createBaseVNode(type, props2, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props2, children, patchFlag, dynamicProps) {
  return setupBlock(createVNode(type, props2, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
  return n1.type === n2.type && n1.key === n2.key;
}
const InternalObjectKey = `__vInternal`;
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({ ref: ref2 }) => {
  return ref2 != null ? isString$5(ref2) || isRef(ref2) || isFunction$4(ref2) ? { i: currentRenderingInstance, r: ref2 } : ref2 : null;
};
function createBaseVNode(type, props2 = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props: props2,
    key: props2 && normalizeKey(props2),
    ref: props2 && normalizeRef(props2),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString$5(children) ? 8 : 16;
  }
  if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props2 = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    type = Comment;
  }
  if (isVNode(type)) {
    const cloned = cloneVNode(type, props2, true);
    if (children) {
      normalizeChildren(cloned, children);
    }
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props2) {
    props2 = guardReactiveProps(props2);
    let { class: klass, style } = props2;
    if (klass && !isString$5(klass)) {
      props2.class = normalizeClass(klass);
    }
    if (isObject$3(style)) {
      if (isProxy(style) && !isArray$c(style)) {
        style = extend$2({}, style);
      }
      props2.style = normalizeStyle(style);
    }
  }
  const shapeFlag = isString$5(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$3(type) ? 4 : isFunction$4(type) ? 2 : 0;
  return createBaseVNode(type, props2, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props2) {
  if (!props2)
    return null;
  return isProxy(props2) || InternalObjectKey in props2 ? extend$2({}, props2) : props2;
}
function cloneVNode(vnode, extraProps, mergeRef = false) {
  const { props: props2, ref: ref2, patchFlag, children } = vnode;
  const mergedProps = extraProps ? mergeProps(props2 || {}, extraProps) : props2;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? mergeRef && ref2 ? isArray$c(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps) : ref2,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children,
    target: vnode.target,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition: vnode.transition,
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor
  };
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
  const vnode = createVNode(Static, null, content);
  vnode.staticCount = numberOfNodes;
  return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
  if (child == null || typeof child === "boolean") {
    return createVNode(Comment);
  } else if (isArray$c(child)) {
    return createVNode(Fragment, null, child.slice());
  } else if (typeof child === "object") {
    return cloneIfMounted(child);
  } else {
    return createVNode(Text, null, String(child));
  }
}
function cloneIfMounted(child) {
  return child.el === null || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray$c(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !(InternalObjectKey in children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction$4(children)) {
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i2 = 0; i2 < args.length; i2++) {
    const toMerge = args[i2];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (existing !== incoming && !(isArray$c(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
function renderList(source4, renderItem, cache, index2) {
  let ret;
  const cached = cache && cache[index2];
  if (isArray$c(source4) || isString$5(source4)) {
    ret = new Array(source4.length);
    for (let i2 = 0, l = source4.length; i2 < l; i2++) {
      ret[i2] = renderItem(source4[i2], i2, void 0, cached && cached[i2]);
    }
  } else if (typeof source4 === "number") {
    ret = new Array(source4);
    for (let i2 = 0; i2 < source4; i2++) {
      ret[i2] = renderItem(i2 + 1, i2, void 0, cached && cached[i2]);
    }
  } else if (isObject$3(source4)) {
    if (source4[Symbol.iterator]) {
      ret = Array.from(source4, (item, i2) => renderItem(item, i2, void 0, cached && cached[i2]));
    } else {
      const keys3 = Object.keys(source4);
      ret = new Array(keys3.length);
      for (let i2 = 0, l = keys3.length; i2 < l; i2++) {
        const key = keys3[i2];
        ret[i2] = renderItem(source4[key], key, i2, cached && cached[i2]);
      }
    }
  } else {
    ret = [];
  }
  if (cache) {
    cache[index2] = ret;
  }
  return ret;
}
function renderSlot(slots, name, props2 = {}, fallback, noSlotted) {
  if (currentRenderingInstance.isCE) {
    return createVNode("slot", name === "default" ? null : { name }, fallback && fallback());
  }
  let slot = slots[name];
  if (slot && slot._c) {
    slot._d = false;
  }
  openBlock();
  const validSlotContent = slot && ensureValidVNode(slot(props2));
  const rendered = createBlock(Fragment, { key: props2.key || `_${name}` }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
  if (!noSlotted && rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  if (slot && slot._c) {
    slot._d = true;
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child))
      return true;
    if (child.type === Comment)
      return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
const getPublicInstance = (i2) => {
  if (!i2)
    return null;
  if (isStatefulComponent(i2))
    return getExposeProxy(i2) || i2.proxy;
  return getPublicInstance(i2.parent);
};
const publicPropertiesMap = extend$2(/* @__PURE__ */ Object.create(null), {
  $: (i2) => i2,
  $el: (i2) => i2.vnode.el,
  $data: (i2) => i2.data,
  $props: (i2) => i2.props,
  $attrs: (i2) => i2.attrs,
  $slots: (i2) => i2.slots,
  $refs: (i2) => i2.refs,
  $parent: (i2) => getPublicInstance(i2.parent),
  $root: (i2) => getPublicInstance(i2.root),
  $emit: (i2) => i2.emit,
  $options: (i2) => resolveMergedOptions(i2),
  $forceUpdate: (i2) => () => queueJob(i2.update),
  $nextTick: (i2) => nextTick.bind(i2.proxy),
  $watch: (i2) => instanceWatch.bind(i2)
});
const PublicInstanceProxyHandlers = {
  get({ _: instance }, key) {
    const { ctx, setupState, data: data2, props: props2, accessCache, type, appContext } = instance;
    let normalizedProps;
    if (key[0] !== "$") {
      const n = accessCache[key];
      if (n !== void 0) {
        switch (n) {
          case 0:
            return setupState[key];
          case 1:
            return data2[key];
          case 3:
            return ctx[key];
          case 2:
            return props2[key];
        }
      } else if (setupState !== EMPTY_OBJ && hasOwn$4(setupState, key)) {
        accessCache[key] = 0;
        return setupState[key];
      } else if (data2 !== EMPTY_OBJ && hasOwn$4(data2, key)) {
        accessCache[key] = 1;
        return data2[key];
      } else if ((normalizedProps = instance.propsOptions[0]) && hasOwn$4(normalizedProps, key)) {
        accessCache[key] = 2;
        return props2[key];
      } else if (ctx !== EMPTY_OBJ && hasOwn$4(ctx, key)) {
        accessCache[key] = 3;
        return ctx[key];
      } else if (shouldCacheAccess) {
        accessCache[key] = 4;
      }
    }
    const publicGetter = publicPropertiesMap[key];
    let cssModule, globalProperties;
    if (publicGetter) {
      if (key === "$attrs") {
        track(instance, "get", key);
      }
      return publicGetter(instance);
    } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) {
      return cssModule;
    } else if (ctx !== EMPTY_OBJ && hasOwn$4(ctx, key)) {
      accessCache[key] = 3;
      return ctx[key];
    } else if (globalProperties = appContext.config.globalProperties, hasOwn$4(globalProperties, key)) {
      {
        return globalProperties[key];
      }
    } else
      ;
  },
  set({ _: instance }, key, value) {
    const { data: data2, setupState, ctx } = instance;
    if (setupState !== EMPTY_OBJ && hasOwn$4(setupState, key)) {
      setupState[key] = value;
    } else if (data2 !== EMPTY_OBJ && hasOwn$4(data2, key)) {
      data2[key] = value;
    } else if (hasOwn$4(instance.props, key)) {
      return false;
    }
    if (key[0] === "$" && key.slice(1) in instance) {
      return false;
    } else {
      {
        ctx[key] = value;
      }
    }
    return true;
  },
  has({ _: { data: data2, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
    let normalizedProps;
    return accessCache[key] !== void 0 || data2 !== EMPTY_OBJ && hasOwn$4(data2, key) || setupState !== EMPTY_OBJ && hasOwn$4(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn$4(normalizedProps, key) || hasOwn$4(ctx, key) || hasOwn$4(publicPropertiesMap, key) || hasOwn$4(appContext.config.globalProperties, key);
  }
};
const emptyAppContext = createAppContext();
let uid$1 = 0;
function createComponentInstance(vnode, parent, suspense) {
  const type = vnode.type;
  const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
  const instance = {
    uid: uid$1++,
    vnode,
    type,
    parent,
    appContext,
    root: null,
    next: null,
    subTree: null,
    update: null,
    scope: new EffectScope(true),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: parent ? parent.provides : Object.create(appContext.provides),
    accessCache: null,
    renderCache: [],
    components: null,
    directives: null,
    propsOptions: normalizePropsOptions(type, appContext),
    emitsOptions: normalizeEmitsOptions(type, appContext),
    emit: null,
    emitted: null,
    propsDefaults: EMPTY_OBJ,
    inheritAttrs: type.inheritAttrs,
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    suspense,
    suspenseId: suspense ? suspense.pendingId : 0,
    asyncDep: null,
    asyncResolved: false,
    isMounted: false,
    isUnmounted: false,
    isDeactivated: false,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  {
    instance.ctx = { _: instance };
  }
  instance.root = parent ? parent.root : instance;
  instance.emit = emit$1.bind(null, instance);
  if (vnode.ce) {
    vnode.ce(instance);
  }
  return instance;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
const setCurrentInstance = (instance) => {
  currentInstance = instance;
  instance.scope.on();
};
const unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off();
  currentInstance = null;
};
function isStatefulComponent(instance) {
  return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false) {
  isInSSRComponentSetup = isSSR;
  const { props: props2, children } = instance.vnode;
  const isStateful = isStatefulComponent(instance);
  initProps(instance, props2, isStateful, isSSR);
  initSlots(instance, children);
  const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
  isInSSRComponentSetup = false;
  return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
  const Component = instance.type;
  instance.accessCache = /* @__PURE__ */ Object.create(null);
  instance.proxy = markRaw(new Proxy(instance.ctx, PublicInstanceProxyHandlers));
  const { setup } = Component;
  if (setup) {
    const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
    setCurrentInstance(instance);
    pauseTracking();
    const setupResult = callWithErrorHandling(setup, instance, 0, [instance.props, setupContext]);
    resetTracking();
    unsetCurrentInstance();
    if (isPromise(setupResult)) {
      setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
      if (isSSR) {
        return setupResult.then((resolvedResult) => {
          handleSetupResult(instance, resolvedResult, isSSR);
        }).catch((e2) => {
          handleError(e2, instance, 0);
        });
      } else {
        instance.asyncDep = setupResult;
      }
    } else {
      handleSetupResult(instance, setupResult, isSSR);
    }
  } else {
    finishComponentSetup(instance, isSSR);
  }
}
function handleSetupResult(instance, setupResult, isSSR) {
  if (isFunction$4(setupResult)) {
    if (instance.type.__ssrInlineRender) {
      instance.ssrRender = setupResult;
    } else {
      instance.render = setupResult;
    }
  } else if (isObject$3(setupResult)) {
    instance.setupState = proxyRefs(setupResult);
  } else
    ;
  finishComponentSetup(instance, isSSR);
}
let compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
  const Component = instance.type;
  if (!instance.render) {
    if (!isSSR && compile && !Component.render) {
      const template = Component.template;
      if (template) {
        const { isCustomElement, compilerOptions } = instance.appContext.config;
        const { delimiters, compilerOptions: componentCompilerOptions } = Component;
        const finalCompilerOptions = extend$2(extend$2({
          isCustomElement,
          delimiters
        }, compilerOptions), componentCompilerOptions);
        Component.render = compile(template, finalCompilerOptions);
      }
    }
    instance.render = Component.render || NOOP;
  }
  {
    setCurrentInstance(instance);
    pauseTracking();
    applyOptions(instance);
    resetTracking();
    unsetCurrentInstance();
  }
}
function createAttrsProxy(instance) {
  return new Proxy(instance.attrs, {
    get(target, key) {
      track(instance, "get", "$attrs");
      return target[key];
    }
  });
}
function createSetupContext(instance) {
  const expose = (exposed) => {
    instance.exposed = exposed || {};
  };
  let attrs;
  {
    return {
      get attrs() {
        return attrs || (attrs = createAttrsProxy(instance));
      },
      slots: instance.slots,
      emit: instance.emit,
      expose
    };
  }
}
function getExposeProxy(instance) {
  if (instance.exposed) {
    return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance);
        }
      }
    }));
  }
}
function getComponentName(Component) {
  return isFunction$4(Component) ? Component.displayName || Component.name : Component.name;
}
function isClassComponent(value) {
  return isFunction$4(value) && "__vccOpts" in value;
}
function callWithErrorHandling(fn2, instance, type, args) {
  let res;
  try {
    res = args ? fn2(...args) : fn2();
  } catch (err) {
    handleError(err, instance, type);
  }
  return res;
}
function callWithAsyncErrorHandling(fn2, instance, type, args) {
  if (isFunction$4(fn2)) {
    const res = callWithErrorHandling(fn2, instance, type, args);
    if (res && isPromise(res)) {
      res.catch((err) => {
        handleError(err, instance, type);
      });
    }
    return res;
  }
  const values = [];
  for (let i2 = 0; i2 < fn2.length; i2++) {
    values.push(callWithAsyncErrorHandling(fn2[i2], instance, type, args));
  }
  return values;
}
function handleError(err, instance, type, throwInDev = true) {
  const contextVNode = instance ? instance.vnode : null;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy;
    const errorInfo = type;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i2 = 0; i2 < errorCapturedHooks.length; i2++) {
          if (errorCapturedHooks[i2](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    const appErrorHandler = instance.appContext.config.errorHandler;
    if (appErrorHandler) {
      callWithErrorHandling(appErrorHandler, null, 10, [err, exposedInstance, errorInfo]);
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev = true) {
  {
    console.error(err);
  }
}
let isFlushing = false;
let isFlushPending = false;
const queue = [];
let flushIndex = 0;
const pendingPreFlushCbs = [];
let activePreFlushCbs = null;
let preFlushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = Promise.resolve();
let currentFlushPromise = null;
let currentPreFlushParentJob = null;
function nextTick(fn2) {
  const p2 = currentFlushPromise || resolvedPromise;
  return fn2 ? p2.then(this ? fn2.bind(this) : fn2) : p2;
}
function findInsertionIndex(id) {
  let start2 = flushIndex + 1;
  let end2 = queue.length;
  while (start2 < end2) {
    const middle = start2 + end2 >>> 1;
    const middleJobId = getId(queue[middle]);
    middleJobId < id ? start2 = middle + 1 : end2 = middle;
  }
  return start2;
}
function queueJob(job) {
  if ((!queue.length || !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) && job !== currentPreFlushParentJob) {
    if (job.id == null) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(job.id), 0, job);
    }
    queueFlush();
  }
}
function queueFlush() {
  if (!isFlushing && !isFlushPending) {
    isFlushPending = true;
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function invalidateJob(job) {
  const i2 = queue.indexOf(job);
  if (i2 > flushIndex) {
    queue.splice(i2, 1);
  }
}
function queueCb(cb, activeQueue, pendingQueue, index2) {
  if (!isArray$c(cb)) {
    if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index2 + 1 : index2)) {
      pendingQueue.push(cb);
    }
  } else {
    pendingQueue.push(...cb);
  }
  queueFlush();
}
function queuePreFlushCb(cb) {
  queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
}
function queuePostFlushCb(cb) {
  queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
}
function flushPreFlushCbs(seen, parentJob = null) {
  if (pendingPreFlushCbs.length) {
    currentPreFlushParentJob = parentJob;
    activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
    pendingPreFlushCbs.length = 0;
    for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
      activePreFlushCbs[preFlushIndex]();
    }
    activePreFlushCbs = null;
    preFlushIndex = 0;
    currentPreFlushParentJob = null;
    flushPreFlushCbs(seen, parentJob);
  }
}
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)];
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    activePostFlushCbs = deduped;
    activePostFlushCbs.sort((a, b) => getId(a) - getId(b));
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      activePostFlushCbs[postFlushIndex]();
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? Infinity : job.id;
function flushJobs(seen) {
  isFlushPending = false;
  isFlushing = true;
  flushPreFlushCbs(seen);
  queue.sort((a, b) => getId(a) - getId(b));
  const check = NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && job.active !== false) {
        if (false)
          ;
        callWithErrorHandling(job, null, 14);
      }
    }
  } finally {
    flushIndex = 0;
    queue.length = 0;
    flushPostFlushCbs();
    isFlushing = false;
    currentFlushPromise = null;
    if (queue.length || pendingPreFlushCbs.length || pendingPostFlushCbs.length) {
      flushJobs(seen);
    }
  }
}
const INITIAL_WATCHER_VALUE = {};
function watch(source4, cb, options) {
  return doWatch(source4, cb, options);
}
function doWatch(source4, cb, { immediate, deep, flush, onTrack, onTrigger } = EMPTY_OBJ) {
  const instance = currentInstance;
  let getter;
  let forceTrigger = false;
  let isMultiSource = false;
  if (isRef(source4)) {
    getter = () => source4.value;
    forceTrigger = !!source4._shallow;
  } else if (isReactive(source4)) {
    getter = () => source4;
    deep = true;
  } else if (isArray$c(source4)) {
    isMultiSource = true;
    forceTrigger = source4.some(isReactive);
    getter = () => source4.map((s2) => {
      if (isRef(s2)) {
        return s2.value;
      } else if (isReactive(s2)) {
        return traverse(s2);
      } else if (isFunction$4(s2)) {
        return callWithErrorHandling(s2, instance, 2);
      } else
        ;
    });
  } else if (isFunction$4(source4)) {
    if (cb) {
      getter = () => callWithErrorHandling(source4, instance, 2);
    } else {
      getter = () => {
        if (instance && instance.isUnmounted) {
          return;
        }
        if (cleanup) {
          cleanup();
        }
        return callWithAsyncErrorHandling(source4, instance, 3, [onInvalidate]);
      };
    }
  } else {
    getter = NOOP;
  }
  if (cb && deep) {
    const baseGetter = getter;
    getter = () => traverse(baseGetter());
  }
  let cleanup;
  let onInvalidate = (fn2) => {
    cleanup = effect2.onStop = () => {
      callWithErrorHandling(fn2, instance, 4);
    };
  };
  if (isInSSRComponentSetup) {
    onInvalidate = NOOP;
    if (!cb) {
      getter();
    } else if (immediate) {
      callWithAsyncErrorHandling(cb, instance, 3, [
        getter(),
        isMultiSource ? [] : void 0,
        onInvalidate
      ]);
    }
    return NOOP;
  }
  let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
  const job = () => {
    if (!effect2.active) {
      return;
    }
    if (cb) {
      const newValue = effect2.run();
      if (deep || forceTrigger || (isMultiSource ? newValue.some((v2, i2) => hasChanged(v2, oldValue[i2])) : hasChanged(newValue, oldValue)) || false) {
        if (cleanup) {
          cleanup();
        }
        callWithAsyncErrorHandling(cb, instance, 3, [
          newValue,
          oldValue === INITIAL_WATCHER_VALUE ? void 0 : oldValue,
          onInvalidate
        ]);
        oldValue = newValue;
      }
    } else {
      effect2.run();
    }
  };
  job.allowRecurse = !!cb;
  let scheduler;
  if (flush === "sync") {
    scheduler = job;
  } else if (flush === "post") {
    scheduler = () => queuePostRenderEffect(job, instance && instance.suspense);
  } else {
    scheduler = () => {
      if (!instance || instance.isMounted) {
        queuePreFlushCb(job);
      } else {
        job();
      }
    };
  }
  const effect2 = new ReactiveEffect(getter, scheduler);
  if (cb) {
    if (immediate) {
      job();
    } else {
      oldValue = effect2.run();
    }
  } else if (flush === "post") {
    queuePostRenderEffect(effect2.run.bind(effect2), instance && instance.suspense);
  } else {
    effect2.run();
  }
  return () => {
    effect2.stop();
    if (instance && instance.scope) {
      remove(instance.scope.effects, effect2);
    }
  };
}
function instanceWatch(source4, value, options) {
  const publicThis = this.proxy;
  const getter = isString$5(source4) ? source4.includes(".") ? createPathGetter(publicThis, source4) : () => publicThis[source4] : source4.bind(publicThis, publicThis);
  let cb;
  if (isFunction$4(value)) {
    cb = value;
  } else {
    cb = value.handler;
    options = value;
  }
  const cur = currentInstance;
  setCurrentInstance(this);
  const res = doWatch(getter, cb.bind(publicThis), options);
  if (cur) {
    setCurrentInstance(cur);
  } else {
    unsetCurrentInstance();
  }
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i2 = 0; i2 < segments.length && cur; i2++) {
      cur = cur[segments[i2]];
    }
    return cur;
  };
}
function traverse(value, seen) {
  if (!isObject$3(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Set();
  if (seen.has(value)) {
    return value;
  }
  seen.add(value);
  if (isRef(value)) {
    traverse(value.value, seen);
  } else if (isArray$c(value)) {
    for (let i2 = 0; i2 < value.length; i2++) {
      traverse(value[i2], seen);
    }
  } else if (isSet$2(value) || isMap$2(value)) {
    value.forEach((v2) => {
      traverse(v2, seen);
    });
  } else if (isPlainObject$2(value)) {
    for (const key in value) {
      traverse(value[key], seen);
    }
  }
  return value;
}
function h$1(type, propsOrChildren, children) {
  const l = arguments.length;
  if (l === 2) {
    if (isObject$3(propsOrChildren) && !isArray$c(propsOrChildren)) {
      if (isVNode(propsOrChildren)) {
        return createVNode(type, null, [propsOrChildren]);
      }
      return createVNode(type, propsOrChildren);
    } else {
      return createVNode(type, null, propsOrChildren);
    }
  } else {
    if (l > 3) {
      children = Array.prototype.slice.call(arguments, 2);
    } else if (l === 3 && isVNode(children)) {
      children = [children];
    }
    return createVNode(type, propsOrChildren, children);
  }
}
const version = "3.2.22";
const svgNS = "http://www.w3.org/2000/svg";
const doc = typeof document !== "undefined" ? document : null;
const staticTemplateCache = /* @__PURE__ */ new Map();
const nodeOps = {
  insert: (child, parent, anchor) => {
    parent.insertBefore(child, anchor || null);
  },
  remove: (child) => {
    const parent = child.parentNode;
    if (parent) {
      parent.removeChild(child);
    }
  },
  createElement: (tag, isSVG, is, props2) => {
    const el = isSVG ? doc.createElementNS(svgNS, tag) : doc.createElement(tag, is ? { is } : void 0);
    if (tag === "select" && props2 && props2.multiple != null) {
      el.setAttribute("multiple", props2.multiple);
    }
    return el;
  },
  createText: (text) => doc.createTextNode(text),
  createComment: (text) => doc.createComment(text),
  setText: (node, text) => {
    node.nodeValue = text;
  },
  setElementText: (el, text) => {
    el.textContent = text;
  },
  parentNode: (node) => node.parentNode,
  nextSibling: (node) => node.nextSibling,
  querySelector: (selector) => doc.querySelector(selector),
  setScopeId(el, id) {
    el.setAttribute(id, "");
  },
  cloneNode(el) {
    const cloned = el.cloneNode(true);
    if (`_value` in el) {
      cloned._value = el._value;
    }
    return cloned;
  },
  insertStaticContent(content, parent, anchor, isSVG) {
    const before = anchor ? anchor.previousSibling : parent.lastChild;
    let template = staticTemplateCache.get(content);
    if (!template) {
      const t = doc.createElement("template");
      t.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
      template = t.content;
      if (isSVG) {
        const wrapper = template.firstChild;
        while (wrapper.firstChild) {
          template.appendChild(wrapper.firstChild);
        }
        template.removeChild(wrapper);
      }
      staticTemplateCache.set(content, template);
    }
    parent.insertBefore(template.cloneNode(true), anchor);
    return [
      before ? before.nextSibling : parent.firstChild,
      anchor ? anchor.previousSibling : parent.lastChild
    ];
  }
};
function patchClass(el, value, isSVG) {
  const transitionClasses = el._vtc;
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  if (value == null) {
    el.removeAttribute("class");
  } else if (isSVG) {
    el.setAttribute("class", value);
  } else {
    el.className = value;
  }
}
function patchStyle(el, prev2, next) {
  const style = el.style;
  const isCssString = isString$5(next);
  if (next && !isCssString) {
    for (const key in next) {
      setStyle(style, key, next[key]);
    }
    if (prev2 && !isString$5(prev2)) {
      for (const key in prev2) {
        if (next[key] == null) {
          setStyle(style, key, "");
        }
      }
    }
  } else {
    const currentDisplay = style.display;
    if (isCssString) {
      if (prev2 !== next) {
        style.cssText = next;
      }
    } else if (prev2) {
      el.removeAttribute("style");
    }
    if ("_vod" in el) {
      style.display = currentDisplay;
    }
  }
}
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
  if (isArray$c(val)) {
    val.forEach((v2) => setStyle(style, name, v2));
  } else {
    if (name.startsWith("--")) {
      style.setProperty(name, val);
    } else {
      const prefixed = autoPrefix(style, name);
      if (importantRE.test(val)) {
        style.setProperty(hyphenate(prefixed), val.replace(importantRE, ""), "important");
      } else {
        style[prefixed] = val;
      }
    }
  }
}
const prefixes = ["Webkit", "Moz", "ms"];
const prefixCache = {};
function autoPrefix(style, rawName) {
  const cached = prefixCache[rawName];
  if (cached) {
    return cached;
  }
  let name = camelize(rawName);
  if (name !== "filter" && name in style) {
    return prefixCache[rawName] = name;
  }
  name = capitalize(name);
  for (let i2 = 0; i2 < prefixes.length; i2++) {
    const prefixed = prefixes[i2] + name;
    if (prefixed in style) {
      return prefixCache[rawName] = prefixed;
    }
  }
  return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance) {
  if (isSVG && key.startsWith("xlink:")) {
    if (value == null) {
      el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    const isBoolean2 = isSpecialBooleanAttr(key);
    if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, isBoolean2 ? "" : value);
    }
  }
}
function patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
  if (key === "innerHTML" || key === "textContent") {
    if (prevChildren) {
      unmountChildren(prevChildren, parentComponent, parentSuspense);
    }
    el[key] = value == null ? "" : value;
    return;
  }
  if (key === "value" && el.tagName !== "PROGRESS") {
    el._value = value;
    const newValue = value == null ? "" : value;
    if (el.value !== newValue) {
      el.value = newValue;
    }
    if (value == null) {
      el.removeAttribute(key);
    }
    return;
  }
  if (value === "" || value == null) {
    const type = typeof el[key];
    if (type === "boolean") {
      el[key] = includeBooleanAttr(value);
      return;
    } else if (value == null && type === "string") {
      el[key] = "";
      el.removeAttribute(key);
      return;
    } else if (type === "number") {
      try {
        el[key] = 0;
      } catch (_a) {
      }
      el.removeAttribute(key);
      return;
    }
  }
  try {
    el[key] = value;
  } catch (e2) {
  }
}
let _getNow = Date.now;
let skipTimestampCheck = false;
if (typeof window !== "undefined") {
  if (_getNow() > document.createEvent("Event").timeStamp) {
    _getNow = () => performance.now();
  }
  const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
  skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
}
let cachedNow = 0;
const p = Promise.resolve();
const reset = () => {
  cachedNow = 0;
};
const getNow = () => cachedNow || (p.then(reset), cachedNow = _getNow());
function addEventListener$1(el, event, handler, options) {
  el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
  el.removeEventListener(event, handler, options);
}
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
  const invokers = el._vei || (el._vei = {});
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name, options] = parseName(rawName);
    if (nextValue) {
      const invoker = invokers[rawName] = createInvoker(nextValue, instance);
      addEventListener$1(el, name, invoker, options);
    } else if (existingInvoker) {
      removeEventListener(el, name, existingInvoker, options);
      invokers[rawName] = void 0;
    }
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
  let options;
  if (optionsModifierRE.test(name)) {
    options = {};
    let m2;
    while (m2 = name.match(optionsModifierRE)) {
      name = name.slice(0, name.length - m2[0].length);
      options[m2[0].toLowerCase()] = true;
    }
  }
  return [hyphenate(name.slice(2)), options];
}
function createInvoker(initialValue, instance) {
  const invoker = (e2) => {
    const timeStamp = e2.timeStamp || _getNow();
    if (skipTimestampCheck || timeStamp >= invoker.attached - 1) {
      callWithAsyncErrorHandling(patchStopImmediatePropagation(e2, invoker.value), instance, 5, [e2]);
    }
  };
  invoker.value = initialValue;
  invoker.attached = getNow();
  return invoker;
}
function patchStopImmediatePropagation(e2, value) {
  if (isArray$c(value)) {
    const originalStop = e2.stopImmediatePropagation;
    e2.stopImmediatePropagation = () => {
      originalStop.call(e2);
      e2._stopped = true;
    };
    return value.map((fn2) => (e3) => !e3._stopped && fn2(e3));
  } else {
    return value;
  }
}
const nativeOnRE = /^on[a-z]/;
const patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
  if (key === "class") {
    patchClass(el, nextValue, isSVG);
  } else if (key === "style") {
    patchStyle(el, prevValue, nextValue);
  } else if (isOn(key)) {
    if (!isModelListener(key)) {
      patchEvent(el, key, prevValue, nextValue, parentComponent);
    }
  } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
    patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
  } else {
    if (key === "true-value") {
      el._trueValue = nextValue;
    } else if (key === "false-value") {
      el._falseValue = nextValue;
    }
    patchAttr(el, key, nextValue, isSVG);
  }
};
function shouldSetAsProp(el, key, value, isSVG) {
  if (isSVG) {
    if (key === "innerHTML" || key === "textContent") {
      return true;
    }
    if (key in el && nativeOnRE.test(key) && isFunction$4(value)) {
      return true;
    }
    return false;
  }
  if (key === "spellcheck" || key === "draggable") {
    return false;
  }
  if (key === "form") {
    return false;
  }
  if (key === "list" && el.tagName === "INPUT") {
    return false;
  }
  if (key === "type" && el.tagName === "TEXTAREA") {
    return false;
  }
  if (nativeOnRE.test(key) && isString$5(value)) {
    return false;
  }
  return key in el;
}
function defineCustomElement(options, hydate) {
  const Comp = defineComponent(options);
  class VueCustomElement extends VueElement {
    constructor(initialProps) {
      super(Comp, initialProps, hydate);
    }
  }
  VueCustomElement.def = Comp;
  return VueCustomElement;
}
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
  constructor(_def, _props = {}, hydrate) {
    super();
    this._def = _def;
    this._props = _props;
    this._instance = null;
    this._connected = false;
    this._resolved = false;
    this._numberProps = null;
    if (this.shadowRoot && hydrate) {
      hydrate(this._createVNode(), this.shadowRoot);
    } else {
      this.attachShadow({ mode: "open" });
    }
  }
  connectedCallback() {
    this._connected = true;
    if (!this._instance) {
      this._resolveDef();
    }
  }
  disconnectedCallback() {
    this._connected = false;
    nextTick(() => {
      if (!this._connected) {
        render$3(null, this.shadowRoot);
        this._instance = null;
      }
    });
  }
  _resolveDef() {
    if (this._resolved) {
      return;
    }
    this._resolved = true;
    for (let i2 = 0; i2 < this.attributes.length; i2++) {
      this._setAttr(this.attributes[i2].name);
    }
    new MutationObserver((mutations) => {
      for (const m2 of mutations) {
        this._setAttr(m2.attributeName);
      }
    }).observe(this, { attributes: true });
    const resolve2 = (def2) => {
      const { props: props2, styles: styles2 } = def2;
      const hasOptions = !isArray$c(props2);
      const rawKeys = props2 ? hasOptions ? Object.keys(props2) : props2 : [];
      let numberProps;
      if (hasOptions) {
        for (const key in this._props) {
          const opt = props2[key];
          if (opt === Number || opt && opt.type === Number) {
            this._props[key] = toNumber(this._props[key]);
            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[key] = true;
          }
        }
      }
      this._numberProps = numberProps;
      for (const key of Object.keys(this)) {
        if (key[0] !== "_") {
          this._setProp(key, this[key], true, false);
        }
      }
      for (const key of rawKeys.map(camelize)) {
        Object.defineProperty(this, key, {
          get() {
            return this._getProp(key);
          },
          set(val) {
            this._setProp(key, val);
          }
        });
      }
      this._applyStyles(styles2);
      this._update();
    };
    const asyncDef = this._def.__asyncLoader;
    if (asyncDef) {
      asyncDef().then(resolve2);
    } else {
      resolve2(this._def);
    }
  }
  _setAttr(key) {
    let value = this.getAttribute(key);
    if (this._numberProps && this._numberProps[key]) {
      value = toNumber(value);
    }
    this._setProp(camelize(key), value, false);
  }
  _getProp(key) {
    return this._props[key];
  }
  _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
    if (val !== this._props[key]) {
      this._props[key] = val;
      if (shouldUpdate && this._instance) {
        this._update();
      }
      if (shouldReflect) {
        if (val === true) {
          this.setAttribute(hyphenate(key), "");
        } else if (typeof val === "string" || typeof val === "number") {
          this.setAttribute(hyphenate(key), val + "");
        } else if (!val) {
          this.removeAttribute(hyphenate(key));
        }
      }
    }
  }
  _update() {
    render$3(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const vnode = createVNode(this._def, extend$2({}, this._props));
    if (!this._instance) {
      vnode.ce = (instance) => {
        this._instance = instance;
        instance.isCE = true;
        instance.emit = (event, ...args) => {
          this.dispatchEvent(new CustomEvent(event, {
            detail: args
          }));
        };
        let parent = this;
        while (parent = parent && (parent.parentNode || parent.host)) {
          if (parent instanceof VueElement) {
            instance.parent = parent._instance;
            break;
          }
        }
      };
    }
    return vnode;
  }
  _applyStyles(styles2) {
    if (styles2) {
      styles2.forEach((css) => {
        const s2 = document.createElement("style");
        s2.textContent = css;
        this.shadowRoot.appendChild(s2);
      });
    }
  }
}
const DOMTransitionPropsValidators = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: true
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
/* @__PURE__ */ extend$2({}, BaseTransition.props, DOMTransitionPropsValidators);
const systemModifiers = ["ctrl", "shift", "alt", "meta"];
const modifierGuards = {
  stop: (e2) => e2.stopPropagation(),
  prevent: (e2) => e2.preventDefault(),
  self: (e2) => e2.target !== e2.currentTarget,
  ctrl: (e2) => !e2.ctrlKey,
  shift: (e2) => !e2.shiftKey,
  alt: (e2) => !e2.altKey,
  meta: (e2) => !e2.metaKey,
  left: (e2) => "button" in e2 && e2.button !== 0,
  middle: (e2) => "button" in e2 && e2.button !== 1,
  right: (e2) => "button" in e2 && e2.button !== 2,
  exact: (e2, modifiers) => systemModifiers.some((m2) => e2[`${m2}Key`] && !modifiers.includes(m2))
};
const withModifiers = (fn2, modifiers) => {
  return (event, ...args) => {
    for (let i2 = 0; i2 < modifiers.length; i2++) {
      const guard = modifierGuards[modifiers[i2]];
      if (guard && guard(event, modifiers))
        return;
    }
    return fn2(event, ...args);
  };
};
const vShow = {
  beforeMount(el, { value }, { transition }) {
    el._vod = el.style.display === "none" ? "" : el.style.display;
    if (transition && value) {
      transition.beforeEnter(el);
    } else {
      setDisplay(el, value);
    }
  },
  mounted(el, { value }, { transition }) {
    if (transition && value) {
      transition.enter(el);
    }
  },
  updated(el, { value, oldValue }, { transition }) {
    if (!value === !oldValue)
      return;
    if (transition) {
      if (value) {
        transition.beforeEnter(el);
        setDisplay(el, true);
        transition.enter(el);
      } else {
        transition.leave(el, () => {
          setDisplay(el, false);
        });
      }
    } else {
      setDisplay(el, value);
    }
  },
  beforeUnmount(el, { value }) {
    setDisplay(el, value);
  }
};
function setDisplay(el, value) {
  el.style.display = value ? el._vod : "none";
}
const rendererOptions = extend$2({ patchProp }, nodeOps);
let renderer;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
const render$3 = (...args) => {
  ensureRenderer().render(...args);
};
var styles = "/* import token variables */\n/**\n * Do not edit directly\n * Generated on Fri, 11 Mar 2022 11:02:36 GMT\n */\n:root {\n  --token-c-sidenav-default-size-nav-item-height: 40px;\n  --token-c-sidenav-default-size-nav-item-width: 164px;\n  --token-c-sidenav-default-size-logo-height: 20px;\n  --token-c-sidenav-default-size-logo-width: 140px;\n  --token-c-sidenav-default-size-width: 208px;\n  --token-c-sidenav-default-color-bg-nav-item-hover: hsla(231, 37%, 14%, 1);\n  --token-c-sidenav-default-color-bg-nav-item-active: hsla(231, 37%, 14%, 1);\n  --token-c-sidenav-menu-default-size-width: 230px;\n  --token-c-modal-size-xxl: 1620px;\n  --token-c-modal-size-xl: 1024px;\n  --token-c-modal-size-lg: 896px;\n  --token-c-modal-size-md: 768px;\n  --token-c-modal-size-sm: 512px;\n  --token-c-modal-size-xs: 312px;\n  --token-c-button-size-x-large: 48px;\n  --token-c-button-size-large: 40px;\n  --token-c-button-size-medium: 32px;\n  --token-c-button-size-small: 24px;\n  --token-c-assignee-picker-size-default-list: 222px;\n  --token-c-assignee-picker-size-default-content: 264px;\n  --token-c-assignee-picker-size-default-height: 320px;\n  --token-c-assignee-picker-size-default-width: 244px;\n  --token-c-alert-size-max-width: 280px;\n  --token-font-line-height-relaxed: 1.75;\n  --token-font-line-height-default: 1.5;\n  --token-font-line-height-tight: 1.25;\n  --token-font-line-height-none: 1;\n  --token-font-family-nunito: 'Nunito', sans-serif;;\n  --token-font-family-sans: 'Open Sans';\n  --token-size-3-5: 14px;\n  --token-size-2-5: 10px;\n  --token-size-1-5: 6px;\n  --token-size-0-5: 2px;\n  --token-size-px: 1px;\n  --token-size-4800: 384px;\n  --token-size-4000: 320px;\n  --token-size-3600: 288px;\n  --token-size-3200: 256px;\n  --token-size-3000: 240px;\n  --token-size-2800: 224px;\n  --token-size-2600: 208px;\n  --token-size-2400: 192px;\n  --token-size-2200: 176px;\n  --token-size-2000: 160px;\n  --token-size-1800: 144px;\n  --token-size-1600: 128px;\n  --token-size-1500: 120px;\n  --token-size-1400: 112px;\n  --token-size-1200: 96px;\n  --token-size-1000: 80px;\n  --token-size-800: 64px;\n  --token-size-700: 56px;\n  --token-size-600: 48px;\n  --token-size-550: 44px;\n  --token-size-500: 40px;\n  --token-size-450: 36px;\n  --token-size-400: 32px;\n  --token-size-350: 28px;\n  --token-size-300: 24px;\n  --token-size-250: 20px;\n  --token-size-200: 16px;\n  --token-size-175: 14px;\n  --token-size-150: 12px; /* Size-12px is used for the padding top and bottom in the table rows */\n  --token-size-100: 8px; /* Size-8px is used when the space is limited. E.g. (space between icon and label) */\n  --token-size-96: 384px;\n  --token-size-80: 320px;\n  --token-size-72: 288px;\n  --token-size-64: 256px;\n  --token-size-60: 240px;\n  --token-size-56: 224px;\n  --token-size-52: 208px;\n  --token-size-50: 4px; /* Size-4px is used when the space is limited. E.g. (space between icon and label, small button) */\n  --token-size-48: 192px;\n  --token-size-44: 176px;\n  --token-size-40: 160px;\n  --token-size-36: 144px;\n  --token-size-32: 128px;\n  --token-size-28: 112px;\n  --token-size-25: 2px;\n  --token-size-24: 96px;\n  --token-size-20: 80px;\n  --token-size-16: 64px;\n  --token-size-14: 56px;\n  --token-size-12: 48px;\n  --token-size-11: 44px;\n  --token-size-10: 40px;\n  --token-size-9: 36px;\n  --token-size-8: 32px;\n  --token-size-7: 28px;\n  --token-size-6: 24px;\n  --token-size-5: 20px;\n  --token-size-4: 16px;\n  --token-size-3: 12px;\n  --token-size-2: 8px;\n  --token-size-1: 4px;\n  --token-size-0: 0;\n  --token-shadow-lg: 0px 16px 40px rgba(11, 14, 31, 0.16); /* Modals */\n  --token-shadow-md: 0px 8px 24px rgba(11, 14, 31, 0.16); /* Dialogs */\n  --token-shadow-sm: 0px 4px 12px rgba(11, 14, 31, 0.12); /* Dropdown Menus, Date pickers, Float buttons */\n  --token-shadow-xs: 0px 4px 12px rgba(11, 14, 31, 0.08); /* Pop overs, Sticky headers | footers | sidebars */\n  --token-screens-xx-large: 1536px;\n  --token-screens-x-large: 1280px;\n  --token-screens-large: 1024px;\n  --token-screens-medium: 768px;\n  --token-screens-small: 640px;\n  --token-palette-color-pink-base: #FF61C7;\n  --token-palette-color-pink-60: #C43692;\n  --token-palette-color-pink-50: #E557B3;\n  --token-palette-color-pink-40: #FF61C7;\n  --token-palette-color-pink-30: #FFA0DD;\n  --token-palette-color-pink-20: #F1CCE6;\n  --token-palette-color-pink-10: #ffeff9;\n  --token-palette-color-teal-base: #4CD5E3;\n  --token-palette-color-teal-60: #3dadb8;\n  --token-palette-color-teal-50: #44C0CC;\n  --token-palette-color-teal-40: #4CD5E3;\n  --token-palette-color-teal-30: #A1E9F0;\n  --token-palette-color-teal-20: #C5F2F2;\n  --token-palette-color-teal-10: #EDFBFC;\n  --token-palette-color-blue-base: #4DA2F8;\n  --token-palette-color-blue-60: #3578BB;\n  --token-palette-color-blue-50: #4592DF;\n  --token-palette-color-blue-40: #4DA2F8;\n  --token-palette-color-blue-30: #94C7FB;\n  --token-palette-color-blue-20: #C2E9FF;\n  --token-palette-color-blue-10: #edf6fe;\n  --token-palette-color-brown-base: #CA6419;\n  --token-palette-color-brown-60: #9b4d13;\n  --token-palette-color-brown-50: #AC5515;\n  --token-palette-color-brown-40: #CA6419;\n  --token-palette-color-brown-30: #DFA275;\n  --token-palette-color-brown-20: #F4E0D1;\n  --token-palette-color-brown-10: #faf0e8;\n  --token-palette-color-orange-base: #FF7641;\n  --token-palette-color-orange-60: #ce5f34;\n  --token-palette-color-orange-50: #E56A3A;\n  --token-palette-color-orange-40: #FF7641;\n  --token-palette-color-orange-30: #FFAD8D;\n  --token-palette-color-orange-20: #FFE4D9;\n  --token-palette-color-orange-10: #fff1ec;\n  --token-palette-color-purple-base: #895EF7;\n  --token-palette-color-purple-60: #6848bd;\n  --token-palette-color-purple-50: #7450D2;\n  --token-palette-color-purple-40: #895EF7;\n  --token-palette-color-purple-30: #BBA1FF;\n  --token-palette-color-purple-20: #E2DAFF;\n  --token-palette-color-purple-10: #f3effe;\n  --token-palette-color-green-base: #4ECD97;\n  --token-palette-color-green-60: #318160;\n  --token-palette-color-green-50: #46B988;\n  --token-palette-color-green-40: #4ECD97;\n  --token-palette-color-green-30: #95E1C1;\n  --token-palette-color-green-20: #D2FBE8;\n  --token-palette-color-green-10: #edfaf5;\n  --token-palette-color-yellow-base: #FFC63C;\n  --token-palette-color-yellow-60: #cb9f34;\n  --token-palette-color-yellow-50: #E2B13A;\n  --token-palette-color-yellow-40: #FFC63C;\n  --token-palette-color-yellow-30: #FFE29B;\n  --token-palette-color-yellow-20: #FFF0CA;\n  --token-palette-color-yellow-10: #FFF9EC;\n  --token-palette-color-red-base: #E12D42;\n  --token-palette-color-red-60: #B42435;\n  --token-palette-color-red-50: #CB283B;\n  --token-palette-color-red-40: #E12D42;\n  --token-palette-color-red-30: #ED818E;\n  --token-palette-color-red-20: #FFD0DA;\n  --token-palette-color-red-10: #fceaec;\n  --token-palette-color-grey-base: #CACDDC;\n  --token-palette-color-grey-60: #969bb1;\n  --token-palette-color-grey-50: #A7ACC5;\n  --token-palette-color-grey-40: #CACDDC;\n  --token-palette-color-grey-30: #E8EAF1;\n  --token-palette-color-grey-20: #EEF1F5;\n  --token-palette-color-grey-10: #FAFAFC;\n  --token-palette-color-indigo-base: #4461D7;\n  --token-palette-color-indigo-60: #364DAA;\n  --token-palette-color-indigo-50: #3C55BD;\n  --token-palette-color-indigo-40: #4461D7;\n  --token-palette-color-indigo-30: #8F9FE7;\n  --token-palette-color-indigo-20: #D8E0FF;\n  --token-palette-color-indigo-10: #F2F4FC;\n  --token-palette-color-neutral-base: #0B0E1F;\n  --token-palette-color-neutral-60: #0B0E1F;\n  --token-palette-color-neutral-50: #646D7D;\n  --token-palette-color-neutral-40: #8F9BB3;\n  --token-palette-color-neutral-30: #C5CEE0;\n  --token-palette-color-neutral-20: #E1E6EE;\n  --token-palette-color-neutral-10: #F5F7FA;\n  --token-palette-color-black: #000000;\n  --token-palette-color-white: #FFFFFF;\n  --token-opacity-100: 1;\n  --token-opacity-95: 0.95;\n  --token-opacity-90: 0.90;\n  --token-opacity-85: 0.85;\n  --token-opacity-80: 0.80;\n  --token-opacity-75: 0.75;\n  --token-opacity-70: 0.70;\n  --token-opacity-60: 0.60;\n  --token-opacity-50: 0.50;\n  --token-opacity-40: 0.40;\n  --token-opacity-30: 0.30;\n  --token-opacity-25: 0.25;\n  --token-opacity-20: 0.20;\n  --token-opacity-10: 0.10;\n  --token-opacity-5: 0.05;\n  --token-opacity-0: 0;\n  --token-elevation-auto: auto;\n  --token-elevation-50: 50;\n  --token-elevation-40: 40;\n  --token-elevation-30: 30;\n  --token-elevation-20: 20;\n  --token-elevation-10: 10;\n  --token-elevation-0: 0;\n  --token-ui-overlay: rgba(11,14,31,0.2);\n  --token-ui-black: #000000;\n  --token-ui-white: #FFFFFF;\n  --token-color-overlay: rgba(11, 14, 31, 0.2);\n  --token-border-radius-full: 9999px;\n  --token-border-radius-none: 0;\n  --token-border-width-default: 1px;\n  --token-border-width-2: 2px;\n  --token-border-width-0: 0;\n  --token-animations-timing-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  --token-animations-timing-out: cubic-bezier(0, 0, 0.2, 1);\n  --token-animations-timing-in: cubic-bezier(0.4, 0, 1, 1);\n  --token-animations-timing-linear: linear;\n  --token-animations-timing-default: cubic-bezier(0.4, 0, 0.2, 1);\n  --token-animations-durations-default: 150ms;\n  --token-animations-durations-1000: 1000ms;\n  --token-animations-durations-700: 700ms;\n  --token-animations-durations-500: 500ms;\n  --token-animations-durations-300: 300ms;\n  --token-animations-durations-200: 200ms;\n  --token-animations-durations-150: 150ms;\n  --token-animations-durations-100: 100ms;\n  --token-animations-durations-75: 75ms;\n  --token-c-sidenav-default-color-divider: var(--token-palette-color-neutral-50);\n  --token-c-sidenav-default-color-icon-nav-item-active: var(--token-palette-color-white);\n  --token-c-sidenav-default-color-icon-nav-item: var(--token-palette-color-neutral-50);\n  --token-c-sidenav-default-color-text-nav-item-active: var(--token-palette-color-white);\n  --token-c-sidenav-default-color-text-nav-item: var(--token-palette-color-white);\n  --token-c-sidenav-default-color-notification: var(--token-palette-color-pink-40);\n  --token-c-sidenav-default-color-bg: var(--token-palette-color-neutral-60); /* hsla equivalent hsl(231, 48%, 8%, 1) */\n  --token-c-sidenav-menu-default-color-bg-item-active: var(--token-palette-color-neutral-10);\n  --token-c-sidenav-menu-default-color-icon-item: var(--token-palette-color-neutral-40);\n  --token-c-sidenav-menu-default-color-text-item-active: var(--token-palette-color-neutral-60);\n  --token-c-sidenav-menu-default-color-text-item: var(--token-palette-color-neutral-60);\n  --token-c-radio-color-active-strongest: var(--token-palette-color-indigo-20);\n  --token-c-radio-color-active-strong: var(--token-palette-color-indigo-10);\n  --token-c-radio-color-shadow-background: var(--token-palette-color-neutral-20);\n  --token-c-radio-color-border: var(--token-palette-color-neutral-30);\n  --token-c-radio-color-background: var(--token-palette-color-neutral-10);\n  --token-c-peoplepicker-size-default-height: var(--token-size-4000);\n  --token-c-peoplepicker-size-default-width: var(--token-size-3000);\n  --token-c-input-size-large: var(--token-size-600);\n  --token-c-input-size-medium: var(--token-size-500);\n  --token-c-input-size-small: var(--token-size-400);\n  --token-c-dialog-color-warning: var(--token-palette-color-red-40);\n  --token-c-dialog-color-informative: var(--token-palette-color-indigo-40);\n  --token-c-checkbox-color-active-strongest: var(--token-palette-color-indigo-20);\n  --token-c-checkbox-color-active-strong: var(--token-palette-color-indigo-10);\n  --token-c-checkbox-color-shadow-background: var(--token-palette-color-neutral-20);\n  --token-c-checkbox-color-border: var(--token-palette-color-neutral-30);\n  --token-c-checkbox-color-background: var(--token-palette-color-neutral-10);\n  --token-c-button-size-default: var(--token-c-button-size-medium);\n  --token-c-button-color-icon: var(--token-palette-color-neutral-10);\n  --token-c-button-color-outline-disabled: var(--token-palette-color-neutral-30);\n  --token-c-button-color-outline-strongest: var(--token-palette-color-indigo-50);\n  --token-c-button-color-outline-strong: var(--token-palette-color-indigo-40);\n  --token-c-button-color-outline-text: var(--token-palette-color-neutral-50);\n  --token-c-button-color-outline: var(--token-palette-color-neutral-30);\n  --token-c-button-color-ghost-border-disabled: var(--token-palette-color-neutral-50);\n  --token-c-button-color-ghost-text-disabled: var(--token-palette-color-neutral-50);\n  --token-c-button-color-ghost-border: var(--token-palette-color-white);\n  --token-c-button-color-slate-disabled: var(--token-palette-color-neutral-30);\n  --token-c-button-color-slate: var(--token-palette-color-neutral-base);\n  --token-c-button-color-warning-color: var(--token-palette-color-white);\n  --token-c-button-color-warning-strongest: var(--token-palette-color-red-60);\n  --token-c-button-color-warning-strong: var(--token-palette-color-red-50);\n  --token-c-button-color-warning: var(--token-palette-color-red-base);\n  --token-c-button-color-tertiary-border-focus: var(--token-palette-color-neutral-50);\n  --token-c-button-color-tertiary-disabled: var(--token-palette-color-neutral-30);\n  --token-c-button-color-tertiary-background-strongest: var(--token-palette-color-neutral-20);\n  --token-c-button-color-tertiary-background-strong: var(--token-palette-color-neutral-10);\n  --token-c-button-color-tertiary-color: var(--token-palette-color-neutral-60);\n  --token-c-button-color-tertiary: var(--token-palette-color-white);\n  --token-c-button-color-secondary-border-disabled: var(--token-palette-color-indigo-30);\n  --token-c-button-color-secondary-color-disabled: var(--token-palette-color-indigo-30);\n  --token-c-button-color-secondary-disabled: var(--token-palette-color-indigo-30);\n  --token-c-button-color-secondary: var(--token-palette-color-indigo-30);\n  --token-c-button-color-primary: var(--token-palette-color-indigo-30);\n  --token-c-banner-color-text: var(--token-palette-color-neutral-60);\n  --token-c-banner-color-error: var(--token-palette-color-red-20);\n  --token-c-banner-color-warning: var(--token-palette-color-yellow-20);\n  --token-c-banner-color-default: var(--token-palette-color-indigo-20);\n  --token-c-avatar-size-xx-large: var(--token-size-700);\n  --token-c-avatar-size-x-large: var(--token-size-600);\n  --token-c-avatar-size-large: var(--token-size-500);\n  --token-c-avatar-size-medium: var(--token-size-400);\n  --token-c-avatar-size-small: var(--token-size-300);\n  --token-c-avatar-size-default: var(--token-size-300);\n  --token-c-assignee-picker-color-bg: var(--token-palette-color-white);\n  --token-c-alert-text-error: var(--token-palette-color-white);\n  --token-c-alert-text-warning: var(--token-palette-color-neutral-60);\n  --token-c-alert-text-success: var(--token-palette-color-neutral-60);\n  --token-c-alert-text-information: var(--token-palette-color-white);\n  --token-c-alert-color-error: var(--token-palette-color-red-40);\n  --token-c-alert-color-warning: var(--token-palette-color-yellow-40);\n  --token-c-alert-color-success: var(--token-palette-color-green-40);\n  --token-c-alert-color-information: var(--token-palette-color-indigo-40);\n  --token-font-size-label-large: var(--token-size-175);\n  --token-font-size-label-default: var(--token-size-150);\n  --token-font-size-caption: var(--token-size-150);\n  --token-font-size-heading-four: var(--token-size-250);\n  --token-font-size-heading-three: var(--token-size-300);\n  --token-font-size-heading-two: var(--token-size-350);\n  --token-font-size-heading-one: var(--token-size-400);\n  --token-font-size-base: var(--token-size-200);\n  --token-font-size-default: var(--token-size-175);\n  --token-font-size-xs: var(--token-size-150);\n  --token-ui-input-border-focus: var(--token-palette-color-indigo-30);\n  --token-ui-input-bg-focus: var(--token-palette-color-neutral-10);\n  --token-ui-success: var(--token-palette-color-green-40);\n  --token-ui-warning: var(--token-palette-color-yellow-40);\n  --token-ui-error: var(--token-palette-color-red-40);\n  --token-ui-primary-pressed: var(--token-palette-color-indigo-60);\n  --token-ui-primary-hover: var(--token-palette-color-indigo-50);\n  --token-ui-primary: var(--token-palette-color-indigo-40);\n  --token-ui-bg-icons-btn: var(--token-palette-color-neutral-10);\n  --token-ui-icons-hover: var(--token-palette-color-neutral-30);\n  --token-ui-icons: var(--token-palette-color-neutral-20);\n  --token-ui-text-03: var(--token-palette-color-neutral-40);\n  --token-ui-text-02: var(--token-palette-color-neutral-50);\n  --token-ui-text-01: var(--token-palette-color-neutral-60);\n  --token-ui-disabled: var(--token-palette-color-neutral-30);\n  --token-ui-divider: var(--token-palette-color-neutral-10);\n  --token-ui-bg-dropdownselected: var(--token-palette-color-neutral-20);\n  --token-ui-bg-hover: var(--token-palette-color-neutral-20);\n  --token-ui-bg: var(--token-palette-color-neutral-10);\n  --token-color-bg-hover: var(--token-palette-color-neutral-20);\n  --token-color-bg: var(--token-palette-color-neutral-10);\n  --token-color-divider: var(--token-palette-color-neutral-10);\n  --token-color-text-error: var(--token-palette-color-red-40);\n  --token-color-text-disabled: var(--token-palette-color-neutral-40);\n  --token-color-text-secondary: var(--token-palette-color-neutral-50);\n  --token-color-text: var(--token-palette-color-neutral-60);\n  --token-color-error: var(--token-palette-color-red-40);\n  --token-color-warning-disabled: var(--token-palette-color-red-20);\n  --token-color-warning: var(--token-palette-color-yellow-40);\n  --token-color-success: var(--token-palette-color-green-40);\n  --token-color-secondary-strongest: var(--token-palette-color-indigo-20);\n  --token-color-secondary-strong: var(--token-palette-color-indigo-10);\n  --token-color-primary-disabled: var(--token-palette-color-indigo-20);\n  --token-color-primary-strongest: var(--token-palette-color-indigo-60);\n  --token-color-primary-strong: var(--token-palette-color-indigo-50);\n  --token-color-primary: var(--token-palette-color-indigo-40);\n  --token-color-white: var(--token-palette-color-white);\n  --token-border-radius-lg: var(--token-size-150);\n  --token-border-radius-md: var(--token-size-100);\n  --token-border-radius-default: var(--token-size-50);\n  --token-border-radius-sm: var(--token-size-50);\n  --token-border-color-success: var(--token-palette-color-green-40);\n  --token-border-color-warning: var(--token-palette-color-yellow-40);\n  --token-border-color-error: var(--token-palette-color-red-40);\n  --token-border-color-primary-pressed: var(--token-palette-color-indigo-60);\n  --token-border-color-primary-hover: var(--token-palette-color-indigo-50);\n  --token-border-color-primary-default: var(--token-palette-color-indigo-40);\n  --token-border-color-input-focus: var(--token-palette-color-indigo-40);\n  --token-border-color-input: var(--token-palette-color-neutral-20);\n  --token-border-color-dividers: var(--token-palette-color-neutral-10);\n  --token-border-color-default: var(--token-palette-color-neutral-20);\n  --token-c-input-size-default: var(--token-c-input-size-small);\n}\n/* Todo Optimize how we are normalize shadow dom reset styles */\n/* ! tailwindcss v2.2.19 | MIT License | https://tailwindcss.com */\n/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n/*\nDocument\n========\n*/\n/**\nUse a better box model (opinionated).\n*/\n*,\n::before,\n::after {\n	box-sizing: border-box;\n}\n/**\nUse a more readable tab size (opinionated).\n*/\nhtml {\n	-moz-tab-size: 4;\n	tab-size: 4;\n}\n/**\n1. Correct the line height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n*/\nhtml {\n	line-height: 1.15; /* 1 */\n	-webkit-text-size-adjust: 100%; /* 2 */\n}\n/*\nSections\n========\n*/\n/**\nRemove the margin in all browsers.\n*/\nbody {\n	margin: 0;\n}\n/**\nImprove consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n*/\nbody {\n	font-family:\n		system-ui,\n		-apple-system, /* Firefox supports this but not yet `system-ui` */\n		'Segoe UI',\n		Roboto,\n		Helvetica,\n		Arial,\n		sans-serif,\n		'Apple Color Emoji',\n		'Segoe UI Emoji';\n}\n/*\nGrouping content\n================\n*/\n/**\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n*/\nhr {\n	height: 0; /* 1 */\n	color: inherit; /* 2 */\n}\n/*\nText-level semantics\n====================\n*/\n/**\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\nabbr[title] {\n	text-decoration: underline dotted;\n}\n/**\nAdd the correct font weight in Edge and Safari.\n*/\nb,\nstrong {\n	font-weight: bolder;\n}\n/**\n1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)\n2. Correct the odd 'em' font sizing in all browsers.\n*/\ncode,\nkbd,\nsamp,\npre {\n	font-family:\n		ui-monospace,\n		SFMono-Regular,\n		Consolas,\n		'Liberation Mono',\n		Menlo,\n		monospace; /* 1 */\n	font-size: 1em; /* 2 */\n}\n/**\nAdd the correct font size in all browsers.\n*/\nsmall {\n	font-size: 80%;\n}\n/**\nPrevent 'sub' and 'sup' elements from affecting the line height in all browsers.\n*/\nsub,\nsup {\n	font-size: 75%;\n	line-height: 0;\n	position: relative;\n	vertical-align: baseline;\n}\nsub {\n	bottom: -0.25em;\n}\nsup {\n	top: -0.5em;\n}\n/*\nTabular data\n============\n*/\n/**\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n*/\ntable {\n	text-indent: 0; /* 1 */\n	border-color: inherit; /* 2 */\n}\n/*\nForms\n=====\n*/\n/**\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n*/\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n	font-family: inherit; /* 1 */\n	font-size: 100%; /* 1 */\n	line-height: 1.15; /* 1 */\n	margin: 0; /* 2 */\n}\n/**\nRemove the inheritance of text transform in Edge and Firefox.\n1. Remove the inheritance of text transform in Firefox.\n*/\nbutton,\nselect { /* 1 */\n	text-transform: none;\n}\n/**\nCorrect the inability to style clickable types in iOS and Safari.\n*/\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n	-webkit-appearance: button;\n}\n/**\nRemove the inner border and padding in Firefox.\n*/\n::-moz-focus-inner {\n	border-style: none;\n	padding: 0;\n}\n/**\nRestore the focus styles unset by the previous rule.\n*/\n:-moz-focusring {\n	outline: 1px dotted ButtonText;\n}\n/**\nRemove the additional ':invalid' styles in Firefox.\nSee: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737\n*/\n:-moz-ui-invalid {\n	box-shadow: none;\n}\n/**\nRemove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.\n*/\nlegend {\n	padding: 0;\n}\n/**\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\nprogress {\n	vertical-align: baseline;\n}\n/**\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n	height: auto;\n}\n/**\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n[type='search'] {\n	-webkit-appearance: textfield; /* 1 */\n	outline-offset: -2px; /* 2 */\n}\n/**\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n::-webkit-search-decoration {\n	-webkit-appearance: none;\n}\n/**\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to 'inherit' in Safari.\n*/\n::-webkit-file-upload-button {\n	-webkit-appearance: button; /* 1 */\n	font: inherit; /* 2 */\n}\n/*\nInteractive\n===========\n*/\n/*\nAdd the correct display in Chrome and Safari.\n*/\nsummary {\n	display: list-item;\n}\n/**\n * Manually forked from SUIT CSS Base: https://github.com/suitcss/base\n * A thin layer on top of normalize.css that provides a starting point more\n * suitable for web applications.\n */\n/**\n * Removes the default spacing and border for appropriate elements.\n */\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\nbutton {\n  background-color: transparent;\n  background-image: none;\n}\nfieldset {\n  margin: 0;\n  padding: 0;\n}\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n/**\n * Tailwind custom reset styles\n */\n/**\n * 1. Use the user's configured `sans` font-family (with Tailwind's default\n *    sans-serif font stack as a fallback) as a sane default.\n * 2. Use Tailwind's default \"normal\" line-height so the user isn't forced\n *    to override it to ensure consistency even when using the default theme.\n */\nhtml {\n  font-family: \"Open Sans\"; /* 1 */\n  line-height: 1.5; /* 2 */\n}\n/**\n * Inherit font-family and line-height from `html` so users can set them as\n * a class directly on the `html` element.\n */\nbody {\n  font-family: inherit;\n  line-height: inherit;\n}\n/**\n * 1. Prevent padding and border from affecting element width.\n *\n *    We used to set this in the html element and inherit from\n *    the parent element for everything else. This caused issues\n *    in shadow-dom-enhanced elements like <details> where the content\n *    is wrapped by a div with box-sizing set to `content-box`.\n *\n *    https://github.com/mozdevs/cssremedy/issues/4\n *\n *\n * 2. Allow adding a border to an element by just adding a border-width.\n *\n *    By default, the way the browser specifies that an element should have no\n *    border is by setting it's border-style to `none` in the user-agent\n *    stylesheet.\n *\n *    In order to easily add borders to elements by just setting the `border-width`\n *    property, we change the default border-style for all elements to `solid`, and\n *    use border-width to hide them instead. This way our `border` utilities only\n *    need to set the `border-width` property instead of the entire `border`\n *    shorthand, making our border utilities much more straightforward to compose.\n *\n *    https://github.com/tailwindcss/tailwindcss/pull/116\n */\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: currentColor; /* 2 */\n}\n/*\n * Ensure horizontal rules are visible by default\n */\nhr {\n  border-top-width: 1px;\n}\n/**\n * Undo the `border-style: none` reset that Normalize applies to images so that\n * our `border-{width}` utilities have the expected effect.\n *\n * The Normalize reset is unnecessary for us since we default the border-width\n * to 0 on all elements.\n *\n * https://github.com/tailwindcss/tailwindcss/issues/362\n */\nimg {\n  border-style: solid;\n}\ntextarea {\n  resize: vertical;\n}\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  color: #a1a1aa;\n}\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n/**\n * Override legacy focus reset from Normalize with modern Firefox focus styles.\n *\n * This is actually an improvement over the new defaults in Firefox in our testing,\n * as it triggers the better focus styles even for links, which still use a dotted\n * outline in Firefox by default.\n */\n:-moz-focusring {\n	outline: auto;\n}\ntable {\n  border-collapse: collapse;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n/**\n * Reset links to optimize for opt-in styling instead of\n * opt-out.\n */\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n/**\n * Reset form element properties that are easy to forget to\n * style explicitly so you don't inadvertently introduce\n * styles that deviate from your design system. These styles\n * supplement a partial reset that is already applied by\n * normalize.css.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\n/**\n * Use the configured 'mono' font family for elements that\n * are expected to be rendered with a monospace font, falling\n * back to the system monospace stack if there is no configured\n * 'mono' font family.\n */\npre,\ncode,\nkbd,\nsamp {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n/**\n * 1. Make replaced elements `display: block` by default as that's\n *    the behavior you want almost all of the time. Inspired by\n *    CSS Remedy, with `svg` added as well.\n *\n *    https://github.com/mozdevs/cssremedy/issues/14\n * \n * 2. Add `vertical-align: middle` to align replaced elements more\n *    sensibly by default when overriding `display` by adding a\n *    utility like `inline`.\n *\n *    This can trigger a poorly considered linting error in some\n *    tools but is included by design.\n * \n *    https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210\n */\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n/**\n * Constrain images and videos to the parent width and preserve\n * their intrinsic aspect ratio.\n *\n * https://github.com/mozdevs/cssremedy/issues/14\n */\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n/**\n * Ensure the default browser behavior of the `hidden` attribute.\n */\n[hidden] {\n  display: none;\n}\n*, ::before, ::after {\n  border-color: currentColor;\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-blur: var(--tw-empty,/*!*/ /*!*/);\n  --tw-brightness: var(--tw-empty,/*!*/ /*!*/);\n  --tw-contrast: var(--tw-empty,/*!*/ /*!*/);\n  --tw-grayscale: var(--tw-empty,/*!*/ /*!*/);\n  --tw-hue-rotate: var(--tw-empty,/*!*/ /*!*/);\n  --tw-invert: var(--tw-empty,/*!*/ /*!*/);\n  --tw-saturate: var(--tw-empty,/*!*/ /*!*/);\n  --tw-sepia: var(--tw-empty,/*!*/ /*!*/);\n  --tw-drop-shadow: var(--tw-empty,/*!*/ /*!*/);\n  --tw-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1536px;\n  }\n}\n.pointer-events-none {\n  pointer-events: none;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.left-0 {\n  left: 0;\n}\n.top-0 {\n  top: 0;\n}\n.z-10 {\n  z-index: 10;\n}\n.m-0 {\n  margin: 0;\n}\n.ml-100 {\n  margin-left: 8px;\n}\n.mt-100 {\n  margin-top: 8px;\n}\n.mb-100 {\n  margin-bottom: 8px;\n}\n.mb-50 {\n  margin-bottom: 4px;\n}\n.mt-\\[24px\\] {\n  margin-top: 24px;\n}\n.mb-\\[20px\\] {\n  margin-bottom: 20px;\n}\n.mt-\\[20px\\] {\n  margin-top: 20px;\n}\n.mb-\\[16px\\] {\n  margin-bottom: 16px;\n}\n.box-border {\n  box-sizing: border-box;\n}\n.block {\n  display: block;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.table {\n  display: table;\n}\n.hidden {\n  display: none;\n}\n.h-full {\n  height: 100%;\n}\n.h-200 {\n  height: 16px;\n}\n.h-\\[var\\(--token-c-assignee-picker-size-default-list\\)\\] {\n  height: var(--token-c-assignee-picker-size-default-list);\n}\n.h-\\[64px\\] {\n  height: 64px;\n}\n.max-h-\\[200px\\] {\n  max-height: 200px;\n}\n.w-full {\n  width: 100%;\n}\n.w-2800 {\n  width: 224px;\n}\n.w-200 {\n  width: 16px;\n}\n.flex-1 {\n  flex: 1 1 0%;\n}\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n.flex-grow {\n  flex-grow: 1;\n}\n.flex-grow-0 {\n  flex-grow: 0;\n}\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-default {\n  cursor: default;\n}\n.list-none {\n  list-style-type: none;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-col {\n  flex-direction: column;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-center {\n  justify-content: center;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.break-words {\n  overflow-wrap: break-word;\n}\n.break-all {\n  word-break: break-all;\n}\n.rounded-sm {\n  border-radius: 0.25rem;\n}\n.rounded {\n  border-radius: 0.25rem;\n}\n.border {\n  border-width: 1px;\n}\n.border-\\[white\\] {\n  --tw-border-opacity: 1;\n  border-color: rgba(255, 255, 255, var(--tw-border-opacity));\n}\n.bg-black {\n  --tw-bg-opacity: 1;\n  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));\n}\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n.bg-transparent {\n  background-color: transparent;\n}\n.bg-\\[\\#4461D7\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgba(68, 97, 215, var(--tw-bg-opacity));\n}\n.bg-opacity-50 {\n  --tw-bg-opacity: 0.5;\n}\n.bg-center {\n  background-position: center;\n}\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n.p-0 {\n  padding: 0;\n}\n.px-200 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.py-100 {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.px-300 {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.px-150 {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.px-175 {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n.py-50 {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.py-\\[4px\\] {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.px-\\[18px\\] {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n.pl-100 {\n  padding-left: 8px;\n}\n.pb-100 {\n  padding-bottom: 8px;\n}\n.pl-300 {\n  padding-left: 24px;\n}\n.pt-150 {\n  padding-top: 12px;\n}\n.text-left {\n  text-align: left;\n}\n.text-center {\n  text-align: center;\n}\n.text-xs {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.text-default {\n  font-size: 14px;\n  line-height: 1.5;\n}\n.text-base {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.text-\\[14px\\] {\n  font-size: 14px;\n}\n.font-semibold {\n  font-weight: 600;\n}\n.leading-none {\n  line-height: 1;\n}\n.leading-\\[24px\\] {\n  line-height: 24px;\n}\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n}\n.text-primary {\n  --tw-text-opacity: 1;\n  color: rgba(68, 97, 215, var(--tw-text-opacity));\n}\n.filter {\n  filter: var(--tw-filter);\n}\n/* Todo Config Postcss to purge unused styles */\n.avatar{align-items:center;border-radius:9999px;display:flex;justify-content:center;overflow:hidden}\n.avatar--default{height:24px;width:24px}\n.avatar--default .avatar-icon{height:16px;width:16px}\n.avatar-company{fill:var(--token-ui-icons);background-color:var(--token-ui-bg)}\n.avatar-icon{fill:#fff}\n.avatar-stack>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(-8px*(1 - var(--tw-space-x-reverse)));margin-right:calc(-8px*var(--tw-space-x-reverse))}\n.btn{--tw-border-opacity:1;align-items:center;border-color:rgb(245 247 250/var(--tw-border-opacity));border-radius:.25rem;border-width:1px;display:inline-flex;font-size:16px;line-height:1.25;padding:12px 16px}\n.btn-icon{--tw-bg-opacity:1;background-color:rgb(245 247 250/var(--tw-bg-opacity));border-radius:9999px;border-style:none;height:24px;justify-content:center;padding:0;width:24px}\n.btn-clean{--tw-text-opacity:1;border-style:none;color:rgb(100 109 125/var(--tw-text-opacity))}\n.btn-clean:hover{opacity:.75}\n.btn-primary-link{--tw-text-opacity:1;border-color:transparent;color:rgb(68 97 215/var(--tw-text-opacity));padding:4px 0}\n.btn-primary-link:hover{--tw-text-opacity:1;color:rgb(60 85 189/var(--tw-text-opacity))}\n.btn-primary-borderless{--tw-text-opacity:1;border-color:transparent;color:rgb(68 97 215/var(--tw-text-opacity))}\n.btn-primary-borderless:hover{border-color:currentColor}\n.btn--small{font-size:14px;line-height:1.5;padding:4px 12px}\n.btn--large{font-size:20px;line-height:1.5;padding:12px 24px}\n.search{--tw-border-opacity:1;--tw-bg-opacity:1;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:rgb(255 255 255/var(--tw-bg-opacity));background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License)--%3E%3Cpath d='M507.3 484.7 365.8 343.2c31.2-36.4 49.3-83.5 49.3-135.2 0-114.9-93.13-208-208-208S0 93.13 0 208s93.12 208 207.1 208c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5c4 3.05 8.1 4.65 12.2 4.65s8.188-1.562 11.31-4.688c6.29-6.212 6.29-16.412-.01-22.612zM208 384c-97.9 0-176-79-176-176S110.1 32 208 32s176 78.1 176 176-79 176-176 176z' fill='%23646D7D'/%3E%3C/svg%3E\");background-position:.5em;background-repeat:no-repeat;background-size:1rem;border-color:rgb(245 247 250/var(--tw-border-opacity));border-radius:9999px;border-width:1px;bottom:0;box-sizing:border-box;font-family:Open Sans;font-size:16px;left:0;line-height:1.5;outline:2px solid transparent;outline-offset:2px;padding:4px 8px 4px 28px;position:relative;right:0;top:0}\n.search:focus{--tw-border-opacity:1;border-color:rgb(143 159 231/var(--tw-border-opacity));outline:2px solid transparent;outline-offset:2px}\n.search::-webkit-search-cancel-button{-webkit-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3Cpath d='M193.94 256 296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'/%3E%3C/svg%3E\");background-repeat:no-repeat;cursor:pointer;height:16px;position:relative;right:-8px;width:16px}\n.container{width:100%}\n@media (min-width:640px){.container{max-width:640px}}\n@media (min-width:768px){.container{max-width:768px}}\n@media (min-width:1024px){.container{max-width:1024px}}\n@media (min-width:1280px){.container{max-width:1280px}}\n@media (min-width:1536px){.container{max-width:1536px}}\n.pointer-events-none{pointer-events:none}\n.visible{visibility:visible}\n.invisible{visibility:hidden}\n.absolute{position:absolute}\n.relative{position:relative}\n.sticky{position:-webkit-sticky;position:sticky}\n.inset-0{bottom:0;left:0;right:0;top:0}\n.-right-100{right:-8px}\n.top-0{top:0}\n.right-0{right:0}\n.z-50{z-index:50}\n.mx-auto{margin-left:auto;margin-right:auto}\n.-mx-2{margin-left:-8px;margin-right:-8px}\n.-mx-3{margin-left:-12px;margin-right:-12px}\n.mt-2{margin-top:8px}\n.mt-4{margin-top:16px}\n.mt-8{margin-top:32px}\n.mt-1{margin-top:4px}\n.ml-2{margin-left:8px}\n.mt-0{margin-top:0}\n.ml-1{margin-left:4px}\n.mr-2{margin-right:8px}\n.mb-2{margin-bottom:8px}\n.mb-3{margin-bottom:12px}\n.ml-3{margin-left:12px}\n.mb-4{margin-bottom:16px}\n.mt-6{margin-top:24px}\n.mb-6{margin-bottom:24px}\n.mb-12{margin-bottom:48px}\n.-mt-3{margin-top:-12px}\n.-mb-4{margin-bottom:-16px}\n.box-border{box-sizing:border-box}\n.block{display:block}\n.inline-block{display:inline-block}\n.inline{display:inline}\n.flex{display:flex}\n.inline-flex{display:inline-flex}\n.table{display:table}\n.grid{display:grid}\n.contents{display:contents}\n.hidden{display:none}\n.h-300{height:24px}\n.h-200{height:16px}\n.h-24{height:96px}\n.h-6{height:24px}\n.h-16{height:64px}\n.h-28{height:112px}\n.h-36{height:144px}\n.h-full{height:100%}\n.max-h-screen{max-height:100vh}\n.w-300{width:24px}\n.w-200{width:16px}\n.w-full{width:100%}\n.w-6{width:24px}\n.w-10{width:40px}\n.w-28{width:112px}\n.max-w-xl{max-width:36rem}\n.max-w-md{max-width:28rem}\n.max-w-4xl{max-width:56rem}\n.max-w-full{max-width:100%}\n.flex-none{flex:none}\n.flex-shrink{flex-shrink:1}\n.border-collapse{border-collapse:collapse}\n.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}\n.cursor-pointer{cursor:pointer}\n.select-none{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n.resize{resize:both}\n.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}\n.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}\n.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}\n.flex-wrap{flex-wrap:wrap}\n.items-start{align-items:flex-start}\n.items-center{align-items:center}\n.justify-center{justify-content:center}\n.justify-between{justify-content:space-between}\n.justify-around{justify-content:space-around}\n.gap-6{gap:24px}\n.space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:calc(16px*(1 - var(--tw-space-x-reverse)));margin-right:calc(16px*var(--tw-space-x-reverse))}\n.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-bottom:calc(24px*var(--tw-space-y-reverse));margin-top:calc(24px*(1 - var(--tw-space-y-reverse)))}\n.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;border-bottom-width:calc(1px*var(--tw-divide-y-reverse));border-top-width:calc(1px*(1 - var(--tw-divide-y-reverse)))}\n.overflow-hidden{overflow:hidden}\n.overflow-y-auto{overflow-y:auto}\n.break-words{overflow-wrap:break-word}\n.rounded-full{border-radius:9999px}\n.rounded{border-radius:.25rem}\n.rounded-md{border-radius:.5rem}\n.rounded-sm{border-radius:.25rem}\n.rounded-lg{border-radius:.75rem}\n.border{border-width:1px}\n.border-0{border-width:0}\n.border-2{border-width:2px}\n.border-b-2{border-bottom-width:2px}\n.border-t{border-top-width:1px}\n.border-b{border-bottom-width:1px}\n.border-l{border-left-width:1px}\n.border-none{border-style:none}\n.border-default{--tw-border-opacity:1;border-color:rgb(245 247 250/var(--tw-border-opacity))}\n.border-transparent{border-color:transparent}\n.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}\n.bg-searchIcon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.0.0-beta2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License)--%3E%3Cpath d='M507.3 484.7 365.8 343.2c31.2-36.4 49.3-83.5 49.3-135.2 0-114.9-93.13-208-208-208S0 93.13 0 208s93.12 208 207.1 208c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5c4 3.05 8.1 4.65 12.2 4.65s8.188-1.562 11.31-4.688c6.29-6.212 6.29-16.412-.01-22.612zM208 384c-97.9 0-176-79-176-176S110.1 32 208 32s176 78.1 176 176-79 176-176 176z' fill='%23646D7D'/%3E%3C/svg%3E\")}\n.bg-xIcon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3Cpath d='M193.94 256 296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'/%3E%3C/svg%3E\")}\n.bg-size-input-icon{background-size:1rem}\n.bg-position-search-icon{background-position:.5em}\n.bg-no-repeat{background-repeat:no-repeat}\n.fill-current{fill:currentColor}\n.p-3{padding:12px}\n.p-4{padding:16px}\n.p-6{padding:24px}\n.px-200{padding-left:16px;padding-right:16px}\n.py-150{padding-bottom:12px;padding-top:12px}\n.px-0{padding-left:0;padding-right:0}\n.py-0{padding-bottom:0;padding-top:0}\n.px-150{padding-left:12px;padding-right:12px}\n.py-50{padding-bottom:4px;padding-top:4px}\n.px-300{padding-left:24px;padding-right:24px}\n.px-6{padding-left:24px;padding-right:24px}\n.py-12{padding-bottom:48px;padding-top:48px}\n.py-8{padding-bottom:32px;padding-top:32px}\n.py-1{padding-bottom:4px;padding-top:4px}\n.py-2{padding-bottom:8px;padding-top:8px}\n.px-2{padding-left:8px;padding-right:8px}\n.px-3{padding-left:12px;padding-right:12px}\n.px-4{padding-left:16px;padding-right:16px}\n.pl-350{padding-left:28px}\n.pr-100{padding-right:8px}\n.pt-2{padding-top:8px}\n.pt-3{padding-top:12px}\n.pt-8{padding-top:32px}\n.pb-12{padding-bottom:48px}\n.pr-20{padding-right:80px}\n.text-center{text-align:center}\n.align-middle{vertical-align:middle}\n.font-sans{font-family:Open Sans}\n.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}\n.text-base{font-size:16px;line-height:1.5}\n.text-lg{font-size:24px;line-height:1.5}\n.text-xs{font-size:12px;line-height:1.5}\n.font-bold{font-weight:700}\n.leading-tight{line-height:1.25}\n.leading-none{line-height:1}\n.text-text-secondary{--tw-text-opacity:1;color:rgb(100 109 125/var(--tw-text-opacity))}\n.text-primary{--tw-text-opacity:1;color:rgb(68 97 215/var(--tw-text-opacity))}\n.text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity))}\n.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}\n.underline{-webkit-text-decoration-line:underline;text-decoration-line:underline}\n.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}\n.opacity-0{opacity:0}\n.opacity-100{opacity:1}\n.shadow-sm{--tw-shadow:0px 4px 12px rgba(11,14,31,.12);--tw-shadow-colored:0px 4px 12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}\n.shadow-md{--tw-shadow:0px 8px 24px rgba(11,14,31,.16);--tw-shadow-colored:0px 8px 24px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}\n.outline-none{outline:2px solid transparent;outline-offset:2px}\n.outline{outline-style:solid}\n.transition{transition-duration:.15s;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-timing-function:cubic-bezier(.4,0,.2,1)}\n.duration-100{transition-duration:.1s}\n.duration-150{transition-duration:.15s}\n.duration-200{transition-duration:.2s}\n.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}\n.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}\n.focus\\:border-focus--input:focus{--tw-border-opacity:1;border-color:rgb(143 159 231/var(--tw-border-opacity))}\n.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}\n/* PeoplePicker Override Styles */\n/* Set the width of the people picker */\n:host {\n  font-size: 16px;\n}\n.element-popover__content {\n  width: 240px;\n  overflow: hidden;\n  border-radius: 0.5rem;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  --tw-shadow: 0px 4px 12px rgba(11, 14, 31, 0.12);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}";
function tryOnScopeDispose(fn2) {
  if (getCurrentScope()) {
    onScopeDispose(fn2);
    return true;
  }
  return false;
}
const isClient = typeof window !== "undefined";
const isString$4 = (val) => typeof val === "string";
const noop$1 = () => {
};
function createFilterWrapper(filter, fn2) {
  function wrapper(...args) {
    filter(() => fn2.apply(this, args), { fn: fn2, thisArg: this, args });
  }
  return wrapper;
}
const bypassFilter = (invoke) => {
  return invoke();
};
function debounceFilter(ms2, options = {}) {
  let timer;
  let maxTimer;
  const filter = (invoke) => {
    const duration = unref(ms2);
    const maxDuration = unref(options.maxWait);
    if (timer)
      clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        clearTimeout(maxTimer);
        maxTimer = null;
      }
      return invoke();
    }
    if (maxDuration && !maxTimer) {
      maxTimer = setTimeout(() => {
        if (timer)
          clearTimeout(timer);
        maxTimer = null;
        invoke();
      }, maxDuration);
    }
    timer = setTimeout(() => {
      if (maxTimer)
        clearTimeout(maxTimer);
      maxTimer = null;
      invoke();
    }, duration);
  };
  return filter;
}
function useDebounceFn(fn2, ms2 = 200, options = {}) {
  return createFilterWrapper(debounceFilter(ms2, options), fn2);
}
function useDebounce(value, ms2 = 200, options = {}) {
  if (ms2 <= 0)
    return value;
  const debounced = ref(value.value);
  const updater = useDebounceFn(() => {
    debounced.value = value.value;
  }, ms2, options);
  watch(value, () => updater());
  return debounced;
}
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __objRest$5 = (source4, exclude) => {
  var target = {};
  for (var prop in source4)
    if (__hasOwnProp$9.call(source4, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source4[prop];
  if (source4 != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source4)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source4, prop))
        target[prop] = source4[prop];
    }
  return target;
};
function watchWithFilter(source4, cb, options = {}) {
  const _a = options, {
    eventFilter = bypassFilter
  } = _a, watchOptions = __objRest$5(_a, [
    "eventFilter"
  ]);
  return watch(source4, createFilterWrapper(eventFilter, cb), watchOptions);
}
function unrefElement(elRef) {
  var _a;
  const plain = unref(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...args) {
  let target;
  let event;
  let listener;
  let options;
  if (isString$4(args[0])) {
    [event, listener, options] = args;
    target = defaultWindow;
  } else {
    [target, event, listener, options] = args;
  }
  if (!target)
    return noop$1;
  let cleanup = noop$1;
  const stopWatch = watch(() => unref(target), (el) => {
    cleanup();
    if (!el)
      return;
    el.addEventListener(event, listener, options);
    cleanup = () => {
      el.removeEventListener(event, listener, options);
      cleanup = noop$1;
    };
  }, { immediate: true, flush: "post" });
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
function onClickOutside(target, handler, options = {}) {
  const { window: window2 = defaultWindow, event = "pointerdown" } = options;
  if (!window2)
    return;
  const listener = (event2) => {
    const el = unrefElement(target);
    if (!el)
      return;
    if (el === event2.target || event2.composedPath().includes(el))
      return;
    handler(event2);
  };
  return useEventListener(window2, event, listener, { passive: true });
}
const StorageSerializers = {
  boolean: {
    read: (v2) => v2 === "true",
    write: (v2) => String(v2)
  },
  object: {
    read: (v2) => JSON.parse(v2),
    write: (v2) => JSON.stringify(v2)
  },
  number: {
    read: (v2) => Number.parseFloat(v2),
    write: (v2) => String(v2)
  },
  any: {
    read: (v2) => v2,
    write: (v2) => String(v2)
  },
  string: {
    read: (v2) => v2,
    write: (v2) => String(v2)
  },
  map: {
    read: (v2) => new Map(JSON.parse(v2)),
    write: (v2) => JSON.stringify(Array.from(v2.entries()))
  },
  set: {
    read: (v2) => new Set(JSON.parse(v2)),
    write: (v2) => JSON.stringify(Array.from(v2.entries()))
  }
};
function useStorage(key, initialValue, storage = ((_a) => (_a = defaultWindow) == null ? void 0 : _a.localStorage)(), options = {}) {
  var _a2;
  const {
    flush = "pre",
    deep = true,
    listenToStorageChanges = true,
    writeDefaults = true,
    shallow,
    window: window2 = defaultWindow,
    eventFilter,
    onError = (e2) => {
      console.error(e2);
    }
  } = options;
  const rawInit = unref(initialValue);
  const type = rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : Array.isArray(rawInit) ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
  const data2 = (shallow ? shallowRef : ref)(initialValue);
  const serializer = (_a2 = options.serializer) != null ? _a2 : StorageSerializers[type];
  function read2(event) {
    if (!storage || event && event.key !== key)
      return;
    try {
      const rawValue = event ? event.newValue : storage.getItem(key);
      if (rawValue == null) {
        data2.value = rawInit;
        if (writeDefaults && rawInit !== null)
          storage.setItem(key, serializer.write(rawInit));
      } else {
        data2.value = serializer.read(rawValue);
      }
    } catch (e2) {
      onError(e2);
    }
  }
  read2();
  if (window2 && listenToStorageChanges)
    useEventListener(window2, "storage", (e2) => setTimeout(() => read2(e2), 0));
  if (storage) {
    watchWithFilter(data2, () => {
      try {
        if (data2.value == null)
          storage.removeItem(key);
        else
          storage.setItem(key, serializer.write(data2.value));
      } catch (e2) {
        onError(e2);
      }
    }, {
      flush,
      deep,
      eventFilter
    });
  }
  return data2;
}
var SwipeDirection;
(function(SwipeDirection2) {
  SwipeDirection2["UP"] = "UP";
  SwipeDirection2["RIGHT"] = "RIGHT";
  SwipeDirection2["DOWN"] = "DOWN";
  SwipeDirection2["LEFT"] = "LEFT";
  SwipeDirection2["NONE"] = "NONE";
})(SwipeDirection || (SwipeDirection = {}));
const _hoisted_1$b = {
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};
const _hoisted_2$9 = /* @__PURE__ */ createBaseVNode("path", { d: "M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z" }, null, -1);
const _hoisted_3$7 = [
  _hoisted_2$9
];
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$7);
}
var __unplugin_components_1 = { name: "tw-assignee-picker-company", render: render$2 };
const _hoisted_1$a = {
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
};
const _hoisted_2$8 = /* @__PURE__ */ createBaseVNode("path", { d: "M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z" }, null, -1);
const _hoisted_3$6 = [
  _hoisted_2$8
];
function render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$6);
}
var __unplugin_components_0 = { name: "tw-assignee-picker-team", render: render$1 };
function i$1() {
  return (i$1 = Object.assign || function(r) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var i2 in t)
        Object.prototype.hasOwnProperty.call(t, i2) && (r[i2] = t[i2]);
    }
    return r;
  }).apply(this, arguments);
}
var e = { class: "icon", url: "/assets/svg/sprite.svg" }, u = function(r, n) {
  return n.url === "" ? "#" + r : n.url + "#" + r;
}, o = function(r) {
  var n = { height: null, width: null, viewBox: null };
  if (!r)
    return n;
  var t = r.toString().replace(/( |, |,)/g, " ").split(" "), i2 = t.length;
  if (i2 === 3 || i2 > 4)
    return console.warn('[vue-svg-sprite] size: "' + r + '" is not valid'), n;
  var e2 = [];
  return e2[0] = i2 < 4 ? 0 : t[0], e2[1] = i2 < 4 ? 0 : t[1], n.width = e2[2] = i2 < 4 ? t[0] : t[2], n.height = e2[3] = t[i2 - 1], n.viewBox = e2.join(" "), n;
}, v = i$1({}, e), s$1 = defineComponent({ name: "SvgSprite", props: { symbol: { type: String, required: true }, size: { type: String, validator: function(r) {
  return /^\d+( \d+( \d+ \d+)?)?$/.test(r);
} }, url: String }, setup: function(r, e2) {
  var s2 = e2.attrs;
  s2.class && s2.class.includes(v.class) && (v.class = null);
  var l = computed(function() {
    return u(r.symbol, i$1({}, v, { url: r.url === void 0 ? v.url : r.url }));
  }), f = computed(function() {
    return o(r.size);
  });
  return function() {
    return h$1("svg", { role: "presentation", class: v.class, width: f.value.width, height: f.value.height, viewBox: f.value.viewBox }, h$1("use", { "xmlns:xlink": "http://www.w3.org/1999/xlink", href: l.value, "xlink-href": l.value }));
  };
} });
i$1({}, e);
const avatarVariants = ["image", "company", "user", "userPlaceholder", "icon"];
const avatarSizes = ["default", "small", "large", "xlarge", "xxlarge", "table"];
const avatarIconSizes = {
  small: "10",
  default: "14",
  large: "16",
  xlarge: "20",
  xxlarge: "20",
  table: "28"
};
const props$1 = {
  source: {
    type: String,
    default: ""
  },
  variant: {
    type: String,
    default: "user",
    validator: (val) => {
      const valid = avatarVariants.includes(val);
      if (!valid) {
        console.error(`Invalid avatar variant specified "${val}". Valid values are [${avatarVariants}]`);
      }
      return valid;
    }
  },
  size: {
    type: String,
    default: "default",
    validator: (val) => {
      const valid = avatarSizes.includes(val);
      if (!valid) {
        console.error(`Invalid avatar size specified "${val}". Valid values are [${avatarSizes.slice(1)}]`);
      }
      return valid;
    }
  }
};
const useCommonAvatar = (variant2, size2, source4) => {
  const avatarClasses = computed(() => {
    const classes = ["avatar", "border", "border-[white]"];
    if (variant2) {
      classes.push(`avatar--${variant2.toLowerCase()}`);
    } else {
      classes.push("avatar");
    }
    if (size2) {
      classes.push(`avatar--${size2}`);
    } else {
      classes.push("avatar--default");
    }
    return classes;
  });
  const avatarIconSize = computed(() => {
    if (size2) {
      return avatarIconSizes[size2];
    } else {
      return avatarIconSizes["default"];
    }
  });
  return { avatarClasses, avatarIconSize, source: source4 };
};
var teamsIcons = "data:image/svg+xml;base64,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";
var _style_0$4 = '.avatar-icon svg[data-v-3807bd55]{fill:currentColor}.avatar--small[data-v-3807bd55]{width:24px;height:24px;font-size:12px;line-height:20px}.avatar--small svg[data-v-3807bd55]{width:10px;height:10px}.avatar--default[data-v-3807bd55]{width:32px;height:32px;font-size:14px;line-height:24px}.avatar--default svg[data-v-3807bd55]{width:14px;height:14px}.avatar--large[data-v-3807bd55]{width:40px;height:40px}.avatar--large svg[data-v-3807bd55]{width:16px;height:16px}.avatar--xlarge[data-v-3807bd55]{width:48px;height:48px}.avatar--xxlarge[data-v-3807bd55]{width:56px;height:56px}.avatar--large[data-v-3807bd55],.avatar--xlarge[data-v-3807bd55],.avatar--xxlarge[data-v-3807bd55]{font-size:16px;line-height:26px}.avatar--xlarge svg[data-v-3807bd55],.avatar--xxlarge svg[data-v-3807bd55]{width:20px;height:20px}.avatar--table[data-v-3807bd55]{width:28px;height:28px;font-size:13px;line-height:18px}.avatar--table svg[data-v-3807bd55]{width:14px;height:14px}.skeleton[data-v-3807bd55]{position:relative;overflow:hidden;height:24px;width:24px}.skeleton[data-v-3807bd55]:after{position:absolute;top:0;right:0;bottom:0;left:0;animation:shimmer-3807bd55 4s infinite linear;background:linear-gradient(to right,#e1e6ee 4%,#c5cee0 25%,#e1e6ee 36%);background-size:1000px 100%;content:""}@keyframes shimmer-3807bd55{0%{background-position:-1000px 0}to{background-position:1000px 0}}\n';
var _export_sfc$1 = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
const { variant: variant$1, size: size$1, source } = props$1;
const _sfc_main$9 = {
  name: "CAvatar",
  components: {
    SvgSprite: s$1
  },
  props: {
    source,
    variant: variant$1,
    size: size$1,
    icon: {
      type: String,
      required: false,
      default: ""
    },
    background: {
      type: String,
      required: false,
      default: "#E1E6EE"
    },
    color: {
      type: String,
      required: false,
      default: "#fff"
    },
    initials: {
      type: String,
      required: false,
      default: ""
    },
    name: {
      type: String,
      required: false,
      default: ""
    },
    skeleton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props2) {
    const { avatarClasses, avatarIconSize } = useCommonAvatar(props2.variant, props2.size);
    const imageVariant = props2.variant === "image" && props2.source && !props2.source.includes("noPhoto");
    const iconVariant = props2.variant === "icon" && props2.icon && props2.color;
    const companyVariant = props2.variant === "company";
    const teamVariant = props2.variant === "team";
    const bgColor = (str) => {
      const strNoSpaces = str.replace(/ /g, "");
      let hash2 = 0;
      for (let i2 = 0; i2 < strNoSpaces.length; i2++) {
        hash2 = strNoSpaces.charCodeAt(i2) + ((hash2 << 5) - hash2);
      }
      let colour = "#";
      for (let i2 = 0; i2 < 3; i2++) {
        const value = hash2 >> i2 * 8 & 255;
        colour += `00${value.toString(16)}`.substr(-2);
      }
      return colour;
    };
    return {
      avatarClasses,
      teamsIcons,
      avatarIconSize,
      bgColor,
      imageVariant,
      iconVariant,
      companyVariant,
      teamVariant
    };
  }
};
const _hoisted_1$9 = ["src"];
const _hoisted_2$7 = ["title"];
const _hoisted_3$5 = ["title"];
const _hoisted_4$5 = ["title"];
const _hoisted_5$3 = ["title"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SvgSprite = resolveComponent("SvgSprite");
  const _component_icon_tw_assignee_picker_team = __unplugin_components_0;
  const _component_icon_tw_assignee_picker_company = __unplugin_components_1;
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["avatar", $props.skeleton ? ["skeleton"] : []])
  }, [
    $setup.imageVariant ? (openBlock(), createElementBlock("img", {
      key: 0,
      class: normalizeClass(["avatar-image", $setup.avatarClasses]),
      src: $props.source
    }, null, 10, _hoisted_1$9)) : $setup.iconVariant ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass(["avatar-icon", $setup.avatarClasses]),
      style: normalizeStyle({ "background-color": $props.background, color: $props.color }),
      title: $props.name
    }, [
      createVNode(_component_SvgSprite, {
        symbol: $props.icon,
        size: $setup.avatarIconSize,
        url: $setup.teamsIcons
      }, null, 8, ["symbol", "size", "url"])
    ], 14, _hoisted_2$7)) : $setup.teamVariant ? (openBlock(), createElementBlock("div", {
      key: 2,
      class: normalizeClass(["avatar-icon", $setup.avatarClasses]),
      style: { "background-color": "#eeeeee", fill: "#777777" },
      title: $props.name
    }, [
      createVNode(_component_icon_tw_assignee_picker_team)
    ], 10, _hoisted_3$5)) : $setup.companyVariant ? (openBlock(), createElementBlock("div", {
      key: 3,
      class: normalizeClass(["avatar-company", $setup.avatarClasses]),
      style: { "background-color": "#eeeeee", fill: "#777777" },
      title: $props.name
    }, [
      createVNode(_component_icon_tw_assignee_picker_company, { style: { "background-color": "#eeeeee" } })
    ], 10, _hoisted_4$5)) : !$props.skeleton ? (openBlock(), createElementBlock("div", {
      key: 4,
      style: normalizeStyle({
        backgroundColor: $setup.bgColor($props.name)
      }),
      class: normalizeClass(["inline-flex justify-center text-white", $setup.avatarClasses]),
      title: $props.name
    }, toDisplayString(` ${$props.initials} `), 15, _hoisted_5$3)) : createCommentVNode("", true)
  ], 2);
}
var Avatar = /* @__PURE__ */ _export_sfc$1(_sfc_main$9, [["render", _sfc_render$4], ["styles", [_style_0$4]], ["__scopeId", "data-v-3807bd55"]]);
function isFunction$3(value) {
  return typeof value === "function";
}
const tooltipState = reactive({
  tooltipText: null,
  node: null,
  tooltipPlacement: null
});
function useTooltipManager() {
  function closeTooltip2() {
    tooltipState.tooltipText = null;
    tooltipState.node = null;
    tooltipState.tooltipPlacement = null;
  }
  function showTooltip2(text, domNode, tooltipPlacement) {
    if (!isFunction$3(domNode.getBoundingClientRect)) {
      throw new Error("Invalid 'node' specified in call to 'showTooltip'");
    }
    setTimeout(() => {
      tooltipState.tooltipText = text;
      tooltipState.node = domNode;
      tooltipState.tooltipPlacement = tooltipPlacement;
    }, 0);
  }
  return {
    tooltipText: computed(() => tooltipState.tooltipText),
    node: computed(() => tooltipState.node),
    tooltipPlacement: computed(() => tooltipState.tooltipPlacement),
    showTooltip: showTooltip2,
    closeTooltip: closeTooltip2
  };
}
const { showTooltip, closeTooltip } = useTooltipManager();
const show = (el, text) => {
  showTooltip(text, el, "top");
};
const close = () => {
  closeTooltip();
};
const tooltipDirective = {
  beforeMount(el, binding) {
    el.addEventListener("mouseenter", () => {
      show(el, el.tooltip || binding.value);
    });
    el.addEventListener("mouseleave", () => {
      close();
    });
  },
  updated(el, binding) {
    el.tooltip = binding.value;
  },
  unmounted(el) {
    el.removeEventListener("mouseenter", show);
    el.removeEventListener("mouseleave", close);
  }
};
const _hoisted_1$8 = { class: "flex items-center justify-start leading-none avatar-stack" };
const _hoisted_2$6 = { key: 0 };
const _hoisted_3$4 = { class: "inline-flex items-center justify-center leading-none avatar avatar--default bg-black text-white" };
const _hoisted_4$4 = { class: "text-xs" };
const _sfc_main$8 = {
  props: {
    size: props$1.size,
    users: {
      type: Object,
      default: () => {
      }
    },
    show: {
      type: Number,
      default: 2
    }
  },
  setup(__props) {
    const props2 = __props;
    const variantName = (user) => {
      if (user.value.startsWith("c-")) {
        return "company";
      } else if (user.value.startsWith("t-")) {
        return "team";
      }
      return user.icon ? "icon" : "image";
    };
    const visibleUsers = computed(() => {
      return props2.users.slice(0, props2.show).map((user) => __spreadProps(__spreadValues({}, user), {
        initials: user.firstName && user.lastName ? `${user.firstName[0].toUpperCase()}${user.lastName[0].toUpperCase()}` : ""
      }));
    });
    const hiddenUsers = computed(() => {
      return props2.users.slice(props2.show);
    });
    const hiddenUsersTooltip = computed(() => {
      return hiddenUsers.value.map((user) => user.name).sort((a, b) => {
        if (a.toLowerCase() < b.toLowerCase())
          return 1;
        if (a.toLowerCase() > b.toLowerCase())
          return -1;
        return 0;
      }).join(`<br>`);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$8, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleUsers), (user) => {
          return openBlock(), createElementBlock("div", {
            key: user.value
          }, [
            withDirectives(createVNode(Avatar, {
              variant: variantName(user),
              source: user.image,
              background: user.icon ? user.icon.color : "",
              icon: user.icon ? user.icon.name : "",
              initials: user.initials ? user.initials : "",
              name: user.name,
              size: __props.size
            }, null, 8, ["variant", "source", "background", "icon", "initials", "name", "size"]), [
              [unref(tooltipDirective), user.name]
            ])
          ]);
        }), 128)),
        unref(hiddenUsers).length ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$6, [
          createBaseVNode("span", _hoisted_3$4, [
            createBaseVNode("span", _hoisted_4$4, " +" + toDisplayString(unref(hiddenUsers).length), 1)
          ])
        ], 512)), [
          [unref(tooltipDirective), unref(hiddenUsersTooltip)]
        ]) : createCommentVNode("", true)
      ]);
    };
  }
};
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement$2(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;
    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }
    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }
  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getDocumentElement(element) {
  return ((isElement$2(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE = navigator.userAgent.indexOf("Trident") !== -1;
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn2());
        });
      });
    }
    return pending;
  };
}
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y: y2
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement$2(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement$2(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$2(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function getVariation(placement) {
  return placement.split("-")[1];
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys3) {
  return keys3.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$2(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement$2(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var passive = {
  passive: true
};
function effect$2(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect: effect$2,
  data: {}
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y2 = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y2 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y: y2
  }) : {
    x,
    y: y2
  };
  x = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y: y2
  }) : {
    x,
    y: y2
  };
  x = _ref4.x;
  y2 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y2 + "px)" : "translate3d(" + x + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$1(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$1,
  requires: ["computeStyles"]
};
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v2 = within(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i2 = 0; i2 < placements2.length; i2++) {
    var placement = placements2[i2];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data2 = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data2[state.placement], x = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data2;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data2 = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data2[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data2[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data2;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
var _style_0$3 = ".element-popover__content[data-v-1e79bf91]{padding:0}\n";
function isFunction$2(value) {
  return typeof value === "function";
}
const createPopper = popperGenerator({
  defaultModifiers: [...defaultModifiers, arrow$1, flip$1, hide$1, offset$1, preventOverflow$1]
});
const PLACEMENTS = Object.freeze({
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
});
const PLACEMENT_MODIFIERS = Object.freeze({
  START: "start",
  END: "end"
});
const _sfc_main$7 = {
  name: "CPopover",
  props: {
    element: {
      type: [Object, Element],
      required: false,
      default: null,
      validator(value) {
        if (!value) {
          return true;
        }
        if (!isFunction$2(value.getBoundingClientRect)) {
          return false;
        }
        return true;
      }
    },
    isArrowEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    positionFixed: {
      type: Boolean,
      required: false,
      default: true
    },
    placement: {
      type: String,
      required: false,
      default: PLACEMENTS.BOTTOM,
      validator(value) {
        const [placement, modifier] = value.split("-");
        if (!placement) {
          return false;
        }
        if (!PLACEMENTS[placement.toUpperCase()]) {
          return false;
        }
        if (modifier) {
          if (!PLACEMENT_MODIFIERS[modifier.toUpperCase()]) {
            return false;
          }
        }
        return true;
      }
    },
    offset: {
      type: Array,
      required: false,
      default: () => [0, 8]
    }
  },
  data() {
    return {
      popper: null
    };
  },
  computed: {
    offsetSkidding() {
      return this.offset[0];
    },
    offsetDistance() {
      return this.offset[1];
    },
    config() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? "fixed" : "absolute",
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              padding: 8
            }
          },
          {
            name: "arrow",
            options: {
              element: "[data-popper-arrow]",
              padding: 8
            }
          },
          {
            name: "offset",
            options: {
              offset: this.offset
            }
          }
        ]
      };
    }
  },
  mounted() {
    this.handlePopper();
  },
  updated() {
    this.handlePopper();
  },
  methods: {
    createPopper() {
      if (!this.element || !isFunction$2(this.element.getBoundingClientRect) || !this.$el || !isFunction$2(this.$el.getBoundingClientRect)) {
        return;
      }
      this.popper = createPopper(this.element, this.$el, this.config);
    },
    update() {
      if (this.popper && isFunction$2(this.popper.update)) {
        this.popper.update();
      }
    },
    scheduleUpdate() {
      if (this.popper && isFunction$2(this.popper.scheduleUpdate)) {
        this.popper.scheduleUpdate();
      }
    },
    destroyPopper() {
      if (this.popper && isFunction$2(this.popper.destroy)) {
        this.popper.destroy();
      }
    },
    handlePopper() {
      if (!this.element || !isFunction$2(this.element.getBoundingClientRect) || !this.$el || !isFunction$2(this.$el.getBoundingClientRect)) {
        this.destroyPopper();
        return;
      }
      this.createPopper();
    }
  }
};
const _hoisted_1$7 = {
  class: "element-popover",
  style: { "z-index": "9999" }
};
const _hoisted_2$5 = {
  class: "element-popover__arrow",
  "data-popper-arrow": ""
};
const _hoisted_3$3 = {
  ref: "content",
  class: "bg-white element-popover__content"
};
const _hoisted_4$3 = {
  ref: "spacer",
  class: "element-popover__spacer"
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    withDirectives(createBaseVNode("div", _hoisted_2$5, null, 512), [
      [vShow, $props.isArrowEnabled]
    ]),
    createBaseVNode("div", _hoisted_3$3, [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ], 512),
    createBaseVNode("div", _hoisted_4$3, null, 512)
  ]);
}
var Popover = /* @__PURE__ */ _export_sfc$1(_sfc_main$7, [["render", _sfc_render$3], ["styles", [_style_0$3]], ["__scopeId", "data-v-1e79bf91"]]);
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
function isNullish(val) {
  return [null, void 0, false].indexOf(val) !== -1;
}
function useData(props2, context, dep) {
  const { object, valueProp, mode } = toRefs(props2);
  const iv = dep.iv;
  const update = (val) => {
    iv.value = makeInternal(val);
    const externalVal = makeExternal(val);
    context.emit("change", externalVal);
    context.emit("input", externalVal);
    context.emit("update:modelValue", externalVal);
  };
  const makeExternal = (val) => {
    if (object.value) {
      return val;
    }
    if (isNullish(val)) {
      return val;
    }
    return !Array.isArray(val) ? val[valueProp.value] : val.map((v2) => v2[valueProp.value]);
  };
  const makeInternal = (val) => {
    if (isNullish(val)) {
      return mode.value === "single" ? {} : [];
    }
    return val;
  };
  return {
    update
  };
}
function useValue(props2, context) {
  const { value, modelValue, mode, valueProp } = toRefs(props2);
  const iv = ref(mode.value !== "single" ? [] : {});
  const ev = context.expose !== void 0 ? modelValue : value;
  const plainValue = computed(() => {
    return mode.value === "single" ? iv.value[valueProp.value] : iv.value.map((v2) => v2[valueProp.value]);
  });
  const textValue = computed(() => {
    return mode.value !== "single" ? iv.value.map((v2) => v2[valueProp.value]).join(",") : iv.value[valueProp.value];
  });
  return {
    iv,
    internalValue: iv,
    ev,
    externalValue: ev,
    textValue,
    plainValue
  };
}
function useSearch(props2, context, dep) {
  const search = ref(null);
  const input = ref(null);
  const clearSearch = () => {
    search.value = "";
  };
  const handleSearchInput = (e2) => {
    search.value = e2.target.value;
  };
  const handlePaste = (e2) => {
    context.emit("paste", e2);
  };
  watch(search, (val) => {
    context.emit("search-change", val);
  });
  return {
    search,
    input,
    clearSearch,
    handleSearchInput,
    handlePaste
  };
}
function usePointer$1(props2, context, dep) {
  const { groupSelect, mode, groups } = toRefs(props2);
  const pointer = ref(null);
  const setPointer = (option) => {
    if (option === void 0 || option !== null && option.disabled) {
      return;
    }
    if (groups.value && option && option.group && (mode.value === "single" || !groupSelect.value)) {
      return;
    }
    pointer.value = option;
  };
  const clearPointer = () => {
    setPointer(null);
  };
  return {
    pointer,
    setPointer,
    clearPointer
  };
}
function normalize(str, strict = true) {
  return strict ? String(str).toLowerCase().trim() : String(str).normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().trim();
}
function isObject$2(variable) {
  return Object.prototype.toString.call(variable) === "[object Object]";
}
function arraysEqual(array1, array2) {
  const array2Sorted = array2.slice().sort();
  return array1.length === array2.length && array1.slice().sort().every(function(value, index2) {
    return value === array2Sorted[index2];
  });
}
function useOptions(props2, context, dep) {
  const {
    options,
    mode,
    trackBy,
    limit,
    hideSelected,
    createTag,
    label,
    appendNewTag,
    multipleLabel,
    object,
    loading,
    delay,
    resolveOnLoad,
    minChars,
    filterResults,
    clearOnSearch,
    clearOnSelect,
    valueProp,
    canDeselect,
    max: max2,
    strict,
    closeOnSelect,
    groups: groupped,
    groupLabel,
    groupOptions,
    groupHideEmpty,
    groupSelect,
    shouldRefreshLabels,
    shouldShowSelectionsInPlace
  } = toRefs(props2);
  const iv = dep.iv;
  const ev = dep.ev;
  const search = dep.search;
  const clearSearch = dep.clearSearch;
  const update = dep.update;
  const pointer = dep.pointer;
  const clearPointer = dep.clearPointer;
  const blur = dep.blur;
  const deactivate = dep.deactivate;
  const ap = ref([]);
  const ro = ref([]);
  const resolving = ref(false);
  const eo = computed(() => {
    if (groupped.value) {
      let groups = ro.value || [];
      let eo2 = [];
      groups.forEach((group) => {
        optionsToArray(group[groupOptions.value]).forEach((option) => {
          eo2.push(Object.assign({}, option, group.disabled ? { disabled: true } : {}));
        });
      });
      return eo2;
    } else {
      let eo2 = optionsToArray(ro.value || []);
      if (ap.value.length) {
        eo2 = eo2.concat(ap.value);
      }
      return eo2;
    }
  });
  const fg = computed(() => {
    if (!groupped.value) {
      return [];
    }
    return filterGroups((ro.value || []).map((group) => {
      const arrayOptions = optionsToArray(group[groupOptions.value]);
      return __spreadProps$1(__spreadValues$1({}, group), {
        group: true,
        [groupOptions.value]: filterOptions(arrayOptions, false).map((o2) => Object.assign({}, o2, group.disabled ? { disabled: true } : {})),
        __VISIBLE__: filterOptions(arrayOptions, !shouldShowSelectionsInPlace).map((o2) => Object.assign({}, o2, group.disabled ? { disabled: true } : {}))
      });
    }));
  });
  const fo = computed(() => {
    let options2 = eo.value;
    if (createdTag.value.length) {
      options2 = createdTag.value.concat(options2);
    }
    options2 = filterOptions(options2, !shouldShowSelectionsInPlace);
    if (limit.value > 0) {
      options2 = options2.slice(0, limit.value);
    }
    return options2;
  });
  const hasSelected = computed(() => {
    switch (mode.value) {
      case "single":
        return !isNullish(iv.value[valueProp.value]);
      case "multiple":
      case "tags":
        return !isNullish(iv.value) && iv.value.length > 0;
    }
  });
  const multipleLabelText = computed(() => {
    return multipleLabel !== void 0 && multipleLabel.value !== void 0 ? multipleLabel.value(iv.value) : iv.value && iv.value.length > 1 ? `${iv.value.length} options selected` : `1 option selected`;
  });
  const noOptions = computed(() => {
    return !eo.value.length && !resolving.value && !createdTag.value.length;
  });
  const noResults = computed(() => {
    return eo.value.length > 0 && fo.value.length == 0 && (search.value && groupped.value || !groupped.value);
  });
  const createdTag = computed(() => {
    if (createTag.value === false || !search.value) {
      return [];
    }
    return getOptionByTrackBy(search.value) !== -1 ? [] : [
      {
        [valueProp.value]: search.value,
        [label.value]: search.value,
        [trackBy.value]: search.value
      }
    ];
  });
  const nullValue = computed(() => {
    switch (mode.value) {
      case "single":
        return null;
      case "multiple":
      case "tags":
        return [];
    }
  });
  const busy = computed(() => {
    return loading.value || resolving.value;
  });
  const select = (option) => {
    if (typeof option !== "object") {
      option = getOption(option);
    }
    switch (mode.value) {
      case "single":
        update(option);
        break;
      case "multiple":
      case "tags":
        update(iv.value.concat(option));
        break;
    }
    context.emit("select", finalValue(option), option);
  };
  const deselect = (option) => {
    if (typeof option !== "object") {
      option = getOption(option);
    }
    switch (mode.value) {
      case "single":
        clear2();
        break;
      case "tags":
      case "multiple":
        update(Array.isArray(option) ? iv.value.filter((v2) => option.map((o2) => o2[valueProp.value]).indexOf(v2[valueProp.value]) === -1) : iv.value.filter((v2) => v2[valueProp.value] != option[valueProp.value]));
        break;
    }
    context.emit("deselect", finalValue(option), option);
  };
  const finalValue = (option) => {
    return object.value ? option : option[valueProp.value];
  };
  const remove2 = (option) => {
    deselect(option);
  };
  const handleTagRemove = (option, e2) => {
    if (e2.button !== 0) {
      e2.preventDefault();
      return;
    }
    remove2(option);
  };
  const clear2 = () => {
    context.emit("clear");
    update(nullValue.value);
  };
  const isSelected = (option) => {
    if (option.group !== void 0) {
      return mode.value === "single" ? false : areAllSelected(option[groupOptions.value]) && option[groupOptions.value].length;
    }
    switch (mode.value) {
      case "single":
        return !isNullish(iv.value) && iv.value[valueProp.value] == option[valueProp.value];
      case "tags":
      case "multiple":
        return !isNullish(iv.value) && iv.value.map((o2) => o2[valueProp.value]).indexOf(option[valueProp.value]) !== -1;
    }
  };
  const isDisabled = (option) => {
    return option.disabled === true;
  };
  const isMax = () => {
    if (max2 === void 0 || max2.value === -1 || !hasSelected.value && max2.value > 0) {
      return false;
    }
    return iv.value.length >= max2.value;
  };
  const handleOptionClick = (option) => {
    if (isDisabled(option)) {
      return;
    }
    switch (mode.value) {
      case "single":
        if (isSelected(option)) {
          if (canDeselect.value) {
            deselect(option);
          }
          return;
        }
        blur();
        select(option);
        break;
      case "multiple":
        if (isSelected(option)) {
          deselect(option);
          return;
        }
        if (isMax()) {
          return;
        }
        select(option);
        if (clearOnSelect.value) {
          clearSearch();
        }
        if (hideSelected.value) {
          clearPointer();
        }
        if (closeOnSelect.value) {
          blur();
        }
        break;
      case "tags":
        if (isSelected(option)) {
          deselect(option);
          return;
        }
        if (isMax()) {
          return;
        }
        if (getOption(option[valueProp.value]) === void 0 && createTag.value) {
          context.emit("tag", option[valueProp.value]);
          if (appendNewTag.value) {
            appendOption(option);
          }
          clearSearch();
        }
        if (clearOnSelect.value) {
          clearSearch();
        }
        select(option);
        if (hideSelected.value) {
          clearPointer();
        }
        if (closeOnSelect.value) {
          blur();
        }
        break;
    }
    if (closeOnSelect.value) {
      deactivate();
    }
  };
  const handleGroupClick = (group) => {
    if (isDisabled(group) || mode.value === "single" || !groupSelect.value) {
      return;
    }
    switch (mode.value) {
      case "multiple":
      case "tags":
        if (areAllEnabledSelected(group[groupOptions.value])) {
          deselect(group[groupOptions.value]);
        } else {
          select(group[groupOptions.value].filter((o2) => iv.value.map((v2) => v2[valueProp.value]).indexOf(o2[valueProp.value]) === -1).filter((o2) => !o2.disabled).filter((o2, k) => iv.value.length + 1 + k <= max2.value || max2.value === -1));
        }
        break;
    }
    if (closeOnSelect.value) {
      deactivate();
    }
  };
  const areAllEnabledSelected = (options2) => {
    return options2.find((o2) => !isSelected(o2) && !o2.disabled) === void 0;
  };
  const areAllSelected = (options2) => {
    return options2.find((o2) => !isSelected(o2)) === void 0;
  };
  const getOption = (val) => {
    return eo.value[eo.value.map((o2) => String(o2[valueProp.value])).indexOf(String(val))];
  };
  const getOptionByTrackBy = (val, norm = true) => {
    return eo.value.map((o2) => o2[trackBy.value]).indexOf(val);
  };
  const shouldHideOption = (option) => {
    return ["tags", "multiple"].indexOf(mode.value) !== -1 && hideSelected.value && isSelected(option);
  };
  const appendOption = (option) => {
    ap.value.push(option);
  };
  const filterGroups = (groups) => {
    return groupHideEmpty.value ? groups.filter((g) => search.value ? g.__VISIBLE__.length : g[groupOptions.value].length) : groups.filter((g) => search.value ? g.__VISIBLE__.length : true);
  };
  const filterOptions = (options2, excludeHideSelected = true) => {
    let fo2 = options2;
    if (search.value && filterResults.value) {
      fo2 = fo2.filter((option) => {
        return normalize(option[trackBy.value], strict.value).indexOf(normalize(search.value, strict.value)) !== -1;
      });
    }
    if (hideSelected.value && excludeHideSelected) {
      fo2 = fo2.filter((option) => !shouldHideOption(option));
    }
    return fo2;
  };
  const optionsToArray = (options2) => {
    let uo = options2;
    if (isObject$2(uo)) {
      uo = Object.keys(uo).map((key) => {
        let val = uo[key];
        return { [valueProp.value]: key, [trackBy.value]: val, [label.value]: val };
      });
    }
    uo = uo.map((val) => {
      return typeof val === "object" ? val : { [valueProp.value]: val, [trackBy.value]: val, [label.value]: val };
    });
    return uo;
  };
  const initInternalValue = () => {
    if (!isNullish(ev.value)) {
      iv.value = makeInternal(ev.value);
    }
  };
  const resolveOptions = (callback) => {
    resolving.value = true;
    options.value(search.value).then((response) => {
      ro.value = response;
      if (typeof callback == "function") {
        callback(response);
      }
      resolving.value = false;
    });
  };
  const refreshLabels = () => {
    if (!hasSelected.value) {
      return;
    }
    if (mode.value === "single") {
      let newLabel = getOption(iv.value[valueProp.value])[label.value];
      iv.value[label.value] = newLabel;
      if (object.value) {
        ev.value[label.value] = newLabel;
      }
    } else {
      iv.value.forEach((val, i2) => {
        let newLabel = getOption(iv.value[i2][valueProp.value])[label.value];
        iv.value[i2][label.value] = newLabel;
        if (object.value) {
          ev.value[i2][label.value] = newLabel;
        }
      });
    }
  };
  const refreshOptions = (callback) => {
    resolveOptions(callback);
  };
  const makeInternal = (val) => {
    if (isNullish(val)) {
      return mode.value === "single" ? {} : [];
    }
    if (object.value) {
      return val;
    }
    return mode.value === "single" ? getOption(val) || {} : val.filter((v2) => !!getOption(v2)).map((v2) => getOption(v2));
  };
  if (mode.value !== "single" && !isNullish(ev.value) && !Array.isArray(ev.value)) {
    throw new Error(`v-model must be an array when using "${mode.value}" mode`);
  }
  if (options && typeof options.value == "function") {
    if (resolveOnLoad.value) {
      resolveOptions(initInternalValue);
    } else if (object.value == true) {
      initInternalValue();
    }
  } else {
    ro.value = options.value;
    initInternalValue();
  }
  if (delay.value > -1) {
    watch(search, (query) => {
      if (query.length < minChars.value) {
        return;
      }
      resolving.value = true;
      if (clearOnSearch.value) {
        ro.value = [];
      }
      setTimeout(() => {
        if (query != search.value) {
          return;
        }
        options.value(search.value).then((response) => {
          if (query == search.value) {
            ro.value = response;
            pointer.value = fo.value.filter((o2) => o2.disabled !== true)[0] || null;
            resolving.value = false;
          }
        });
      }, delay.value);
    }, { flush: "sync" });
  }
  watch(ev, (newValue) => {
    if (isNullish(newValue)) {
      iv.value = makeInternal(newValue);
      return;
    }
    switch (mode.value) {
      case "single":
        if (object.value ? newValue[valueProp.value] != iv.value[valueProp.value] : newValue != iv.value[valueProp.value]) {
          iv.value = makeInternal(newValue);
        }
        break;
      case "multiple":
      case "tags":
        if (!arraysEqual(object.value ? newValue.map((o2) => o2[valueProp.value]) : newValue, iv.value.map((o2) => o2[valueProp.value]))) {
          iv.value = makeInternal(newValue);
        }
        break;
    }
  }, { deep: true });
  if (typeof props2.options !== "function") {
    watch(options, (n, o2) => {
      ro.value = props2.options;
      if (!Object.keys(iv.value).length) {
        initInternalValue();
      }
      if (shouldRefreshLabels.value) {
        refreshLabels();
      }
    });
  }
  return {
    fo,
    filteredOptions: fo,
    hasSelected,
    multipleLabelText,
    eo,
    extendedOptions: eo,
    fg,
    filteredGroups: fg,
    noOptions,
    noResults,
    resolving,
    busy,
    select,
    deselect,
    remove: remove2,
    clear: clear2,
    isSelected,
    isDisabled,
    isMax,
    getOption,
    handleOptionClick,
    handleGroupClick,
    handleTagRemove,
    refreshOptions,
    resolveOptions
  };
}
function usePointer(props2, context, dep) {
  const {
    valueProp,
    showOptions,
    searchable,
    groupLabel,
    groups: groupped,
    mode,
    groupSelect
  } = toRefs(props2);
  const fo = dep.fo;
  const fg = dep.fg;
  const handleOptionClick = dep.handleOptionClick;
  const handleGroupClick = dep.handleGroupClick;
  const search = dep.search;
  const pointer = dep.pointer;
  const setPointer = dep.setPointer;
  const clearPointer = dep.clearPointer;
  const multiselect = dep.multiselect;
  const options = computed(() => {
    return fo.value.filter((o2) => !o2.disabled);
  });
  const groups = computed(() => {
    return fg.value.filter((o2) => !o2.disabled);
  });
  const canPointGroups = computed(() => {
    return mode.value !== "single" && groupSelect.value;
  });
  const isPointerGroup = computed(() => {
    return pointer.value && pointer.value.group;
  });
  const currentGroup = computed(() => {
    return getParentGroup(pointer.value);
  });
  const prevGroup = computed(() => {
    const group = isPointerGroup.value ? pointer.value : getParentGroup(pointer.value);
    const groupIndex = groups.value.map((g) => g[groupLabel.value]).indexOf(group[groupLabel.value]);
    let prevGroup2 = groups.value[groupIndex - 1];
    if (prevGroup2 === void 0) {
      prevGroup2 = lastGroup.value;
    }
    return prevGroup2;
  });
  const nextGroup = computed(() => {
    let nextIndex = groups.value.map((g) => g.label).indexOf(isPointerGroup.value ? pointer.value[groupLabel.value] : getParentGroup(pointer.value)[groupLabel.value]) + 1;
    if (groups.value.length <= nextIndex) {
      nextIndex = 0;
    }
    return groups.value[nextIndex];
  });
  const lastGroup = computed(() => {
    return [...groups.value].slice(-1)[0];
  });
  const currentGroupFirstEnabledOption = computed(() => {
    return pointer.value.__VISIBLE__.filter((o2) => !o2.disabled)[0];
  });
  const currentGroupPrevEnabledOption = computed(() => {
    const options2 = currentGroup.value.__VISIBLE__.filter((o2) => !o2.disabled);
    return options2[options2.map((o2) => o2[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1];
  });
  const currentGroupNextEnabledOption = computed(() => {
    const options2 = getParentGroup(pointer.value).__VISIBLE__.filter((o2) => !o2.disabled);
    return options2[options2.map((o2) => o2[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1];
  });
  const prevGroupLastEnabledOption = computed(() => {
    return [...prevGroup.value.__VISIBLE__.filter((o2) => !o2.disabled)].slice(-1)[0];
  });
  const lastGroupLastEnabledOption = computed(() => {
    return [...lastGroup.value.__VISIBLE__.filter((o2) => !o2.disabled)].slice(-1)[0];
  });
  const isPointed = (option) => {
    return !!pointer.value && (!option.group && pointer.value[valueProp.value] == option[valueProp.value] || option.group !== void 0 && pointer.value[groupLabel.value] == option[groupLabel.value]) ? true : void 0;
  };
  const setPointerFirst = () => {
    setPointer(options.value[0] || null);
  };
  const selectPointer = () => {
    if (!pointer.value || pointer.value.disabled === true) {
      return;
    }
    if (isPointerGroup.value) {
      handleGroupClick(pointer.value);
    } else {
      handleOptionClick(pointer.value);
    }
  };
  const forwardPointer = () => {
    if (pointer.value === null) {
      setPointer((groupped.value && canPointGroups.value ? groups.value[0] : options.value[0]) || null);
    } else if (groupped.value && canPointGroups.value) {
      let nextPointer = isPointerGroup.value ? currentGroupFirstEnabledOption.value : currentGroupNextEnabledOption.value;
      if (nextPointer === void 0) {
        nextPointer = nextGroup.value;
      }
      setPointer(nextPointer || null);
    } else {
      let next = options.value.map((o2) => o2[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1;
      if (options.value.length <= next) {
        next = 0;
      }
      setPointer(options.value[next] || null);
    }
    nextTick(() => {
      adjustWrapperScrollToPointer();
    });
  };
  const backwardPointer = () => {
    if (pointer.value === null) {
      let prevPointer = options.value[options.value.length - 1];
      if (groupped.value && canPointGroups.value) {
        prevPointer = lastGroupLastEnabledOption.value;
        if (prevPointer === void 0) {
          prevPointer = lastGroup.value;
        }
      }
      setPointer(prevPointer || null);
    } else if (groupped.value && canPointGroups.value) {
      let prevPointer = isPointerGroup.value ? prevGroupLastEnabledOption.value : currentGroupPrevEnabledOption.value;
      if (prevPointer === void 0) {
        prevPointer = isPointerGroup.value ? prevGroup.value : currentGroup.value;
      }
      setPointer(prevPointer || null);
    } else {
      let prevIndex = options.value.map((o2) => o2[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1;
      if (prevIndex < 0) {
        prevIndex = options.value.length - 1;
      }
      setPointer(options.value[prevIndex] || null);
    }
    nextTick(() => {
      adjustWrapperScrollToPointer();
    });
  };
  const getParentGroup = (option) => {
    return groups.value.find((group) => {
      return group.__VISIBLE__.map((o2) => o2[valueProp.value]).indexOf(option[valueProp.value]) !== -1;
    });
  };
  const adjustWrapperScrollToPointer = () => {
    let pointedOption = multiselect.value.querySelector(`[data-pointed]`);
    if (!pointedOption) {
      return;
    }
    let wrapper = pointedOption.parentElement.parentElement.parentElement;
    if (groupped.value) {
      wrapper = isPointerGroup.value ? pointedOption.parentElement.parentElement.parentElement.parentElement : pointedOption.parentElement.parentElement.parentElement.parentElement.parentElement;
    }
    if (pointedOption.offsetTop + pointedOption.offsetHeight > wrapper.clientHeight + wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop + pointedOption.offsetHeight - wrapper.clientHeight;
    }
    if (pointedOption.offsetTop < wrapper.scrollTop) {
      wrapper.scrollTop = pointedOption.offsetTop;
    }
  };
  watch(search, (val) => {
    if (searchable.value) {
      if (val.length && showOptions.value) {
        setPointerFirst();
      } else {
        clearPointer();
      }
    }
  });
  return {
    pointer,
    canPointGroups,
    isPointed,
    setPointerFirst,
    selectPointer,
    forwardPointer,
    backwardPointer
  };
}
function useDropdown(props2, context, dep) {
  const { disabled: disabled2 } = toRefs(props2);
  const isOpen = ref(false);
  const open = () => {
    if (isOpen.value || disabled2.value) {
      return;
    }
    isOpen.value = true;
    context.emit("open");
  };
  const close2 = () => {
    if (!isOpen.value) {
      return;
    }
    isOpen.value = false;
    context.emit("close");
  };
  return {
    isOpen,
    open,
    close: close2
  };
}
function useMultiselect(props2, context, dep) {
  const { searchable, disabled: disabled2 } = toRefs(props2);
  const input = dep.input;
  const open = dep.open;
  const close2 = dep.close;
  const clearSearch = dep.clearSearch;
  const shouldClearSearchOnDeactivate = dep.shouldClearSearchOnDeactivate;
  const multiselect = ref(null);
  const isActive = ref(false);
  const tabindex = computed(() => {
    return searchable.value || disabled2.value ? -1 : 0;
  });
  const blur = () => {
    if (searchable.value) {
      input.value.blur();
    }
    multiselect.value.blur();
  };
  const handleFocus = () => {
    if (searchable.value && !disabled2.value) {
      input.value.focus();
    }
  };
  const activate = () => {
    if (disabled2.value) {
      return;
    }
    isActive.value = true;
    open();
  };
  const deactivate = () => {
    isActive.value = false;
    setTimeout(() => {
      if (!isActive.value) {
        close2();
        if (shouldClearSearchOnDeactivate) {
          clearSearch();
        }
      }
    }, 1);
  };
  const handleCaretClick = () => {
    deactivate();
    blur();
  };
  return {
    multiselect,
    tabindex,
    isActive,
    blur,
    handleFocus,
    activate,
    deactivate,
    handleCaretClick
  };
}
function useKeyboard(props2, context, dep) {
  const {
    mode,
    addTagOn,
    createTag,
    openDirection,
    searchable,
    showOptions,
    valueProp,
    groups: groupped
  } = toRefs(props2);
  const iv = dep.iv;
  const update = dep.update;
  const search = dep.search;
  const setPointer = dep.setPointer;
  const selectPointer = dep.selectPointer;
  const backwardPointer = dep.backwardPointer;
  const forwardPointer = dep.forwardPointer;
  const blur = dep.blur;
  const fo = dep.fo;
  const preparePointer = () => {
    if (mode.value === "tags" && !showOptions.value && createTag.value && searchable.value && !groupped.value) {
      setPointer(fo.value[fo.value.map((o2) => o2[valueProp.value]).indexOf(search.value)]);
    }
  };
  const handleKeydown = (e2) => {
    switch (e2.keyCode) {
      case 8:
        if (mode.value === "single") {
          return;
        }
        if (searchable.value && [null, ""].indexOf(search.value) === -1) {
          return;
        }
        if (iv.value.length === 0) {
          return;
        }
        update([...iv.value].slice(0, -1));
        break;
      case 13:
        e2.preventDefault();
        if (mode.value === "tags" && addTagOn.value.indexOf("enter") === -1 && createTag.value) {
          return;
        }
        preparePointer();
        selectPointer();
        break;
      case 32:
        if (searchable.value && mode.value !== "tags" && !createTag.value) {
          return;
        }
        if (mode.value === "tags" && (addTagOn.value.indexOf("space") === -1 && createTag.value || !createTag.value)) {
          return;
        }
        e2.preventDefault();
        preparePointer();
        selectPointer();
        break;
      case 9:
      case 186:
      case 188:
        if (mode.value !== "tags") {
          return;
        }
        const charMap = {
          9: "tab",
          186: ";",
          188: ","
        };
        if (addTagOn.value.indexOf(charMap[e2.keyCode]) === -1 || !createTag.value) {
          return;
        }
        preparePointer();
        selectPointer();
        e2.preventDefault();
        break;
      case 27:
        blur();
        break;
      case 38:
        e2.stopPropagation();
        if (!showOptions.value) {
          return;
        }
        openDirection.value === "top" ? forwardPointer() : backwardPointer();
        break;
      case 40:
        e2.stopPropagation();
        if (!showOptions.value) {
          return;
        }
        openDirection.value === "top" ? backwardPointer() : forwardPointer();
        break;
    }
  };
  return {
    handleKeydown,
    preparePointer
  };
}
function useClasses(props2, context, dependencies) {
  const refs = toRefs(props2);
  const { disabled: disabled2, openDirection, showOptions, shouldShowSelectionsInPlace } = refs;
  const isOpen = dependencies.isOpen;
  const isPointed = dependencies.isPointed;
  const isSelected = dependencies.isSelected;
  const isDisabled = dependencies.isDisabled;
  const isActive = dependencies.isActive;
  const canPointGroups = dependencies.canPointGroups;
  const resolving = dependencies.resolving;
  const fo = dependencies.fo;
  const classes = __spreadValues$1({
    container: "multiselect",
    contentWrapper: "multiselect__content",
    containerDisabled: "is-disabled",
    containerOpen: "is-open",
    containerOpenTop: "is-open-top",
    containerActive: "is-active",
    singleLabel: "multiselect-single-label",
    multipleLabel: "multiselect-multiple-label",
    searchInputWrapper: "multiselect-search-wrapper",
    searchInput: "multiselect-search",
    tags: "multiselect-tags",
    tag: "multiselect-tag",
    tagDisabled: "is-disabled",
    tagRemove: "multiselect-tag-remove",
    tagRemoveIcon: "multiselect-tag-remove-icon",
    tagsSearchWrapper: "multiselect-tags-search-wrapper",
    tagsSearch: "multiselect-tags-search",
    tagsSearchCopy: "multiselect-tags-search-copy",
    placeholder: "multiselect-placeholder",
    caret: "multiselect-caret",
    caretOpen: "is-open",
    clear: "multiselect-clear",
    clearIcon: "multiselect-clear-icon",
    spinner: "multiselect-spinner",
    dropdown: "multiselect-dropdown",
    dropdownTop: "is-top",
    dropdownHidden: "is-hidden",
    options: "multiselect-options",
    optionsTop: "is-top",
    group: "multiselect-group",
    groupLabel: "multiselect-group-label",
    groupLabelPointable: "is-pointable",
    groupLabelPointed: "is-pointed",
    groupLabelSelected: "is-selected",
    groupLabelDisabled: "is-disabled",
    groupLabelSelectedPointed: "is-selected is-pointed",
    groupLabelSelectedDisabled: "is-selected is-disabled",
    groupOptions: "multiselect-group-options",
    option: "multiselect-option",
    optionPointed: "is-pointed",
    optionSelected: "is-selected",
    optionDisabled: "is-disabled",
    optionSelectedPointed: "is-selected is-pointed",
    optionSelectedDisabled: "is-selected is-disabled",
    noOptions: "multiselect-no-options",
    noResults: "multiselect-no-results",
    fakeInput: "multiselect-fake-input",
    spacer: "multiselect-spacer"
  }, refs.classes.value);
  const showDropdown = computed(() => {
    return !!(isOpen.value && showOptions.value && (!resolving.value || resolving.value && fo.value.length));
  });
  const classList = computed(() => {
    return {
      container: [classes.container].concat(disabled2.value ? classes.containerDisabled : []).concat(showDropdown.value && openDirection.value === "top" ? classes.containerOpenTop : []).concat(showDropdown.value && openDirection.value !== "top" ? classes.containerOpen : []).concat(isActive.value ? classes.containerActive : []),
      spacer: classes.spacer,
      singleLabel: classes.singleLabel,
      multipleLabel: classes.multipleLabel,
      search: classes.search,
      searchInputWrapper: classes.searchInputWrapper,
      searchInputWrapper: classes.searchInputWrapper,
      contentWrapper: classes.contentWrapper,
      searchInput: classes.searchInput,
      tags: classes.tags,
      tag: [classes.tag].concat(disabled2.value ? classes.tagDisabled : []),
      tagRemove: classes.tagRemove,
      tagRemoveIcon: classes.tagRemoveIcon,
      tagsSearchWrapper: classes.tagsSearchWrapper,
      tagsSearch: classes.tagsSearch,
      tagsSearchCopy: classes.tagsSearchCopy,
      placeholder: classes.placeholder,
      caret: [classes.caret].concat(isOpen.value ? classes.caretOpen : []),
      clear: classes.clear,
      clearIcon: classes.clearIcon,
      spinner: classes.spinner,
      dropdown: [classes.dropdown].concat(openDirection.value === "top" ? classes.dropdownTop : []).concat(!isOpen.value || !showOptions.value || !showDropdown.value ? classes.dropdownHidden : []),
      options: [classes.options].concat(openDirection.value === "top" ? classes.optionsTop : []),
      group: classes.group,
      groupLabel: (g) => {
        let groupLabel = [classes.groupLabel];
        if (isPointed(g)) {
          groupLabel.push(isSelected(g) ? classes.groupLabelSelectedPointed : classes.groupLabelPointed);
        } else if (isSelected(g) && canPointGroups.value) {
          groupLabel.push(isDisabled(g) ? classes.groupLabelSelectedDisabled : classes.groupLabelSelected);
        } else if (isDisabled(g)) {
          groupLabel.push(classes.groupLabelDisabled);
        }
        if (canPointGroups.value) {
          groupLabel.push(classes.groupLabelPointable);
        }
        return groupLabel;
      },
      groupOptions: classes.groupOptions,
      option: (o2, g) => {
        let option = [classes.option];
        if (isPointed(o2)) {
          option.push(isSelected(o2) && !shouldShowSelectionsInPlace ? classes.optionSelectedPointed : classes.optionPointed);
        } else if (isSelected(o2)) {
          option.push(isDisabled(o2) ? classes.optionSelectedDisabled : classes.optionSelected);
        } else if (isDisabled(o2) || g && isDisabled(g)) {
          option.push(classes.optionDisabled);
        }
        return option;
      },
      noOptions: classes.noOptions,
      noResults: classes.noResults,
      fakeInput: classes.fakeInput
    };
  });
  return {
    classList,
    showDropdown
  };
}
var _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$6 = {
  name: "Multiselect",
  props: {
    value: {
      required: false
    },
    modelValue: {
      required: false
    },
    options: {
      type: [Array, Object, Function],
      required: false,
      default: () => []
    },
    id: {
      type: [String, Number],
      required: false
    },
    name: {
      type: [String, Number],
      required: false,
      default: "multiselect"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: "label"
    },
    trackBy: {
      type: String,
      required: false,
      default: "label"
    },
    valueProp: {
      type: String,
      required: false,
      default: "value"
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    mode: {
      type: String,
      required: false,
      default: "single"
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    limit: {
      type: Number,
      required: false,
      default: -1
    },
    hideSelected: {
      type: Boolean,
      required: false,
      default: true
    },
    createTag: {
      type: Boolean,
      required: false,
      default: false
    },
    appendNewTag: {
      type: Boolean,
      required: false,
      default: true
    },
    caret: {
      type: Boolean,
      required: false,
      default: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    noOptionsText: {
      type: String,
      required: false,
      default: "The list is empty"
    },
    noResultsText: {
      type: String,
      required: false,
      default: "No results found"
    },
    multipleLabel: {
      type: Function,
      required: false
    },
    object: {
      type: Boolean,
      required: false,
      default: false
    },
    delay: {
      type: Number,
      required: false,
      default: -1
    },
    minChars: {
      type: Number,
      required: false,
      default: 0
    },
    resolveOnLoad: {
      type: Boolean,
      required: false,
      default: true
    },
    filterResults: {
      type: Boolean,
      required: false,
      default: true
    },
    clearOnSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    clearOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    canDeselect: {
      type: Boolean,
      required: false,
      default: true
    },
    canClear: {
      type: Boolean,
      required: false,
      default: true
    },
    max: {
      type: Number,
      required: false,
      default: -1
    },
    showOptions: {
      type: Boolean,
      required: false,
      default: true
    },
    addTagOn: {
      type: Array,
      required: false,
      default: () => ["enter"]
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    openDirection: {
      type: String,
      required: false,
      default: "bottom"
    },
    nativeSupport: {
      type: Boolean,
      required: false,
      default: false
    },
    classes: {
      type: Object,
      required: false,
      default: () => ({})
    },
    strict: {
      type: Boolean,
      required: false,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    autocomplete: {
      type: String,
      required: false
    },
    groups: {
      type: Boolean,
      required: false,
      default: false
    },
    groupLabel: {
      type: String,
      required: false,
      default: "label"
    },
    groupOptions: {
      type: String,
      required: false,
      default: "options"
    },
    groupHideEmpty: {
      type: Boolean,
      required: false,
      default: false
    },
    groupSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    inputType: {
      type: String,
      required: false,
      default: "text"
    },
    shouldRefreshLabels: {
      type: Boolean,
      required: false,
      default: true
    },
    shouldShowSelectionsInPlace: {
      type: Boolean,
      required: false,
      default: true
    },
    shouldClearSearchOnDeactivate: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: [
    "open",
    "close",
    "select",
    "deselect",
    "input",
    "search-change",
    "tag",
    "update:modelValue",
    "change",
    "clear"
  ],
  setup(props2, context) {
    const value = useValue(props2, context);
    const pointer = usePointer$1(props2);
    const dropdown = useDropdown(props2, context);
    const search = useSearch(props2, context);
    const data2 = useData(props2, context, {
      iv: value.iv
    });
    const multiselect = useMultiselect(props2, context, {
      input: search.input,
      open: dropdown.open,
      close: dropdown.close,
      clearSearch: search.clearSearch,
      shouldClearSearchOnDeactivate: props2.shouldClearSearchOnDeactivate
    });
    const options = useOptions(props2, context, {
      ev: value.ev,
      iv: value.iv,
      search: search.search,
      clearSearch: search.clearSearch,
      update: data2.update,
      pointer: pointer.pointer,
      clearPointer: pointer.clearPointer,
      blur: multiselect.blur,
      deactivate: multiselect.deactivate
    });
    const pointerAction = usePointer(props2, context, {
      fo: options.fo,
      fg: options.fg,
      handleOptionClick: options.handleOptionClick,
      handleGroupClick: options.handleGroupClick,
      search: search.search,
      pointer: pointer.pointer,
      setPointer: pointer.setPointer,
      clearPointer: pointer.clearPointer,
      multiselect: multiselect.multiselect
    });
    const keyboard = useKeyboard(props2, context, {
      iv: value.iv,
      update: data2.update,
      search: search.search,
      setPointer: pointer.setPointer,
      selectPointer: pointerAction.selectPointer,
      backwardPointer: pointerAction.backwardPointer,
      forwardPointer: pointerAction.forwardPointer,
      blur: multiselect.blur,
      fo: options.fo
    });
    const classes = useClasses(props2, context, {
      isOpen: dropdown.isOpen,
      isPointed: pointerAction.isPointed,
      canPointGroups: pointerAction.canPointGroups,
      isSelected: options.isSelected,
      isDisabled: options.isDisabled,
      isActive: multiselect.isActive,
      resolving: options.resolving,
      fo: options.fo
    });
    onMounted(() => {
      var _a;
      (_a = search.input.value) == null ? void 0 : _a.focus();
    });
    return __spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1({}, value), dropdown), multiselect), pointer), data2), search), options), pointerAction), keyboard), classes);
  }
};
const _hoisted_1$6 = ["id", "tabindex"];
const _hoisted_2$4 = ["type", "modelValue", "value", "autocomplete"];
const _hoisted_3$2 = ["onMousedown"];
const _hoisted_4$2 = ["type", "modelValue", "value", "autocomplete"];
const _hoisted_5$2 = ["data-pointed", "onMouseenter", "onClick"];
const _hoisted_6$2 = ["data-pointed", "onMouseenter", "onClick"];
const _hoisted_7$1 = ["data-pointed", "onMouseenter", "onClick"];
const _hoisted_8$1 = ["innerHTML"];
const _hoisted_9$1 = ["innerHTML"];
const _hoisted_10$1 = ["value"];
const _hoisted_11$1 = ["name", "value"];
const _hoisted_12$1 = ["name", "value"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: $props.id,
    ref: "multiselect",
    tabindex: _ctx.tabindex,
    class: normalizeClass(_ctx.classList.container),
    onFocusin: _cache[6] || (_cache[6] = (...args) => _ctx.activate && _ctx.activate(...args)),
    onFocusout: _cache[7] || (_cache[7] = (...args) => _ctx.deactivate && _ctx.deactivate(...args)),
    onKeydown: _cache[8] || (_cache[8] = (...args) => _ctx.handleKeydown && _ctx.handleKeydown(...args)),
    onFocus: _cache[9] || (_cache[9] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args))
  }, [
    $props.mode !== "tags" && $props.searchable && !$props.disabled ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["multiselect__search-wrapper", _ctx.classList.searchInputWrapper])
    }, [
      createBaseVNode("input", {
        ref: "input",
        type: $props.inputType,
        modelValue: _ctx.search,
        value: _ctx.search,
        class: normalizeClass(_ctx.classList.searchInput),
        autocomplete: $props.autocomplete,
        onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleSearchInput && _ctx.handleSearchInput(...args)),
        onPaste: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.handlePaste && _ctx.handlePaste(...args), ["stop"]))
      }, null, 42, _hoisted_2$4)
    ], 2)) : createCommentVNode("", true),
    createBaseVNode("div", {
      class: normalizeClass(["multiselect__content", _ctx.classList.contentWrapper])
    }, [
      $props.mode == "tags" ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(_ctx.classList.tags)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.iv, (option, i2, key) => {
          return renderSlot(_ctx.$slots, "tag", {
            option,
            handleTagRemove: _ctx.handleTagRemove,
            disabled: $props.disabled
          }, () => [
            (openBlock(), createElementBlock("span", {
              key,
              class: normalizeClass(_ctx.classList.tag)
            }, [
              createTextVNode(toDisplayString(option[$props.label]) + " ", 1),
              !$props.disabled ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: normalizeClass(_ctx.classList.tagRemove),
                onMousedown: withModifiers(($event) => _ctx.handleTagRemove(option, $event), ["prevent"])
              }, [
                createBaseVNode("span", {
                  class: normalizeClass(_ctx.classList.tagRemoveIcon)
                }, null, 2)
              ], 42, _hoisted_3$2)) : createCommentVNode("", true)
            ], 2))
          ]);
        }), 256)),
        createBaseVNode("div", {
          class: normalizeClass(_ctx.classList.tagsSearchWrapper)
        }, [
          createBaseVNode("span", {
            class: normalizeClass(_ctx.classList.tagsSearchCopy)
          }, toDisplayString(_ctx.search), 3),
          $props.searchable && !$props.disabled ? (openBlock(), createElementBlock("input", {
            key: 0,
            ref: "input",
            type: $props.inputType,
            modelValue: _ctx.search,
            value: _ctx.search,
            class: normalizeClass(_ctx.classList.tagsSearch),
            autocomplete: $props.autocomplete,
            onInput: _cache[2] || (_cache[2] = (...args) => _ctx.handleSearchInput && _ctx.handleSearchInput(...args)),
            onPaste: _cache[3] || (_cache[3] = withModifiers((...args) => _ctx.handlePaste && _ctx.handlePaste(...args), ["stop"]))
          }, null, 42, _hoisted_4$2)) : createCommentVNode("", true)
        ], 2)
      ], 2)) : createCommentVNode("", true),
      $props.mode == "single" && _ctx.hasSelected && !_ctx.search && _ctx.iv && !$props.shouldShowSelectionsInPlace ? renderSlot(_ctx.$slots, "singlelabel", {
        key: 1,
        value: _ctx.iv
      }, () => [
        createBaseVNode("div", {
          class: normalizeClass(_ctx.classList.singleLabel)
        }, toDisplayString(_ctx.iv[$props.label]), 3)
      ]) : createCommentVNode("", true),
      $props.mode == "multiple" && _ctx.hasSelected && !_ctx.search && !$props.shouldShowSelectionsInPlace ? renderSlot(_ctx.$slots, "multiplelabel", {
        key: 2,
        values: _ctx.iv
      }, () => [
        createBaseVNode("div", {
          class: normalizeClass(_ctx.classList.multipleLabel)
        }, toDisplayString(_ctx.multipleLabelText), 3)
      ]) : createCommentVNode("", true),
      $props.placeholder && !_ctx.hasSelected && !_ctx.search ? renderSlot(_ctx.$slots, "placeholder", { key: 3 }, () => [
        createBaseVNode("div", {
          class: normalizeClass(_ctx.classList.placeholder)
        }, toDisplayString($props.placeholder), 3)
      ]) : createCommentVNode("", true),
      _ctx.busy ? renderSlot(_ctx.$slots, "spinner", { key: 4 }, () => [
        createBaseVNode("span", {
          class: normalizeClass(_ctx.classList.spinner)
        }, null, 2)
      ]) : createCommentVNode("", true),
      _ctx.hasSelected && !$props.disabled && $props.canClear && !_ctx.busy ? renderSlot(_ctx.$slots, "clear", {
        key: 5,
        clear: _ctx.clear
      }, () => [
        createBaseVNode("span", {
          class: normalizeClass(_ctx.classList.clear),
          onMousedown: _cache[4] || (_cache[4] = (...args) => _ctx.clear && _ctx.clear(...args))
        }, [
          createBaseVNode("span", {
            class: normalizeClass(_ctx.classList.clearIcon)
          }, null, 2)
        ], 34)
      ]) : createCommentVNode("", true),
      $props.caret ? renderSlot(_ctx.$slots, "caret", { key: 6 }, () => [
        createBaseVNode("span", {
          class: normalizeClass(_ctx.classList.caret),
          onClick: _cache[5] || (_cache[5] = (...args) => _ctx.handleCaretClick && _ctx.handleCaretClick(...args))
        }, null, 2)
      ]) : createCommentVNode("", true),
      createBaseVNode("div", {
        class: normalizeClass(_ctx.classList.dropdown),
        tabindex: "-1"
      }, [
        renderSlot(_ctx.$slots, "beforelist", { options: _ctx.fo }),
        createBaseVNode("ul", {
          class: normalizeClass(_ctx.classList.options)
        }, [
          $props.groups ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.fg, (group, i2, key) => {
            return openBlock(), createElementBlock("li", {
              key,
              class: normalizeClass(_ctx.classList.group)
            }, [
              createBaseVNode("div", {
                class: normalizeClass(_ctx.classList.groupLabel(group)),
                "data-pointed": _ctx.isPointed(group),
                onMouseenter: ($event) => _ctx.setPointer(group),
                onClick: ($event) => _ctx.handleGroupClick(group)
              }, [
                renderSlot(_ctx.$slots, "grouplabel", { group }, () => [
                  createBaseVNode("span", null, toDisplayString(group[$props.groupLabel]), 1)
                ])
              ], 42, _hoisted_5$2),
              createBaseVNode("ul", {
                class: normalizeClass(_ctx.classList.groupOptions)
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.shouldShowSelectionsInPlace ? group.options : group.__VISIBLE__, (option, i22, key2) => {
                  return openBlock(), createElementBlock("li", {
                    key: key2,
                    class: normalizeClass(_ctx.classList.option(option, group)),
                    "data-pointed": _ctx.isPointed(option),
                    onMouseenter: ($event) => _ctx.setPointer(option),
                    onClick: ($event) => _ctx.handleOptionClick(option)
                  }, [
                    renderSlot(_ctx.$slots, "option", {
                      option,
                      search: _ctx.search
                    }, () => [
                      createBaseVNode("span", null, toDisplayString(option[$props.label]), 1)
                    ])
                  ], 42, _hoisted_6$2);
                }), 128))
              ], 2)
            ], 2);
          }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.fo, (option, i2, key) => {
            return openBlock(), createElementBlock("li", {
              key,
              class: normalizeClass(_ctx.classList.option(option)),
              "data-pointed": _ctx.isPointed(option),
              onMouseenter: ($event) => _ctx.setPointer(option),
              onClick: ($event) => _ctx.handleOptionClick(option)
            }, [
              renderSlot(_ctx.$slots, "option", {
                option,
                search: _ctx.search
              }, () => [
                createBaseVNode("span", null, toDisplayString(option[$props.label]), 1)
              ])
            ], 42, _hoisted_7$1);
          }), 128))
        ], 2),
        _ctx.noOptions && !$props.loading ? renderSlot(_ctx.$slots, "nooptions", { key: 0 }, () => [
          createBaseVNode("div", {
            class: normalizeClass(_ctx.classList.noOptions),
            innerHTML: $props.noOptionsText
          }, null, 10, _hoisted_8$1)
        ]) : createCommentVNode("", true),
        _ctx.noResults && !$props.loading ? renderSlot(_ctx.$slots, "noresults", { key: 1 }, () => [
          createBaseVNode("div", {
            class: normalizeClass(_ctx.classList.noResults),
            innerHTML: $props.noResultsText
          }, null, 10, _hoisted_9$1)
        ]) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "afterlist", { options: _ctx.fo })
      ], 2),
      $props.required ? (openBlock(), createElementBlock("input", {
        key: 7,
        class: normalizeClass(_ctx.classList.fakeInput),
        tabindex: "-1",
        value: _ctx.textValue,
        required: ""
      }, null, 10, _hoisted_10$1)) : createCommentVNode("", true),
      $props.nativeSupport ? (openBlock(), createElementBlock(Fragment, { key: 8 }, [
        $props.mode == "single" ? (openBlock(), createElementBlock("input", {
          key: 0,
          type: "hidden",
          name: $props.name,
          value: _ctx.plainValue !== void 0 ? _ctx.plainValue : ""
        }, null, 8, _hoisted_11$1)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.plainValue, (v2, i2) => {
          return openBlock(), createElementBlock("input", {
            key: i2,
            type: "hidden",
            name: `${$props.name}[]`,
            value: v2
          }, null, 8, _hoisted_12$1);
        }), 128))
      ], 64)) : createCommentVNode("", true),
      createBaseVNode("div", {
        class: normalizeClass(_ctx.classList.spacer)
      }, null, 2)
    ], 2)
  ], 42, _hoisted_1$6);
}
var MultiSelect = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$2]]);
var _style_0$2 = '.skeleton[data-v-088d5970]{position:relative;overflow:hidden}.skeleton[data-v-088d5970]:after{position:absolute;top:0;right:0;bottom:0;left:0;animation:shimmer 4s infinite linear;background:linear-gradient(to right,#e1e6ee 4%,#c5cee0 25%,#e1e6ee 36%);background-size:1000px 100%;content:""}\n';
const _withScopeId$1 = (n) => (pushScopeId("data-v-088d5970"), n = n(), popScopeId(), n);
const _hoisted_1$5 = { class: "flex items-center w-full overflow-x-hidden" };
const _hoisted_2$3 = {
  key: 0,
  class: "flex-1 flex-grow block truncate ml-100 text-default text-text-01 skeleton"
};
const _hoisted_3$1 = {
  key: 1,
  class: "flex-1 block truncate ml-100 text-default text-text-01"
};
const _hoisted_4$1 = {
  key: 2,
  class: "pl-100"
};
const _hoisted_5$1 = /* @__PURE__ */ _withScopeId$1(() => /* @__PURE__ */ createBaseVNode("svg", {
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createBaseVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.82805 10.4176C5.69497 10.4176 5.56592 10.3643 5.47115 10.2707L0.926196 5.73551C0.729598 5.53929 0.729598 5.22031 0.926196 5.02409C1.12279 4.82787 1.44239 4.82787 1.63899 5.02409L5.82805 9.20305L14.0378 1.00412C14.2344 0.806895 14.553 0.806895 14.7506 1.00412C14.9472 1.19933 14.9472 1.51831 14.7506 1.71554L6.18495 10.2707C6.09018 10.3643 5.96214 10.4176 5.82805 10.4176",
    fill: "black"
  })
], -1));
const _hoisted_6$1 = [
  _hoisted_5$1
];
const _sfc_main$5 = {
  props: {
    option: {
      type: Object,
      required: true
    },
    variant: {
      default: "",
      type: String
    },
    skeleton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$5, [
        createVNode(Avatar, {
          variant: __props.option.icon ? "icon" : "image",
          source: __props.option.image,
          background: __props.option.icon ? __props.option.icon.color : "",
          icon: __props.option.icon ? __props.option.icon.name : "",
          initials: __props.option.initials,
          name: __props.option.name,
          skeleton: __props.skeleton,
          size: "small"
        }, null, 8, ["variant", "source", "background", "icon", "initials", "name", "skeleton"]),
        __props.skeleton ? (openBlock(), createElementBlock("span", _hoisted_2$3, "\xA0")) : createCommentVNode("", true),
        !__props.skeleton ? (openBlock(), createElementBlock("span", _hoisted_3$1, toDisplayString(__props.option.name), 1)) : createCommentVNode("", true),
        !__props.skeleton && __props.variant === "selected" ? (openBlock(), createElementBlock("span", _hoisted_4$1, _hoisted_6$1)) : createCommentVNode("", true)
      ]);
    };
  }
};
var Assignee = /* @__PURE__ */ _export_sfc$1(_sfc_main$5, [["styles", [_style_0$2]], ["__scopeId", "data-v-088d5970"]]);
const buttonVariants = [
  "primary",
  "primary-link",
  "primary-borderless",
  "icon",
  "secondary",
  "danger",
  "clean"
];
const buttonSizes = ["default", "small", "large", "xlarge", "xxlarge"];
const props = {
  disabled: Boolean,
  title: String,
  variant: {
    type: String,
    default: "primary",
    validator: (val) => {
      const valid = buttonVariants.includes(val);
      if (!valid) {
        console.error(`Invalid button variant specified "${val}". Valid values are [${buttonVariants}]`);
      }
      return valid;
    }
  },
  size: {
    type: String,
    default: "default",
    validator: (val) => {
      const valid = buttonSizes.includes(val);
      if (!valid) {
        console.error(`Invalid button size specified "${val}". Valid values are [${buttonSizes.slice(1)}]`);
      }
      return valid;
    }
  }
};
const useCommonBtn = (variant2, size2) => {
  const buttonClasses = computed(() => {
    const classes = ["btn"];
    if (variant2) {
      classes.push(`btn-${variant2.toLowerCase()}`);
    } else {
      classes.push("btn-primary");
    }
    if (size2) {
      classes.push(`btn--${size2}`);
    } else {
      classes.push("btn--default");
    }
    return classes;
  });
  return { buttonClasses };
};
const { disabled: disabled$1, variant, size } = props;
const _sfc_main$4 = {
  name: "Btn",
  props: {
    disabled: disabled$1,
    variant,
    size
  },
  emits: ["click"],
  setup(props2) {
    const { buttonClasses } = useCommonBtn(props2.variant, props2.size);
    return {
      buttonClasses
    };
  }
};
const _hoisted_1$4 = ["disabled"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    class: normalizeClass($setup.buttonClasses),
    disabled: $props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1$4);
}
var Btn = /* @__PURE__ */ _export_sfc$1(_sfc_main$4, [["render", _sfc_render$1]]);
var _style_0$1 = ".btn[data-v-714b94c0]{padding:0}.btn[data-v-714b94c0]:hover{border-color:transparent;text-decoration:underline}\n";
const { disabled, title } = props;
const _sfc_main$3 = {
  name: "BtnText",
  props: {
    disabled,
    title,
    primary: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["click"]
};
const _hoisted_1$3 = ["title", "disabled"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    title: $props.title || "",
    class: normalizeClass(["btn btn--small", { "btn-clean": !$props.primary, "btn-primary-borderless": $props.primary }]),
    disabled: $props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 10, _hoisted_1$3);
}
var BtnText = /* @__PURE__ */ _export_sfc$1(_sfc_main$3, [["render", _sfc_render], ["styles", [_style_0$1]], ["__scopeId", "data-v-714b94c0"]]);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace$1(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var axios$5 = { exports: {} };
var bind$9 = function bind(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$8 = bind$9;
var toString = Object.prototype.toString;
function isArray$b(val) {
  return toString.call(val) === "[object Array]";
}
function isUndefined$1(val) {
  return typeof val === "undefined";
}
function isBuffer$3(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer$1(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData$1(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView$1(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$3(val) {
  return typeof val === "string";
}
function isNumber$3(val) {
  return typeof val === "number";
}
function isObject$1(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$1(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$3(val) {
  return toString.call(val) === "[object Date]";
}
function isFile$1(val) {
  return toString.call(val) === "[object File]";
}
function isBlob$1(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction$1(val) {
  return toString.call(val) === "[object Function]";
}
function isStream$1(val) {
  return isObject$1(val) && isFunction$1(val.pipe);
}
function isURLSearchParams$1(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim$1(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv$1() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach$1(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$b(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$3() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge$3(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge$3({}, val);
    } else if (isArray$b(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
    forEach$1(arguments[i2], assignValue);
  }
  return result;
}
function extend$1(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$8(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM$1(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$x = {
  isArray: isArray$b,
  isArrayBuffer: isArrayBuffer$1,
  isBuffer: isBuffer$3,
  isFormData: isFormData$1,
  isArrayBufferView: isArrayBufferView$1,
  isString: isString$3,
  isNumber: isNumber$3,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate$3,
  isFile: isFile$1,
  isBlob: isBlob$1,
  isFunction: isFunction$1,
  isStream: isStream$1,
  isURLSearchParams: isURLSearchParams$1,
  isStandardBrowserEnv: isStandardBrowserEnv$1,
  forEach: forEach$1,
  merge: merge$3,
  extend: extend$1,
  trim: trim$1,
  stripBOM: stripBOM$1
};
var utils$w = utils$x;
function encode$3(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$4 = function buildURL(url2, params, paramsSerializer) {
  if (!params) {
    return url2;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$w.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts2 = [];
    utils$w.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$w.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$w.forEach(val, function parseValue(v2) {
        if (utils$w.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$w.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts2.push(encode$3(key) + "=" + encode$3(v2));
      });
    });
    serializedParams = parts2.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url2.indexOf("#");
    if (hashmarkIndex !== -1) {
      url2 = url2.slice(0, hashmarkIndex);
    }
    url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url2;
};
var utils$v = utils$x;
function InterceptorManager$3() {
  this.handlers = [];
}
InterceptorManager$3.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$3.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$3.prototype.forEach = function forEach(fn2) {
  utils$v.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn2(h2);
    }
  });
};
var InterceptorManager_1$1 = InterceptorManager$3;
var utils$u = utils$x;
var normalizeHeaderName$2 = function normalizeHeaderName(headers, normalizedName) {
  utils$u.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$4 = function enhanceError(error, config, code, request3, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request3;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$3 = enhanceError$4;
var createError$4 = function createError(message, config, code, request3, response) {
  var error = new Error(message);
  return enhanceError$3(error, config, code, request3, response);
};
var createError$3 = createError$4;
var settle$2 = function settle(resolve2, reject, response) {
  var validateStatus3 = response.config.validateStatus;
  if (!response.status || !validateStatus3 || validateStatus3(response.status)) {
    resolve2(response);
  } else {
    reject(createError$3("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$t = utils$x;
var cookies$3 = utils$t.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write2(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$t.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$t.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$t.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read2(name) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove2(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write2() {
    },
    read: function read2() {
      return null;
    },
    remove: function remove2() {
    }
  };
}();
var isAbsoluteURL$2 = function isAbsoluteURL(url2) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url2);
};
var combineURLs$2 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$2;
var combineURLs2 = combineURLs$2;
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$s = utils$x;
var ignoreDuplicateOf$1 = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$2 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$s.forEach(headers.split("\n"), function parser2(line) {
    i2 = line.indexOf(":");
    key = utils$s.trim(line.substr(0, i2)).toLowerCase();
    val = utils$s.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf$1.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$r = utils$x;
var isURLSameOrigin$3 = utils$r.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url2) {
    var href = url2;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$r.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$7(message) {
  this.message = message;
}
Cancel$7.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$7.prototype.__CANCEL__ = true;
var Cancel_1$1 = Cancel$7;
var utils$q = utils$x;
var settle2 = settle$2;
var cookies$2 = cookies$3;
var buildURL$3 = buildURL$4;
var buildFullPath2 = buildFullPath$2;
var parseHeaders2 = parseHeaders$2;
var isURLSameOrigin$2 = isURLSameOrigin$3;
var createError2 = createError$4;
var defaults$d = defaults_1$1;
var Cancel$6 = Cancel_1$1;
var xhr$1 = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve2, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$q.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request3 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request3.open(config.method.toUpperCase(), buildURL$3(fullPath, config.params, config.paramsSerializer), true);
    request3.timeout = config.timeout;
    function onloadend() {
      if (!request3) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders2(request3.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
      var response = {
        data: responseData,
        status: request3.status,
        statusText: request3.statusText,
        headers: responseHeaders,
        config,
        request: request3
      };
      settle2(function _resolve(value) {
        resolve2(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request3 = null;
    }
    if ("onloadend" in request3) {
      request3.onloadend = onloadend;
    } else {
      request3.onreadystatechange = function handleLoad() {
        if (!request3 || request3.readyState !== 4) {
          return;
        }
        if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request3.onabort = function handleAbort() {
      if (!request3) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request3));
      request3 = null;
    };
    request3.onerror = function handleError2() {
      reject(createError2("Network Error", config, null, request3));
      request3 = null;
    };
    request3.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config.transitional || defaults$d.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional3.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request3));
      request3 = null;
    };
    if (utils$q.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$2(fullPath)) && config.xsrfCookieName ? cookies$2.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request3) {
      utils$q.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request3.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$q.isUndefined(config.withCredentials)) {
      request3.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request3.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request3.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request3.upload) {
      request3.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request3) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$6("canceled") : cancel);
        request3.abort();
        request3 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request3.send(requestData);
  });
};
var utils$p = utils$x;
var normalizeHeaderName2 = normalizeHeaderName$2;
var enhanceError2 = enhanceError$4;
var DEFAULT_CONTENT_TYPE$1 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset$1(headers, value) {
  if (!utils$p.isUndefined(headers) && utils$p.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter$1() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr$1;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr$1;
  }
  return adapter;
}
function stringifySafely$1(rawValue, parser2, encoder) {
  if (utils$p.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$p.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$c = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter$1(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$p.isFormData(data2) || utils$p.isArrayBuffer(data2) || utils$p.isBuffer(data2) || utils$p.isStream(data2) || utils$p.isFile(data2) || utils$p.isBlob(data2)) {
      return data2;
    }
    if (utils$p.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$p.isURLSearchParams(data2)) {
      setContentTypeIfUnset$1(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$p.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset$1(headers, "application/json");
      return stringifySafely$1(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$c.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$p.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError2(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$p.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$c.headers[method] = {};
});
utils$p.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$c.headers[method] = utils$p.merge(DEFAULT_CONTENT_TYPE$1);
});
var defaults_1$1 = defaults$c;
var utils$o = utils$x;
var defaults$b = defaults_1$1;
var transformData$2 = function transformData(data2, headers, fns) {
  var context = this || defaults$b;
  utils$o.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$2 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$n = utils$x;
var transformData2 = transformData$2;
var isCancel2 = isCancel$2;
var defaults$a = defaults_1$1;
var Cancel$5 = Cancel_1$1;
function throwIfCancellationRequested$1(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$5("canceled");
  }
}
var dispatchRequest$2 = function dispatchRequest(config) {
  throwIfCancellationRequested$1(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$a.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested$1(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested$1(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$m = utils$x;
var mergeConfig$4 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source4) {
    if (utils$m.isPlainObject(target) && utils$m.isPlainObject(source4)) {
      return utils$m.merge(target, source4);
    } else if (utils$m.isPlainObject(source4)) {
      return utils$m.merge({}, source4);
    } else if (utils$m.isArray(source4)) {
      return source4.slice();
    }
    return source4;
  }
  function mergeDeepProperties(prop) {
    if (!utils$m.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$m.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$m.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$m.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$m.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$m.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge3 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge3(prop);
    utils$m.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data$1 = {
  "version": "0.24.0"
};
var VERSION$1 = data$1.version;
var validators$3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$3[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings$1 = {};
validators$3.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings$1[opt]) {
      deprecatedWarnings$1[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions$1(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys3 = Object.keys(options);
  var i2 = keys3.length;
  while (i2-- > 0) {
    var opt = keys3[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$3 = {
  assertOptions: assertOptions$1,
  validators: validators$3
};
var utils$l = utils$x;
var buildURL2 = buildURL$4;
var InterceptorManager$2 = InterceptorManager_1$1;
var dispatchRequest2 = dispatchRequest$2;
var mergeConfig$3 = mergeConfig$4;
var validator$2 = validator$3;
var validators$2 = validator$2.validators;
function Axios$3(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager$2(),
    response: new InterceptorManager$2()
  };
}
Axios$3.prototype.request = function request(config) {
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$3(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional3 = config.transitional;
  if (transitional3 !== void 0) {
    validator$2.assertOptions(transitional3, {
      silentJSONParsing: validators$2.transitional(validators$2.boolean),
      forcedJSONParsing: validators$2.transitional(validators$2.boolean),
      clarifyTimeoutError: validators$2.transitional(validators$2.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$3.prototype.getUri = function getUri(config) {
  config = mergeConfig$3(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$l.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$3.prototype[method] = function(url2, config) {
    return this.request(mergeConfig$3(config || {}, {
      method,
      url: url2,
      data: (config || {}).data
    }));
  };
});
utils$l.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$3.prototype[method] = function(url2, data2, config) {
    return this.request(mergeConfig$3(config || {}, {
      method,
      url: url2,
      data: data2
    }));
  };
});
var Axios_1$1 = Axios$3;
var Cancel$4 = Cancel_1$1;
function CancelToken$1(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve2) {
    resolvePromise = resolve2;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i2;
    var l = token._listeners.length;
    for (i2 = 0; i2 < l; i2++) {
      token._listeners[i2](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve2) {
      token.subscribe(resolve2);
      _resolve = resolve2;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel$4(message);
    resolvePromise(token.reason);
  });
}
CancelToken$1.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken$1.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken$1.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken$1.source = function source2() {
  var cancel;
  var token = new CancelToken$1(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1$1 = CancelToken$1;
var spread$1 = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError$1 = function isAxiosError(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils$k = utils$x;
var bind$7 = bind$9;
var Axios$2 = Axios_1$1;
var mergeConfig2 = mergeConfig$4;
var defaults$9 = defaults_1$1;
function createInstance$1(defaultConfig) {
  var context = new Axios$2(defaultConfig);
  var instance = bind$7(Axios$2.prototype.request, context);
  utils$k.extend(instance, Axios$2.prototype, context);
  utils$k.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance$1(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$4 = createInstance$1(defaults$9);
axios$4.Axios = Axios$2;
axios$4.Cancel = Cancel_1$1;
axios$4.CancelToken = CancelToken_1$1;
axios$4.isCancel = isCancel$2;
axios$4.VERSION = data$1.version;
axios$4.all = function all(promises) {
  return Promise.all(promises);
};
axios$4.spread = spread$1;
axios$4.isAxiosError = isAxiosError$1;
axios$5.exports = axios$4;
axios$5.exports.default = axios$4;
var axios$3 = axios$5.exports;
var shams$1 = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol$1 = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham$1 = shams$1;
var hasSymbols$2 = function hasNativeSymbols() {
  if (typeof origSymbol$1 !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol$1("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham$1();
};
var ERROR_MESSAGE$1 = "Function.prototype.bind called on incompatible ";
var slice$2 = Array.prototype.slice;
var toStr$3 = Object.prototype.toString;
var funcType$1 = "[object Function]";
var implementation$3 = function bind2(that) {
  var target = this;
  if (typeof target !== "function" || toStr$3.call(target) !== funcType$1) {
    throw new TypeError(ERROR_MESSAGE$1 + target);
  }
  var args = slice$2.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice$2.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice$2.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs.push("$" + i2);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation$2 = implementation$3;
var functionBind$1 = Function.prototype.bind || implementation$2;
var bind$6 = functionBind$1;
var src$1 = bind$6.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$2;
var $SyntaxError$1 = SyntaxError;
var $Function$1 = Function;
var $TypeError$3 = TypeError;
var getEvalledConstructor$1 = function(expressionSyntax) {
  try {
    return $Function$1('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e2) {
  }
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, "");
  } catch (e2) {
    $gOPD$1 = null;
  }
}
var throwTypeError$1 = function() {
  throw new $TypeError$3();
};
var ThrowTypeError$1 = $gOPD$1 ? function() {
  try {
    arguments.callee;
    return throwTypeError$1;
  } catch (calleeThrows) {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError$1;
    }
  }
}() : throwTypeError$1;
var hasSymbols2 = hasSymbols$2();
var getProto$1 = Object.getPrototypeOf || function(x) {
  return x.__proto__;
};
var needsEval$1 = {};
var TypedArray$1 = typeof Uint8Array === "undefined" ? undefined$2 : getProto$1(Uint8Array);
var INTRINSICS$1 = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$2 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$2 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 ? getProto$1([][Symbol.iterator]()) : undefined$2,
  "%AsyncFromSyncIteratorPrototype%": undefined$2,
  "%AsyncFunction%": needsEval$1,
  "%AsyncGenerator%": needsEval$1,
  "%AsyncGeneratorFunction%": needsEval$1,
  "%AsyncIteratorPrototype%": needsEval$1,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$2 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$2 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$2 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$2 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$2 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$2 : FinalizationRegistry,
  "%Function%": $Function$1,
  "%GeneratorFunction%": needsEval$1,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$2 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$2 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$2 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$2,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$2,
  "%Map%": typeof Map === "undefined" ? undefined$2 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 ? undefined$2 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$2 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$2 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$2 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$2 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 ? undefined$2 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$2 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 ? getProto$1(""[Symbol.iterator]()) : undefined$2,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$2,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError$1,
  "%TypedArray%": TypedArray$1,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$2 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$2 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$2 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$2 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$2 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$2 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$2 : WeakSet
};
var doEval$1 = function doEval(name) {
  var value;
  if (name === "%AsyncFunction%") {
    value = getEvalledConstructor$1("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value = getEvalledConstructor$1("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor$1("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn2 = doEval("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval("%AsyncGenerator%");
    if (gen) {
      value = getProto$1(gen.prototype);
    }
  }
  INTRINSICS$1[name] = value;
  return value;
};
var LEGACY_ALIASES$1 = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind3 = functionBind$1;
var hasOwn$3 = src$1;
var $concat$2 = bind3.call(Function.call, Array.prototype.concat);
var $spliceApply$1 = bind3.call(Function.apply, Array.prototype.splice);
var $replace$2 = bind3.call(Function.call, String.prototype.replace);
var $strSlice$1 = bind3.call(Function.call, String.prototype.slice);
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$1 = function stringToPath(string) {
  var first = $strSlice$1(string, 0, 1);
  var last = $strSlice$1(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$2(string, rePropName$1, function(match2, number, quote2, subString) {
    result[result.length] = quote2 ? $replace$2(subString, reEscapeChar$1, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic$1 = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$3(LEGACY_ALIASES$1, intrinsicName)) {
    alias = LEGACY_ALIASES$1[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$3(INTRINSICS$1, intrinsicName)) {
    var value = INTRINSICS$1[intrinsicName];
    if (value === needsEval$1) {
      value = doEval$1(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$3("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError$1("intrinsic " + name + " does not exist!");
};
var getIntrinsic$1 = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  }
  var parts2 = stringToPath$1(name);
  var intrinsicBaseName = parts2.length > 0 ? parts2[0] : "";
  var intrinsic = getBaseIntrinsic$1("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply$1(parts2, $concat$2([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts2.length; i2 += 1) {
    var part = parts2[i2];
    var first = $strSlice$1(part, 0, 1);
    var last = $strSlice$1(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$3(INTRINSICS$1, intrinsicRealName)) {
      value = INTRINSICS$1[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$3("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$1 && i2 + 1 >= parts2.length) {
        var desc = $gOPD$1(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$3(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS$1[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$3 = { exports: {} };
(function(module) {
  var bind5 = functionBind$1;
  var GetIntrinsic4 = getIntrinsic$1;
  var $apply = GetIntrinsic4("%Function.prototype.apply%");
  var $call = GetIntrinsic4("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic4("%Reflect.apply%", true) || bind5.call($call, $apply);
  var $gOPD2 = GetIntrinsic4("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty = GetIntrinsic4("%Object.defineProperty%", true);
  var $max = GetIntrinsic4("%Math.max%");
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e2) {
      $defineProperty = null;
    }
  }
  module.exports = function callBind2(originalFunction) {
    var func = $reflectApply(bind5, $call, arguments);
    if ($gOPD2 && $defineProperty) {
      var desc = $gOPD2(func, "length");
      if (desc.configurable) {
        $defineProperty(func, "length", { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
      }
    }
    return func;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind5, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$3);
var GetIntrinsic$2 = getIntrinsic$1;
var callBind$2 = callBind$3.exports;
var $indexOf$1 = callBind$2(GetIntrinsic$2("String.prototype.indexOf"));
var callBound$3 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$2(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf$1(name, ".prototype.") > -1) {
    return callBind$2(intrinsic);
  }
  return intrinsic;
};
var __viteBrowserExternal$2 = {};
var __viteBrowserExternal$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": __viteBrowserExternal$2
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace$1(__viteBrowserExternal$3);
var hasMap$1 = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor$1 = Object.getOwnPropertyDescriptor && hasMap$1 ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize$1 = hasMap$1 && mapSizeDescriptor$1 && typeof mapSizeDescriptor$1.get === "function" ? mapSizeDescriptor$1.get : null;
var mapForEach$1 = hasMap$1 && Map.prototype.forEach;
var hasSet$1 = typeof Set === "function" && Set.prototype;
var setSizeDescriptor$1 = Object.getOwnPropertyDescriptor && hasSet$1 ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize$1 = hasSet$1 && setSizeDescriptor$1 && typeof setSizeDescriptor$1.get === "function" ? setSizeDescriptor$1.get : null;
var setForEach$1 = hasSet$1 && Set.prototype.forEach;
var hasWeakMap$1 = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas$1 = hasWeakMap$1 ? WeakMap.prototype.has : null;
var hasWeakSet$1 = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas$1 = hasWeakSet$1 ? WeakSet.prototype.has : null;
var hasWeakRef$1 = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref$1 = hasWeakRef$1 ? WeakRef.prototype.deref : null;
var booleanValueOf$1 = Boolean.prototype.valueOf;
var objectToString$1 = Object.prototype.toString;
var functionToString$1 = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat$1 = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf$1 = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS$1 = Object.getOwnPropertySymbols;
var symToString$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols$1 = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag$1 = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols$1 ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable$1 = Object.prototype.propertyIsEnumerable;
var gPO$1 = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace$1.call(intStr, sepRegex, "$&_") + "." + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace$1.call(str, sepRegex, "$&_");
}
var inspectCustom$1 = require$$0.custom;
var inspectSymbol$1 = inspectCustom$1 && isSymbol$1(inspectCustom$1) ? inspectCustom$1 : null;
var objectInspect$1 = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$8(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$8(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$8(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$8(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$8(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString$1(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$a(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent$1(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf$3(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$8(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function") {
    var name = nameOf$1(obj);
    var keys3 = arrObjKeys$1(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys3.length > 0 ? " { " + $join.call(keys3, ", ") + " }" : "");
  }
  if (isSymbol$1(obj)) {
    var symString = hasShammedSymbols$1 ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString$1.call(obj);
    return typeof obj === "object" && !hasShammedSymbols$1 ? markBoxed$1(symString) : symString;
  }
  if (isElement$1(obj)) {
    var s2 = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s2 += " " + attrs[i2].name + "=" + wrapQuotes$1(quote$1(attrs[i2].value), "double", opts);
    }
    s2 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s2 += "...";
    }
    s2 += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s2;
  }
  if (isArray$a(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys$1(obj, inspect2);
    if (indent && !singleLineValues$1(xs)) {
      return "[" + indentedJoin$1(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError$1(obj)) {
    var parts2 = arrObjKeys$1(obj, inspect2);
    if ("cause" in obj && !isEnumerable$1.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat$1.call("[cause]: " + inspect2(obj.cause), parts2), ", ") + " }";
    }
    if (parts2.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts2, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol$1 && typeof obj[inspectSymbol$1] === "function") {
      return obj[inspectSymbol$1]();
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap$1(obj)) {
    var mapParts = [];
    mapForEach$1.call(obj, function(value, key) {
      mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
    });
    return collectionOf$1("Map", mapSize$1.call(obj), mapParts, indent);
  }
  if (isSet$1(obj)) {
    var setParts = [];
    setForEach$1.call(obj, function(value) {
      setParts.push(inspect2(value, obj));
    });
    return collectionOf$1("Set", setSize$1.call(obj), setParts, indent);
  }
  if (isWeakMap$1(obj)) {
    return weakCollectionOf$1("WeakMap");
  }
  if (isWeakSet$1(obj)) {
    return weakCollectionOf$1("WeakSet");
  }
  if (isWeakRef$1(obj)) {
    return weakCollectionOf$1("WeakRef");
  }
  if (isNumber$2(obj)) {
    return markBoxed$1(inspect2(Number(obj)));
  }
  if (isBigInt$1(obj)) {
    return markBoxed$1(inspect2(bigIntValueOf$1.call(obj)));
  }
  if (isBoolean$1(obj)) {
    return markBoxed$1(booleanValueOf$1.call(obj));
  }
  if (isString$2(obj)) {
    return markBoxed$1(inspect2(String(obj)));
  }
  if (!isDate$2(obj) && !isRegExp$3(obj)) {
    var ys = arrObjKeys$1(obj, inspect2);
    var isPlainObject2 = gPO$1 ? gPO$1(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject2 && toStringTag$1 && Object(obj) === obj && toStringTag$1 in obj ? $slice.call(toStr$2(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat$1.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin$1(ys, indent) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes$1(s2, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s2 + quoteChar;
}
function quote$1(s2) {
  return $replace$1.call(String(s2), /"/g, "&quot;");
}
function isArray$a(obj) {
  return toStr$2(obj) === "[object Array]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isDate$2(obj) {
  return toStr$2(obj) === "[object Date]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isRegExp$3(obj) {
  return toStr$2(obj) === "[object RegExp]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isError$1(obj) {
  return toStr$2(obj) === "[object Error]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isString$2(obj) {
  return toStr$2(obj) === "[object String]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isNumber$2(obj) {
  return toStr$2(obj) === "[object Number]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isBoolean$1(obj) {
  return toStr$2(obj) === "[object Boolean]" && (!toStringTag$1 || !(typeof obj === "object" && toStringTag$1 in obj));
}
function isSymbol$1(obj) {
  if (hasShammedSymbols$1) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString$1) {
    return false;
  }
  try {
    symToString$1.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
function isBigInt$1(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf$1) {
    return false;
  }
  try {
    bigIntValueOf$1.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
var hasOwn$2 = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$8(obj, key) {
  return hasOwn$2.call(obj, key);
}
function toStr$2(obj) {
  return objectToString$1.call(obj);
}
function nameOf$1(f) {
  if (f.name) {
    return f.name;
  }
  var m2 = $match.call(functionToString$1.call(f), /^function\s*([\w$]+)/);
  if (m2) {
    return m2[1];
  }
  return null;
}
function indexOf$3(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x) {
      return i2;
    }
  }
  return -1;
}
function isMap$1(x) {
  if (!mapSize$1 || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize$1.call(x);
    try {
      setSize$1.call(x);
    } catch (s2) {
      return true;
    }
    return x instanceof Map;
  } catch (e2) {
  }
  return false;
}
function isWeakMap$1(x) {
  if (!weakMapHas$1 || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas$1.call(x, weakMapHas$1);
    try {
      weakSetHas$1.call(x, weakSetHas$1);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e2) {
  }
  return false;
}
function isWeakRef$1(x) {
  if (!weakRefDeref$1 || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref$1.call(x);
    return true;
  } catch (e2) {
  }
  return false;
}
function isSet$1(x) {
  if (!setSize$1 || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize$1.call(x);
    try {
      mapSize$1.call(x);
    } catch (m2) {
      return true;
    }
    return x instanceof Set;
  } catch (e2) {
  }
  return false;
}
function isWeakSet$1(x) {
  if (!weakSetHas$1 || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas$1.call(x, weakSetHas$1);
    try {
      weakMapHas$1.call(x, weakMapHas$1);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e2) {
  }
  return false;
}
function isElement$1(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString$1(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString$1($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s2 = $replace$1.call($replace$1.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte$1);
  return wrapQuotes$1(s2, "single", opts);
}
function lowbyte$1(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed$1(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf$1(type) {
  return type + " { ? }";
}
function collectionOf$1(type, size2, entries, indent) {
  var joinedEntries = indent ? indentedJoin$1(entries, indent) : $join.call(entries, ", ");
  return type + " (" + size2 + ") {" + joinedEntries + "}";
}
function singleLineValues$1(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf$3(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent$1(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin$1(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys$1(obj, inspect2) {
  var isArr = isArray$a(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$8(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS$1 === "function" ? gOPS$1(obj) : [];
  var symMap;
  if (hasShammedSymbols$1) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$8(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols$1 && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS$1 === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable$1.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic2 = getIntrinsic$1;
var callBound$2 = callBound$3;
var inspect$1 = objectInspect$1;
var $TypeError$2 = GetIntrinsic2("%TypeError%");
var $WeakMap$1 = GetIntrinsic2("%WeakMap%", true);
var $Map$1 = GetIntrinsic2("%Map%", true);
var $weakMapGet$1 = callBound$2("WeakMap.prototype.get", true);
var $weakMapSet$1 = callBound$2("WeakMap.prototype.set", true);
var $weakMapHas$1 = callBound$2("WeakMap.prototype.has", true);
var $mapGet$1 = callBound$2("Map.prototype.get", true);
var $mapSet$1 = callBound$2("Map.prototype.set", true);
var $mapHas$1 = callBound$2("Map.prototype.has", true);
var listGetNode$1 = function(list, key) {
  for (var prev2 = list, curr; (curr = prev2.next) !== null; prev2 = curr) {
    if (curr.key === key) {
      prev2.next = curr.next;
      curr.next = list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet$1 = function(objects, key) {
  var node = listGetNode$1(objects, key);
  return node && node.value;
};
var listSet$1 = function(objects, key, value) {
  var node = listGetNode$1(objects, key);
  if (node) {
    node.value = value;
  } else {
    objects.next = {
      key,
      next: objects.next,
      value
    };
  }
};
var listHas$1 = function(objects, key) {
  return !!listGetNode$1(objects, key);
};
var sideChannel$1 = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError$2("Side channel does not contain " + inspect$1(key));
      }
    },
    get: function(key) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet$1($wm, key);
        }
      } else if ($Map$1) {
        if ($m) {
          return $mapGet$1($m, key);
        }
      } else {
        if ($o) {
          return listGet$1($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas$1($wm, key);
        }
      } else if ($Map$1) {
        if ($m) {
          return $mapHas$1($m, key);
        }
      } else {
        if ($o) {
          return listHas$1($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap$1();
        }
        $weakMapSet$1($wm, key, value);
      } else if ($Map$1) {
        if (!$m) {
          $m = new $Map$1();
        }
        $mapSet$1($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet$1($o, key, value);
      }
    }
  };
  return channel;
};
var replace$1 = String.prototype.replace;
var percentTwenties$1 = /%20/g;
var Format$1 = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$7 = {
  "default": Format$1.RFC3986,
  formatters: {
    RFC1738: function(value) {
      return replace$1.call(value, percentTwenties$1, "+");
    },
    RFC3986: function(value) {
      return String(value);
    }
  },
  RFC1738: Format$1.RFC1738,
  RFC3986: Format$1.RFC3986
};
var formats$6 = formats$7;
var has$7 = Object.prototype.hasOwnProperty;
var isArray$9 = Array.isArray;
var hexTable$1 = function() {
  var array = [];
  for (var i2 = 0; i2 < 256; ++i2) {
    array.push("%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue$1 = function compactQueue(queue2) {
  while (queue2.length > 1) {
    var item = queue2.pop();
    var obj = item.obj[item.prop];
    if (isArray$9(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject$1 = function arrayToObject(source4, options) {
  var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i2 = 0; i2 < source4.length; ++i2) {
    if (typeof source4[i2] !== "undefined") {
      obj[i2] = source4[i2];
    }
  }
  return obj;
};
var merge$2 = function merge(target, source4, options) {
  if (!source4) {
    return target;
  }
  if (typeof source4 !== "object") {
    if (isArray$9(target)) {
      target.push(source4);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$7.call(Object.prototype, source4)) {
        target[source4] = true;
      }
    } else {
      return [target, source4];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source4);
  }
  var mergeTarget = target;
  if (isArray$9(target) && !isArray$9(source4)) {
    mergeTarget = arrayToObject$1(target, options);
  }
  if (isArray$9(target) && isArray$9(source4)) {
    source4.forEach(function(item, i2) {
      if (has$7.call(target, i2)) {
        var targetItem = target[i2];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target[i2] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i2] = item;
      }
    });
    return target;
  }
  return Object.keys(source4).reduce(function(acc, key) {
    var value = source4[key];
    if (has$7.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign$1 = function assignSingleSource(target, source4) {
  return Object.keys(source4).reduce(function(acc, key) {
    acc[key] = source4[key];
    return acc;
  }, target);
};
var decode$2 = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e2) {
    return strWithoutPlus;
  }
};
var encode = function encode2(str, defaultEncoder, charset, kind, format) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var i2 = 0; i2 < string.length; ++i2) {
    var c = string.charCodeAt(i2);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats$6.RFC1738 && (c === 40 || c === 41)) {
      out += string.charAt(i2);
      continue;
    }
    if (c < 128) {
      out = out + hexTable$1[c];
      continue;
    }
    if (c < 2048) {
      out = out + (hexTable$1[192 | c >> 6] + hexTable$1[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      out = out + (hexTable$1[224 | c >> 12] + hexTable$1[128 | c >> 6 & 63] + hexTable$1[128 | c & 63]);
      continue;
    }
    i2 += 1;
    c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i2) & 1023);
    out += hexTable$1[240 | c >> 18] + hexTable$1[128 | c >> 12 & 63] + hexTable$1[128 | c >> 6 & 63] + hexTable$1[128 | c & 63];
  }
  return out;
};
var compact$1 = function compact(value) {
  var queue2 = [{ obj: { o: value }, prop: "o" }];
  var refs = [];
  for (var i2 = 0; i2 < queue2.length; ++i2) {
    var item = queue2[i2];
    var obj = item.obj[item.prop];
    var keys3 = Object.keys(obj);
    for (var j = 0; j < keys3.length; ++j) {
      var key = keys3[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue2.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue$1(queue2);
  return value;
};
var isRegExp$2 = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer2(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine$1 = function combine(a, b) {
  return [].concat(a, b);
};
var maybeMap$1 = function maybeMap(val, fn2) {
  if (isArray$9(val)) {
    var mapped = [];
    for (var i2 = 0; i2 < val.length; i2 += 1) {
      mapped.push(fn2(val[i2]));
    }
    return mapped;
  }
  return fn2(val);
};
var utils$j = {
  arrayToObject: arrayToObject$1,
  assign: assign$1,
  combine: combine$1,
  compact: compact$1,
  decode: decode$2,
  encode,
  isBuffer,
  isRegExp: isRegExp$2,
  maybeMap: maybeMap$1,
  merge: merge$2
};
var getSideChannel2 = sideChannel$1;
var utils$i = utils$j;
var formats$5 = formats$7;
var has$6 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators$1 = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$8 = Array.isArray;
var split = String.prototype.split;
var push$1 = Array.prototype.push;
var pushToArray$1 = function(arr, valueOrArray) {
  push$1.apply(arr, isArray$8(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO$1 = Date.prototype.toISOString;
var defaultFormat$1 = formats$5["default"];
var defaults$8 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encoder: utils$i.encode,
  encodeValuesOnly: false,
  format: defaultFormat$1,
  formatter: formats$5.formatters[defaultFormat$1],
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO$1.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive$1 = function isNonNullishPrimitive(v2) {
  return typeof v2 === "string" || typeof v2 === "number" || typeof v2 === "boolean" || typeof v2 === "symbol" || typeof v2 === "bigint";
};
var sentinel = {};
var stringify$2 = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate3, format, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  var tmpSc = sideChannel2;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== "undefined") {
      if (pos === step) {
        throw new RangeError("Cyclic object value");
      } else {
        findFlag = true;
      }
    }
    if (typeof tmpSc.get(sentinel) === "undefined") {
      step = 0;
    }
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate3(obj);
  } else if (generateArrayPrefix === "comma" && isArray$8(obj)) {
    obj = utils$i.maybeMap(obj, function(value2) {
      if (value2 instanceof Date) {
        return serializeDate3(value2);
      }
      return value2;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$8.encoder, charset, "key", format) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive$1(obj) || utils$i.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$8.encoder, charset, "key", format);
      if (generateArrayPrefix === "comma" && encodeValuesOnly) {
        var valuesArray = split.call(String(obj), ",");
        var valuesJoined = "";
        for (var i2 = 0; i2 < valuesArray.length; ++i2) {
          valuesJoined += (i2 === 0 ? "" : ",") + formatter(encoder(valuesArray[i2], defaults$8.encoder, charset, "value", format));
        }
        return [formatter(keyValue) + "=" + valuesJoined];
      }
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$8.encoder, charset, "value", format))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$8(obj)) {
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$8(filter)) {
    objKeys = filter;
  } else {
    var keys3 = Object.keys(obj);
    objKeys = sort ? keys3.sort(sort) : keys3;
  }
  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var keyPrefix = isArray$8(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
    sideChannel2.set(object, step);
    var valueSideChannel = getSideChannel2();
    valueSideChannel.set(sentinel, sideChannel2);
    pushToArray$1(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate3, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions$1 = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults$8;
  }
  if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$8.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format = formats$5["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$6.call(formats$5.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format = opts.format;
  }
  var formatter = formats$5.formatters[format];
  var filter = defaults$8.filter;
  if (typeof opts.filter === "function" || isArray$8(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$8.addQueryPrefix,
    allowDots: typeof opts.allowDots === "undefined" ? defaults$8.allowDots : !!opts.allowDots,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$8.charsetSentinel,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$8.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$8.encode,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$8.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$8.encodeValuesOnly,
    filter,
    format,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$8.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$8.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$8.strictNullHandling
  };
};
var stringify_1$1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions$1(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$8(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys3 = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators$1) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && "indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators$1[arrayFormat];
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray$1(keys3, stringify$2(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel2));
  }
  var joined = keys3.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils$h = utils$j;
var has$5 = Object.prototype.hasOwnProperty;
var isArray$7 = Array.isArray;
var defaults$7 = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decoder: utils$h.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities$1 = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue$1 = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel$1 = "utf8=%26%2310003%3B";
var charsetSentinel$1 = "utf8=%E2%9C%93";
var parseValues$1 = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts2 = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1;
  var i2;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i2 = 0; i2 < parts2.length; ++i2) {
      if (parts2[i2].indexOf("utf8=") === 0) {
        if (parts2[i2] === charsetSentinel$1) {
          charset = "utf-8";
        } else if (parts2[i2] === isoSentinel$1) {
          charset = "iso-8859-1";
        }
        skipIndex = i2;
        i2 = parts2.length;
      }
    }
  }
  for (i2 = 0; i2 < parts2.length; ++i2) {
    if (i2 === skipIndex) {
      continue;
    }
    var part = parts2[i2];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults$7.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults$7.decoder, charset, "key");
      val = utils$h.maybeMap(parseArrayValue$1(part.slice(pos + 1), options), function(encodedVal) {
        return options.decoder(encodedVal, defaults$7.decoder, charset, "value");
      });
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities$1(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray$7(val) ? [val] : val;
    }
    if (has$5.call(obj, key)) {
      obj[key] = utils$h.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject$1 = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue$1(val, options);
  for (var i2 = chain.length - 1; i2 >= 0; --i2) {
    var obj;
    var root = chain[i2];
    if (root === "[]" && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
      var index2 = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index2) && root !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
        obj = [];
        obj[index2] = leaf;
      } else if (cleanRoot !== "__proto__") {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys$1 = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets3 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets3.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys3 = [];
  if (parent) {
    if (!options.plainObjects && has$5.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(parent);
  }
  var i2 = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i2 < options.depth) {
    i2 += 1;
    if (!options.plainObjects && has$5.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(segment[1]);
  }
  if (segment) {
    keys3.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject$1(keys3, val, options, valuesParsed);
};
var normalizeParseOptions$1 = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults$7;
  }
  if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults$7.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === "undefined" ? defaults$7.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults$7.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults$7.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults$7.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$7.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults$7.comma,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults$7.decoder,
    delimiter: typeof opts.delimiter === "string" || utils$h.isRegExp(opts.delimiter) ? opts.delimiter : defaults$7.delimiter,
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults$7.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults$7.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults$7.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults$7.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$7.strictNullHandling
  };
};
var parse$4 = function(str, opts) {
  var options = normalizeParseOptions$1(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues$1(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys3 = Object.keys(tempObj);
  for (var i2 = 0; i2 < keys3.length; ++i2) {
    var key = keys3[i2];
    var newObj = parseKeys$1(key, tempObj[key], options, typeof str === "string");
    obj = utils$h.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils$h.compact(obj);
};
var stringify2 = stringify_1$1;
var parse$3 = parse$4;
var formats$4 = formats$7;
var lib$3 = {
  formats: formats$4,
  parse: parse$3,
  stringify: stringify2
};
var domParser = new DOMParser();
function getDocument(response) {
  var contentTypeHeader = response.headers.get("content-type") || "";
  var contentType = contentTypeHeader.replace(/;.*/, "");
  return response.text().then(function(text) {
    return domParser.parseFromString(text, contentType);
  });
}
function getResponseData(response, responseType) {
  switch (responseType) {
    case "arraybuffer":
      return response.arrayBuffer();
    case "blob":
      return response.blob();
    case "document":
      return getDocument(response);
    case "json":
      return response.json();
    case "text":
      return response.text();
    case "stream":
      return Promise.resolve(response.body);
    default:
      return response.text();
  }
}
function fetchAdapter(config) {
  var aborter = new AbortController();
  var cancelToken = config.cancelToken, signal = config.signal;
  var onCanceled;
  return new Promise(function dispatchFetchRequest(resolve2, reject) {
    onCanceled = function(cancel) {
      reject(isCancel$2(cancel) ? cancel : new Cancel_1$1("canceled"));
      aborter.abort();
    };
    if (cancelToken) {
      cancelToken.subscribe(onCanceled);
    }
    if (signal) {
      signal.aborted ? onCanceled() : signal.addEventListener("abort", onCanceled);
    }
    if (config.timeout) {
      setTimeout(function() {
        return aborter.abort();
      }, config.timeout);
    }
    var fullPath = buildFullPath$2(config.baseURL, config.url);
    var url2 = buildURL$4(fullPath, config.params, config.paramsSerializer);
    var requestHeaders = new Headers();
    utils$x.forEach(config.headers, function(value, key) {
      if (key.toLowerCase() === "content-type" && (typeof config.data === "undefined" || utils$x.isFormData(config.data))) {
        return;
      }
      requestHeaders.set(key, value);
    });
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
    }
    if (utils$x.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin$3(fullPath)) && config.xsrfCookieName ? cookies$3.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }
    var request3 = new Request(url2, {
      method: config.method.toUpperCase(),
      headers: requestHeaders,
      body: config.data,
      mode: config.mode,
      credentials: config.withCredentials ? "include" : "same-origin",
      cache: config.cache || "default",
      signal: aborter.signal
    });
    fetch(request3).then(function handleFetchResponse(response) {
      var responseHeaders = {};
      response.headers.forEach(function(value, key) {
        responseHeaders[key] = value;
      });
      getResponseData(response, config.responseType).then(function handleDataOk(data2) {
        settle$2(resolve2, reject, {
          data: data2,
          status: response.status,
          statusText: response.statusText,
          headers: responseHeaders,
          config,
          request: request3
        });
      }, function handleDataError() {
        reject(createError$4("Failed to get response data", config, null, request3, response));
      });
    }, function handleFetchError(error) {
      if (error.name === "AbortError") {
        reject(createError$4("Request aborted", config, "ECONNABORTED", request3));
      } else {
        reject(createError$4("Request failed", config, null, request3));
      }
    });
  }).finally(function() {
    if (cancelToken) {
      cancelToken.unsubscribe(onCanceled);
    }
    if (signal) {
      signal.removeEventListener("abort", onCanceled);
    }
  });
}
var api = axios$3.create({
  paramsSerializer: function(params) {
    return lib$3.stringify(params, { arrayFormat: "brackets" });
  },
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Teams-Enabled": "true"
  },
  adapter: fetchAdapter
});
function pagination(response) {
  var data2 = response.data;
  var pageMeta = data2 && data2.meta && data2.meta.page;
  if (pageMeta) {
    var page_1 = pageMeta.pageOffset + 1;
    var pageSize_1 = pageMeta.pageSize;
    var records_1 = pageMeta.count;
    var pages_1 = Math.ceil(records_1 / pageSize_1);
    return { page: page_1, pages: pages_1, pageSize: pageSize_1, records: records_1 };
  }
  var headers = response.headers, params = response.config.params;
  var page = Number(headers["x-page"]);
  var pages = Number(headers["x-pages"]);
  var records = Number(headers["x-records"]);
  var pageSize = params && typeof params.pageSize === "number" ? params.pageSize : 0;
  if (Number.isInteger(page) && Number.isInteger(pages) && Number.isInteger(pageSize) && Number.isInteger(records)) {
    return { page, pages, pageSize, records };
  }
  return { page: 0, pages: 0, pageSize: 0, records: 0 };
}
var lscache = { exports: {} };
(function(module) {
  (function(root, factory) {
    if (module.exports) {
      module.exports = factory();
    } else {
      root.lscache = factory();
    }
  })(commonjsGlobal, function() {
    var CACHE_PREFIX = "lscache-";
    var CACHE_SUFFIX = "-cacheexpiration";
    var EXPIRY_RADIX = 10;
    var expiryMilliseconds = 60 * 1e3;
    var maxDate = calculateMaxDate(expiryMilliseconds);
    var cachedStorage;
    var cachedJSON;
    var cacheBucket = "";
    var warnings = false;
    function supportsStorage() {
      var key = "__lscachetest__";
      var value = key;
      if (cachedStorage !== void 0) {
        return cachedStorage;
      }
      try {
        if (!localStorage) {
          return false;
        }
      } catch (ex) {
        return false;
      }
      try {
        setItem(key, value);
        removeItem(key);
        cachedStorage = true;
      } catch (e2) {
        if (isOutOfSpace(e2) && localStorage.length) {
          cachedStorage = true;
        } else {
          cachedStorage = false;
        }
      }
      return cachedStorage;
    }
    function isOutOfSpace(e2) {
      return e2 && (e2.name === "QUOTA_EXCEEDED_ERR" || e2.name === "NS_ERROR_DOM_QUOTA_REACHED" || e2.name === "QuotaExceededError");
    }
    function supportsJSON() {
      if (cachedJSON === void 0) {
        cachedJSON = window.JSON != null;
      }
      return cachedJSON;
    }
    function escapeRegExpSpecialCharacters(text) {
      return text.replace(/[[\]{}()*+?.\\^$|]/g, "\\$&");
    }
    function expirationKey(key) {
      return key + CACHE_SUFFIX;
    }
    function currentTime() {
      return Math.floor(new Date().getTime() / expiryMilliseconds);
    }
    function getItem(key) {
      return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }
    function setItem(key, value) {
      localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
      localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }
    function removeItem(key) {
      localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }
    function eachKey(fn2) {
      var prefixRegExp = new RegExp("^" + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + "(.*)");
      for (var i2 = localStorage.length - 1; i2 >= 0; --i2) {
        var key = localStorage.key(i2);
        key = key && key.match(prefixRegExp);
        key = key && key[1];
        if (key && key.indexOf(CACHE_SUFFIX) < 0) {
          fn2(key, expirationKey(key));
        }
      }
    }
    function flushItem(key) {
      var exprKey = expirationKey(key);
      removeItem(key);
      removeItem(exprKey);
    }
    function flushExpiredItem(key) {
      var exprKey = expirationKey(key);
      var expr = getItem(exprKey);
      if (expr) {
        var expirationTime = parseInt(expr, EXPIRY_RADIX);
        if (currentTime() >= expirationTime) {
          removeItem(key);
          removeItem(exprKey);
          return true;
        }
      }
    }
    function warn(message, err) {
      if (!warnings)
        return;
      if (!("console" in window) || typeof window.console.warn !== "function")
        return;
      window.console.warn("lscache - " + message);
      if (err)
        window.console.warn("lscache - The error was: " + err.message);
    }
    function calculateMaxDate(expiryMilliseconds2) {
      return Math.floor(864e13 / expiryMilliseconds2);
    }
    var lscache2 = {
      set: function(key, value, time) {
        if (!supportsStorage())
          return false;
        if (!supportsJSON())
          return false;
        try {
          value = JSON.stringify(value);
        } catch (e2) {
          return false;
        }
        try {
          setItem(key, value);
        } catch (e2) {
          if (isOutOfSpace(e2)) {
            var storedKeys = [];
            var storedKey;
            eachKey(function(key2, exprKey) {
              var expiration = getItem(exprKey);
              if (expiration) {
                expiration = parseInt(expiration, EXPIRY_RADIX);
              } else {
                expiration = maxDate;
              }
              storedKeys.push({
                key: key2,
                size: (getItem(key2) || "").length,
                expiration
              });
            });
            storedKeys.sort(function(a, b) {
              return b.expiration - a.expiration;
            });
            var targetSize = (value || "").length;
            while (storedKeys.length && targetSize > 0) {
              storedKey = storedKeys.pop();
              warn("Cache is full, removing item with key '" + key + "'");
              flushItem(storedKey.key);
              targetSize -= storedKey.size;
            }
            try {
              setItem(key, value);
            } catch (e3) {
              warn("Could not add item with key '" + key + "', perhaps it's too big?", e3);
              return false;
            }
          } else {
            warn("Could not add item with key '" + key + "'", e2);
            return false;
          }
        }
        if (time) {
          setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
        } else {
          removeItem(expirationKey(key));
        }
        return true;
      },
      get: function(key) {
        if (!supportsStorage())
          return null;
        if (flushExpiredItem(key)) {
          return null;
        }
        var value = getItem(key);
        if (!value || !supportsJSON()) {
          return value;
        }
        try {
          return JSON.parse(value);
        } catch (e2) {
          return value;
        }
      },
      remove: function(key) {
        if (!supportsStorage())
          return;
        flushItem(key);
      },
      supported: function() {
        return supportsStorage();
      },
      flush: function() {
        if (!supportsStorage())
          return;
        eachKey(function(key) {
          flushItem(key);
        });
      },
      flushExpired: function() {
        if (!supportsStorage())
          return;
        eachKey(function(key) {
          flushExpiredItem(key);
        });
      },
      setBucket: function(bucket) {
        cacheBucket = bucket;
      },
      resetBucket: function() {
        cacheBucket = "";
      },
      getExpiryMilliseconds: function() {
        return expiryMilliseconds;
      },
      setExpiryMilliseconds: function(milliseconds) {
        expiryMilliseconds = milliseconds;
        maxDate = calculateMaxDate(expiryMilliseconds);
      },
      enableWarnings: function(enabled) {
        warnings = enabled;
      }
    };
    return lscache2;
  });
})(lscache);
var __defProp2 = Object.defineProperty;
var __defProps2 = Object.defineProperties;
var __getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b));
const assertHasScope = (message = "Expected to have an active scope.") => {
  if (!getCurrentScope()) {
    throw new Error(message);
  }
};
const AxiosSymbol = Symbol("Axios instance");
function useAxios() {
  return inject(AxiosSymbol, api);
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var axios$2 = { exports: {} };
var bind$5 = function bind4(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$4 = bind$5;
var toString$3 = Object.prototype.toString;
function isArray$6(val) {
  return toString$3.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer$2(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString$3.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber$1(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString$3.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString$3.call(val) === "[object Date]";
}
function isFile(val) {
  return toString$3.call(val) === "[object File]";
}
function isBlob(val) {
  return toString$3.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString$3.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach2(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$6(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge$1() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge$1(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge$1({}, val);
    } else if (isArray$6(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
    forEach2(arguments[i2], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach2(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$4(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$g = {
  isArray: isArray$6,
  isArrayBuffer,
  isBuffer: isBuffer$2,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach: forEach2,
  merge: merge$1,
  extend,
  trim,
  stripBOM
};
var utils$f = utils$g;
function encode$2(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL3(url2, params, paramsSerializer) {
  if (!params) {
    return url2;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$f.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts2 = [];
    utils$f.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$f.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$f.forEach(val, function parseValue(v2) {
        if (utils$f.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$f.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts2.push(encode$2(key) + "=" + encode$2(v2));
      });
    });
    serializedParams = parts2.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url2.indexOf("#");
    if (hashmarkIndex !== -1) {
      url2 = url2.slice(0, hashmarkIndex);
    }
    url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url2;
};
var utils$e = utils$g;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use2(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject2(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach22(fn2) {
  utils$e.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn2(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$d = utils$g;
var normalizeHeaderName$1 = function normalizeHeaderName3(headers, normalizedName) {
  utils$d.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError3(error, config2, code, request22, response) {
  error.config = config2;
  if (code) {
    error.code = code;
  }
  error.request = request22;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError3(message, config2, code, request22, response) {
  var error = new Error(message);
  return enhanceError$1(error, config2, code, request22, response);
};
var createError$1 = createError$2;
var settle$1 = function settle3(resolve2, reject, response) {
  var validateStatus22 = response.config.validateStatus;
  if (!response.status || !validateStatus22 || validateStatus22(response.status)) {
    resolve2(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$c = utils$g;
var cookies$1 = utils$c.isStandardBrowserEnv() ? function standardBrowserEnv3() {
  return {
    write: function write2(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$c.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$c.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$c.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read2(name) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove2(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv3() {
  return {
    write: function write2() {
    },
    read: function read2() {
      return null;
    },
    remove: function remove2() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL3(url2) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url2);
};
var combineURLs$1 = function combineURLs3(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL22 = isAbsoluteURL$1;
var combineURLs22 = combineURLs$1;
var buildFullPath$1 = function buildFullPath3(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL22(requestedURL)) {
    return combineURLs22(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$b = utils$g;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders3(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$b.forEach(headers.split("\n"), function parser2(line) {
    i2 = line.indexOf(":");
    key = utils$b.trim(line.substr(0, i2)).toLowerCase();
    val = utils$b.trim(line.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$a = utils$g;
var isURLSameOrigin$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv22() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url2) {
    var href = url2;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$a.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv22() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString3() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$9 = utils$g;
var settle22 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath22 = buildFullPath$1;
var parseHeaders22 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError22 = createError$2;
var defaults$6 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter2(config2) {
  return new Promise(function dispatchXhrRequest(resolve2, reject) {
    var requestData = config2.data;
    var requestHeaders = config2.headers;
    var responseType = config2.responseType;
    var onCanceled;
    function done() {
      if (config2.cancelToken) {
        config2.cancelToken.unsubscribe(onCanceled);
      }
      if (config2.signal) {
        config2.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$9.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request22 = new XMLHttpRequest();
    if (config2.auth) {
      var username = config2.auth.username || "";
      var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath22(config2.baseURL, config2.url);
    request22.open(config2.method.toUpperCase(), buildURL$1(fullPath, config2.params, config2.paramsSerializer), true);
    request22.timeout = config2.timeout;
    function onloadend() {
      if (!request22) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request22 ? parseHeaders22(request22.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request22.responseText : request22.response;
      var response = {
        data: responseData,
        status: request22.status,
        statusText: request22.statusText,
        headers: responseHeaders,
        config: config2,
        request: request22
      };
      settle22(function _resolve(value) {
        resolve2(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request22 = null;
    }
    if ("onloadend" in request22) {
      request22.onloadend = onloadend;
    } else {
      request22.onreadystatechange = function handleLoad() {
        if (!request22 || request22.readyState !== 4) {
          return;
        }
        if (request22.status === 0 && !(request22.responseURL && request22.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request22.onabort = function handleAbort() {
      if (!request22) {
        return;
      }
      reject(createError22("Request aborted", config2, "ECONNABORTED", request22));
      request22 = null;
    };
    request22.onerror = function handleError2() {
      reject(createError22("Network Error", config2, null, request22));
      request22 = null;
    };
    request22.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
      var transitional22 = config2.transitional || defaults$6.transitional;
      if (config2.timeoutErrorMessage) {
        timeoutErrorMessage = config2.timeoutErrorMessage;
      }
      reject(createError22(timeoutErrorMessage, config2, transitional22.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request22));
      request22 = null;
    };
    if (utils$9.isStandardBrowserEnv()) {
      var xsrfValue = (config2.withCredentials || isURLSameOrigin(fullPath)) && config2.xsrfCookieName ? cookies.read(config2.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config2.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request22) {
      utils$9.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request22.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$9.isUndefined(config2.withCredentials)) {
      request22.withCredentials = !!config2.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request22.responseType = config2.responseType;
    }
    if (typeof config2.onDownloadProgress === "function") {
      request22.addEventListener("progress", config2.onDownloadProgress);
    }
    if (typeof config2.onUploadProgress === "function" && request22.upload) {
      request22.upload.addEventListener("progress", config2.onUploadProgress);
    }
    if (config2.cancelToken || config2.signal) {
      onCanceled = function(cancel) {
        if (!request22) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request22.abort();
        request22 = null;
      };
      config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
      if (config2.signal) {
        config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request22.send(requestData);
  });
};
var utils$8 = utils$g;
var normalizeHeaderName22 = normalizeHeaderName$1;
var enhanceError22 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$8.isUndefined(headers) && utils$8.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils$8.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$8.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$5 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest2(data2, headers) {
    normalizeHeaderName22(headers, "Accept");
    normalizeHeaderName22(headers, "Content-Type");
    if (utils$8.isFormData(data2) || utils$8.isArrayBuffer(data2) || utils$8.isBuffer(data2) || utils$8.isStream(data2) || utils$8.isFile(data2) || utils$8.isBlob(data2)) {
      return data2;
    }
    if (utils$8.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$8.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$8.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse2(data2) {
    var transitional22 = this.transitional || defaults$5.transitional;
    var silentJSONParsing = transitional22 && transitional22.silentJSONParsing;
    var forcedJSONParsing = transitional22 && transitional22.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$8.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError22(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus2(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$8.forEach(["delete", "get", "head"], function forEachMethodNoData3(method) {
  defaults$5.headers[method] = {};
});
utils$8.forEach(["post", "put", "patch"], function forEachMethodWithData3(method) {
  defaults$5.headers[method] = utils$8.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$5;
var utils$7 = utils$g;
var defaults$4 = defaults_1;
var transformData$1 = function transformData3(data2, headers, fns) {
  var context = this || defaults$4;
  utils$7.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel3(value) {
  return !!(value && value.__CANCEL__);
};
var utils$6 = utils$g;
var transformData22 = transformData$1;
var isCancel22 = isCancel$1;
var defaults$3 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
  if (config2.signal && config2.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest3(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = config2.headers || {};
  config2.data = transformData22.call(config2, config2.data, config2.headers, config2.transformRequest);
  config2.headers = utils$6.merge(config2.headers.common || {}, config2.headers[config2.method] || {}, config2.headers);
  utils$6.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config2.headers[method];
  });
  var adapter = config2.adapter || defaults$3.adapter;
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData22.call(config2, response.data, response.headers, config2.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel22(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData22.call(config2, reason.response.data, reason.response.headers, config2.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$5 = utils$g;
var mergeConfig$2 = function mergeConfig3(config1, config2) {
  config2 = config2 || {};
  var config3 = {};
  function getMergedValue(target, source22) {
    if (utils$5.isPlainObject(target) && utils$5.isPlainObject(source22)) {
      return utils$5.merge(target, source22);
    } else if (utils$5.isPlainObject(source22)) {
      return utils$5.merge({}, source22);
    } else if (utils$5.isArray(source22)) {
      return source22.slice();
    }
    return source22;
  }
  function mergeDeepProperties(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$5.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$5.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$5.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge3 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge3(prop);
    utils$5.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config3[prop] = configValue);
  });
  return config3;
};
var data = {
  "version": "0.24.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version2 + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys3 = Object.keys(options);
  var i2 = keys3.length;
  while (i2-- > 0) {
    var opt = keys3[i2];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$4 = utils$g;
var buildURL22 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest22 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request2(config2) {
  if (typeof config2 === "string") {
    config2 = arguments[1] || {};
    config2.url = arguments[0];
  } else {
    config2 = config2 || {};
  }
  config2 = mergeConfig$1(this.defaults, config2);
  if (config2.method) {
    config2.method = config2.method.toLowerCase();
  } else if (this.defaults.method) {
    config2.method = this.defaults.method.toLowerCase();
  } else {
    config2.method = "get";
  }
  var transitional22 = config2.transitional;
  if (transitional22 !== void 0) {
    validator.assertOptions(transitional22, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest22, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config2);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config2;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest22(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri2(config2) {
  config2 = mergeConfig$1(this.defaults, config2);
  return buildURL22(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$4.forEach(["delete", "get", "head", "options"], function forEachMethodNoData22(method) {
  Axios$1.prototype[method] = function(url2, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url: url2,
      data: (config2 || {}).data
    }));
  };
});
utils$4.forEach(["post", "put", "patch"], function forEachMethodWithData22(method) {
  Axios$1.prototype[method] = function(url2, data2, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url: url2,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve2) {
    resolvePromise = resolve2;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i2;
    var l = token._listeners.length;
    for (i2 = 0; i2 < l; i2++) {
      token._listeners[i2](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve2) {
      token.subscribe(resolve2);
      _resolve = resolve2;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested2() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe2(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe2(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source3() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread2 = function spread22(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError2 = function isAxiosError22(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils$3 = utils$g;
var bind$3 = bind$5;
var Axios = Axios_1;
var mergeConfig22 = mergeConfig$2;
var defaults$2 = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$3(Axios.prototype.request, context);
  utils$3.extend(instance, Axios.prototype, context);
  utils$3.extend(instance, context);
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig22(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults$2);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all2(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread2;
axios$1.isAxiosError = isAxiosError2;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
function useListLoader({
  url: _url,
  params: _params,
  count: _count = 0,
  responseToItems: _responseToItems = () => [],
  responseToMeta: _responseToMeta = () => null,
  order: _order = () => 0,
  pageSize: _pageSize = 10
}) {
  assertHasScope();
  const axiosInstance = useAxios();
  const url2 = shallowRef(_url);
  const params = shallowRef(_params);
  const count = shallowRef(_count);
  const responseToItems2 = shallowRef(_responseToItems);
  const responseToMeta2 = shallowRef(_responseToMeta);
  const order2 = shallowRef(_order);
  const pageSize = shallowRef(_pageSize);
  const loadedCount = shallowRef(0);
  const totalCount = shallowRef(void 0);
  const lastUpdated = shallowRef(void 0);
  const itemsMap = shallowRef(/* @__PURE__ */ new Map());
  const updatedItemIds = shallowRef(/* @__PURE__ */ new Set());
  const optimisticUpdates = shallowRef(/* @__PURE__ */ new Set());
  const cancel = shallowRef(void 0);
  const backOff = useBackOff();
  const meta = shallowRef(void 0);
  const response = shallowRef(void 0);
  const error = shallowRef(void 0);
  const loading = computed(() => Boolean(cancel.value));
  const outdatedItems = shallowRef(void 0);
  const needsBuffer = shallowRef(false);
  const bufferSize = computed(() => needsBuffer.value ? Math.ceil(pageSize.value * 0.2) : 0);
  const needsRefresh = computed(() => updatedItemIds.value.size > 0 || Boolean(outdatedItems.value));
  const inSync = computed(() => !needsRefresh.value && optimisticUpdates.value.size === 0 && (lastUpdated.value !== void 0 || count.value < 0) && (pageSize.value === 0 || loadedCount.value >= count.value || loadedCount.value >= totalCount.value));
  const shouldUseCache = computed(() => response.value === void 0 && error.value === void 0);
  let cachedItems = [];
  function applyOptimisticUpdates(loadedItems) {
    let processedItems = loadedItems;
    optimisticUpdates.value.forEach((optimisticUpdate) => {
      processedItems = optimisticUpdate.apply(processedItems);
    });
    return processedItems;
  }
  const items = computed(() => {
    const newItems = applyOptimisticUpdates(outdatedItems.value || Array.from(itemsMap.value.values())).sort(order2.value).slice(0, Math.max(0, count.value));
    if (newItems.length !== cachedItems.length || newItems.some((newItem, index2) => newItem !== cachedItems[index2])) {
      cachedItems = newItems;
    }
    return cachedItems;
  });
  let triggeredBy = "user";
  function reset2() {
    needsBuffer.value = false;
    loadedCount.value = 0;
    totalCount.value = void 0;
    lastUpdated.value = void 0;
    response.value = void 0;
    error.value = void 0;
    meta.value = void 0;
    itemsMap.value.clear();
    triggerRef(itemsMap);
    updatedItemIds.value.clear();
    triggerRef(updatedItemIds);
    if (cancel.value)
      cancel.value();
    backOff.reset();
    triggeredBy = "user";
  }
  function refresh(itemId) {
    if (typeof itemId === "undefined") {
      outdatedItems.value = Array.from(itemsMap.value.values());
      loadedCount.value = 0;
      lastUpdated.value = void 0;
      itemsMap.value.clear();
      triggerRef(itemsMap);
      updatedItemIds.value.clear();
      triggerRef(updatedItemIds);
    } else {
      needsBuffer.value = true;
      updatedItemIds.value.add(itemId);
      triggerRef(updatedItemIds);
    }
    if (cancel.value)
      cancel.value();
    backOff.reset();
    triggeredBy = "event";
  }
  function getLastUpdated({ headers }) {
    return moment.utc(headers.date).subtract(1e4);
  }
  async function loadUpdates() {
    if (lastUpdated.value === void 0) {
      updatedItemIds.value.clear();
      triggerRef(updatedItemIds);
      return;
    }
    if (updatedItemIds.value.size > pageSize.value) {
      refresh();
      return;
    }
    try {
      const loadUpdatesParams = __spreadProps2(__spreadValues2({}, params.value), {
        page: 1,
        pageSize: pageSize.value
      });
      if (url2.value.startsWith("/projects/api/v3/")) {
        loadUpdatesParams.updatedAfter = lastUpdated.value.format();
      } else {
        loadUpdatesParams.updatedAfterDate = lastUpdated.value.format("YYYYMMDDHHmmss");
      }
      response.value = await new Promise((resolve2, reject) => {
        cancel.value = () => reject(new axios.Cancel());
        axiosInstance.get(url2.value, {
          params: loadUpdatesParams,
          headers: {
            "Triggered-By": triggeredBy,
            "Sent-By": "composable"
          }
        }).then(resolve2, reject);
      });
      error.value = void 0;
      if (pagination(response.value).pages > 1) {
        refresh();
        return;
      }
      let newLoadedCount = loadedCount.value;
      const loadedItemsMap = /* @__PURE__ */ new Map();
      const loadedItems = responseToItems2.value(response.value);
      loadedItems.forEach((item) => {
        const oldItem = itemsMap.value.get(item.id);
        if (oldItem && order2.value(item, oldItem) !== 0) {
          newLoadedCount -= 1;
        }
        itemsMap.value.set(item.id, item);
        loadedItemsMap.set(item.id, item);
      });
      updatedItemIds.value.forEach((id) => {
        if (itemsMap.value.has(id) && !loadedItemsMap.has(id)) {
          itemsMap.value.delete(id);
          newLoadedCount -= 1;
        }
      });
      updatedItemIds.value.clear();
      triggerRef(itemsMap);
      triggerRef(updatedItemIds);
      if (loadedCount.value < totalCount.value) {
        loadedCount.value = Math.max(newLoadedCount, 0);
        totalCount.value = Math.max(totalCount.value, itemsMap.value.size);
      } else {
        loadedCount.value = itemsMap.value.size;
        totalCount.value = itemsMap.value.size;
      }
      lastUpdated.value = getLastUpdated(response.value);
      backOff.reset();
    } catch (axiosError) {
      if (axios.isCancel(axiosError))
        return;
      response.value = void 0;
      error.value = axiosError;
      backOff.start();
    } finally {
      cancel.value = void 0;
    }
  }
  async function loadMore() {
    if (count.value < 0) {
      if (outdatedItems.value)
        outdatedItems.value = void 0;
      return;
    }
    if (lastUpdated.value !== void 0) {
      if (pageSize.value <= 0) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        return;
      }
      if (loadedCount.value >= totalCount.value) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        return;
      }
      if (loadedCount.value >= count.value) {
        if (outdatedItems.value)
          outdatedItems.value = void 0;
        if (bufferSize.value <= 0) {
          return;
        }
        if (loadedCount.value > Math.floor((count.value + bufferSize.value - 1) / pageSize.value) * pageSize.value) {
          return;
        }
      }
    }
    try {
      response.value = await new Promise((resolve2, reject) => {
        cancel.value = () => reject(new axios.Cancel());
        axiosInstance.get(url2.value, {
          params: __spreadProps2(__spreadValues2({}, params.value), {
            page: (loadedCount.value / pageSize.value | 0) + 1,
            pageSize: pageSize.value
          }),
          headers: {
            "Triggered-By": triggeredBy,
            "Sent-By": "composable"
          },
          cache: shouldUseCache.value ? "only-if-cached" : void 0,
          mode: shouldUseCache.value ? "same-origin" : void 0
        }).then(resolve2, reject);
      });
      error.value = void 0;
      const pageMeta = pagination(response.value);
      meta.value = responseToMeta2.value(response.value);
      const loadedItems = responseToItems2.value(response.value);
      loadedItems.forEach((item) => itemsMap.value.set(item.id, item));
      triggerRef(itemsMap);
      loadedCount.value = pageMeta.page * pageMeta.pageSize;
      totalCount.value = pageMeta.records;
      if (lastUpdated.value === void 0) {
        lastUpdated.value = getLastUpdated(response.value);
      }
      backOff.reset();
    } catch (axiosError) {
      if (axios.isCancel(axiosError))
        return;
      response.value = void 0;
      error.value = axiosError;
      backOff.start();
    } finally {
      cancel.value = void 0;
    }
  }
  function load() {
    if (cancel.value)
      return;
    if (backOff.active.value)
      return;
    if (typeof url2.value !== "string")
      return;
    if (updatedItemIds.value.size > 0)
      loadUpdates();
    else
      loadMore();
  }
  function itemInSync(itemToCheck) {
    return Boolean(itemToCheck) && itemsMap.value.get(itemToCheck.id) === itemToCheck && !updatedItemIds.value.has(itemToCheck.id);
  }
  function update(apply, promise) {
    const optimisticUpdate = { apply, promise };
    promise.then(() => {
      if (needsRefresh.value) {
        optimisticUpdate.promise = void 0;
      } else {
        optimisticUpdates.value.delete(optimisticUpdate);
        triggerRef(optimisticUpdates);
      }
    }, () => {
      optimisticUpdates.value.delete(optimisticUpdate);
      triggerRef(optimisticUpdates);
    });
    optimisticUpdates.value.add(optimisticUpdate);
    triggerRef(optimisticUpdates);
  }
  watch(needsRefresh, () => {
    if (!needsRefresh.value) {
      optimisticUpdates.value.forEach((optimisticUpdate) => {
        if (!optimisticUpdate.promise) {
          optimisticUpdates.value.delete(optimisticUpdate);
          triggerRef(optimisticUpdates);
        }
      });
    }
  });
  watch(url2, reset2);
  watch(params, reset2, { deep: true });
  watch(responseToItems2, reset2);
  watch(responseToMeta2, reset2);
  watch(order2, reset2);
  watch(cancel, load);
  watch(backOff.active, load);
  watch(updatedItemIds, load);
  watch(pageSize, load);
  watch(count, load);
  watch(loadedCount, load);
  watch(totalCount, load);
  watch(shouldUseCache, () => {
    if (!shouldUseCache.value) {
      refresh();
      triggeredBy = "user";
    }
  });
  onUnmounted(reset2);
  load();
  const state = {
    items,
    totalCount,
    inSync,
    itemInSync,
    loading,
    meta,
    response,
    error
  };
  return __spreadProps2(__spreadValues2({}, state), {
    state,
    refresh,
    update
  });
}
function useBackOff({
  retryDelay = exponentialBackOff()
} = {}) {
  assertHasScope();
  const handle = shallowRef(void 0);
  const retryAttempt = ref(-1);
  function stop() {
    if (handle.value !== void 0) {
      clearTimeout(handle.value);
      handle.value = void 0;
    }
  }
  function start2() {
    stop();
    retryAttempt.value += 1;
    handle.value = setTimeout(stop, retryDelay(retryAttempt.value));
  }
  function reset2() {
    stop();
    retryAttempt.value = -1;
  }
  onUnmounted(stop);
  return {
    start: start2,
    reset: reset2,
    active: computed(() => handle.value !== void 0),
    retryAttempt
  };
}
var shams = function hasSymbols3() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols2() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice$1 = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$1 = function bind22(that) {
  var target = this;
  if (typeof target !== "function" || toStr$1.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice$1.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice$1.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice$1.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs.push("$" + i2);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var bind$2 = functionBind;
var src = bind$2.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e2) {
  }
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, "");
  } catch (e2) {
    $gOPD = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$1();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols22 = hasSymbols$1();
var getProto = Object.getPrototypeOf || function(x) {
  return x.__proto__;
};
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols22 ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols22 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols22 ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols22 ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols22 ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols22 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval2 = function doEval22(name) {
  var value;
  if (name === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn2 = doEval22("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval22("%AsyncGenerator%");
    if (gen) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind$1 = functionBind;
var hasOwn$1 = src;
var $concat = bind$1.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$1.call(Function.apply, Array.prototype.splice);
var $replace = bind$1.call(Function.call, String.prototype.replace);
var $strSlice = bind$1.call(Function.call, String.prototype.slice);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath2 = function stringToPath22(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace(string, rePropName, function(match2, number, quote2, subString) {
    result[result.length] = quote2 ? $replace(subString, reEscapeChar, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic2 = function getBaseIntrinsic22(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval2(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$1("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic3(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  }
  var parts2 = stringToPath2(name);
  var intrinsicBaseName = parts2.length > 0 ? parts2[0] : "";
  var intrinsic = getBaseIntrinsic2("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts2, $concat([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts2.length; i2 += 1) {
    var part = parts2[i2];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$1("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i2 + 1 >= parts2.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$1 = { exports: {} };
(function(module) {
  var bind42 = functionBind;
  var GetIntrinsic32 = getIntrinsic;
  var $apply = GetIntrinsic32("%Function.prototype.apply%");
  var $call = GetIntrinsic32("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic32("%Reflect.apply%", true) || bind42.call($call, $apply);
  var $gOPD2 = GetIntrinsic32("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty = GetIntrinsic32("%Object.defineProperty%", true);
  var $max = GetIntrinsic32("%Math.max%");
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
    } catch (e2) {
      $defineProperty = null;
    }
  }
  module.exports = function callBind2(originalFunction) {
    var func = $reflectApply(bind42, $call, arguments);
    if ($gOPD2 && $defineProperty) {
      var desc = $gOPD2(func, "length");
      if (desc.configurable) {
        $defineProperty(func, "length", { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) });
      }
    }
    return func;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind42, $apply, arguments);
  };
  if ($defineProperty) {
    $defineProperty(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBind$1.exports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic2(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": __viteBrowserExternal
});
var require$$6 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
var inspectCustom = require$$6.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag !== "undefined" ? Symbol.toStringTag : null;
var objectInspect = function inspect_2(obj, options, depth, seen) {
  var opts = options || {};
  if (has$4(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$4(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$4(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$4(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    return String(obj);
  }
  if (typeof obj === "bigint") {
    return String(obj) + "n";
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$5(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf$2(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from, noIndent) {
    if (from) {
      seen = seen.slice();
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$4(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_2(value, newOpts, depth + 1, seen);
    }
    return inspect_2(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function") {
    var name = nameOf(obj);
    var keys3 = arrObjKeys(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys3.length > 0 ? " { " + keys3.join(", ") + " }" : "");
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s2 = "<" + String(obj.nodeName).toLowerCase();
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s2 += " " + attrs[i2].name + "=" + wrapQuotes(quote(attrs[i2].value), "double", opts);
    }
    s2 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s2 += "...";
    }
    s2 += "</" + String(obj.nodeName).toLowerCase() + ">";
    return s2;
  }
  if (isArray$5(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + xs.join(", ") + " ]";
  }
  if (isError(obj)) {
    var parts2 = arrObjKeys(obj, inspect2);
    if (parts2.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + parts2.join(", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function") {
      return obj[inspectSymbol]();
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    mapForEach.call(obj, function(value, key) {
      mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
    });
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    setForEach.call(obj, function(value) {
      setParts.push(inspect2(value, obj));
    });
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + [].concat(stringTag || [], protoTag || []).join(": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + ys.join(", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s2, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s2 + quoteChar;
}
function quote(s2) {
  return String(s2).replace(/"/g, "&quot;");
}
function isArray$5(obj) {
  return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$1(obj) {
  return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$4(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m2 = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m2) {
    return m2[1];
  }
  return null;
}
function indexOf$2(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x) {
      return i2;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s2) {
      return true;
    }
    return x instanceof Map;
  } catch (e2) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e2) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e2) {
  }
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m2) {
      return true;
    }
    return x instanceof Set;
  } catch (e2) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e2) {
  }
  return false;
}
function isElement(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
  }
  var s2 = str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s2, "single", opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n < 16 ? "0" : "") + n.toString(16).toUpperCase();
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type) {
  return type + " { ? }";
}
function collectionOf(type, size2, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(", ");
  return type + " (" + size2 + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf$2(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = Array(opts.indent + 1).join(" ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: Array(depth + 1).join(baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$5(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$4(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap["$" + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    if (!has$4(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if (/[^\w$]/.test(key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic22 = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;
var $TypeError = GetIntrinsic22("%TypeError%");
var $WeakMap = GetIntrinsic22("%WeakMap%", true);
var $Map = GetIntrinsic22("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
var listGetNode = function(list, key) {
  for (var prev2 = list, curr; (curr = prev2.next) !== null; prev2 = curr) {
    if (curr.key === key) {
      prev2.next = curr.next;
      curr.next = list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function(objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    objects.next = {
      key,
      next: objects.next,
      value
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel3() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value) {
      return replace.call(value, percentTwenties, "+");
    },
    RFC3986: function(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var has$3 = Object.prototype.hasOwnProperty;
var isArray$4 = Array.isArray;
var hexTable = function() {
  var array = [];
  for (var i2 = 0; i2 < 256; ++i2) {
    array.push("%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue2 = function compactQueue22(queue2) {
  while (queue2.length > 1) {
    var item = queue2.pop();
    var obj = item.obj[item.prop];
    if (isArray$4(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject2 = function arrayToObject22(source22, options) {
  var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i2 = 0; i2 < source22.length; ++i2) {
    if (typeof source22[i2] !== "undefined") {
      obj[i2] = source22[i2];
    }
  }
  return obj;
};
var merge2 = function merge22(target, source22, options) {
  if (!source22) {
    return target;
  }
  if (typeof source22 !== "object") {
    if (isArray$4(target)) {
      target.push(source22);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$3.call(Object.prototype, source22)) {
        target[source22] = true;
      }
    } else {
      return [target, source22];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source22);
  }
  var mergeTarget = target;
  if (isArray$4(target) && !isArray$4(source22)) {
    mergeTarget = arrayToObject2(target, options);
  }
  if (isArray$4(target) && isArray$4(source22)) {
    source22.forEach(function(item, i2) {
      if (has$3.call(target, i2)) {
        var targetItem = target[i2];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target[i2] = merge22(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i2] = item;
      }
    });
    return target;
  }
  return Object.keys(source22).reduce(function(acc, key) {
    var value = source22[key];
    if (has$3.call(acc, key)) {
      acc[key] = merge22(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource2(target, source22) {
  return Object.keys(source22).reduce(function(acc, key) {
    acc[key] = source22[key];
    return acc;
  }, target);
};
var decode$1 = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e2) {
    return strWithoutPlus;
  }
};
var encode$1 = function encode3(str, defaultEncoder, charset, kind, format) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var i2 = 0; i2 < string.length; ++i2) {
    var c = string.charCodeAt(i2);
    if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats$2.RFC1738 && (c === 40 || c === 41)) {
      out += string.charAt(i2);
      continue;
    }
    if (c < 128) {
      out = out + hexTable[c];
      continue;
    }
    if (c < 2048) {
      out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
      continue;
    }
    if (c < 55296 || c >= 57344) {
      out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
      continue;
    }
    i2 += 1;
    c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i2) & 1023);
    out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
  }
  return out;
};
var compact2 = function compact22(value) {
  var queue2 = [{ obj: { o: value }, prop: "o" }];
  var refs = [];
  for (var i2 = 0; i2 < queue2.length; ++i2) {
    var item = queue2[i2];
    var obj = item.obj[item.prop];
    var keys3 = Object.keys(obj);
    for (var j = 0; j < keys3.length; ++j) {
      var key = keys3[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue2.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue2(queue2);
  return value;
};
var isRegExp2 = function isRegExp22(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer$1 = function isBuffer3(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine2 = function combine22(a, b) {
  return [].concat(a, b);
};
var maybeMap2 = function maybeMap22(val, fn2) {
  if (isArray$4(val)) {
    var mapped = [];
    for (var i2 = 0; i2 < val.length; i2 += 1) {
      mapped.push(fn2(val[i2]));
    }
    return mapped;
  }
  return fn2(val);
};
var utils$2 = {
  arrayToObject: arrayToObject2,
  assign,
  combine: combine2,
  compact: compact2,
  decode: decode$1,
  encode: encode$1,
  isBuffer: isBuffer$1,
  isRegExp: isRegExp2,
  maybeMap: maybeMap2,
  merge: merge2
};
var getSideChannel22 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$2 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets2(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices2(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat2(prefix) {
    return prefix;
  }
};
var isArray$3 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$3(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  indices: false,
  serializeDate: function serializeDate2(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive2 = function isNonNullishPrimitive22(v2) {
  return typeof v2 === "string" || typeof v2 === "number" || typeof v2 === "boolean" || typeof v2 === "symbol" || typeof v2 === "bigint";
};
var stringify$1 = function stringify3(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate22, format, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  if (sideChannel2.has(object)) {
    throw new RangeError("Cyclic object value");
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate22(obj);
  } else if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    obj = utils$1.maybeMap(obj, function(value2) {
      if (value2 instanceof Date) {
        return serializeDate22(value2);
      }
      return value2;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive2(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format);
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$1.encoder, charset, "value", format))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$3(filter)) {
    objKeys = filter;
  } else {
    var keys3 = Object.keys(obj);
    objKeys = sort ? keys3.sort(sort) : keys3;
  }
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    var value = typeof key === "object" && key.value !== void 0 ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var keyPrefix = isArray$3(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
    sideChannel2.set(object, true);
    var valueSideChannel = getSideChannel22();
    pushToArray(values, stringify3(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate22, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions2 = function normalizeStringifyOptions22(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (opts.encoder !== null && opts.encoder !== void 0 && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$2.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format = opts.format;
  }
  var formatter = formats$1.formatters[format];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$3(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof opts.allowDots === "undefined" ? defaults$1.allowDots : !!opts.allowDots,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions2(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$3(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys3 = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && "indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = "indices";
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel22();
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys3, stringify$1(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel2));
  }
  var joined = keys3.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has$1 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues2(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts2 = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1;
  var i2;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i2 = 0; i2 < parts2.length; ++i2) {
      if (parts2[i2].indexOf("utf8=") === 0) {
        if (parts2[i2] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts2[i2] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i2;
        i2 = parts2.length;
      }
    }
  }
  for (i2 = 0; i2 < parts2.length; ++i2) {
    if (i2 === skipIndex) {
      continue;
    }
    var part = parts2[i2];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, "value");
      });
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray$2(val) ? [val] : val;
    }
    if (has$1.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i2 = chain.length - 1; i2 >= 0; --i2) {
    var obj;
    var root = chain[i2];
    if (root === "[]" && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
      var index2 = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index2) && root !== cleanRoot && String(index2) === cleanRoot && index2 >= 0 && (options.parseArrays && index2 <= options.arrayLimit)) {
        obj = [];
        obj[index2] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys2(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets22 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets22.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys3 = [];
  if (parent) {
    if (!options.plainObjects && has$1.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(parent);
  }
  var i2 = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i2 < options.depth) {
    i2 += 1;
    if (!options.plainObjects && has$1.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys3.push(segment[1]);
  }
  if (segment) {
    keys3.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys3, val, options, valuesParsed);
};
var normalizeParseOptions2 = function normalizeParseOptions22(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
var parse$2 = function(str, opts) {
  var options = normalizeParseOptions2(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys3 = Object.keys(tempObj);
  for (var i2 = 0; i2 < keys3.length; ++i2) {
    var key = keys3[i2];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify22 = stringify_1;
var parse$1 = parse$2;
var formats = formats$3;
var lib$2 = {
  formats,
  parse: parse$1,
  stringify: stringify22
};
axios.create({
  paramsSerializer(params) {
    return lib$2.stringify(params, { arrayFormat: "brackets" });
  }
});
var lib$1 = { exports: {} };
var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var parts = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
var parseuri$2 = function parseuri(str) {
  var src2 = str, b = str.indexOf("["), e2 = str.indexOf("]");
  if (b != -1 && e2 != -1) {
    str = str.substring(0, b) + str.substring(b, e2).replace(/:/g, ";") + str.substring(e2, str.length);
  }
  var m2 = re.exec(str || ""), uri = {}, i2 = 14;
  while (i2--) {
    uri[parts[i2]] = m2[i2] || "";
  }
  if (b != -1 && e2 != -1) {
    uri.source = src2;
    uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
    uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
    uri.ipv6uri = true;
  }
  uri.pathNames = pathNames(uri, uri["path"]);
  uri.queryKey = queryKey(uri, uri["query"]);
  return uri;
};
function pathNames(obj, path) {
  var regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
  if (path.substr(0, 1) == "/" || path.length === 0) {
    names.splice(0, 1);
  }
  if (path.substr(path.length - 1, 1) == "/") {
    names.splice(names.length - 1, 1);
  }
  return names;
}
function queryKey(uri, query) {
  var data2 = {};
  query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
    if ($1) {
      data2[$1] = $2;
    }
  });
  return data2;
}
var browser$1 = { exports: {} };
var debug$6 = { exports: {} };
var s = 1e3;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === "string" && val.length > 0) {
    return parse(val);
  } else if (type === "number" && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match2 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match2) {
    return;
  }
  var n = parseFloat(match2[1]);
  var type = (match2[2] || "ms").toLowerCase();
  switch (type) {
    case "years":
    case "year":
    case "yrs":
    case "yr":
    case "y":
      return n * y;
    case "days":
    case "day":
    case "d":
      return n * d;
    case "hours":
    case "hour":
    case "hrs":
    case "hr":
    case "h":
      return n * h;
    case "minutes":
    case "minute":
    case "mins":
    case "min":
    case "m":
      return n * m;
    case "seconds":
    case "second":
    case "secs":
    case "sec":
    case "s":
      return n * s;
    case "milliseconds":
    case "millisecond":
    case "msecs":
    case "msec":
    case "ms":
      return n;
    default:
      return void 0;
  }
}
function fmtShort(ms2) {
  if (ms2 >= d) {
    return Math.round(ms2 / d) + "d";
  }
  if (ms2 >= h) {
    return Math.round(ms2 / h) + "h";
  }
  if (ms2 >= m) {
    return Math.round(ms2 / m) + "m";
  }
  if (ms2 >= s) {
    return Math.round(ms2 / s) + "s";
  }
  return ms2 + "ms";
}
function fmtLong(ms2) {
  return plural(ms2, d, "day") || plural(ms2, h, "hour") || plural(ms2, m, "minute") || plural(ms2, s, "second") || ms2 + " ms";
}
function plural(ms2, n, name) {
  if (ms2 < n) {
    return;
  }
  if (ms2 < n * 1.5) {
    return Math.floor(ms2 / n) + " " + name;
  }
  return Math.ceil(ms2 / n) + " " + name + "s";
}
(function(module, exports) {
  exports = module.exports = createDebug.debug = createDebug["default"] = createDebug;
  exports.coerce = coerce;
  exports.disable = disable;
  exports.enable = enable;
  exports.enabled = enabled;
  exports.humanize = ms;
  exports.instances = [];
  exports.names = [];
  exports.skips = [];
  exports.formatters = {};
  function selectColor(namespace) {
    var hash2 = 0, i2;
    for (i2 in namespace) {
      hash2 = (hash2 << 5) - hash2 + namespace.charCodeAt(i2);
      hash2 |= 0;
    }
    return exports.colors[Math.abs(hash2) % exports.colors.length];
  }
  function createDebug(namespace) {
    var prevTime;
    function debug2() {
      if (!debug2.enabled)
        return;
      var self2 = debug2;
      var curr = +new Date();
      var ms2 = curr - (prevTime || curr);
      self2.diff = ms2;
      self2.prev = prevTime;
      self2.curr = curr;
      prevTime = curr;
      var args = new Array(arguments.length);
      for (var i2 = 0; i2 < args.length; i2++) {
        args[i2] = arguments[i2];
      }
      args[0] = exports.coerce(args[0]);
      if (typeof args[0] !== "string") {
        args.unshift("%O");
      }
      var index2 = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match2, format) {
        if (match2 === "%%")
          return match2;
        index2++;
        var formatter = exports.formatters[format];
        if (typeof formatter === "function") {
          var val = args[index2];
          match2 = formatter.call(self2, val);
          args.splice(index2, 1);
          index2--;
        }
        return match2;
      });
      exports.formatArgs.call(self2, args);
      var logFn = debug2.log || exports.log || console.log.bind(console);
      logFn.apply(self2, args);
    }
    debug2.namespace = namespace;
    debug2.enabled = exports.enabled(namespace);
    debug2.useColors = exports.useColors();
    debug2.color = selectColor(namespace);
    debug2.destroy = destroy;
    if (typeof exports.init === "function") {
      exports.init(debug2);
    }
    exports.instances.push(debug2);
    return debug2;
  }
  function destroy() {
    var index2 = exports.instances.indexOf(this);
    if (index2 !== -1) {
      exports.instances.splice(index2, 1);
      return true;
    } else {
      return false;
    }
  }
  function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i2;
    var split2 = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
    var len = split2.length;
    for (i2 = 0; i2 < len; i2++) {
      if (!split2[i2])
        continue;
      namespaces = split2[i2].replace(/\*/g, ".*?");
      if (namespaces[0] === "-") {
        exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
      } else {
        exports.names.push(new RegExp("^" + namespaces + "$"));
      }
    }
    for (i2 = 0; i2 < exports.instances.length; i2++) {
      var instance = exports.instances[i2];
      instance.enabled = exports.enabled(instance.namespace);
    }
  }
  function disable() {
    exports.enable("");
  }
  function enabled(name) {
    if (name[name.length - 1] === "*") {
      return true;
    }
    var i2, len;
    for (i2 = 0, len = exports.skips.length; i2 < len; i2++) {
      if (exports.skips[i2].test(name)) {
        return false;
      }
    }
    for (i2 = 0, len = exports.names.length; i2 < len; i2++) {
      if (exports.names[i2].test(name)) {
        return true;
      }
    }
    return false;
  }
  function coerce(val) {
    if (val instanceof Error)
      return val.stack || val.message;
    return val;
  }
})(debug$6, debug$6.exports);
(function(module, exports) {
  exports = module.exports = debug$6.exports;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : localstorage();
  exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function useColors() {
    if (typeof window !== "undefined" && window.process && window.process.type === "renderer") {
      return true;
    }
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    }
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  exports.formatters.j = function(v2) {
    try {
      return JSON.stringify(v2);
    } catch (err) {
      return "[UnexpectedJSONParseError]: " + err.message;
    }
  };
  function formatArgs(args) {
    var useColors2 = this.useColors;
    args[0] = (useColors2 ? "%c" : "") + this.namespace + (useColors2 ? " %c" : " ") + args[0] + (useColors2 ? "%c " : " ") + "+" + exports.humanize(this.diff);
    if (!useColors2)
      return;
    var c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    var index2 = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match2) {
      if (match2 === "%%")
        return;
      index2++;
      if (match2 === "%c") {
        lastC = index2;
      }
    });
    args.splice(lastC, 0, c);
  }
  function log() {
    return typeof console === "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function save(namespaces) {
    try {
      if (namespaces == null) {
        exports.storage.removeItem("debug");
      } else {
        exports.storage.debug = namespaces;
      }
    } catch (e2) {
    }
  }
  function load() {
    var r;
    try {
      r = exports.storage.debug;
    } catch (e2) {
    }
    if (!r && typeof process !== "undefined" && "env" in process) {
      r = {}.DEBUG;
    }
    return r;
  }
  exports.enable(load());
  function localstorage() {
    try {
      return window.localStorage;
    } catch (e2) {
    }
  }
})(browser$1, browser$1.exports);
var parseuri$1 = parseuri$2;
var debug$5 = browser$1.exports("socket.io-client:url");
var url_1 = url;
function url(uri, loc) {
  var obj = uri;
  loc = loc || typeof location !== "undefined" && location;
  if (uri == null)
    uri = loc.protocol + "//" + loc.host;
  if (typeof uri === "string") {
    if (uri.charAt(0) === "/") {
      if (uri.charAt(1) === "/") {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }
    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug$5("protocol-less url %s", uri);
      if (typeof loc !== "undefined") {
        uri = loc.protocol + "//" + uri;
      } else {
        uri = "https://" + uri;
      }
    }
    debug$5("parse %s", uri);
    obj = parseuri$1(uri);
  }
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = "80";
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = "443";
    }
  }
  obj.path = obj.path || "/";
  var ipv6 = obj.host.indexOf(":") !== -1;
  var host = ipv6 ? "[" + obj.host + "]" : obj.host;
  obj.id = obj.protocol + "://" + host + ":" + obj.port;
  obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
  return obj;
}
var socket_ioParser = {};
var componentEmitter = { exports: {} };
(function(module) {
  {
    module.exports = Emitter2;
  }
  function Emitter2(obj) {
    if (obj)
      return mixin(obj);
  }
  function mixin(obj) {
    for (var key in Emitter2.prototype) {
      obj[key] = Emitter2.prototype[key];
    }
    return obj;
  }
  Emitter2.prototype.on = Emitter2.prototype.addEventListener = function(event, fn2) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn2);
    return this;
  };
  Emitter2.prototype.once = function(event, fn2) {
    function on2() {
      this.off(event, on2);
      fn2.apply(this, arguments);
    }
    on2.fn = fn2;
    this.on(event, on2);
    return this;
  };
  Emitter2.prototype.off = Emitter2.prototype.removeListener = Emitter2.prototype.removeAllListeners = Emitter2.prototype.removeEventListener = function(event, fn2) {
    this._callbacks = this._callbacks || {};
    if (arguments.length == 0) {
      this._callbacks = {};
      return this;
    }
    var callbacks2 = this._callbacks["$" + event];
    if (!callbacks2)
      return this;
    if (arguments.length == 1) {
      delete this._callbacks["$" + event];
      return this;
    }
    var cb;
    for (var i2 = 0; i2 < callbacks2.length; i2++) {
      cb = callbacks2[i2];
      if (cb === fn2 || cb.fn === fn2) {
        callbacks2.splice(i2, 1);
        break;
      }
    }
    if (callbacks2.length === 0) {
      delete this._callbacks["$" + event];
    }
    return this;
  };
  Emitter2.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks2 = this._callbacks["$" + event];
    for (var i2 = 1; i2 < arguments.length; i2++) {
      args[i2 - 1] = arguments[i2];
    }
    if (callbacks2) {
      callbacks2 = callbacks2.slice(0);
      for (var i2 = 0, len = callbacks2.length; i2 < len; ++i2) {
        callbacks2[i2].apply(this, args);
      }
    }
    return this;
  };
  Emitter2.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
  };
  Emitter2.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
  };
})(componentEmitter);
var binary = {};
var toString$2 = {}.toString;
var isarray = Array.isArray || function(arr) {
  return toString$2.call(arr) == "[object Array]";
};
var isBuffer22 = isBuf$1;
var withNativeBuffer = typeof Buffer === "function" && typeof Buffer.isBuffer === "function";
var withNativeArrayBuffer = typeof ArrayBuffer === "function";
var isView = function(obj) {
  return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
function isBuf$1(obj) {
  return withNativeBuffer && Buffer.isBuffer(obj) || withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj));
}
var isArray$1 = isarray;
var isBuf = isBuffer22;
var toString$1 = Object.prototype.toString;
var withNativeBlob$1 = typeof Blob === "function" || typeof Blob !== "undefined" && toString$1.call(Blob) === "[object BlobConstructor]";
var withNativeFile$1 = typeof File === "function" || typeof File !== "undefined" && toString$1.call(File) === "[object FileConstructor]";
binary.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length;
  return { packet: pack, buffers };
};
function _deconstructPacket(data2, buffers) {
  if (!data2)
    return data2;
  if (isBuf(data2)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data2);
    return placeholder;
  } else if (isArray$1(data2)) {
    var newData = new Array(data2.length);
    for (var i2 = 0; i2 < data2.length; i2++) {
      newData[i2] = _deconstructPacket(data2[i2], buffers);
    }
    return newData;
  } else if (typeof data2 === "object" && !(data2 instanceof Date)) {
    var newData = {};
    for (var key in data2) {
      newData[key] = _deconstructPacket(data2[key], buffers);
    }
    return newData;
  }
  return data2;
}
binary.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = void 0;
  return packet;
};
function _reconstructPacket(data2, buffers) {
  if (!data2)
    return data2;
  if (data2 && data2._placeholder) {
    return buffers[data2.num];
  } else if (isArray$1(data2)) {
    for (var i2 = 0; i2 < data2.length; i2++) {
      data2[i2] = _reconstructPacket(data2[i2], buffers);
    }
  } else if (typeof data2 === "object") {
    for (var key in data2) {
      data2[key] = _reconstructPacket(data2[key], buffers);
    }
  }
  return data2;
}
binary.removeBlobs = function(data2, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj)
      return obj;
    if (withNativeBlob$1 && obj instanceof Blob || withNativeFile$1 && obj instanceof File) {
      pendingBlobs++;
      var fileReader = new FileReader();
      fileReader.onload = function() {
        if (containingObject) {
          containingObject[curKey] = this.result;
        } else {
          bloblessData = this.result;
        }
        if (!--pendingBlobs) {
          callback(bloblessData);
        }
      };
      fileReader.readAsArrayBuffer(obj);
    } else if (isArray$1(obj)) {
      for (var i2 = 0; i2 < obj.length; i2++) {
        _removeBlobs(obj[i2], i2, obj);
      }
    } else if (typeof obj === "object" && !isBuf(obj)) {
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }
  var pendingBlobs = 0;
  var bloblessData = data2;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};
(function(exports) {
  var debug2 = browser$1.exports("socket.io-parser");
  var Emitter2 = componentEmitter.exports;
  var binary$1 = binary;
  var isArray2 = isarray;
  var isBuf2 = isBuffer22;
  exports.protocol = 4;
  exports.types = [
    "CONNECT",
    "DISCONNECT",
    "EVENT",
    "ACK",
    "ERROR",
    "BINARY_EVENT",
    "BINARY_ACK"
  ];
  exports.CONNECT = 0;
  exports.DISCONNECT = 1;
  exports.EVENT = 2;
  exports.ACK = 3;
  exports.ERROR = 4;
  exports.BINARY_EVENT = 5;
  exports.BINARY_ACK = 6;
  exports.Encoder = Encoder;
  exports.Decoder = Decoder;
  function Encoder() {
  }
  var ERROR_PACKET = exports.ERROR + '"encode error"';
  Encoder.prototype.encode = function(obj, callback) {
    debug2("encoding packet %j", obj);
    if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
      encodeAsBinary(obj, callback);
    } else {
      var encoding = encodeAsString(obj);
      callback([encoding]);
    }
  };
  function encodeAsString(obj) {
    var str = "" + obj.type;
    if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
      str += obj.attachments + "-";
    }
    if (obj.nsp && obj.nsp !== "/") {
      str += obj.nsp + ",";
    }
    if (obj.id != null) {
      str += obj.id;
    }
    if (obj.data != null) {
      var payload = tryStringify(obj.data);
      if (payload !== false) {
        str += payload;
      } else {
        return ERROR_PACKET;
      }
    }
    debug2("encoded %j as %s", obj, str);
    return str;
  }
  function tryStringify(str) {
    try {
      return JSON.stringify(str);
    } catch (e2) {
      return false;
    }
  }
  function encodeAsBinary(obj, callback) {
    function writeEncoding(bloblessData) {
      var deconstruction = binary$1.deconstructPacket(bloblessData);
      var pack = encodeAsString(deconstruction.packet);
      var buffers = deconstruction.buffers;
      buffers.unshift(pack);
      callback(buffers);
    }
    binary$1.removeBlobs(obj, writeEncoding);
  }
  function Decoder() {
    this.reconstructor = null;
  }
  Emitter2(Decoder.prototype);
  Decoder.prototype.add = function(obj) {
    var packet;
    if (typeof obj === "string") {
      packet = decodeString(obj);
      if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) {
        this.reconstructor = new BinaryReconstructor(packet);
        if (this.reconstructor.reconPack.attachments === 0) {
          this.emit("decoded", packet);
        }
      } else {
        this.emit("decoded", packet);
      }
    } else if (isBuf2(obj) || obj.base64) {
      if (!this.reconstructor) {
        throw new Error("got binary data when not reconstructing a packet");
      } else {
        packet = this.reconstructor.takeBinaryData(obj);
        if (packet) {
          this.reconstructor = null;
          this.emit("decoded", packet);
        }
      }
    } else {
      throw new Error("Unknown type: " + obj);
    }
  };
  function decodeString(str) {
    var i2 = 0;
    var p2 = {
      type: Number(str.charAt(0))
    };
    if (exports.types[p2.type] == null) {
      return error("unknown packet type " + p2.type);
    }
    if (exports.BINARY_EVENT === p2.type || exports.BINARY_ACK === p2.type) {
      var start2 = i2 + 1;
      while (str.charAt(++i2) !== "-" && i2 != str.length) {
      }
      var buf = str.substring(start2, i2);
      if (buf != Number(buf) || str.charAt(i2) !== "-") {
        throw new Error("Illegal attachments");
      }
      p2.attachments = Number(buf);
    }
    if (str.charAt(i2 + 1) === "/") {
      var start2 = i2 + 1;
      while (++i2) {
        var c = str.charAt(i2);
        if (c === ",")
          break;
        if (i2 === str.length)
          break;
      }
      p2.nsp = str.substring(start2, i2);
    } else {
      p2.nsp = "/";
    }
    var next = str.charAt(i2 + 1);
    if (next !== "" && Number(next) == next) {
      var start2 = i2 + 1;
      while (++i2) {
        var c = str.charAt(i2);
        if (c == null || Number(c) != c) {
          --i2;
          break;
        }
        if (i2 === str.length)
          break;
      }
      p2.id = Number(str.substring(start2, i2 + 1));
    }
    if (str.charAt(++i2)) {
      var payload = tryParse(str.substr(i2));
      var isPayloadValid = payload !== false && (p2.type === exports.ERROR || isArray2(payload));
      if (isPayloadValid) {
        p2.data = payload;
      } else {
        return error("invalid payload");
      }
    }
    debug2("decoded %s as %j", str, p2);
    return p2;
  }
  function tryParse(str) {
    try {
      return JSON.parse(str);
    } catch (e2) {
      return false;
    }
  }
  Decoder.prototype.destroy = function() {
    if (this.reconstructor) {
      this.reconstructor.finishedReconstruction();
    }
  };
  function BinaryReconstructor(packet) {
    this.reconPack = packet;
    this.buffers = [];
  }
  BinaryReconstructor.prototype.takeBinaryData = function(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
      var packet = binary$1.reconstructPacket(this.reconPack, this.buffers);
      this.finishedReconstruction();
      return packet;
    }
    return null;
  };
  BinaryReconstructor.prototype.finishedReconstruction = function() {
    this.reconPack = null;
    this.buffers = [];
  };
  function error(msg) {
    return {
      type: exports.ERROR,
      data: "parser error: " + msg
    };
  }
})(socket_ioParser);
var lib = { exports: {} };
var transports$1 = {};
var hasCors = { exports: {} };
try {
  hasCors.exports = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
  hasCors.exports = false;
}
var globalThis_browser = function() {
  if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();
var hasCORS = hasCors.exports;
var globalThis$2 = globalThis_browser;
var xmlhttprequest = function(opts) {
  var xdomain = opts.xdomain;
  var xscheme = opts.xscheme;
  var enablesXDR = opts.enablesXDR;
  try {
    if (typeof XMLHttpRequest !== "undefined" && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e2) {
  }
  try {
    if (typeof XDomainRequest !== "undefined" && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e2) {
  }
  if (!xdomain) {
    try {
      return new globalThis$2[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e2) {
    }
  }
};
var pollingXhr = { exports: {} };
var browser = {};
var keys = Object.keys || function keys2(obj) {
  var arr = [];
  var has2 = Object.prototype.hasOwnProperty;
  for (var i2 in obj) {
    if (has2.call(obj, i2)) {
      arr.push(i2);
    }
  }
  return arr;
};
var isArray = isarray;
var toString22 = Object.prototype.toString;
var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString22.call(Blob) === "[object BlobConstructor]";
var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString22.call(File) === "[object FileConstructor]";
var hasBinary2 = hasBinary;
function hasBinary(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  if (isArray(obj)) {
    for (var i2 = 0, l = obj.length; i2 < l; i2++) {
      if (hasBinary(obj[i2])) {
        return true;
      }
    }
    return false;
  }
  if (typeof Buffer === "function" && Buffer.isBuffer && Buffer.isBuffer(obj) || typeof ArrayBuffer === "function" && obj instanceof ArrayBuffer || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File) {
    return true;
  }
  if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }
  return false;
}
var arraybuffer_slice = function(arraybuffer, start2, end2) {
  var bytes = arraybuffer.byteLength;
  start2 = start2 || 0;
  end2 = end2 || bytes;
  if (arraybuffer.slice) {
    return arraybuffer.slice(start2, end2);
  }
  if (start2 < 0) {
    start2 += bytes;
  }
  if (end2 < 0) {
    end2 += bytes;
  }
  if (end2 > bytes) {
    end2 = bytes;
  }
  if (start2 >= bytes || start2 >= end2 || bytes === 0) {
    return new ArrayBuffer(0);
  }
  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end2 - start2);
  for (var i2 = start2, ii = 0; i2 < end2; i2++, ii++) {
    result[ii] = abv[i2];
  }
  return result.buffer;
};
var after_1 = after;
function after(count, callback, err_cb) {
  var bail = false;
  err_cb = err_cb || noop;
  proxy.count = count;
  return count === 0 ? callback() : proxy;
  function proxy(err, result) {
    if (proxy.count <= 0) {
      throw new Error("after called too many times");
    }
    --proxy.count;
    if (err) {
      bail = true;
      callback(err);
      callback = err_cb;
    } else if (proxy.count === 0 && !bail) {
      callback(null, result);
    }
  }
}
function noop() {
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var stringFromCharCode = String.fromCharCode;
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length2 = string.length;
  var value;
  var extra;
  while (counter < length2) {
    value = string.charCodeAt(counter++);
    if (value >= 55296 && value <= 56319 && counter < length2) {
      extra = string.charCodeAt(counter++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function ucs2encode(array) {
  var length2 = array.length;
  var index2 = -1;
  var value;
  var output = "";
  while (++index2 < length2) {
    value = array[index2];
    if (value > 65535) {
      value -= 65536;
      output += stringFromCharCode(value >>> 10 & 1023 | 55296);
      value = 56320 | value & 1023;
    }
    output += stringFromCharCode(value);
  }
  return output;
}
function checkScalarValue(codePoint, strict) {
  if (codePoint >= 55296 && codePoint <= 57343) {
    if (strict) {
      throw Error("Lone surrogate U+" + codePoint.toString(16).toUpperCase() + " is not a scalar value");
    }
    return false;
  }
  return true;
}
function createByte(codePoint, shift) {
  return stringFromCharCode(codePoint >> shift & 63 | 128);
}
function encodeCodePoint(codePoint, strict) {
  if ((codePoint & 4294967168) == 0) {
    return stringFromCharCode(codePoint);
  }
  var symbol = "";
  if ((codePoint & 4294965248) == 0) {
    symbol = stringFromCharCode(codePoint >> 6 & 31 | 192);
  } else if ((codePoint & 4294901760) == 0) {
    if (!checkScalarValue(codePoint, strict)) {
      codePoint = 65533;
    }
    symbol = stringFromCharCode(codePoint >> 12 & 15 | 224);
    symbol += createByte(codePoint, 6);
  } else if ((codePoint & 4292870144) == 0) {
    symbol = stringFromCharCode(codePoint >> 18 & 7 | 240);
    symbol += createByte(codePoint, 12);
    symbol += createByte(codePoint, 6);
  }
  symbol += stringFromCharCode(codePoint & 63 | 128);
  return symbol;
}
function utf8encode(string, opts) {
  opts = opts || {};
  var strict = opts.strict !== false;
  var codePoints = ucs2decode(string);
  var length2 = codePoints.length;
  var index2 = -1;
  var codePoint;
  var byteString = "";
  while (++index2 < length2) {
    codePoint = codePoints[index2];
    byteString += encodeCodePoint(codePoint, strict);
  }
  return byteString;
}
function readContinuationByte() {
  if (byteIndex >= byteCount) {
    throw Error("Invalid byte index");
  }
  var continuationByte = byteArray[byteIndex] & 255;
  byteIndex++;
  if ((continuationByte & 192) == 128) {
    return continuationByte & 63;
  }
  throw Error("Invalid continuation byte");
}
function decodeSymbol(strict) {
  var byte1;
  var byte2;
  var byte3;
  var byte4;
  var codePoint;
  if (byteIndex > byteCount) {
    throw Error("Invalid byte index");
  }
  if (byteIndex == byteCount) {
    return false;
  }
  byte1 = byteArray[byteIndex] & 255;
  byteIndex++;
  if ((byte1 & 128) == 0) {
    return byte1;
  }
  if ((byte1 & 224) == 192) {
    byte2 = readContinuationByte();
    codePoint = (byte1 & 31) << 6 | byte2;
    if (codePoint >= 128) {
      return codePoint;
    } else {
      throw Error("Invalid continuation byte");
    }
  }
  if ((byte1 & 240) == 224) {
    byte2 = readContinuationByte();
    byte3 = readContinuationByte();
    codePoint = (byte1 & 15) << 12 | byte2 << 6 | byte3;
    if (codePoint >= 2048) {
      return checkScalarValue(codePoint, strict) ? codePoint : 65533;
    } else {
      throw Error("Invalid continuation byte");
    }
  }
  if ((byte1 & 248) == 240) {
    byte2 = readContinuationByte();
    byte3 = readContinuationByte();
    byte4 = readContinuationByte();
    codePoint = (byte1 & 7) << 18 | byte2 << 12 | byte3 << 6 | byte4;
    if (codePoint >= 65536 && codePoint <= 1114111) {
      return codePoint;
    }
  }
  throw Error("Invalid UTF-8 detected");
}
var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
  opts = opts || {};
  var strict = opts.strict !== false;
  byteArray = ucs2decode(byteString);
  byteCount = byteArray.length;
  byteIndex = 0;
  var codePoints = [];
  var tmp;
  while ((tmp = decodeSymbol(strict)) !== false) {
    codePoints.push(tmp);
  }
  return ucs2encode(codePoints);
}
var utf8 = {
  version: "2.1.2",
  encode: utf8encode,
  decode: utf8decode
};
var base64Arraybuffer = {};
(function(chars) {
  base64Arraybuffer.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for (i2 = 0; i2 < len; i2 += 3) {
      base64 += chars[bytes[i2] >> 2];
      base64 += chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
      base64 += chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
      base64 += chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }
    return base64;
  };
  base64Arraybuffer.decode = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i2, p2 = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for (i2 = 0; i2 < len; i2 += 4) {
      encoded1 = chars.indexOf(base64[i2]);
      encoded2 = chars.indexOf(base64[i2 + 1]);
      encoded3 = chars.indexOf(base64[i2 + 2]);
      encoded4 = chars.indexOf(base64[i2 + 3]);
      bytes[p2++] = encoded1 << 2 | encoded2 >> 4;
      bytes[p2++] = (encoded2 & 15) << 4 | encoded3 >> 2;
      bytes[p2++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
  };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
var BlobBuilder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof WebKitBlobBuilder !== "undefined" ? WebKitBlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : false;
var blobSupported = function() {
  try {
    var a = new Blob(["hi"]);
    return a.size === 2;
  } catch (e2) {
    return false;
  }
}();
var blobSupportsArrayBufferView = blobSupported && function() {
  try {
    var b = new Blob([new Uint8Array([1, 2])]);
    return b.size === 2;
  } catch (e2) {
    return false;
  }
}();
var blobBuilderSupported = BlobBuilder && BlobBuilder.prototype.append && BlobBuilder.prototype.getBlob;
function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }
      return buf;
    }
    return chunk;
  });
}
function BlobBuilderConstructor(ary, options) {
  options = options || {};
  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });
  return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
}
if (typeof Blob !== "undefined") {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}
var blob = function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return void 0;
  }
}();
(function(exports) {
  var keys$1 = keys;
  var hasBinary3 = hasBinary2;
  var sliceBuffer = arraybuffer_slice;
  var after2 = after_1;
  var utf8$1 = utf8;
  var base64encoder;
  if (typeof ArrayBuffer !== "undefined") {
    base64encoder = base64Arraybuffer;
  }
  var isAndroid = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent);
  var isPhantomJS = typeof navigator !== "undefined" && /PhantomJS/i.test(navigator.userAgent);
  var dontSendBlobs = isAndroid || isPhantomJS;
  exports.protocol = 3;
  var packets = exports.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  };
  var packetslist = keys$1(packets);
  var err = { type: "error", data: "parser error" };
  var Blob2 = blob;
  exports.encodePacket = function(packet, supportsBinary, utf8encode2, callback) {
    if (typeof supportsBinary === "function") {
      callback = supportsBinary;
      supportsBinary = false;
    }
    if (typeof utf8encode2 === "function") {
      callback = utf8encode2;
      utf8encode2 = null;
    }
    var data2 = packet.data === void 0 ? void 0 : packet.data.buffer || packet.data;
    if (typeof ArrayBuffer !== "undefined" && data2 instanceof ArrayBuffer) {
      return encodeArrayBuffer(packet, supportsBinary, callback);
    } else if (typeof Blob2 !== "undefined" && data2 instanceof Blob2) {
      return encodeBlob(packet, supportsBinary, callback);
    }
    if (data2 && data2.base64) {
      return encodeBase64Object(packet, callback);
    }
    var encoded = packets[packet.type];
    if (packet.data !== void 0) {
      encoded += utf8encode2 ? utf8$1.encode(String(packet.data), { strict: false }) : String(packet.data);
    }
    return callback("" + encoded);
  };
  function encodeBase64Object(packet, callback) {
    var message = "b" + exports.packets[packet.type] + packet.data.data;
    return callback(message);
  }
  function encodeArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var data2 = packet.data;
    var contentArray = new Uint8Array(data2);
    var resultBuffer = new Uint8Array(1 + data2.byteLength);
    resultBuffer[0] = packets[packet.type];
    for (var i2 = 0; i2 < contentArray.length; i2++) {
      resultBuffer[i2 + 1] = contentArray[i2];
    }
    return callback(resultBuffer.buffer);
  }
  function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    var fr = new FileReader();
    fr.onload = function() {
      exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
    };
    return fr.readAsArrayBuffer(packet.data);
  }
  function encodeBlob(packet, supportsBinary, callback) {
    if (!supportsBinary) {
      return exports.encodeBase64Packet(packet, callback);
    }
    if (dontSendBlobs) {
      return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
    }
    var length2 = new Uint8Array(1);
    length2[0] = packets[packet.type];
    var blob2 = new Blob2([length2.buffer, packet.data]);
    return callback(blob2);
  }
  exports.encodeBase64Packet = function(packet, callback) {
    var message = "b" + exports.packets[packet.type];
    if (typeof Blob2 !== "undefined" && packet.data instanceof Blob2) {
      var fr = new FileReader();
      fr.onload = function() {
        var b64 = fr.result.split(",")[1];
        callback(message + b64);
      };
      return fr.readAsDataURL(packet.data);
    }
    var b64data;
    try {
      b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
    } catch (e2) {
      var typed = new Uint8Array(packet.data);
      var basic = new Array(typed.length);
      for (var i2 = 0; i2 < typed.length; i2++) {
        basic[i2] = typed[i2];
      }
      b64data = String.fromCharCode.apply(null, basic);
    }
    message += btoa(b64data);
    return callback(message);
  };
  exports.decodePacket = function(data2, binaryType, utf8decode2) {
    if (data2 === void 0) {
      return err;
    }
    if (typeof data2 === "string") {
      if (data2.charAt(0) === "b") {
        return exports.decodeBase64Packet(data2.substr(1), binaryType);
      }
      if (utf8decode2) {
        data2 = tryDecode(data2);
        if (data2 === false) {
          return err;
        }
      }
      var type = data2.charAt(0);
      if (Number(type) != type || !packetslist[type]) {
        return err;
      }
      if (data2.length > 1) {
        return { type: packetslist[type], data: data2.substring(1) };
      } else {
        return { type: packetslist[type] };
      }
    }
    var asArray = new Uint8Array(data2);
    var type = asArray[0];
    var rest = sliceBuffer(data2, 1);
    if (Blob2 && binaryType === "blob") {
      rest = new Blob2([rest]);
    }
    return { type: packetslist[type], data: rest };
  };
  function tryDecode(data2) {
    try {
      data2 = utf8$1.decode(data2, { strict: false });
    } catch (e2) {
      return false;
    }
    return data2;
  }
  exports.decodeBase64Packet = function(msg, binaryType) {
    var type = packetslist[msg.charAt(0)];
    if (!base64encoder) {
      return { type, data: { base64: true, data: msg.substr(1) } };
    }
    var data2 = base64encoder.decode(msg.substr(1));
    if (binaryType === "blob" && Blob2) {
      data2 = new Blob2([data2]);
    }
    return { type, data: data2 };
  };
  exports.encodePayload = function(packets2, supportsBinary, callback) {
    if (typeof supportsBinary === "function") {
      callback = supportsBinary;
      supportsBinary = null;
    }
    var isBinary = hasBinary3(packets2);
    if (supportsBinary && isBinary) {
      if (Blob2 && !dontSendBlobs) {
        return exports.encodePayloadAsBlob(packets2, callback);
      }
      return exports.encodePayloadAsArrayBuffer(packets2, callback);
    }
    if (!packets2.length) {
      return callback("0:");
    }
    function setLengthHeader(message) {
      return message.length + ":" + message;
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
        doneCallback(null, setLengthHeader(message));
      });
    }
    map2(packets2, encodeOne, function(err2, results) {
      return callback(results.join(""));
    });
  };
  function map2(ary, each, done) {
    var result = new Array(ary.length);
    var next = after2(ary.length, done);
    var eachWithIndex = function(i3, el, cb) {
      each(el, function(error, msg) {
        result[i3] = msg;
        cb(error, result);
      });
    };
    for (var i2 = 0; i2 < ary.length; i2++) {
      eachWithIndex(i2, ary[i2], next);
    }
  }
  exports.decodePayload = function(data2, binaryType, callback) {
    if (typeof data2 !== "string") {
      return exports.decodePayloadAsBinary(data2, binaryType, callback);
    }
    if (typeof binaryType === "function") {
      callback = binaryType;
      binaryType = null;
    }
    var packet;
    if (data2 === "") {
      return callback(err, 0, 1);
    }
    var length2 = "", n, msg;
    for (var i2 = 0, l = data2.length; i2 < l; i2++) {
      var chr = data2.charAt(i2);
      if (chr !== ":") {
        length2 += chr;
        continue;
      }
      if (length2 === "" || length2 != (n = Number(length2))) {
        return callback(err, 0, 1);
      }
      msg = data2.substr(i2 + 1, n);
      if (length2 != msg.length) {
        return callback(err, 0, 1);
      }
      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, false);
        if (err.type === packet.type && err.data === packet.data) {
          return callback(err, 0, 1);
        }
        var ret = callback(packet, i2 + n, l);
        if (ret === false)
          return;
      }
      i2 += n;
      length2 = "";
    }
    if (length2 !== "") {
      return callback(err, 0, 1);
    }
  };
  exports.encodePayloadAsArrayBuffer = function(packets2, callback) {
    if (!packets2.length) {
      return callback(new ArrayBuffer(0));
    }
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function(data2) {
        return doneCallback(null, data2);
      });
    }
    map2(packets2, encodeOne, function(err2, encodedPackets) {
      var totalLength = encodedPackets.reduce(function(acc, p2) {
        var len;
        if (typeof p2 === "string") {
          len = p2.length;
        } else {
          len = p2.byteLength;
        }
        return acc + len.toString().length + len + 2;
      }, 0);
      var resultArray = new Uint8Array(totalLength);
      var bufferIndex = 0;
      encodedPackets.forEach(function(p2) {
        var isString2 = typeof p2 === "string";
        var ab = p2;
        if (isString2) {
          var view = new Uint8Array(p2.length);
          for (var i2 = 0; i2 < p2.length; i2++) {
            view[i2] = p2.charCodeAt(i2);
          }
          ab = view.buffer;
        }
        if (isString2) {
          resultArray[bufferIndex++] = 0;
        } else {
          resultArray[bufferIndex++] = 1;
        }
        var lenStr = ab.byteLength.toString();
        for (var i2 = 0; i2 < lenStr.length; i2++) {
          resultArray[bufferIndex++] = parseInt(lenStr[i2]);
        }
        resultArray[bufferIndex++] = 255;
        var view = new Uint8Array(ab);
        for (var i2 = 0; i2 < view.length; i2++) {
          resultArray[bufferIndex++] = view[i2];
        }
      });
      return callback(resultArray.buffer);
    });
  };
  exports.encodePayloadAsBlob = function(packets2, callback) {
    function encodeOne(packet, doneCallback) {
      exports.encodePacket(packet, true, true, function(encoded) {
        var binaryIdentifier = new Uint8Array(1);
        binaryIdentifier[0] = 1;
        if (typeof encoded === "string") {
          var view = new Uint8Array(encoded.length);
          for (var i2 = 0; i2 < encoded.length; i2++) {
            view[i2] = encoded.charCodeAt(i2);
          }
          encoded = view.buffer;
          binaryIdentifier[0] = 0;
        }
        var len = encoded instanceof ArrayBuffer ? encoded.byteLength : encoded.size;
        var lenStr = len.toString();
        var lengthAry = new Uint8Array(lenStr.length + 1);
        for (var i2 = 0; i2 < lenStr.length; i2++) {
          lengthAry[i2] = parseInt(lenStr[i2]);
        }
        lengthAry[lenStr.length] = 255;
        if (Blob2) {
          var blob2 = new Blob2([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
          doneCallback(null, blob2);
        }
      });
    }
    map2(packets2, encodeOne, function(err2, results) {
      return callback(new Blob2(results));
    });
  };
  exports.decodePayloadAsBinary = function(data2, binaryType, callback) {
    if (typeof binaryType === "function") {
      callback = binaryType;
      binaryType = null;
    }
    var bufferTail = data2;
    var buffers = [];
    while (bufferTail.byteLength > 0) {
      var tailArray = new Uint8Array(bufferTail);
      var isString2 = tailArray[0] === 0;
      var msgLength = "";
      for (var i2 = 1; ; i2++) {
        if (tailArray[i2] === 255)
          break;
        if (msgLength.length > 310) {
          return callback(err, 0, 1);
        }
        msgLength += tailArray[i2];
      }
      bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
      msgLength = parseInt(msgLength);
      var msg = sliceBuffer(bufferTail, 0, msgLength);
      if (isString2) {
        try {
          msg = String.fromCharCode.apply(null, new Uint8Array(msg));
        } catch (e2) {
          var typed = new Uint8Array(msg);
          msg = "";
          for (var i2 = 0; i2 < typed.length; i2++) {
            msg += String.fromCharCode(typed[i2]);
          }
        }
      }
      buffers.push(msg);
      bufferTail = sliceBuffer(bufferTail, msgLength);
    }
    var total = buffers.length;
    buffers.forEach(function(buffer, i3) {
      callback(exports.decodePacket(buffer, binaryType, true), i3, total);
    });
  };
})(browser);
var parser$4 = browser;
var Emitter$3 = componentEmitter.exports;
var transport = Transport$2;
function Transport$2(opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = "";
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;
  this.isReactNative = opts.isReactNative;
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}
Emitter$3(Transport$2.prototype);
Transport$2.prototype.onError = function(msg, desc) {
  var err = new Error(msg);
  err.type = "TransportError";
  err.description = desc;
  this.emit("error", err);
  return this;
};
Transport$2.prototype.open = function() {
  if (this.readyState === "closed" || this.readyState === "") {
    this.readyState = "opening";
    this.doOpen();
  }
  return this;
};
Transport$2.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.doClose();
    this.onClose();
  }
  return this;
};
Transport$2.prototype.send = function(packets) {
  if (this.readyState === "open") {
    this.write(packets);
  } else {
    throw new Error("Transport not open");
  }
};
Transport$2.prototype.onOpen = function() {
  this.readyState = "open";
  this.writable = true;
  this.emit("open");
};
Transport$2.prototype.onData = function(data2) {
  var packet = parser$4.decodePacket(data2, this.socket.binaryType);
  this.onPacket(packet);
};
Transport$2.prototype.onPacket = function(packet) {
  this.emit("packet", packet);
};
Transport$2.prototype.onClose = function() {
  this.readyState = "closed";
  this.emit("close");
};
var parseqs$3 = {};
parseqs$3.encode = function(obj) {
  var str = "";
  for (var i2 in obj) {
    if (obj.hasOwnProperty(i2)) {
      if (str.length)
        str += "&";
      str += encodeURIComponent(i2) + "=" + encodeURIComponent(obj[i2]);
    }
  }
  return str;
};
parseqs$3.decode = function(qs) {
  var qry = {};
  var pairs = qs.split("&");
  for (var i2 = 0, l = pairs.length; i2 < l; i2++) {
    var pair = pairs[i2].split("=");
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};
var componentInherit = function(a, b) {
  var fn2 = function() {
  };
  fn2.prototype = b.prototype;
  a.prototype = new fn2();
  a.prototype.constructor = a;
};
var alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), length = 64, map = {}, seed = 0, i = 0, prev;
function encode22(num) {
  var encoded = "";
  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);
  return encoded;
}
function decode(str) {
  var decoded = 0;
  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }
  return decoded;
}
function yeast$2() {
  var now = encode22(+new Date());
  if (now !== prev)
    return seed = 0, prev = now;
  return now + "." + encode22(seed++);
}
for (; i < length; i++)
  map[alphabet[i]] = i;
yeast$2.encode = encode22;
yeast$2.decode = decode;
var yeast_1 = yeast$2;
var Transport$1 = transport;
var parseqs$2 = parseqs$3;
var parser$3 = browser;
var inherit$3 = componentInherit;
var yeast$1 = yeast_1;
var debug$4 = browser$1.exports("engine.io-client:polling");
var polling$1 = Polling$2;
var hasXHR2 = function() {
  var XMLHttpRequest2 = xmlhttprequest;
  var xhr2 = new XMLHttpRequest2({ xdomain: false });
  return xhr2.responseType != null;
}();
function Polling$2(opts) {
  var forceBase64 = opts && opts.forceBase64;
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport$1.call(this, opts);
}
inherit$3(Polling$2, Transport$1);
Polling$2.prototype.name = "polling";
Polling$2.prototype.doOpen = function() {
  this.poll();
};
Polling$2.prototype.pause = function(onPause) {
  var self2 = this;
  this.readyState = "pausing";
  function pause() {
    debug$4("paused");
    self2.readyState = "paused";
    onPause();
  }
  if (this.polling || !this.writable) {
    var total = 0;
    if (this.polling) {
      debug$4("we are currently polling - waiting to pause");
      total++;
      this.once("pollComplete", function() {
        debug$4("pre-pause polling complete");
        --total || pause();
      });
    }
    if (!this.writable) {
      debug$4("we are currently writing - waiting to pause");
      total++;
      this.once("drain", function() {
        debug$4("pre-pause writing complete");
        --total || pause();
      });
    }
  } else {
    pause();
  }
};
Polling$2.prototype.poll = function() {
  debug$4("polling");
  this.polling = true;
  this.doPoll();
  this.emit("poll");
};
Polling$2.prototype.onData = function(data2) {
  var self2 = this;
  debug$4("polling got data %s", data2);
  var callback = function(packet, index2, total) {
    if (self2.readyState === "opening" && packet.type === "open") {
      self2.onOpen();
    }
    if (packet.type === "close") {
      self2.onClose();
      return false;
    }
    self2.onPacket(packet);
  };
  parser$3.decodePayload(data2, this.socket.binaryType, callback);
  if (this.readyState !== "closed") {
    this.polling = false;
    this.emit("pollComplete");
    if (this.readyState === "open") {
      this.poll();
    } else {
      debug$4('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};
Polling$2.prototype.doClose = function() {
  var self2 = this;
  function close2() {
    debug$4("writing close packet");
    self2.write([{ type: "close" }]);
  }
  if (this.readyState === "open") {
    debug$4("transport open - closing");
    close2();
  } else {
    debug$4("transport not open - deferring close");
    this.once("open", close2);
  }
};
Polling$2.prototype.write = function(packets) {
  var self2 = this;
  this.writable = false;
  var callbackfn = function() {
    self2.writable = true;
    self2.emit("drain");
  };
  parser$3.encodePayload(packets, this.supportsBinary, function(data2) {
    self2.doWrite(data2, callbackfn);
  });
};
Polling$2.prototype.uri = function() {
  var query = this.query || {};
  var schema = this.secure ? "https" : "http";
  var port = "";
  if (this.timestampRequests !== false) {
    query[this.timestampParam] = yeast$1();
  }
  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }
  query = parseqs$2.encode(query);
  if (this.port && (schema === "https" && Number(this.port) !== 443 || schema === "http" && Number(this.port) !== 80)) {
    port = ":" + this.port;
  }
  if (query.length) {
    query = "?" + query;
  }
  var ipv6 = this.hostname.indexOf(":") !== -1;
  return schema + "://" + (ipv6 ? "[" + this.hostname + "]" : this.hostname) + port + this.path + query;
};
var XMLHttpRequest$2 = xmlhttprequest;
var Polling$1 = polling$1;
var Emitter$2 = componentEmitter.exports;
var inherit$2 = componentInherit;
var debug$3 = browser$1.exports("engine.io-client:polling-xhr");
var globalThis$1 = globalThis_browser;
pollingXhr.exports = XHR$1;
pollingXhr.exports.Request = Request$1;
function empty$1() {
}
function XHR$1(opts) {
  Polling$1.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;
  if (typeof location !== "undefined") {
    var isSSL = location.protocol === "https:";
    var port = location.port;
    if (!port) {
      port = isSSL ? 443 : 80;
    }
    this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}
inherit$2(XHR$1, Polling$1);
XHR$1.prototype.supportsBinary = true;
XHR$1.prototype.request = function(opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;
  opts.withCredentials = this.withCredentials;
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;
  opts.extraHeaders = this.extraHeaders;
  return new Request$1(opts);
};
XHR$1.prototype.doWrite = function(data2, fn2) {
  var isBinary = typeof data2 !== "string" && data2 !== void 0;
  var req = this.request({ method: "POST", data: data2, isBinary });
  var self2 = this;
  req.on("success", fn2);
  req.on("error", function(err) {
    self2.onError("xhr post error", err);
  });
  this.sendXhr = req;
};
XHR$1.prototype.doPoll = function() {
  debug$3("xhr poll");
  var req = this.request();
  var self2 = this;
  req.on("data", function(data2) {
    self2.onData(data2);
  });
  req.on("error", function(err) {
    self2.onError("xhr poll error", err);
  });
  this.pollXhr = req;
};
function Request$1(opts) {
  this.method = opts.method || "GET";
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = opts.async !== false;
  this.data = opts.data !== void 0 ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.withCredentials = opts.withCredentials;
  this.requestTimeout = opts.requestTimeout;
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.extraHeaders = opts.extraHeaders;
  this.create();
}
Emitter$2(Request$1.prototype);
Request$1.prototype.create = function() {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  var xhr2 = this.xhr = new XMLHttpRequest$2(opts);
  var self2 = this;
  try {
    debug$3("xhr open %s: %s", this.method, this.uri);
    xhr2.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr2.setDisableHeaderCheck && xhr2.setDisableHeaderCheck(true);
        for (var i2 in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i2)) {
            xhr2.setRequestHeader(i2, this.extraHeaders[i2]);
          }
        }
      }
    } catch (e2) {
    }
    if (this.method === "POST") {
      try {
        if (this.isBinary) {
          xhr2.setRequestHeader("Content-type", "application/octet-stream");
        } else {
          xhr2.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        }
      } catch (e2) {
      }
    }
    try {
      xhr2.setRequestHeader("Accept", "*/*");
    } catch (e2) {
    }
    if ("withCredentials" in xhr2) {
      xhr2.withCredentials = this.withCredentials;
    }
    if (this.requestTimeout) {
      xhr2.timeout = this.requestTimeout;
    }
    if (this.hasXDR()) {
      xhr2.onload = function() {
        self2.onLoad();
      };
      xhr2.onerror = function() {
        self2.onError(xhr2.responseText);
      };
    } else {
      xhr2.onreadystatechange = function() {
        if (xhr2.readyState === 2) {
          try {
            var contentType = xhr2.getResponseHeader("Content-Type");
            if (self2.supportsBinary && contentType === "application/octet-stream" || contentType === "application/octet-stream; charset=UTF-8") {
              xhr2.responseType = "arraybuffer";
            }
          } catch (e2) {
          }
        }
        if (xhr2.readyState !== 4)
          return;
        if (xhr2.status === 200 || xhr2.status === 1223) {
          self2.onLoad();
        } else {
          setTimeout(function() {
            self2.onError(typeof xhr2.status === "number" ? xhr2.status : 0);
          }, 0);
        }
      };
    }
    debug$3("xhr data %s", this.data);
    xhr2.send(this.data);
  } catch (e2) {
    setTimeout(function() {
      self2.onError(e2);
    }, 0);
    return;
  }
  if (typeof document !== "undefined") {
    this.index = Request$1.requestsCount++;
    Request$1.requests[this.index] = this;
  }
};
Request$1.prototype.onSuccess = function() {
  this.emit("success");
  this.cleanup();
};
Request$1.prototype.onData = function(data2) {
  this.emit("data", data2);
  this.onSuccess();
};
Request$1.prototype.onError = function(err) {
  this.emit("error", err);
  this.cleanup(true);
};
Request$1.prototype.cleanup = function(fromError) {
  if (typeof this.xhr === "undefined" || this.xhr === null) {
    return;
  }
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty$1;
  } else {
    this.xhr.onreadystatechange = empty$1;
  }
  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e2) {
    }
  }
  if (typeof document !== "undefined") {
    delete Request$1.requests[this.index];
  }
  this.xhr = null;
};
Request$1.prototype.onLoad = function() {
  var data2;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader("Content-Type");
    } catch (e2) {
    }
    if (contentType === "application/octet-stream" || contentType === "application/octet-stream; charset=UTF-8") {
      data2 = this.xhr.response || this.xhr.responseText;
    } else {
      data2 = this.xhr.responseText;
    }
  } catch (e2) {
    this.onError(e2);
  }
  if (data2 != null) {
    this.onData(data2);
  }
};
Request$1.prototype.hasXDR = function() {
  return typeof XDomainRequest !== "undefined" && !this.xs && this.enablesXDR;
};
Request$1.prototype.abort = function() {
  this.cleanup();
};
Request$1.requestsCount = 0;
Request$1.requests = {};
if (typeof document !== "undefined") {
  if (typeof attachEvent === "function") {
    attachEvent("onunload", unloadHandler);
  } else if (typeof addEventListener === "function") {
    var terminationEvent = "onpagehide" in globalThis$1 ? "pagehide" : "unload";
    addEventListener(terminationEvent, unloadHandler, false);
  }
}
function unloadHandler() {
  for (var i2 in Request$1.requests) {
    if (Request$1.requests.hasOwnProperty(i2)) {
      Request$1.requests[i2].abort();
    }
  }
}
var Polling = polling$1;
var inherit$1 = componentInherit;
var globalThis$3 = globalThis_browser;
var pollingJsonp = JSONPPolling;
var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;
var callbacks;
function empty() {
}
function JSONPPolling(opts) {
  Polling.call(this, opts);
  this.query = this.query || {};
  if (!callbacks) {
    callbacks = globalThis$3.___eio = globalThis$3.___eio || [];
  }
  this.index = callbacks.length;
  var self2 = this;
  callbacks.push(function(msg) {
    self2.onData(msg);
  });
  this.query.j = this.index;
  if (typeof addEventListener === "function") {
    addEventListener("beforeunload", function() {
      if (self2.script)
        self2.script.onerror = empty;
    }, false);
  }
}
inherit$1(JSONPPolling, Polling);
JSONPPolling.prototype.supportsBinary = false;
JSONPPolling.prototype.doClose = function() {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }
  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }
  Polling.prototype.doClose.call(this);
};
JSONPPolling.prototype.doPoll = function() {
  var self2 = this;
  var script = document.createElement("script");
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }
  script.async = true;
  script.src = this.uri();
  script.onerror = function(e2) {
    self2.onError("jsonp poll error", e2);
  };
  var insertAt = document.getElementsByTagName("script")[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;
  var isUAgecko = typeof navigator !== "undefined" && /gecko/i.test(navigator.userAgent);
  if (isUAgecko) {
    setTimeout(function() {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};
JSONPPolling.prototype.doWrite = function(data2, fn2) {
  var self2 = this;
  if (!this.form) {
    var form = document.createElement("form");
    var area = document.createElement("textarea");
    var id = this.iframeId = "eio_iframe_" + this.index;
    var iframe;
    form.className = "socketio";
    form.style.position = "absolute";
    form.style.top = "-1000px";
    form.style.left = "-1000px";
    form.target = id;
    form.method = "POST";
    form.setAttribute("accept-charset", "utf-8");
    area.name = "d";
    form.appendChild(area);
    document.body.appendChild(form);
    this.form = form;
    this.area = area;
  }
  this.form.action = this.uri();
  function complete() {
    initIframe();
    fn2();
  }
  function initIframe() {
    if (self2.iframe) {
      try {
        self2.form.removeChild(self2.iframe);
      } catch (e2) {
        self2.onError("jsonp polling iframe removal error", e2);
      }
    }
    try {
      var html = '<iframe src="javascript:0" name="' + self2.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e2) {
      iframe = document.createElement("iframe");
      iframe.name = self2.iframeId;
      iframe.src = "javascript:0";
    }
    iframe.id = self2.iframeId;
    self2.form.appendChild(iframe);
    self2.iframe = iframe;
  }
  initIframe();
  data2 = data2.replace(rEscapedNewline, "\\\n");
  this.area.value = data2.replace(rNewline, "\\n");
  try {
    this.form.submit();
  } catch (e2) {
  }
  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function() {
      if (self2.iframe.readyState === "complete") {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};
var Transport = transport;
var parser$2 = browser;
var parseqs$1 = parseqs$3;
var inherit = componentInherit;
var yeast = yeast_1;
var debug$2 = browser$1.exports("engine.io-client:websocket");
var BrowserWebSocket, NodeWebSocket;
if (typeof WebSocket !== "undefined") {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== "undefined") {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}
if (typeof window === "undefined") {
  try {
    NodeWebSocket = require$$6;
  } catch (e2) {
  }
}
var WebSocketImpl = BrowserWebSocket || NodeWebSocket;
var websocket$1 = WS;
function WS(opts) {
  var forceBase64 = opts && opts.forceBase64;
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}
inherit(WS, Transport);
WS.prototype.name = "websocket";
WS.prototype.supportsBinary = true;
WS.prototype.doOpen = function() {
  if (!this.check()) {
    return;
  }
  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {};
  if (!this.isReactNative) {
    opts.agent = this.agent;
    opts.perMessageDeflate = this.perMessageDeflate;
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
  }
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }
  try {
    this.ws = this.usingBrowserWebSocket && !this.isReactNative ? protocols ? new WebSocketImpl(uri, protocols) : new WebSocketImpl(uri) : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit("error", err);
  }
  if (this.ws.binaryType === void 0) {
    this.supportsBinary = false;
  }
  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = "nodebuffer";
  } else {
    this.ws.binaryType = "arraybuffer";
  }
  this.addEventListeners();
};
WS.prototype.addEventListeners = function() {
  var self2 = this;
  this.ws.onopen = function() {
    self2.onOpen();
  };
  this.ws.onclose = function() {
    self2.onClose();
  };
  this.ws.onmessage = function(ev) {
    self2.onData(ev.data);
  };
  this.ws.onerror = function(e2) {
    self2.onError("websocket error", e2);
  };
};
WS.prototype.write = function(packets) {
  var self2 = this;
  this.writable = false;
  var total = packets.length;
  for (var i2 = 0, l = total; i2 < l; i2++) {
    (function(packet) {
      parser$2.encodePacket(packet, self2.supportsBinary, function(data2) {
        if (!self2.usingBrowserWebSocket) {
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }
          if (self2.perMessageDeflate) {
            var len = typeof data2 === "string" ? Buffer.byteLength(data2) : data2.length;
            if (len < self2.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }
        try {
          if (self2.usingBrowserWebSocket) {
            self2.ws.send(data2);
          } else {
            self2.ws.send(data2, opts);
          }
        } catch (e2) {
          debug$2("websocket closed before onclose event");
        }
        --total || done();
      });
    })(packets[i2]);
  }
  function done() {
    self2.emit("flush");
    setTimeout(function() {
      self2.writable = true;
      self2.emit("drain");
    }, 0);
  }
};
WS.prototype.onClose = function() {
  Transport.prototype.onClose.call(this);
};
WS.prototype.doClose = function() {
  if (typeof this.ws !== "undefined") {
    this.ws.close();
  }
};
WS.prototype.uri = function() {
  var query = this.query || {};
  var schema = this.secure ? "wss" : "ws";
  var port = "";
  if (this.port && (schema === "wss" && Number(this.port) !== 443 || schema === "ws" && Number(this.port) !== 80)) {
    port = ":" + this.port;
  }
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }
  if (!this.supportsBinary) {
    query.b64 = 1;
  }
  query = parseqs$1.encode(query);
  if (query.length) {
    query = "?" + query;
  }
  var ipv6 = this.hostname.indexOf(":") !== -1;
  return schema + "://" + (ipv6 ? "[" + this.hostname + "]" : this.hostname) + port + this.path + query;
};
WS.prototype.check = function() {
  return !!WebSocketImpl && !("__initialize" in WebSocketImpl && this.name === WS.prototype.name);
};
var XMLHttpRequest$1 = xmlhttprequest;
var XHR = pollingXhr.exports;
var JSONP = pollingJsonp;
var websocket = websocket$1;
transports$1.polling = polling;
transports$1.websocket = websocket;
function polling(opts) {
  var xhr2;
  var xd = false;
  var xs = false;
  var jsonp = opts.jsonp !== false;
  if (typeof location !== "undefined") {
    var isSSL = location.protocol === "https:";
    var port = location.port;
    if (!port) {
      port = isSSL ? 443 : 80;
    }
    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }
  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr2 = new XMLHttpRequest$1(opts);
  if ("open" in xhr2 && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp)
      throw new Error("JSONP disabled");
    return new JSONP(opts);
  }
}
var indexOf$1 = [].indexOf;
var indexof = function(arr, obj) {
  if (indexOf$1)
    return arr.indexOf(obj);
  for (var i2 = 0; i2 < arr.length; ++i2) {
    if (arr[i2] === obj)
      return i2;
  }
  return -1;
};
var transports = transports$1;
var Emitter$1 = componentEmitter.exports;
var debug$1 = browser$1.exports("engine.io-client:socket");
var index = indexof;
var parser$1 = browser;
var parseuri2 = parseuri$2;
var parseqs = parseqs$3;
var socket$1 = Socket$1;
function Socket$1(uri, opts) {
  if (!(this instanceof Socket$1))
    return new Socket$1(uri, opts);
  opts = opts || {};
  if (uri && typeof uri === "object") {
    opts = uri;
    uri = null;
  }
  if (uri) {
    uri = parseuri2(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === "https" || uri.protocol === "wss";
    opts.port = uri.port;
    if (uri.query)
      opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri2(opts.host).host;
  }
  this.secure = opts.secure != null ? opts.secure : typeof location !== "undefined" && location.protocol === "https:";
  if (opts.hostname && !opts.port) {
    opts.port = this.secure ? "443" : "80";
  }
  this.agent = opts.agent || false;
  this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
  this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? 443 : 80);
  this.query = opts.query || {};
  if (typeof this.query === "string")
    this.query = parseqs.decode(this.query);
  this.upgrade = opts.upgrade !== false;
  this.path = (opts.path || "/engine.io").replace(/\/$/, "") + "/";
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = opts.jsonp !== false;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.withCredentials = opts.withCredentials !== false;
  this.timestampParam = opts.timestampParam || "t";
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ["polling", "websocket"];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = "";
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = opts.perMessageDeflate !== false ? opts.perMessageDeflate || {} : false;
  if (this.perMessageDeflate === true)
    this.perMessageDeflate = {};
  if (this.perMessageDeflate && this.perMessageDeflate.threshold == null) {
    this.perMessageDeflate.threshold = 1024;
  }
  this.pfx = opts.pfx || void 0;
  this.key = opts.key || void 0;
  this.passphrase = opts.passphrase || void 0;
  this.cert = opts.cert || void 0;
  this.ca = opts.ca || void 0;
  this.ciphers = opts.ciphers || void 0;
  this.rejectUnauthorized = opts.rejectUnauthorized === void 0 ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;
  this.isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
  if (typeof self === "undefined" || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }
    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;
  this.open();
}
Socket$1.priorWebsocketSuccess = false;
Emitter$1(Socket$1.prototype);
Socket$1.protocol = parser$1.protocol;
Socket$1.Socket = Socket$1;
Socket$1.Transport = transport;
Socket$1.transports = transports$1;
Socket$1.parser = browser;
Socket$1.prototype.createTransport = function(name) {
  debug$1('creating transport "%s"', name);
  var query = clone(this.query);
  query.EIO = parser$1.protocol;
  query.transport = name;
  var options = this.transportOptions[name] || {};
  if (this.id)
    query.sid = this.id;
  var transport2 = new transports[name]({
    query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    withCredentials: options.withCredentials || this.withCredentials,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void 0,
    isReactNative: this.isReactNative
  });
  return transport2;
};
function clone(obj) {
  var o2 = {};
  for (var i2 in obj) {
    if (obj.hasOwnProperty(i2)) {
      o2[i2] = obj[i2];
    }
  }
  return o2;
}
Socket$1.prototype.open = function() {
  var transport2;
  if (this.rememberUpgrade && Socket$1.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) {
    transport2 = "websocket";
  } else if (this.transports.length === 0) {
    var self2 = this;
    setTimeout(function() {
      self2.emit("error", "No transports available");
    }, 0);
    return;
  } else {
    transport2 = this.transports[0];
  }
  this.readyState = "opening";
  try {
    transport2 = this.createTransport(transport2);
  } catch (e2) {
    this.transports.shift();
    this.open();
    return;
  }
  transport2.open();
  this.setTransport(transport2);
};
Socket$1.prototype.setTransport = function(transport2) {
  debug$1("setting transport %s", transport2.name);
  var self2 = this;
  if (this.transport) {
    debug$1("clearing existing transport %s", this.transport.name);
    this.transport.removeAllListeners();
  }
  this.transport = transport2;
  transport2.on("drain", function() {
    self2.onDrain();
  }).on("packet", function(packet) {
    self2.onPacket(packet);
  }).on("error", function(e2) {
    self2.onError(e2);
  }).on("close", function() {
    self2.onClose("transport close");
  });
};
Socket$1.prototype.probe = function(name) {
  debug$1('probing transport "%s"', name);
  var transport2 = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self2 = this;
  Socket$1.priorWebsocketSuccess = false;
  function onTransportOpen() {
    if (self2.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self2.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed)
      return;
    debug$1('probe transport "%s" opened', name);
    transport2.send([{ type: "ping", data: "probe" }]);
    transport2.once("packet", function(msg) {
      if (failed)
        return;
      if (msg.type === "pong" && msg.data === "probe") {
        debug$1('probe transport "%s" pong', name);
        self2.upgrading = true;
        self2.emit("upgrading", transport2);
        if (!transport2)
          return;
        Socket$1.priorWebsocketSuccess = transport2.name === "websocket";
        debug$1('pausing current transport "%s"', self2.transport.name);
        self2.transport.pause(function() {
          if (failed)
            return;
          if (self2.readyState === "closed")
            return;
          debug$1("changing transport and sending upgrade packet");
          cleanup();
          self2.setTransport(transport2);
          transport2.send([{ type: "upgrade" }]);
          self2.emit("upgrade", transport2);
          transport2 = null;
          self2.upgrading = false;
          self2.flush();
        });
      } else {
        debug$1('probe transport "%s" failed', name);
        var err = new Error("probe error");
        err.transport = transport2.name;
        self2.emit("upgradeError", err);
      }
    });
  }
  function freezeTransport() {
    if (failed)
      return;
    failed = true;
    cleanup();
    transport2.close();
    transport2 = null;
  }
  function onerror(err) {
    var error = new Error("probe error: " + err);
    error.transport = transport2.name;
    freezeTransport();
    debug$1('probe transport "%s" failed because of error: %s', name, err);
    self2.emit("upgradeError", error);
  }
  function onTransportClose() {
    onerror("transport closed");
  }
  function onclose() {
    onerror("socket closed");
  }
  function onupgrade(to) {
    if (transport2 && to.name !== transport2.name) {
      debug$1('"%s" works - aborting "%s"', to.name, transport2.name);
      freezeTransport();
    }
  }
  function cleanup() {
    transport2.removeListener("open", onTransportOpen);
    transport2.removeListener("error", onerror);
    transport2.removeListener("close", onTransportClose);
    self2.removeListener("close", onclose);
    self2.removeListener("upgrading", onupgrade);
  }
  transport2.once("open", onTransportOpen);
  transport2.once("error", onerror);
  transport2.once("close", onTransportClose);
  this.once("close", onclose);
  this.once("upgrading", onupgrade);
  transport2.open();
};
Socket$1.prototype.onOpen = function() {
  debug$1("socket open");
  this.readyState = "open";
  Socket$1.priorWebsocketSuccess = this.transport.name === "websocket";
  this.emit("open");
  this.flush();
  if (this.readyState === "open" && this.upgrade && this.transport.pause) {
    debug$1("starting upgrade probes");
    for (var i2 = 0, l = this.upgrades.length; i2 < l; i2++) {
      this.probe(this.upgrades[i2]);
    }
  }
};
Socket$1.prototype.onPacket = function(packet) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    debug$1('socket receive: type "%s", data "%s"', packet.type, packet.data);
    this.emit("packet", packet);
    this.emit("heartbeat");
    switch (packet.type) {
      case "open":
        this.onHandshake(JSON.parse(packet.data));
        break;
      case "pong":
        this.setPing();
        this.emit("pong");
        break;
      case "error":
        var err = new Error("server error");
        err.code = packet.data;
        this.onError(err);
        break;
      case "message":
        this.emit("data", packet.data);
        this.emit("message", packet.data);
        break;
    }
  } else {
    debug$1('packet received with socket readyState "%s"', this.readyState);
  }
};
Socket$1.prototype.onHandshake = function(data2) {
  this.emit("handshake", data2);
  this.id = data2.sid;
  this.transport.query.sid = data2.sid;
  this.upgrades = this.filterUpgrades(data2.upgrades);
  this.pingInterval = data2.pingInterval;
  this.pingTimeout = data2.pingTimeout;
  this.onOpen();
  if (this.readyState === "closed")
    return;
  this.setPing();
  this.removeListener("heartbeat", this.onHeartbeat);
  this.on("heartbeat", this.onHeartbeat);
};
Socket$1.prototype.onHeartbeat = function(timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self2 = this;
  self2.pingTimeoutTimer = setTimeout(function() {
    if (self2.readyState === "closed")
      return;
    self2.onClose("ping timeout");
  }, timeout || self2.pingInterval + self2.pingTimeout);
};
Socket$1.prototype.setPing = function() {
  var self2 = this;
  clearTimeout(self2.pingIntervalTimer);
  self2.pingIntervalTimer = setTimeout(function() {
    debug$1("writing ping packet - expecting pong within %sms", self2.pingTimeout);
    self2.ping();
    self2.onHeartbeat(self2.pingTimeout);
  }, self2.pingInterval);
};
Socket$1.prototype.ping = function() {
  var self2 = this;
  this.sendPacket("ping", function() {
    self2.emit("ping");
  });
};
Socket$1.prototype.onDrain = function() {
  this.writeBuffer.splice(0, this.prevBufferLen);
  this.prevBufferLen = 0;
  if (this.writeBuffer.length === 0) {
    this.emit("drain");
  } else {
    this.flush();
  }
};
Socket$1.prototype.flush = function() {
  if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
    debug$1("flushing %d packets in socket", this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    this.prevBufferLen = this.writeBuffer.length;
    this.emit("flush");
  }
};
Socket$1.prototype.write = Socket$1.prototype.send = function(msg, options, fn2) {
  this.sendPacket("message", msg, options, fn2);
  return this;
};
Socket$1.prototype.sendPacket = function(type, data2, options, fn2) {
  if (typeof data2 === "function") {
    fn2 = data2;
    data2 = void 0;
  }
  if (typeof options === "function") {
    fn2 = options;
    options = null;
  }
  if (this.readyState === "closing" || this.readyState === "closed") {
    return;
  }
  options = options || {};
  options.compress = options.compress !== false;
  var packet = {
    type,
    data: data2,
    options
  };
  this.emit("packetCreate", packet);
  this.writeBuffer.push(packet);
  if (fn2)
    this.once("flush", fn2);
  this.flush();
};
Socket$1.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.readyState = "closing";
    var self2 = this;
    if (this.writeBuffer.length) {
      this.once("drain", function() {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close2();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close2();
    }
  }
  function close2() {
    self2.onClose("forced close");
    debug$1("socket closing - telling transport to close");
    self2.transport.close();
  }
  function cleanupAndClose() {
    self2.removeListener("upgrade", cleanupAndClose);
    self2.removeListener("upgradeError", cleanupAndClose);
    close2();
  }
  function waitForUpgrade() {
    self2.once("upgrade", cleanupAndClose);
    self2.once("upgradeError", cleanupAndClose);
  }
  return this;
};
Socket$1.prototype.onError = function(err) {
  debug$1("socket error %j", err);
  Socket$1.priorWebsocketSuccess = false;
  this.emit("error", err);
  this.onClose("transport error", err);
};
Socket$1.prototype.onClose = function(reason, desc) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    debug$1('socket close with reason: "%s"', reason);
    var self2 = this;
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);
    this.transport.removeAllListeners("close");
    this.transport.close();
    this.transport.removeAllListeners();
    this.readyState = "closed";
    this.id = null;
    this.emit("close", reason, desc);
    self2.writeBuffer = [];
    self2.prevBufferLen = 0;
  }
};
Socket$1.prototype.filterUpgrades = function(upgrades) {
  var filteredUpgrades = [];
  for (var i2 = 0, j = upgrades.length; i2 < j; i2++) {
    if (~index(this.transports, upgrades[i2]))
      filteredUpgrades.push(upgrades[i2]);
  }
  return filteredUpgrades;
};
lib.exports = socket$1;
lib.exports.parser = browser;
var socket = { exports: {} };
var toArray_1 = toArray;
function toArray(list, index2) {
  var array = [];
  index2 = index2 || 0;
  for (var i2 = index2 || 0; i2 < list.length; i2++) {
    array[i2 - index2] = list[i2];
  }
  return array;
}
var on_1 = on$1;
function on$1(obj, ev, fn2) {
  obj.on(ev, fn2);
  return {
    destroy: function() {
      obj.removeListener(ev, fn2);
    }
  };
}
var slice = [].slice;
var componentBind = function(obj, fn2) {
  if (typeof fn2 == "string")
    fn2 = obj[fn2];
  if (typeof fn2 != "function")
    throw new Error("bind() requires a function");
  var args = slice.call(arguments, 2);
  return function() {
    return fn2.apply(obj, args.concat(slice.call(arguments)));
  };
};
(function(module, exports) {
  var parser2 = socket_ioParser;
  var Emitter2 = componentEmitter.exports;
  var toArray2 = toArray_1;
  var on2 = on_1;
  var bind42 = componentBind;
  var debug2 = browser$1.exports("socket.io-client:socket");
  var parseqs2 = parseqs$3;
  var hasBin = hasBinary2;
  module.exports = Socket2;
  var events = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
  };
  var emit = Emitter2.prototype.emit;
  function Socket2(io2, nsp, opts) {
    this.io = io2;
    this.nsp = nsp;
    this.json = this;
    this.ids = 0;
    this.acks = {};
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this.connected = false;
    this.disconnected = true;
    this.flags = {};
    if (opts && opts.query) {
      this.query = opts.query;
    }
    if (this.io.autoConnect)
      this.open();
  }
  Emitter2(Socket2.prototype);
  Socket2.prototype.subEvents = function() {
    if (this.subs)
      return;
    var io2 = this.io;
    this.subs = [
      on2(io2, "open", bind42(this, "onopen")),
      on2(io2, "packet", bind42(this, "onpacket")),
      on2(io2, "close", bind42(this, "onclose"))
    ];
  };
  Socket2.prototype.open = Socket2.prototype.connect = function() {
    if (this.connected)
      return this;
    this.subEvents();
    if (!this.io.reconnecting)
      this.io.open();
    if (this.io.readyState === "open")
      this.onopen();
    this.emit("connecting");
    return this;
  };
  Socket2.prototype.send = function() {
    var args = toArray2(arguments);
    args.unshift("message");
    this.emit.apply(this, args);
    return this;
  };
  Socket2.prototype.emit = function(ev) {
    if (events.hasOwnProperty(ev)) {
      emit.apply(this, arguments);
      return this;
    }
    var args = toArray2(arguments);
    var packet = {
      type: (this.flags.binary !== void 0 ? this.flags.binary : hasBin(args)) ? parser2.BINARY_EVENT : parser2.EVENT,
      data: args
    };
    packet.options = {};
    packet.options.compress = !this.flags || this.flags.compress !== false;
    if (typeof args[args.length - 1] === "function") {
      debug2("emitting packet with ack id %d", this.ids);
      this.acks[this.ids] = args.pop();
      packet.id = this.ids++;
    }
    if (this.connected) {
      this.packet(packet);
    } else {
      this.sendBuffer.push(packet);
    }
    this.flags = {};
    return this;
  };
  Socket2.prototype.packet = function(packet) {
    packet.nsp = this.nsp;
    this.io.packet(packet);
  };
  Socket2.prototype.onopen = function() {
    debug2("transport is open - connecting");
    if (this.nsp !== "/") {
      if (this.query) {
        var query = typeof this.query === "object" ? parseqs2.encode(this.query) : this.query;
        debug2("sending connect packet with query %s", query);
        this.packet({ type: parser2.CONNECT, query });
      } else {
        this.packet({ type: parser2.CONNECT });
      }
    }
  };
  Socket2.prototype.onclose = function(reason) {
    debug2("close (%s)", reason);
    this.connected = false;
    this.disconnected = true;
    delete this.id;
    this.emit("disconnect", reason);
  };
  Socket2.prototype.onpacket = function(packet) {
    var sameNamespace = packet.nsp === this.nsp;
    var rootNamespaceError = packet.type === parser2.ERROR && packet.nsp === "/";
    if (!sameNamespace && !rootNamespaceError)
      return;
    switch (packet.type) {
      case parser2.CONNECT:
        this.onconnect();
        break;
      case parser2.EVENT:
        this.onevent(packet);
        break;
      case parser2.BINARY_EVENT:
        this.onevent(packet);
        break;
      case parser2.ACK:
        this.onack(packet);
        break;
      case parser2.BINARY_ACK:
        this.onack(packet);
        break;
      case parser2.DISCONNECT:
        this.ondisconnect();
        break;
      case parser2.ERROR:
        this.emit("error", packet.data);
        break;
    }
  };
  Socket2.prototype.onevent = function(packet) {
    var args = packet.data || [];
    debug2("emitting event %j", args);
    if (packet.id != null) {
      debug2("attaching ack callback to event");
      args.push(this.ack(packet.id));
    }
    if (this.connected) {
      emit.apply(this, args);
    } else {
      this.receiveBuffer.push(args);
    }
  };
  Socket2.prototype.ack = function(id) {
    var self2 = this;
    var sent = false;
    return function() {
      if (sent)
        return;
      sent = true;
      var args = toArray2(arguments);
      debug2("sending ack %j", args);
      self2.packet({
        type: hasBin(args) ? parser2.BINARY_ACK : parser2.ACK,
        id,
        data: args
      });
    };
  };
  Socket2.prototype.onack = function(packet) {
    var ack = this.acks[packet.id];
    if (typeof ack === "function") {
      debug2("calling ack %s with %j", packet.id, packet.data);
      ack.apply(this, packet.data);
      delete this.acks[packet.id];
    } else {
      debug2("bad ack %s", packet.id);
    }
  };
  Socket2.prototype.onconnect = function() {
    this.connected = true;
    this.disconnected = false;
    this.emit("connect");
    this.emitBuffered();
  };
  Socket2.prototype.emitBuffered = function() {
    var i2;
    for (i2 = 0; i2 < this.receiveBuffer.length; i2++) {
      emit.apply(this, this.receiveBuffer[i2]);
    }
    this.receiveBuffer = [];
    for (i2 = 0; i2 < this.sendBuffer.length; i2++) {
      this.packet(this.sendBuffer[i2]);
    }
    this.sendBuffer = [];
  };
  Socket2.prototype.ondisconnect = function() {
    debug2("server disconnect (%s)", this.nsp);
    this.destroy();
    this.onclose("io server disconnect");
  };
  Socket2.prototype.destroy = function() {
    if (this.subs) {
      for (var i2 = 0; i2 < this.subs.length; i2++) {
        this.subs[i2].destroy();
      }
      this.subs = null;
    }
    this.io.destroy(this);
  };
  Socket2.prototype.close = Socket2.prototype.disconnect = function() {
    if (this.connected) {
      debug2("performing disconnect (%s)", this.nsp);
      this.packet({ type: parser2.DISCONNECT });
    }
    this.destroy();
    if (this.connected) {
      this.onclose("io client disconnect");
    }
    return this;
  };
  Socket2.prototype.compress = function(compress) {
    this.flags.compress = compress;
    return this;
  };
  Socket2.prototype.binary = function(binary2) {
    this.flags.binary = binary2;
    return this;
  };
})(socket);
var backo2 = Backoff$1;
function Backoff$1(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 1e4;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}
Backoff$1.prototype.duration = function() {
  var ms2 = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand = Math.random();
    var deviation = Math.floor(rand * this.jitter * ms2);
    ms2 = (Math.floor(rand * 10) & 1) == 0 ? ms2 - deviation : ms2 + deviation;
  }
  return Math.min(ms2, this.max) | 0;
};
Backoff$1.prototype.reset = function() {
  this.attempts = 0;
};
Backoff$1.prototype.setMin = function(min2) {
  this.ms = min2;
};
Backoff$1.prototype.setMax = function(max2) {
  this.max = max2;
};
Backoff$1.prototype.setJitter = function(jitter) {
  this.jitter = jitter;
};
var eio = lib.exports;
var Socket = socket.exports;
var Emitter = componentEmitter.exports;
var parser = socket_ioParser;
var on = on_1;
var bind32 = componentBind;
var debug = browser$1.exports("socket.io-client:manager");
var indexOf = indexof;
var Backoff = backo2;
var has = Object.prototype.hasOwnProperty;
var manager = Manager;
function Manager(uri, opts) {
  if (!(this instanceof Manager))
    return new Manager(uri, opts);
  if (uri && typeof uri === "object") {
    opts = uri;
    uri = void 0;
  }
  opts = opts || {};
  opts.path = opts.path || "/socket.io";
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1e3);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5e3);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(opts.timeout == null ? 2e4 : opts.timeout);
  this.readyState = "closed";
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect)
    this.open();
}
Manager.prototype.emitAll = function() {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};
Manager.prototype.updateSocketIds = function() {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};
Manager.prototype.generateId = function(nsp) {
  return (nsp === "/" ? "" : nsp + "#") + this.engine.id;
};
Emitter(Manager.prototype);
Manager.prototype.reconnection = function(v2) {
  if (!arguments.length)
    return this._reconnection;
  this._reconnection = !!v2;
  return this;
};
Manager.prototype.reconnectionAttempts = function(v2) {
  if (!arguments.length)
    return this._reconnectionAttempts;
  this._reconnectionAttempts = v2;
  return this;
};
Manager.prototype.reconnectionDelay = function(v2) {
  if (!arguments.length)
    return this._reconnectionDelay;
  this._reconnectionDelay = v2;
  this.backoff && this.backoff.setMin(v2);
  return this;
};
Manager.prototype.randomizationFactor = function(v2) {
  if (!arguments.length)
    return this._randomizationFactor;
  this._randomizationFactor = v2;
  this.backoff && this.backoff.setJitter(v2);
  return this;
};
Manager.prototype.reconnectionDelayMax = function(v2) {
  if (!arguments.length)
    return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v2;
  this.backoff && this.backoff.setMax(v2);
  return this;
};
Manager.prototype.timeout = function(v2) {
  if (!arguments.length)
    return this._timeout;
  this._timeout = v2;
  return this;
};
Manager.prototype.maybeReconnectOnOpen = function() {
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    this.reconnect();
  }
};
Manager.prototype.open = Manager.prototype.connect = function(fn2, opts) {
  debug("readyState %s", this.readyState);
  if (~this.readyState.indexOf("open"))
    return this;
  debug("opening %s", this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket2 = this.engine;
  var self2 = this;
  this.readyState = "opening";
  this.skipReconnect = false;
  var openSub = on(socket2, "open", function() {
    self2.onopen();
    fn2 && fn2();
  });
  var errorSub = on(socket2, "error", function(data2) {
    debug("connect_error");
    self2.cleanup();
    self2.readyState = "closed";
    self2.emitAll("connect_error", data2);
    if (fn2) {
      var err = new Error("Connection error");
      err.data = data2;
      fn2(err);
    } else {
      self2.maybeReconnectOnOpen();
    }
  });
  if (this._timeout !== false) {
    var timeout = this._timeout;
    debug("connect attempt will timeout after %d", timeout);
    if (timeout === 0) {
      openSub.destroy();
    }
    var timer = setTimeout(function() {
      debug("connect attempt timed out after %d", timeout);
      openSub.destroy();
      socket2.close();
      socket2.emit("error", "timeout");
      self2.emitAll("connect_timeout", timeout);
    }, timeout);
    this.subs.push({
      destroy: function() {
        clearTimeout(timer);
      }
    });
  }
  this.subs.push(openSub);
  this.subs.push(errorSub);
  return this;
};
Manager.prototype.onopen = function() {
  debug("open");
  this.cleanup();
  this.readyState = "open";
  this.emit("open");
  var socket2 = this.engine;
  this.subs.push(on(socket2, "data", bind32(this, "ondata")));
  this.subs.push(on(socket2, "ping", bind32(this, "onping")));
  this.subs.push(on(socket2, "pong", bind32(this, "onpong")));
  this.subs.push(on(socket2, "error", bind32(this, "onerror")));
  this.subs.push(on(socket2, "close", bind32(this, "onclose")));
  this.subs.push(on(this.decoder, "decoded", bind32(this, "ondecoded")));
};
Manager.prototype.onping = function() {
  this.lastPing = new Date();
  this.emitAll("ping");
};
Manager.prototype.onpong = function() {
  this.emitAll("pong", new Date() - this.lastPing);
};
Manager.prototype.ondata = function(data2) {
  this.decoder.add(data2);
};
Manager.prototype.ondecoded = function(packet) {
  this.emit("packet", packet);
};
Manager.prototype.onerror = function(err) {
  debug("error", err);
  this.emitAll("error", err);
};
Manager.prototype.socket = function(nsp, opts) {
  var socket2 = this.nsps[nsp];
  if (!socket2) {
    socket2 = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket2;
    var self2 = this;
    socket2.on("connecting", onConnecting);
    socket2.on("connect", function() {
      socket2.id = self2.generateId(nsp);
    });
    if (this.autoConnect) {
      onConnecting();
    }
  }
  function onConnecting() {
    if (!~indexOf(self2.connecting, socket2)) {
      self2.connecting.push(socket2);
    }
  }
  return socket2;
};
Manager.prototype.destroy = function(socket2) {
  var index2 = indexOf(this.connecting, socket2);
  if (~index2)
    this.connecting.splice(index2, 1);
  if (this.connecting.length)
    return;
  this.close();
};
Manager.prototype.packet = function(packet) {
  debug("writing packet %j", packet);
  var self2 = this;
  if (packet.query && packet.type === 0)
    packet.nsp += "?" + packet.query;
  if (!self2.encoding) {
    self2.encoding = true;
    this.encoder.encode(packet, function(encodedPackets) {
      for (var i2 = 0; i2 < encodedPackets.length; i2++) {
        self2.engine.write(encodedPackets[i2], packet.options);
      }
      self2.encoding = false;
      self2.processPacketQueue();
    });
  } else {
    self2.packetBuffer.push(packet);
  }
};
Manager.prototype.processPacketQueue = function() {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};
Manager.prototype.cleanup = function() {
  debug("cleanup");
  var subsLength = this.subs.length;
  for (var i2 = 0; i2 < subsLength; i2++) {
    var sub = this.subs.shift();
    sub.destroy();
  }
  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;
  this.decoder.destroy();
};
Manager.prototype.close = Manager.prototype.disconnect = function() {
  debug("disconnect");
  this.skipReconnect = true;
  this.reconnecting = false;
  if (this.readyState === "opening") {
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = "closed";
  if (this.engine)
    this.engine.close();
};
Manager.prototype.onclose = function(reason) {
  debug("onclose");
  this.cleanup();
  this.backoff.reset();
  this.readyState = "closed";
  this.emit("close", reason);
  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};
Manager.prototype.reconnect = function() {
  if (this.reconnecting || this.skipReconnect)
    return this;
  var self2 = this;
  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug("reconnect failed");
    this.backoff.reset();
    this.emitAll("reconnect_failed");
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug("will wait %dms before reconnect attempt", delay);
    this.reconnecting = true;
    var timer = setTimeout(function() {
      if (self2.skipReconnect)
        return;
      debug("attempting reconnect");
      self2.emitAll("reconnect_attempt", self2.backoff.attempts);
      self2.emitAll("reconnecting", self2.backoff.attempts);
      if (self2.skipReconnect)
        return;
      self2.open(function(err) {
        if (err) {
          debug("reconnect attempt error");
          self2.reconnecting = false;
          self2.reconnect();
          self2.emitAll("reconnect_error", err.data);
        } else {
          debug("reconnect success");
          self2.onreconnect();
        }
      });
    }, delay);
    this.subs.push({
      destroy: function() {
        clearTimeout(timer);
      }
    });
  }
};
Manager.prototype.onreconnect = function() {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll("reconnect", attempt);
};
(function(module, exports) {
  var url2 = url_1;
  var parser2 = socket_ioParser;
  var Manager2 = manager;
  var debug2 = browser$1.exports("socket.io-client");
  module.exports = exports = lookup;
  var cache2 = exports.managers = {};
  function lookup(uri, opts) {
    if (typeof uri === "object") {
      opts = uri;
      uri = void 0;
    }
    opts = opts || {};
    var parsed = url2(uri);
    var source22 = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache2[id] && path in cache2[id].nsps;
    var newConnection = opts.forceNew || opts["force new connection"] || opts.multiplex === false || sameNamespace;
    var io2;
    if (newConnection) {
      debug2("ignoring socket cache for %s", source22);
      io2 = Manager2(source22, opts);
    } else {
      if (!cache2[id]) {
        debug2("new io instance for %s", source22);
        cache2[id] = Manager2(source22, opts);
      }
      io2 = cache2[id];
    }
    if (parsed.query && !opts.query) {
      opts.query = parsed.query;
    }
    return io2.socket(parsed.path, opts);
  }
  exports.protocol = parser2.protocol;
  exports.connect = lookup;
  exports.Manager = manager;
  exports.Socket = socket.exports;
})(lib$1, lib$1.exports);
lib$1.exports;
const assertInComponent = (message = "Expected to be called in a Vue component's `setup` or life-cycle hook function.") => {
  if (!getCurrentInstance()) {
    throw new Error(message);
  }
};
window.location.hostname.endsWith(".localhost");
const exponentialBackOff = ({ minDelay = 1e3, maxDelay = 5 * 60 * 1e3, delayFactor = 2 } = {}) => (retryAttempt) => Math.max(minDelay, Math.min(maxDelay, Math.floor(minDelay * delayFactor ** retryAttempt)));
function v3Url(endpoint) {
  return `/projects/api/v3/${endpoint}.json`;
}
function responseToItems$1(response) {
  return response.data.people.map(({ id, firstName, lastName, avatarUrl, companyId, isAdmin }) => {
    return {
      id,
      firstName,
      lastName,
      avatarUrl,
      companyId,
      companyName: response.data.included.companies[companyId].name,
      projectAdministrator: response.data.included.ProjectPermissions[id].projectAdministrator,
      siteOwner: isAdmin
    };
  });
}
function useProjectPeopleLoader({
  projectId: _projectId,
  params: _params,
  count,
  pageSize = 50
}) {
  assertInComponent();
  const params = reactive(__spreadProps(__spreadValues({}, toRefs(_params)), {
    excludeContacts: true,
    include: "companies,permissions",
    fields: {
      companies: "id,name"
    }
  }));
  const loader = useListLoader({
    url: v3Url(`projects/${_projectId}/people`),
    params,
    count,
    responseToItems: responseToItems$1,
    pageSize,
    shouldMemoize: true
  });
  return {
    items: loader.items,
    totalCount: loader.totalCount,
    itemInSync: loader.itemInSync,
    inSync: loader.inSync,
    loading: loader.loading,
    meta: loader.meta,
    response: loader.response,
    error: loader.error
  };
}
function v1Url(endpoint) {
  return `/${endpoint}.json`;
}
function responseToItems(response) {
  return response.data.teams;
}
function useTeamsLoader({
  taskId,
  params,
  count,
  pageSize = 50
}) {
  assertInComponent();
  const loader = useListLoader({
    url: v1Url(`tasks/${taskId}/teams`),
    params,
    count,
    responseToItems,
    pageSize,
    shouldMemoize: true
  });
  return {
    items: loader.items,
    totalCount: loader.totalCount,
    itemInSync: loader.itemInSync,
    inSync: loader.inSync,
    loading: loader.loading,
    meta: loader.meta,
    response: loader.response,
    error: loader.error
  };
}
function useAssigneeList({
  projectId = 0,
  taskId = 0,
  searchTerm = ref(""),
  privacyIds = [],
  currentUser,
  recentAssignees,
  shouldUseRecentlyAssigned = false,
  shouldIncludeObservers = false,
  companyIds = []
}) {
  const DEFAULT_PAGE_SIZE = 50;
  let INITIAL_TOTAL_COUNT = 0;
  const params = reactive({
    searchTerm: "",
    ids: privacyIds.join(","),
    companyIds: companyIds.join(","),
    includeObservers: shouldIncludeObservers
  });
  const peopleResult = useProjectPeopleLoader({
    projectId,
    params,
    count: DEFAULT_PAGE_SIZE,
    pageSize: DEFAULT_PAGE_SIZE
  });
  const stopWatchTotalCount = watch(peopleResult.totalCount, () => {
    INITIAL_TOTAL_COUNT = peopleResult.totalCount.value;
    stopWatchTotalCount();
  });
  const teamsResult = useTeamsLoader({
    taskId,
    params,
    count: DEFAULT_PAGE_SIZE,
    pageSize: DEFAULT_PAGE_SIZE
  });
  const isLoading = computed(() => {
    return teamsResult.loading.value || peopleResult.loading.value;
  });
  const hasError = computed(() => {
    return peopleResult.error.value || teamsResult.error.value;
  });
  const recentAssigneesForProject = recentAssignees.value[projectId] && shouldUseRecentlyAssigned ? recentAssignees.value[projectId] : [];
  const teamsMap = computed(() => {
    if (isLoading.value) {
      return [];
    }
    if (teamsResult.items.value.length === 0) {
      return [];
    }
    return [
      {
        label: "Teams",
        options: teamsResult.items.value.filter((item) => !recentAssigneesForProject.some((ru) => ru.value === `t-${item.id}`)).filter((item) => item.name.toLowerCase().startsWith(searchTerm.value.toLowerCase()) || searchTerm.value === "" || INITIAL_TOTAL_COUNT > DEFAULT_PAGE_SIZE).map(({ logoUrl, logoColor, logoIcon, name, id }) => ({
          id,
          icon: { color: logoColor, name: logoIcon },
          image: logoUrl,
          name,
          value: `t-${id}`,
          type: "team"
        }))
      }
    ];
  });
  const currentUserGroup = [
    {
      label: "",
      options: [
        __spreadProps(__spreadValues({}, currentUser), {
          initials: `${currentUser.firstName && currentUser.firstName.length ? currentUser.firstName[0].toUpperCase() : ""}${currentUser.lastName && currentUser.lastName.length ? currentUser.lastName[0].toUpperCase() : ""}`
        }),
        ...recentAssigneesForProject
      ]
    }
  ];
  const itemsMap = computed(() => {
    if (isLoading.value) {
      return [];
    }
    if (peopleResult.items.value.length === 0) {
      return [...teamsMap.value];
    }
    const companyNames = Array.from(new Set(peopleResult.items.value.map(({ companyName }) => companyName)));
    const companyGroups = companyNames.map((label) => {
      return {
        label,
        options: peopleResult.items.value.filter((user) => user.id !== currentUser.id).filter((user) => !recentAssigneesForProject.some((ru) => ru.value === `u-${user.id}`)).filter((item) => item.companyName === label && (`${item.firstName} ${item.lastName}`.toLowerCase().includes(searchTerm.value.toLowerCase()) || searchTerm.value === "") || INITIAL_TOTAL_COUNT > DEFAULT_PAGE_SIZE).map(({ avatarUrl, firstName, lastName, id, siteOwner, projectAdministrator }) => ({
          id,
          image: avatarUrl,
          name: `${firstName} ${lastName}`,
          initials: `${firstName && firstName.length ? firstName[0].toUpperCase() : ""}${lastName && lastName.length ? lastName[0].toUpperCase() : ""}`,
          firstName,
          lastName,
          value: `u-${id}`,
          siteOwner,
          projectAdministrator,
          type: "user"
        }))
      };
    });
    return [
      ...[
        {
          label: currentUserGroup[0].label,
          options: currentUserGroup[0].options.filter((item) => item.name.toLowerCase().includes(searchTerm.value.toLowerCase()) || searchTerm.value === "")
        }
      ],
      ...companyGroups.filter((cg) => cg.options.length > 0),
      ...teamsMap.value.filter((tv) => tv.options.length > 0)
    ];
  });
  const setSearchTerm = () => {
    params.searchTerm = searchTerm.value;
  };
  watch(searchTerm, () => {
    if (INITIAL_TOTAL_COUNT >= DEFAULT_PAGE_SIZE) {
      setSearchTerm();
    }
  });
  return {
    itemsMap,
    isLoading,
    hasError,
    totalCount: peopleResult.totalCount
  };
}
const RECENTLY_ASSIGNED_COUNT = 4;
function useRecentAssignees({ currentUser, projectId }) {
  const recentAssignees = useStorage("c-people-picker", {});
  const addAssigneeToRecentlyAssignedStore = (assignee) => {
    if (!Object.prototype.hasOwnProperty.call(recentAssignees.value, projectId)) {
      recentAssignees.value[projectId] = [];
    }
    let recentAssigneesArray = recentAssignees.value[projectId];
    const exists = recentAssigneesArray.some((user) => user.value === assignee.value);
    if (recentAssigneesArray.length < RECENTLY_ASSIGNED_COUNT && !exists && assignee.value !== currentUser.value) {
      recentAssignees.value[projectId] = [assignee, ...recentAssigneesArray];
    }
    if (recentAssigneesArray.length === RECENTLY_ASSIGNED_COUNT && !exists && assignee.value !== currentUser.value) {
      recentAssignees.value[projectId] = [
        assignee,
        ...recentAssigneesArray.slice(0, RECENTLY_ASSIGNED_COUNT - 1)
      ];
    }
  };
  return {
    addAssigneeToRecentlyAssignedStore,
    recentAssignees
  };
}
const _hoisted_1$2 = {
  width: "136",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$2 = /* @__PURE__ */ createStaticVNode('<path fill-rule="evenodd" clip-rule="evenodd" d="M66.612 40.836c11.146 0 20.18-8.961 20.18-20.015S77.759.806 66.613.806c-11.145 0-20.18 8.961-20.18 20.015s9.035 20.015 20.18 20.015Z" fill="#79E3AA"></path><mask id="a" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="46" y="0" width="41" height="41"><path fill-rule="evenodd" clip-rule="evenodd" d="M66.612 40.836c11.146 0 20.18-8.961 20.18-20.015S77.759.806 66.613.806c-11.145 0-20.18 8.961-20.18 20.015s9.035 20.015 20.18 20.015Z" fill="#fff"></path></mask><g mask="url(#a)"><path d="M59.283 42.057c.124-.948 1.93-13.698 2.885-14.05 2.38-.863 7.092-.533 7.94.44 3.562 4.077 3.43 13.63 3.43 13.63-.415.073-7.025 1.473-14.255-.02Z" fill="#FF7641"></path><path d="M64.757 42.426a.248.248 0 0 1-.25-.245v-.02c.044-1.018.076-2.157.11-3.36.072-2.52.154-5.377.34-7.617a.244.244 0 0 1 .261-.231h.014a.248.248 0 0 1 .235.259.032.032 0 0 1 0 .014c-.184 2.215-.268 5.074-.348 7.597-.035 1.208-.066 2.344-.11 3.368a.248.248 0 0 1-.252.242v-.007Z" fill="#F45721"></path><path d="M64.454 33.496a.248.248 0 0 1-.228-.246c0-.128.099-.235.228-.246a8.36 8.36 0 0 0 1.31-.14.25.25 0 1 1 .094.492c-.459.087-.925.136-1.392.149l-.012-.009ZM65.328 35.478c-.315 0-.629-.02-.94-.064a.247.247 0 0 1-.17-.403.252.252 0 0 1 .24-.089 6 6 0 0 0 .946.059c.142 0 .256.114.256.254s-.114.254-.256.254l-.076-.01ZM65.469 37.491h-1.11a.253.253 0 0 1-.253-.252c0-.139.113-.252.254-.252h1.109c.09 0 .174.048.22.126a.25.25 0 0 1 0 .252.254.254 0 0 1-.22.126ZM65.469 39.404h-1.11a.253.253 0 0 1-.253-.252c0-.139.113-.252.254-.252h1.109c.09 0 .174.048.22.126a.25.25 0 0 1 0 .252.254.254 0 0 1-.22.127ZM64.115 41.026a.255.255 0 0 1-.22-.126.25.25 0 0 1 0-.252.255.255 0 0 1 .22-.126l1.138-.03a.248.248 0 0 1 .263.23v.015a.248.248 0 0 1-.235.26h-.012l-1.14.029h-.014Z" fill="#F45721"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M114.995 41.542c11.567 0 20.943-9.3 20.943-20.771S126.562 0 114.995 0c-11.566 0-20.943 9.3-20.943 20.771 0 11.472 9.377 20.771 20.943 20.771Z" fill="#FF7641"></path><mask id="b" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="94" y="0" width="42" height="42"><path fill-rule="evenodd" clip-rule="evenodd" d="M114.995 41.542c11.567 0 20.943-9.3 20.943-20.771S126.562 0 114.995 0c-11.566 0-20.943 9.3-20.943 20.771 0 11.472 9.377 20.771 20.943 20.771Z" fill="#fff"></path></mask><g mask="url(#b)"><path d="M121.27 41.347c-.063-3.108-.216-9.448-.925-12.086-.943-3.517-2.418-3.726-3.182-3.716l-5.856.345c-.763-.01-3.244-.381-4.062 3.167-.959 4.156-1.302 9.315-1.998 12.827 1.822.482 12.955 1.098 16.023-.537Z" fill="#FFD56A"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="M92.194 19.264c.966-.02 1.766.74 1.787 1.698.116 5.396.895 8.501 1.825 10.192.451.82.907 1.251 1.289 1.481a2.17 2.17 0 0 0 1.223.306c.982-.028 2.145-.557 3.251-1.306a14.763 14.763 0 0 0 2.057-1.694l.003-.004c2.569-2.565 3.895-3.495 4.533-3.942a5.09 5.09 0 0 0 .371-.274 1.759 1.759 0 0 1 2.468.162c.637.72.564 1.817-.162 2.448-.32.278-.578.459-.871.665-.685.48-1.561 1.095-3.855 3.385a18.206 18.206 0 0 1-2.57 2.12c-1.28.866-3.128 1.853-5.126 1.909a5.688 5.688 0 0 1-3.142-.81c-1.012-.612-1.86-1.547-2.54-2.784-1.334-2.424-2.132-6.199-2.252-11.78a1.741 1.741 0 0 1 1.711-1.772Z" fill="#D0916D"></path><path d="m110.579 28.55-.087.066-.006.004c-.086.06-.979.7-1.387 1.025l-.025.02c-.71.57-1.569 1.346-2.674 2.438l-.281.28c-.498.499-1.152 1.082-1.944 1.673-1.238.924-2.517 1.636-3.826 2.031-3.94 1.19-7.2-.767-8.743-6.07l-.046-.162 3.38-.933c.568 2.025 1.32 3.198 2.147 3.703.6.367 1.327.41 2.24.134.861-.26 1.801-.783 2.739-1.483.606-.452 1.114-.9 1.497-1.28l.265-.263c1.233-1.222 2.208-2.104 3.037-2.77.294-.237.554-.434.831-.635l.596-.423.073-.055c.052-.039.096-.074.136-.107l.029-.025 2.312 2.617a5.976 5.976 0 0 1-.263.215Z" fill="#FFD56A"></path><mask id="c" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="91" y="25" width="20" height="12"><path d="m110.579 28.55-.087.066-.006.004c-.086.06-.979.7-1.387 1.025l-.025.02c-.71.57-1.569 1.346-2.674 2.438l-.281.28c-.498.499-1.152 1.082-1.944 1.673-1.238.924-2.517 1.636-3.826 2.031-3.94 1.19-7.2-.767-8.743-6.07l-.046-.162 3.38-.933c.568 2.025 1.32 3.198 2.147 3.703.6.367 1.327.41 2.24.134.861-.26 1.801-.783 2.739-1.483.606-.452 1.114-.9 1.497-1.28l.265-.263c1.233-1.222 2.208-2.104 3.037-2.77.294-.237.554-.434.831-.635l.596-.423.073-.055c.052-.039.096-.074.136-.107l.029-.025 2.312 2.617a5.976 5.976 0 0 1-.263.215Z" fill="#fff"></path></mask><g mask="url(#c)"><path d="M106.216 32.952a.247.247 0 0 1-.071-.01.245.245 0 0 1-.174-.307c.207-.705.611-2.183.797-2.89a.25.25 0 0 1 .304-.178c.133.035.213.17.178.302-.186.71-.592 2.196-.801 2.905a.248.248 0 0 1-.233.178Z" fill="#FEB51F"></path><path d="M96.119 29.65s-1.464 1.196-5.012 2.059M96.88 30.887s-1.464 1.198-5.012 2.062" stroke="#FCB41E" stroke-width="3.18"></path></g><path d="M119.285 45.765a1.863 1.863 0 0 1-1.871-1.856c0-1.025.837-1.856 1.871-1.856 2.679 0 4.662-1.288 5.174-3.36.928-3.762-3.101-7.348-6.831-9.275a1.85 1.85 0 0 1-.142-3.213 1.885 1.885 0 0 1 1.87-.082c7.887 4.073 9.685 9.62 8.74 13.452-.928 3.763-4.387 6.19-8.811 6.19Z" fill="#D1916D"></path><path d="m128.299 38.258-3.729-.273c.084-1.126-.174-5.072-6.942-8.569l1.728-3.294c5.939 3.068 9.292 7.604 8.943 12.136Z" fill="#FFD56A"></path><mask id="d" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="117" y="26" width="12" height="13"><path d="m128.299 38.258-3.729-.273c.084-1.126-.174-5.072-6.942-8.569l1.728-3.294c5.939 3.068 9.292 7.604 8.943 12.136Z" fill="#fff"></path></mask><g mask="url(#d)" fill="#FEB51F"><path d="M123.961 36.911a.25.25 0 0 1-.254-.223.248.248 0 0 1 .207-.267 20.495 20.495 0 0 1 4.774-.364.249.249 0 0 1 .158.43.246.246 0 0 1-.179.065 20.056 20.056 0 0 0-4.657.354.226.226 0 0 1-.049.005ZM123.517 35.753a.25.25 0 0 1-.243-.21.247.247 0 0 1 .165-.274 16.93 16.93 0 0 1 5.048-.863c.13.01.23.119.23.248s-.1.237-.23.247c-1.663.03-3.311.314-4.888.84a.272.272 0 0 1-.082.012Z"></path></g><path fill-rule="evenodd" clip-rule="evenodd" d="m119.235 25.914 1.495 1.06v4.511l-8.446.433-4.959.333.384-4.743 1.472-1.79 10.054.196Z" fill="#FFD56A"></path><path d="M113.815 6.193c-5.501.448-7.425 2.506-7.694 8.115-.26 5.38 1.805 5.957 7.599 5.75 4.462-.16 7.332-.573 7.282-5.437-.058-5.59-2.615-8.8-7.187-8.428Z" fill="#D1916D"></path><path d="M104.926 24.307c1.915 3.427 7.57 4.272 11.452 3.643 11.239-1.814 5.087-15.648 4.462-16.415-.376-.459-1.393-.464-1.64.56-.195.837.567 3.607.433 3.999-.348 1.036-3.294 1.38-4.385 1.507-3.471.394-7.758.29-8.518-.496-.813-.839-.578-3.453-.437-4.661 0 0-.787-.194-.909.388-.138.65-2 8.723-.458 11.475Z" fill="#373753"></path><path d="M114.546 13.915h-.034a.245.245 0 0 1-.22-.274c.129-.899.707-1.165 1.161-1.118.572.059 1 .547.979 1.117a.248.248 0 0 1-.139.206.251.251 0 0 1-.249-.017.247.247 0 0 1-.11-.222.587.587 0 0 0-.533-.594c-.324-.032-.546.22-.614.691a.251.251 0 0 1-.241.21ZM107.7 13.93a.25.25 0 0 1-.246-.207 1.077 1.077 0 0 1 .86-1.209c.449-.091 1.045.114 1.267.997a.244.244 0 0 1-.069.237.251.251 0 0 1-.415-.12c-.114-.464-.363-.69-.682-.628a.586.586 0 0 0-.47.642.25.25 0 0 1-.205.285l-.04.003Z" fill="#935032"></path><path d="M116.392 11.777a.373.373 0 0 1-.251-.095 2.84 2.84 0 0 0-1.694-.71.373.373 0 0 1-.349-.396.374.374 0 0 1 .4-.346 3.617 3.617 0 0 1 2.137.9c.15.136.164.366.03.518a.38.38 0 0 1-.273.13ZM106.277 11.568a.374.374 0 0 1-.35-.238.37.37 0 0 1 .099-.41 3.622 3.622 0 0 1 2.143-.906.373.373 0 0 1 .052.742 2.835 2.835 0 0 0-1.693.71.378.378 0 0 1-.251.102Z" fill="#373753"></path><path d="M111.065 15.712a.264.264 0 0 1-.095-.019c-1.41-.558-1.404-.678-1.392-.848 0-.052 0-.159 1.133-3.039a.25.25 0 0 1 .436-.084.246.246 0 0 1 .029.257c-.348.907-.905 2.331-1.062 2.782.202.11.658.31 1.045.466a.249.249 0 0 1-.094.485Z" fill="#B57352"></path><path d="M107.583 15.859c.612-.577 5.003-.79 5.797-.389 1.37.691 2.15 2.642 2.004 3.117-.077.245-7.533 1.177-8.682 0-.568-.577.719-2.585.881-2.728Z" fill="#373753"></path><path d="M111.049 17.905a2.572 2.572 0 0 1-1.365-.32.246.246 0 0 1 .026-.427.251.251 0 0 1 .249.015c.416.27 1.355.318 2.089.102a.247.247 0 1 1 .141.475 4.252 4.252 0 0 1-1.14.155Z" fill="#0D0D19"></path><path d="M120.55 31.744a.246.246 0 0 1-.174-.074 5.391 5.391 0 0 0-1.353-1.007.245.245 0 0 1-.075-.315.249.249 0 0 1 .303-.118 5.854 5.854 0 0 1 1.478 1.098.246.246 0 0 1-.174.42l-.005-.004ZM116.625 35.05a.248.248 0 0 1-.124-.033c-.127-.072-1.251-.711-1.603-1.036a.246.246 0 0 1-.08-.181v-2.262c0-.129.1-.236.23-.247a17.223 17.223 0 0 1 3.071.009.247.247 0 1 1-.044.492 16.742 16.742 0 0 0-2.757-.024v1.918c.46.327.937.628 1.431.903a.246.246 0 0 1 .094.337.257.257 0 0 1-.218.124Z" fill="#FEB51F"></path><path d="M20.266 40.49c11.16 0 20.205-8.971 20.205-20.038 0-11.068-9.046-20.04-20.205-20.04C9.108.413.062 9.385.062 20.453c0 11.067 9.046 20.038 20.204 20.038Z" fill="#4DA2F8"></path><mask id="e" style="mask-type:alpha;" maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="41"><path d="M20.266 40.49c11.16 0 20.205-8.971 20.205-20.038 0-11.068-9.046-20.04-20.205-20.04C9.108.413.062 9.385.062 20.453c0 11.067 9.046 20.038 20.204 20.038Z" fill="#fff"></path></mask><g mask="url(#e)"><path d="M17.404 71.892s7.166 1.554 8.614.097c.476-.475-.097-3.067-.088-7.982 0-4.966.294-11.967.318-17.17.024-5.366-.214-8.855-.214-8.855l-12.442-1.103a75.51 75.51 0 0 1-2.852 7.305C8.153 49.882 4.42 57.038 2.732 60.587 2.02 62.07-.527 66.483-.527 66.483s3.51 3.64 7.853 3.165c.4-.489 1.26-2.678 2.28-4.79 3.504-7.252 9.402-20.464 9.402-20.464s-.458 15.264-.752 20.342c-.114 1.795-.852 7.156-.852 7.156Z" fill="#F03063"></path><path opacity=".4" d="M12.373 40.311c3.012.223 3.506-2.291 3.511-2.317l-.322-.059c-.017.095-.472 2.322-3.294 2.041l-.033.323.138.012Z" fill="#252551"></path><path opacity=".3" d="m27.005 41.967.2.012.018-.325c-1.365-.067-2.354-.46-2.937-1.172a2.695 2.695 0 0 1-.562-1.95l-.324-.05a3.01 3.01 0 0 0 .632 2.205c.616.752 1.615 1.178 2.973 1.28Z" fill="#252551"></path></g><path d="M36.653 34.385a5.54 5.54 0 0 0 1.332-.445c3.195-1.554 4.321-5.91 3.353-12.95a1.228 1.228 0 0 0-1.385-1.043 1.222 1.222 0 0 0-1.052 1.373c.787 5.724.076 9.433-1.999 10.44-2.594 1.26-7.16-1.417-8.988-3.268a1.234 1.234 0 0 0-1.735-.018 1.21 1.21 0 0 0-.018 1.72c1.783 1.793 6.563 4.977 10.492 4.191Z" fill="#FFCDC0"></path><path d="M11.296 22.843C7.256 9.709 17.563 1.53 24.404 3.094c4.49 1.026 7.86 4.503 8.696 11.494 1.586 13.217-11.142 15.203-11.777 15.203-4.747 0-9.18-4.186-10.027-6.948Z" fill="#373753"></path><path d="M6.576 46.996c.433-.182.715-.602.719-1.068.064-6.506 3.71-12.96 9.255-16.427a1.168 1.168 0 0 0-.058-2.051 1.189 1.189 0 0 0-1.2.07C8.965 31.555 5.077 38.45 4.925 45.91a1.175 1.175 0 0 0 1.166 1.183c.167.004.333-.03.486-.097Z" fill="#FFCDC0"></path><path d="M24.996 26.614c1.008.33 5.34 1.994 5.112 2.804.053.785-4.24 3.206-5.037 2.64-.007-.005-1.032-5.757-.075-5.444ZM13.757 27.484a.278.278 0 0 1 .094-.383h.01a.232.232 0 0 1 .068-.026c1.45-.39 2.897-.832 4.328-1.27.15-.04.306.047.348.196.08.29-1.881 4.265-1.948 4.382a.278.278 0 0 1-.38.107 6.927 6.927 0 0 1-1.451-1.36 8.695 8.695 0 0 1-1.069-1.646Z" fill="#F8FAFC"></path><path d="M18.4 9.738c10.305-5.466 18.41 9.514 6.877 12.604-8.682 2.326-14.512-8.545-6.884-12.595l.007-.009Z" fill="#F7BBA6"></path><path d="M17.916 7.436s1.67 7.758 16.594 5.482c.789-.842-.367-1.035-.367-1.035s-4.71-1.023-5.651-5.1" fill="#373753"></path><path d="M20.352 7.685s.917 6.647-6.268 7.942c-7.184 1.295 0-7.464 0-7.464l6.268-.478ZM26.883 7.362s4.59 2.953 5.92 2.297c1.902-.068-.509 2.16-.509 2.16l-4.845-1.382" fill="#373753"></path><path d="M13.564 36.728c-.348-.397 4.255-10.75 4.55-10.762.312-.43.965 0 4.835.568 1.784.242 2.132-.202 2.223.329.324.345 1.044 11.06 1.017 11.19.46 1.298-6.637 1.476-9.633.518-.644-.218-3.022-1.218-2.992-1.843Z" fill="#F8FAFC"></path><path d="M6.51 47.908c.431-.183.713-.601.719-1.067 0-.456.099-1.832.144-2.34a1.176 1.176 0 0 0-1.068-1.276 1.18 1.18 0 0 0-1.287 1.059c-.044.487-.148 1.95-.154 2.528-.004.31.116.61.334.833.219.223.518.35.831.355a1.14 1.14 0 0 0 .48-.092Z" fill="#FFCDC0"></path><path d="M22.033 14.631a.538.538 0 0 0-.437.677c.095.26.384.398.648.307a.577.577 0 0 0 .237-.918.503.503 0 0 0-.443-.071l-.005.005ZM28.35 14.73a.576.576 0 0 0-.291.764l.033.061c.165.22.471.281.709.14a.533.533 0 0 0 .214-.684.541.541 0 0 0-.666-.281ZM20.415 18.932c.174 2.167 1.65 2.559 2.73.751a.26.26 0 0 0-.15-.383l-2.25-.634a.262.262 0 0 0-.322.173.232.232 0 0 0-.008.093Z" fill="#C0564C"></path><path d="m25.891 17.84.033-.034a.516.516 0 0 0 .147-.378.66.66 0 0 0-.43-.481c-.274-.156-.523-.3-.488-.729v-.036l-.087-1.036a.199.199 0 0 0-.215-.18.198.198 0 0 0-.182.213l.066 1.013c-.057.677.413.941.697 1.1.087.04.166.096.235.162a.148.148 0 0 1-.047.081.998.998 0 0 1-.585.261.206.206 0 0 0-.199.214.207.207 0 0 0 .216.197c.313-.027.609-.156.84-.368Z" fill="#EC9D8B"></path><path d="M21.25 21.61a.44.44 0 0 0-.19.247c-1.65 4.77-1.419 4.329-1.392 4.406a.41.41 0 0 0 .034.544c1.32 1.4 3.585.884 3.952.385.045-.063.097-.12.155-.172.272-.268.25-1.086.432-4.36a.416.416 0 0 0-.413-.416s-2.237-.825-2.578-.634Z" fill="#F7BBA6"></path><path d="M25.935 32.258a.207.207 0 0 0 .099-.148c.014-.246 0-.493-.042-.736a.206.206 0 0 0-.238-.173.205.205 0 0 0-.174.237c.038.211.05.426.036.64-.003.109.08.2.188.21a.193.193 0 0 0 .13-.03ZM16.219 30.359a.173.173 0 0 0 .05-.055c.159-.256.333-.518.507-.76a.203.203 0 0 0-.058-.27.207.207 0 0 0-.276.035c-.175.254-.349.518-.523.78a.203.203 0 0 0 .058.282l.019.01c.072.038.16.03.223-.022Z" fill="#C5CADA"></path><path opacity=".15" d="M14.255 17.851s-.145 4.345 1.393 7.235M17.065 21.436c-.035 2.773-.261 2.032.235 3.626M30.212 20.417s-.823 3.16-2.413 4.342" stroke="#fff" stroke-width="2.47" stroke-linecap="round"></path><path d="M18.844 26.633c-.174 1.381 4.425 2.59 5.586.675" stroke="#C5CADA" stroke-width="2.47" stroke-linecap="round"></path><path d="M16.5 10.817a6.38 6.38 0 0 1-3.307 2.272" stroke="#fff" stroke-opacity=".15" stroke-width="2.47" stroke-linecap="round"></path><path d="M43.426 8.457a.678.678 0 0 0-.68-.676.678.678 0 0 0-.679.676v7.913c0 .373.304.676.68.676.375 0 .679-.303.679-.676V8.457ZM48.613 13.018a.674.674 0 0 0-.23-.928.681.681 0 0 0-.933.228l-2.583 4.251a.674.674 0 0 0 .23.928c.32.194.739.091.933-.228l2.583-4.251ZM36.975 11.91a.681.681 0 0 1 .936.218l2.77 4.434c.198.317.1.734-.218.931a.681.681 0 0 1-.936-.217l-2.77-4.434a.674.674 0 0 1 .218-.931ZM89.708 8.457a.678.678 0 0 0-.68-.676.678.678 0 0 0-.68.676v7.913c0 .373.305.676.68.676.375 0 .68-.303.68-.676V8.457ZM94.665 12.09a.674.674 0 0 1 .23.928l-2.584 4.25a.681.681 0 0 1-.933.23.674.674 0 0 1-.23-.929l2.584-4.25a.681.681 0 0 1 .933-.23ZM84.193 12.128a.681.681 0 0 0-.936-.217.674.674 0 0 0-.218.93l2.768 4.435a.681.681 0 0 0 .935.217.674.674 0 0 0 .219-.93l-2.768-4.435Z" fill="#E7EBF1"></path><path d="M74.704 19.592c.36-.226 5.764-12.086-1.88-11.486.319-2.98-1.27-6.412-4.063-6.412-3.522 0-9.347 5.437-12.709 5.054-1.172-.323-.402 1.59.381 2.662 1.72 2.35 1.868.613.523 2.151a3.439 3.439 0 0 0-.822 1.969c-.334 2.983 3.482 6.42 3.412 6.42l15.158-.358Z" fill="#703713"></path><path d="M53.864 34.37a8.742 8.742 0 0 1-4.526-1.16c-3.268-1.94-4.875-6.123-4.79-12.432a1.778 1.778 0 0 1 1.81-1.745 1.777 1.777 0 0 1 1.76 1.795c-.051 3.41.438 7.797 3.051 9.351 3.158 1.872 8.459-.768 10.007-1.621a1.799 1.799 0 0 1 1.785.025c.548.325.88.914.87 1.547a1.769 1.769 0 0 1-.914 1.52 23.955 23.955 0 0 1-5.745 2.299 14.009 14.009 0 0 1-3.308.42Z" fill="#FFBDA6"></path><path d="M53.847 34.36a9.096 9.096 0 0 1-3.494-.645c-2.761-1.136-4.562-3.626-5.347-7.424l3.496-.711c.538 2.598 1.59 4.183 3.226 4.858 3.322 1.373 8.605-1.28 10.358-2.417l1.959 2.953c-.27.176-5.261 3.385-10.198 3.385Z" fill="#FF7641"></path><path d="m45.58 28.118 2.933-1.554c.806-.185.2-1.585.2-1.573a.538.538 0 0 0-.653-.382l-3.054.69c-.807.186-.198 1.586-.202 1.572.06.287.477 1.314.777 1.247Z" fill="#F45721"></path><path d="M78.543 34.37a8.742 8.742 0 0 0 4.526-1.16c3.268-1.94 4.875-6.123 4.79-12.432a1.778 1.778 0 0 0-1.81-1.745 1.777 1.777 0 0 0-1.76 1.795c.051 3.41-.438 7.797-3.051 9.351-3.158 1.872-8.46-.768-10.007-1.621a1.799 1.799 0 0 0-1.785.025c-.548.325-.88.914-.87 1.547.008.632.357 1.212.914 1.52a23.955 23.955 0 0 0 5.745 2.299c1.082.271 2.192.413 3.308.42Z" fill="#FFBDA6"></path><path d="M78.56 34.36a9.096 9.096 0 0 0 3.494-.645c2.761-1.136 4.56-3.626 5.346-7.424l-3.494-.708c-.537 2.599-1.59 4.184-3.225 4.859-3.322 1.372-8.606-1.28-10.359-2.418l-1.958 2.953c.268.173 5.259 3.382 10.196 3.382Z" fill="#FF7641"></path><path d="m86.826 28.118-2.932-1.554c-.806-.185-.2-1.585-.2-1.573a.537.537 0 0 1 .653-.382l3.054.69c.806.186.198 1.586.202 1.572-.061.287-.477 1.314-.777 1.247ZM62.048 28.378c0 1.629.414 2.544 1.393 3.454.513-.466 1.257-1.283 1.77-1.748.829.505 1.529 1.413 2.234 2.084 1.196-1.001 2.07-1.921 2.73-3.334 0-.775-.517-1.457-1.268-1.673l-2.728-.792-2.855.518a1.532 1.532 0 0 0-1.266 1.502l-.01-.01Z" fill="#F45721"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M67.257 32.33a.253.253 0 0 0 .174.073.241.241 0 0 0 .167-.067c1.177-.99 2.105-1.946 2.785-3.422a.312.312 0 0 0 .025-.106 2.01 2.01 0 0 0-1.454-1.918l-2.73-.78a.267.267 0 0 0-.116 0l-2.857.518a1.782 1.782 0 0 0-1.471 1.752c0 1.646.412 2.66 1.47 3.626a.249.249 0 0 0 .349 0c.237-.215.522-.502.805-.788l.093-.094.15-.151c.21-.212.413-.416.594-.588.504.381.968.814 1.382 1.291.216.232.423.45.634.655Zm-2.058-2.517h.005-.005Zm.134.038a.247.247 0 0 0-.13-.038h.005a.268.268 0 0 0-.174.06 22.17 22.17 0 0 0-.895.883c-.233.243-.48.495-.696.701-.824-.819-1.136-1.68-1.136-3.082a1.275 1.275 0 0 1 1.045-1.255l2.798-.506 2.654.76c.624.18 1.061.737 1.083 1.38-.604 1.289-1.396 2.152-2.453 3.048l-.282-.295-.17-.18a8.35 8.35 0 0 0-1.649-1.476Z" fill="#F45721"></path><path d="M64.44 22.047c-.371 2.567-1.219 5.087-1.266 5.884a1.685 1.685 0 0 1-.033.247c-.174.77 1.915 1.172 2.893 1.181.455 0 3.209.086 3.035-.808.028-.135-.432-2.315-.625-6.433a.347.347 0 0 0-.348-.345c-3.24.036-3.614-.096-3.656.274Z" fill="#FFBDA6"></path><path d="M63.016 9.648c-2.481 0-3.722.494-3.956 5.132-.108 2.179-.283 5.428 1.064 7.098.385.47.867.85 1.414 1.119 1.845.913 7.754.839 8.683.599 5.098-1.31 3.52-9.814 3.02-11.028-.326-.786-.403-1.763-1.119-2.177-2.428-1.413-6.483-.74-9.106-.74v-.003Z" fill="#FFBDA6"></path><path d="M71.471 20.881c.697 1.097 2.072 1.328 2.906.612 1.845-1.582.026-3.91-1.9-3.37l-1.006 2.758Z" fill="#FFBDA6"></path><path d="M68.386 16.21a.568.568 0 0 1 .514.668.537.537 0 0 1-.65.376c-.39-.092-.593-.653-.325-.93a.526.526 0 0 1 .462-.115ZM61.31 16.192c.315.138.543.518.348.837a.579.579 0 0 1-.782.199.53.53 0 0 1-.07-.917.525.525 0 0 1 .497-.119h.007Z" fill="#C1564D"></path><path d="M64.273 18.753c-.67 0-.91-.278-.958-.346a.293.293 0 0 1-.04-.09c-.146-.62-.04-.821.275-1.065.228-.172.576-.445.787-1.86a.252.252 0 0 1 .404-.159c.07.056.105.144.092.232-.223 1.492-.607 1.9-.992 2.186-.146.114-.183.143-.11.475.233.123.502.16.76.105a.25.25 0 0 1 .28.213.03.03 0 0 0 0 .012.247.247 0 0 1-.215.276h-.012c-.09.012-.18.019-.271.02Z" fill="#D36E63" opacity=".4"></path><path d="M64.711 20.526c-.211 0-.422-.02-.63-.059a.252.252 0 0 1-.19-.165.249.249 0 0 1 .048-.246.254.254 0 0 1 .24-.08c.73.139 1.486-.01 2.108-.414a.258.258 0 0 1 .265-.028.254.254 0 0 1 .015.451 3.39 3.39 0 0 1-1.856.54Z" fill="#C1564D"></path><path d="M69.631 14.346a.237.237 0 0 1-.143-.043 3.274 3.274 0 0 0-2.03-.537.248.248 0 0 1-.27-.233.247.247 0 0 1 .224-.27h.026a3.76 3.76 0 0 1 2.35.622.246.246 0 0 1-.143.463l-.014-.002ZM60.272 14.35a.246.246 0 0 1-.129-.473 3.789 3.789 0 0 1 2.385-.492.249.249 0 0 1-.066.492 3.294 3.294 0 0 0-2.058.416.255.255 0 0 1-.132.057ZM59.882 9.716l4.917-.624 3.563.422s-3.56 5.44-8.48.202Z" fill="#703713"></path><path d="M62.091 7.457a.25.25 0 0 1-.235-.11.245.245 0 0 1-.007-.258.25.25 0 0 1 .229-.124 10.253 10.253 0 0 0 5.764-2.19.257.257 0 0 1 .355.045.252.252 0 0 1-.037.353 10.767 10.767 0 0 1-6.053 2.296l-.016-.012ZM65.488 9.344a.254.254 0 0 1-.24-.08.25.25 0 0 1 .14-.412 9.851 9.851 0 0 0 3.186-2.156c.1-.075.24-.067.33.019.091.085.106.223.036.326a10.41 10.41 0 0 1-3.353 2.283.273.273 0 0 1-.1.02ZM57.764 14.676a.25.25 0 0 1-.247-.172 3.173 3.173 0 0 1 .045-1.99.255.255 0 0 1 .326-.15c.132.047.2.192.153.323a2.69 2.69 0 0 0-.039 1.671.246.246 0 0 1-.247.329l.009-.01ZM74.727 13.813a.248.248 0 0 1-.25-.325 4.314 4.314 0 0 0 .163-1.75.245.245 0 0 1 .209-.278h.013a.25.25 0 0 1 .283.207v.017c.074.656.015 1.32-.174 1.953a.249.249 0 0 1-.244.176Z" fill="#59280E"></path><path d="M72.657 11.092c.73 2.118-.362 4.508-.87 6.42-.47 1.767.617 2.054 1.044 1.816.142-.099.265-.222.362-.365a3.345 3.345 0 0 1 1.452-1.003c-1.915-8.674-1.405-6.388-1.489-6.78l-.5-.088Z" fill="#703713"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M66.597 18.326c.478.424 1.1.655 1.74.648a2.993 2.993 0 0 0 1.749-.572c.898-.677 1.142-1.744.62-2.78a2.984 2.984 0 0 0-2.849-1.57 2.24 2.24 0 0 0-2.043 1.641 2.577 2.577 0 0 0 .783 2.633Zm1.318-3.783h.174l.002.005c.908 0 1.744.493 2.177 1.285.587 1.169-.134 1.908-.471 2.153-.732.55-1.975.72-2.836-.048a2.103 2.103 0 0 1-.638-2.11 1.755 1.755 0 0 1 1.592-1.285ZM59.036 18.552a2.57 2.57 0 0 0 1.741.648 2.975 2.975 0 0 0 1.746-.572c.898-.677 1.142-1.742.62-2.778a2.986 2.986 0 0 0-2.846-1.573 2.242 2.242 0 0 0-2.044 1.646 2.577 2.577 0 0 0 .783 2.63Zm1.318-3.78h.174l-.007.002a2.484 2.484 0 0 1 2.176 1.289c.589 1.18-.134 1.904-.472 2.15-.729.552-1.965.72-2.835-.05a2.097 2.097 0 0 1-.638-2.106 1.753 1.753 0 0 1 1.602-1.286Z" fill="#494E6A"></path><path d="M63.151 16.672a.253.253 0 0 1-.29-.204.252.252 0 0 1 .205-.288 4.684 4.684 0 0 1 2.996-.081.246.246 0 0 1 .15.314v.01a.246.246 0 0 1-.317.152h-.01a4.255 4.255 0 0 0-2.647.087.275.275 0 0 1-.087.01ZM74.488 18.575a.286.286 0 0 1-.1-.02l-3.761-1.612a.246.246 0 0 1-.14-.32v-.011a.25.25 0 0 1 .323-.14h.014l3.76 1.604a.251.251 0 1 1-.1.492l.004.007ZM57.271 17.48a.248.248 0 0 1-.252-.23.248.248 0 0 1 .219-.262l1.172-.148a.252.252 0 0 1 .245.089.247.247 0 0 1 .032.257.25.25 0 0 1-.216.146l-1.169.148h-.031Z" fill="#494E6A"></path>', 62);
const _hoisted_64 = [
  _hoisted_2$2
];
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1$2, _hoisted_64);
}
var InviteIcon = { render };
var _style_0 = ".people-picker-list[data-v-91015b68]{padding:16px 0;display:flex;flex-direction:column}[data-v-91015b68] .group-label{line-height:22px;margin:4px 0}.people-picker-list__footer[data-v-91015b68]{padding:0 12px;margin-top:16px}\n";
const _withScopeId = (n) => (pushScopeId("data-v-91015b68"), n = n(), popScopeId(), n);
const _hoisted_1$1 = { class: "people-picker-list h-full" };
const _hoisted_2$1 = { class: "overflow-hidden" };
const _hoisted_3 = { class: "w-full" };
const _hoisted_4 = { class: "flex flex-col items-center justify-center text-center px-150 h-[var(--token-c-assignee-picker-size-default-list)]" };
const _hoisted_5 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createBaseVNode("svg", {
  class: "mb-100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  viewBox: "0 0 62 60"
}, [
  /* @__PURE__ */ createBaseVNode("path", {
    d: "M42.456 45.02c1.138 3.195 8.315 13.279 8.33 13.295 5.189 5.48 14.496-3.724 8.949-8.804-.016-.014-10.136-7.204-13.383-8.322",
    fill: "#F03063"
  }),
  /* @__PURE__ */ createBaseVNode("path", {
    d: "m36.238 45.731 3.365 3.35a2.992 2.992 0 0 0 4.035.16c2.533-2.133 4.719-4.66 6.922-7.168a2.953 2.953 0 0 0-.042-3.944c-.99-1.084-1.795-2.028-3.2-3.426-3.004 4.28-7.218 7.495-11.08 11.028Z",
    fill: "#727491"
  }),
  /* @__PURE__ */ createBaseVNode("path", {
    d: "M1.925 32.778c12.671 33.78 56.889 15.327 49.943-14.192-1.932-8.212-8.614-15.123-16.787-17.563-18.917-5.65-40.154 13.1-33.156 31.755Z",
    fill: "#B3B9CE"
  }),
  /* @__PURE__ */ createBaseVNode("path", {
    d: "M8.748 30.727c9.165 24.313 41.146 11.032 36.123-10.215-1.398-5.91-6.231-10.884-12.142-12.64C19.047 3.805 3.686 17.3 8.749 30.726Z",
    fill: "#BAF8DD"
  }),
  /* @__PURE__ */ createBaseVNode("path", {
    d: "M16.794 24.649c-.47 0-.85-.408-.85-.912 0-1.877 1.461-2.935 2.836-2.979 1.515-.048 2.639 1.044 2.727 2.656.027.502-.33.933-.8.963-.467.029-.87-.354-.897-.857-.046-.844-.634-.952-.98-.94-.477.014-1.186.335-1.186 1.158 0 .503-.38.91-.85.91ZM33.488 24.324c-.47 0-.85-.405-.85-.906 0-1.94 1.489-2.986 2.89-2.986.7 0 1.35.257 1.831.721.385.372.843 1.05.843 2.178 0 .5-.381.906-.852.906-.47 0-.85-.405-.85-.906 0-.373-.096-.654-.284-.835-.168-.162-.412-.251-.688-.251-.411 0-1.19.245-1.19 1.173.002.5-.38.906-.85.906ZM22.355 31.784a.877.877 0 0 1-.383-.088.793.793 0 0 1-.372-1.09c.906-1.702 3.026-2.767 5.402-2.712 2.14.05 3.852 1 4.578 2.546a.796.796 0 0 1-.426 1.07c-.428.184-.93.001-1.122-.407-.452-.962-1.6-1.556-3.071-1.59-1.413-.032-3.153.52-3.849 1.827a.852.852 0 0 1-.756.444Z",
    fill: "#494E6A"
  })
], -1));
const _hoisted_6 = { class: "text-text-02 text-default" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "font-semibold pt-150 text-default px-200 mb-50" };
const _hoisted_9 = { class: "text-center text-text-02" };
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center mt-[24px] mb-[20px]"
};
const _hoisted_11 = { class: "text-center text-base mt-[20px] mb-[16px]" };
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row people-picker-list__footer"
};
const _hoisted_13 = { class: "flex flex-col items-start flex-1" };
const _hoisted_14 = { class: "flex flex-col items-end flex-1" };
const _sfc_main$2 = {
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    canAddUsers: {
      type: Boolean,
      default: false
    },
    companyIds: {
      type: Array,
      default: () => []
    },
    currentUser: {
      type: Object,
      required: true
    },
    projectId: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 0
    },
    privacyIds: {
      type: Array,
      default: () => []
    },
    searchLabelText: {
      type: String,
      default: "Search"
    },
    emptyListText: {
      type: String,
      default: "No users match your search"
    },
    noResultsText: {
      type: String,
      default: "No results found for your search"
    },
    clearText: {
      type: String,
      default: "Clear"
    },
    chooseMoreText: {
      type: String,
      default: "Choose more"
    },
    addUserLabelText: {
      type: String,
      default: "Can\u2019t find who you\u2019re looking for?"
    },
    addUserButtonText: {
      type: String,
      default: "Add user to project"
    },
    inviteUserLabelText: {
      type: String,
      default: "Collaborate with your team!"
    },
    inviteUserButtonText: {
      type: String,
      default: "Invite People"
    },
    shouldUseRecentlyAssigned: {
      type: Boolean,
      default: false
    },
    shouldIncludeObservers: {
      type: Boolean,
      default: false
    },
    shouldShowInviteSlate: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue",
    "addNewUser",
    "assigneeSelected",
    "chooseMore",
    "inviteUser"
  ],
  setup(__props, { emit }) {
    const props2 = __props;
    const searchTerm = ref("");
    const debouncedSearchTerm = useDebounce(searchTerm, 400);
    const { recentAssignees, addAssigneeToRecentlyAssignedStore } = useRecentAssignees({
      currentUser: props2.currentUser,
      projectId: props2.projectId
    });
    const { itemsMap, isLoading, totalCount } = useAssigneeList({
      projectId: props2.projectId,
      taskId: props2.taskId,
      searchTerm: debouncedSearchTerm,
      privacyIds: props2.privacyIds,
      currentUser: props2.currentUser,
      recentAssignees,
      shouldUseRecentlyAssigned: props2.shouldUseRecentlyAssigned && props2.privacyIds.length === 0,
      shouldIncludeObservers: props2.shouldIncludeObservers,
      companyIds: props2.companyIds
    });
    const findInItemsMap = (value) => {
      if (value.startsWith("t-")) {
        return itemsMap.value.filter((item) => item.label === "Teams" || item.label === "").reduce((a, b) => {
          return [...a, ...b.options];
        }, []).find((item) => item.value === value);
      } else {
        return itemsMap.value.filter((item) => item.label !== "Teams").reduce((a, b) => {
          return [...a, ...b.options];
        }, []).find((item) => item.value === value);
      }
    };
    const assignees = computed({
      get() {
        return props2.modelValue.map(({ value }) => value);
      },
      set(val) {
        if (val.length) {
          const itemsSelected = val.map(findInItemsMap);
          addAssigneeToRecentlyAssignedStore(itemsSelected[itemsSelected.length - 1]);
          emit("update:modelValue", itemsSelected);
        } else {
          emit("update:modelValue", []);
        }
      }
    });
    const shouldShowInvite = computed(() => props2.shouldShowInviteSlate && totalCount.value <= 1 && !isLoading.value);
    const contentWrapperClasses = computed(() => {
      return `flex flex-col overflow-y-auto ${shouldShowInvite.value ? "h-[64px]" : "h-var(--token-c-assignee-picker-size-default-list)]"}`;
    });
    const onSearchTermChange = (query) => {
      searchTerm.value = query;
    };
    const onClickClearSelection = () => {
      searchTerm.value = "";
      assignees.value = [];
    };
    const onClickChooseMore = () => {
      emit("chooseMore");
    };
    const onClickAddNewUser = () => {
      emit("addNewUser");
    };
    const onClickInviteUser = () => {
      emit("inviteUser");
    };
    const peoplepickerRef = ref(null);
    const userSelected = (value) => {
      const itemSelected = findInItemsMap(value);
      addAssigneeToRecentlyAssignedStore(itemSelected);
      emit("update:modelValue", [itemSelected]);
      emit("assigneeSelected");
    };
    const deSelect = (index2) => {
      assignees.value.splice(index2, 1);
    };
    const refocusSearch = () => {
      const input = peoplepickerRef.value.$refs.input;
      input.focus();
    };
    const isSelected = (option) => {
      return assignees.value.find((value) => value === option.value) ? "selected" : "";
    };
    onMounted(() => {
      peoplepickerRef.value.open();
      nextTick(() => {
        const input = peoplepickerRef.value.$refs.input;
        input.setAttribute("type", "search");
        input.setAttribute("placeholder", props2.searchLabelText);
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1, [
        createBaseVNode("div", _hoisted_2$1, [
          createVNode(unref(MultiSelect), {
            ref: (_value, _refs) => {
              _refs["peoplepickerRef"] = _value;
              peoplepickerRef.value = _value;
            },
            mode: "multiple",
            classes: {
              container: "people-picker-list__multiselect",
              contentWrapper: unref(contentWrapperClasses),
              dropdown: "w-full py-100 max-h-[200px]",
              singleLabel: "flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug",
              searchInput: "w-2800 search",
              searchInputWrapper: "flex flex-row justify-center pb-100 search-wrapper",
              placeholder: "flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug text-text-02",
              caret: "hidden",
              spinner: "bg-multiselect-spinner bg-center bg-no-repeat w-200 h-200 z-10 animate-spin flex-shrink-0 flex-grow-0",
              dropdownHidden: "block",
              options: "flex flex-col p-0 m-0 list-none",
              optionsTop: "flex-col",
              group: "p-0 m-0",
              groupLabel: "flex text-xs font-semibold text-text-01 box-border items-center justify-start text-left pl-300 font-semibold cursor-default leading-normal group-label",
              groupLabelPointable: "cursor-pointer",
              groupLabelDisabled: "cursor-not-allowed",
              groupLabelSelectedDisabled: "cursor-not-allowed",
              groupOptions: "p-0 m-0",
              option: "flex items-center justify-start box-border text-left cursor-pointer text-base leading-snug py-100 px-300",
              optionSelected: "bg-dropdownselected",
              optionPointed: "bg-bg--hover",
              optionDisabled: "cursor-not-allowed",
              optionSelectedDisabled: "bg-opacity-50 cursor-not-allowed",
              noOptions: "py-100 px-150 text-text-02 bg-white text-center",
              noResults: "mt-100 px-150 text-text-02 bg-white text-center"
            },
            "close-on-select": false,
            filterResults: false,
            searchable: true,
            groups: true,
            options: unref(itemsMap),
            "hide-selected": true,
            loading: unref(isLoading),
            "should-refresh-labels": false,
            "should-clear-search-on-deactivate": false,
            "track-by": "name",
            label: "name",
            onSelect: userSelected,
            onSearchChange: onSearchTermChange,
            onDeselect: _cache[0] || (_cache[0] = ($event) => refocusSearch())
          }, {
            multiplelabel: withCtx(() => [
              createBaseVNode("div", _hoisted_3, [
                createBaseVNode("ul", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (option, index2) => {
                    return openBlock(), createElementBlock("li", {
                      key: option.name,
                      class: "box-border flex items-center justify-start text-base leading-snug text-left cursor-pointer py-100 px-150 hover:bg-bg--hover"
                    }, [
                      createVNode(Assignee, {
                        variant: "selected",
                        option,
                        onClick: ($event) => deSelect(index2)
                      }, null, 8, ["option", "onClick"])
                    ]);
                  }), 128))
                ])
              ])
            ]),
            option: withCtx(({ option }) => [
              createVNode(Assignee, {
                variant: isSelected(option),
                option
              }, null, 8, ["variant", "option"])
            ]),
            spinner: withCtx(() => [
              createBaseVNode("ul", null, [
                (openBlock(), createElementBlock(Fragment, null, renderList([1, 2, 3, 4, 5], (option, index2) => {
                  return createBaseVNode("li", {
                    key: index2,
                    class: "box-border flex items-center justify-start text-base leading-snug text-left cursor-pointer py-100 px-150 hover:bg-bg--hover"
                  }, [
                    createVNode(Assignee, {
                      variant: "selected",
                      option: {},
                      skeleton: true
                    })
                  ]);
                }), 64))
              ])
            ]),
            nooptions: withCtx(() => [
              createBaseVNode("div", _hoisted_4, [
                _hoisted_5,
                createBaseVNode("p", _hoisted_6, toDisplayString(__props.emptyListText), 1),
                __props.canAddUsers ? (openBlock(), createElementBlock("div", _hoisted_7, [
                  createBaseVNode("p", _hoisted_8, toDisplayString(__props.addUserLabelText), 1),
                  createVNode(Btn, {
                    size: "small",
                    variant: "clean",
                    class: "add-new-user text-default text-primary px-175 py-50",
                    onClick: withModifiers(onClickAddNewUser, ["prevent"])
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.addUserButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])) : createCommentVNode("", true)
              ])
            ]),
            noresults: withCtx(() => [
              createBaseVNode("div", _hoisted_9, toDisplayString(__props.noResultsText), 1)
            ]),
            _: 1
          }, 8, ["classes", "options", "loading"])
        ]),
        unref(shouldShowInvite) ? (openBlock(), createElementBlock("div", _hoisted_10, [
          createVNode(unref(InviteIcon)),
          createBaseVNode("p", _hoisted_11, toDisplayString(__props.inviteUserLabelText), 1),
          createBaseVNode("button", {
            class: "bg-[#4461D7] text-white rounded py-[4px] px-[18px] text-[14px] leading-[24px]",
            onClick: onClickInviteUser
          }, toDisplayString(__props.inviteUserButtonText), 1)
        ])) : createCommentVNode("", true),
        !unref(shouldShowInvite) ? (openBlock(), createElementBlock("div", _hoisted_12, [
          createBaseVNode("div", _hoisted_13, [
            createVNode(BtnText, {
              size: "small",
              onClick: onClickClearSelection
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.clearText), 1)
              ]),
              _: 1
            })
          ]),
          createBaseVNode("div", _hoisted_14, [
            createVNode(BtnText, {
              primary: true,
              size: "small",
              onClick: withModifiers(onClickChooseMore, ["prevent", "stop"])
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.chooseMoreText), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
};
var PeoplePickerList = /* @__PURE__ */ _export_sfc$1(_sfc_main$2, [["styles", [_style_0]], ["__scopeId", "data-v-91015b68"]]);
const _hoisted_1 = {
  key: 0,
  class: "bg-black text-white rounded-sm text-xs px-200 py-100 break-words",
  style: {
    "max-width": "200px",
    "word-break": "break-all"
  }
};
const _hoisted_2 = ["innerHTML"];
const _sfc_main$1 = {
  setup(__props) {
    function isFunction2(value) {
      return typeof value === "function";
    }
    const createPopper2 = popperGenerator({
      defaultModifiers: [...defaultModifiers, arrow$1, flip$1, hide$1, offset$1, preventOverflow$1]
    });
    const { tooltipText, node } = useTooltipManager();
    let tooltipInstance = null;
    const tooltipRef = ref(null);
    const tooltipConfig = computed(() => {
      return {
        placement: "top",
        strategy: "fixed",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 12]
            }
          }
        ]
      };
    });
    const destroyTooltip = () => {
      if (tooltipInstance && isFunction2(tooltipInstance.destroy)) {
        tooltipInstance.destroy();
      }
    };
    const createTooltip = () => {
      destroyTooltip();
      if (node.value) {
        tooltipInstance = createPopper2(node.value, tooltipRef.value, tooltipConfig.value);
      }
    };
    watch(tooltipText, () => {
      if (tooltipText.value) {
        createTooltip();
      } else {
        destroyTooltip();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: (_value, _refs) => {
          _refs["tooltipRef"] = _value;
          tooltipRef.value = _value;
        },
        style: { "z-index": "1090" }
      }, [
        unref(tooltipText) ? withDirectives((openBlock(), createElementBlock("div", _hoisted_1, [
          createBaseVNode("span", { innerHTML: unref(tooltipText) }, null, 8, _hoisted_2)
        ], 512)), [
          [vShow, unref(tooltipText)]
        ]) : createCommentVNode("", true)
      ], 512);
    };
  }
};
const _sfc_main = {
  props: {
    size: props$1.size,
    assignees: {
      type: Array,
      default: () => []
    },
    canAddUsers: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object,
      required: true
    },
    companyPrivacyIds: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 0
    },
    userPrivacyIds: {
      type: Array,
      default: () => []
    },
    searchLabelText: {
      type: String,
      default: "Search"
    },
    emptyListText: {
      type: String,
      default: "List is empty"
    },
    noResultsText: {
      type: String,
      default: "No results found for your search"
    },
    clearText: {
      type: String,
      default: "Clear"
    },
    chooseMoreText: {
      type: String,
      default: "Add more"
    },
    addUserLabelText: {
      type: String,
      default: "Can\u2019t find who you\u2019re looking for?"
    },
    addUserButtonText: {
      type: String,
      default: "Add user to project"
    },
    noAssigneeText: {
      type: String,
      default: "Assign this task"
    },
    inviteUserLabelText: {
      type: String,
      default: "Collaborate with your team!"
    },
    inviteUserButtonText: {
      type: String,
      default: "Invite People"
    },
    shouldUseRecentlyAssigned: {
      type: Boolean,
      default: false
    },
    shouldIncludeObservers: {
      type: Boolean,
      default: false
    },
    shouldShowInviteSlate: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  emits: [
    "assignees:choose-more",
    "assignees:closed",
    "assignees:updated",
    "assignees:add-new-user",
    "assignees:invite-user"
  ],
  setup(__props, { emit }) {
    const props2 = __props;
    const shouldShowAssignPopover = ref(false);
    function showAssignPopover() {
      if (!props2.disabled) {
        shouldShowAssignPopover.value = true;
      }
    }
    function hideAssignPopover() {
      shouldShowAssignPopover.value = false;
    }
    function assigneeSelected() {
      shouldShowAssignPopover.value = false;
    }
    function onUpdateAssignees(val) {
      emit("assignees:updated", val);
    }
    function onChooseMore() {
      hideAssignPopover();
      emit("assignees:choose-more");
    }
    function onAddNewUser() {
      emit("assignees:add-new-user");
    }
    function onInviteUser() {
      emit("assignees:invite-user");
    }
    const peoplepickerRef = ref(null);
    const assignButton = ref(null);
    onClickOutside(peoplepickerRef, () => {
      hideAssignPopover();
      emit("assignees:closed");
    });
    const orderedAssignees = computed(() => {
      return [...props2.assignees].sort((a, b) => {
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;
        return 0;
      }).sort((a, b) => {
        if (!props2.currentUser)
          return 0;
        return props2.currentUser.value === a.value ? -1 : props2.currentUser.value === b.value ? 1 : 0;
      });
    });
    const cursorClass = computed(() => {
      return props2.disabled ? "cursor-not-allowed" : "cursor-pointer";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: (_value, _refs) => {
          _refs["peoplepickerRef"] = _value;
          peoplepickerRef.value = _value;
        },
        onKeydown: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop"])),
        onKeypress: _cache[1] || (_cache[1] = withModifiers(() => {
        }, ["stop"])),
        onKeyup: _cache[2] || (_cache[2] = withModifiers(() => {
        }, ["stop"]))
      }, [
        createVNode(_sfc_main$1),
        createBaseVNode("div", {
          ref: (_value, _refs) => {
            _refs["assignButton"] = _value;
            assignButton.value = _value;
          },
          class: normalizeClass(["inline-flex", [unref(cursorClass)]]),
          onClick: showAssignPopover
        }, [
          __props.assignees.length === 0 ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: normalizeClass([unref(cursorClass)]),
            type: "button"
          }, [
            withDirectives(createVNode(Avatar, {
              background: "#E1E6EE",
              color: "#646D7D",
              variant: "icon",
              icon: "assignee",
              size: __props.size
            }, null, 8, ["size"]), [
              [unref(tooltipDirective), __props.noAssigneeText]
            ])
          ], 2)) : (openBlock(), createBlock(_sfc_main$8, {
            key: 1,
            users: unref(orderedAssignees),
            show: 3,
            size: __props.size
          }, null, 8, ["users", "size"]))
        ], 2),
        shouldShowAssignPopover.value ? (openBlock(), createBlock(Popover, {
          key: 0,
          ref: (_value, _refs) => {
            _refs["popover"] = _value;
          },
          class: "popover",
          element: assignButton.value,
          placement: __props.placement
        }, {
          default: withCtx(() => [
            createVNode(PeoplePickerList, {
              "model-value": __props.assignees,
              "add-user-label-text": __props.addUserLabelText,
              "add-user-button-text": __props.addUserButtonText,
              "can-add-users": __props.canAddUsers,
              "company-ids": __props.companyPrivacyIds,
              "current-user": __props.currentUser,
              "project-id": __props.projectId,
              "task-id": __props.taskId,
              "privacy-ids": __props.userPrivacyIds,
              "search-label-text": __props.searchLabelText,
              "empty-list-text": __props.emptyListText,
              "no-results-text": __props.noResultsText,
              "clear-text": __props.clearText,
              "choose-more-text": __props.chooseMoreText,
              "invite-user-label-text": __props.inviteUserLabelText,
              "invite-user-button-text": __props.inviteUserButtonText,
              "should-use-recently-assigned": __props.shouldUseRecentlyAssigned,
              "should-exclude-observers": _ctx.shouldExcludeObservers,
              "should-show-invite-slate": __props.shouldShowInviteSlate,
              "onUpdate:modelValue": onUpdateAssignees,
              onAssigneeSelected: assigneeSelected,
              onChooseMore,
              onAddNewUser,
              onInviteUser
            }, null, 8, ["model-value", "add-user-label-text", "add-user-button-text", "can-add-users", "company-ids", "current-user", "project-id", "task-id", "privacy-ids", "search-label-text", "empty-list-text", "no-results-text", "clear-text", "choose-more-text", "invite-user-label-text", "invite-user-button-text", "should-use-recently-assigned", "should-exclude-observers", "should-show-invite-slate"])
          ]),
          _: 1
        }, 8, ["element", "placement"])) : createCommentVNode("", true)
      ], 544);
    };
  }
};
const CPeoplePicker = defineCustomElement(__spreadProps(__spreadValues({}, _sfc_main), {
  styles: [
    styles.concat(_sfc_main.styles),
    styles.concat(PeoplePickerList.styles),
    styles.concat(Avatar.styles),
    styles.concat(Assignee.styles),
    styles.concat(BtnText.styles),
    styles.concat(Popover.styles)
  ]
}));
const CBtn = defineCustomElement(__spreadProps(__spreadValues({}, Btn), { styles: [styles.concat(Btn.styles)] }));
function registerDS() {
  customElements.define("c-people-picker", CPeoplePicker);
  customElements.define("c-btn", CBtn);
}
export { CBtn, CPeoplePicker, registerDS };
